
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// Imports from MXG modules.
var $ad9e9f310a798519$exports = {};
(function(GLOBAL) {
    'use strict';
    var Big, /************************************** EDITABLE DEFAULTS *****************************************/ // The default values below must be integers within the stated ranges.
    /*
     * The maximum number of decimal places (DP) of the results of operations involving division:
     * div and sqrt, and pow with negative exponents.
     */ DP = 20, /*
     * The rounding mode (RM) used when rounding to the above decimal places.
     *
     *  0  Towards zero (i.e. truncate, no rounding).       (ROUND_DOWN)
     *  1  To nearest neighbour. If equidistant, round up.  (ROUND_HALF_UP)
     *  2  To nearest neighbour. If equidistant, to even.   (ROUND_HALF_EVEN)
     *  3  Away from zero.                                  (ROUND_UP)
     */ RM = 1, // The maximum value of DP and Big.DP.
    MAX_DP = 1E6, // The maximum magnitude of the exponent argument to the pow method.
    MAX_POWER = 1E6, /*
     * The negative exponent (NE) at and beneath which toString returns exponential notation.
     * (JavaScript numbers: -7)
     * -1000000 is the minimum recommended exponent value of a Big.
     */ NE = -7, /*
     * The positive exponent (PE) at and above which toString returns exponential notation.
     * (JavaScript numbers: 21)
     * 1000000 is the maximum recommended exponent value of a Big, but this limit is not enforced.
     */ PE = 21, /*
     * When true, an error will be thrown if a primitive number is passed to the Big constructor,
     * or if valueOf is called, or if toNumber is called on a Big which cannot be converted to a
     * primitive number without a loss of precision.
     */ STRICT = false, /**************************************************************************************************/ // Error messages.
    NAME = '[big.js] ', INVALID = NAME + 'Invalid ', INVALID_DP = INVALID + 'decimal places', INVALID_RM = INVALID + 'rounding mode', DIV_BY_ZERO = NAME + 'Division by zero', // The shared prototype object.
    P = {}, UNDEFINED = void 0, NUMERIC = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
    /*
   * Create and return a Big constructor.
   */ function _Big_() {
        /*
     * The Big constructor and exported function.
     * Create and return a new instance of a Big number object.
     *
     * n {number|string|Big} A numeric value.
     */ function Big(n) {
            var x = this;
            // Enable constructor usage without new.
            if (!(x instanceof Big)) return n === UNDEFINED ? _Big_() : new Big(n);
            // Duplicate.
            if (n instanceof Big) {
                x.s = n.s;
                x.e = n.e;
                x.c = n.c.slice();
            } else {
                if (typeof n !== 'string') {
                    if (Big.strict === true && typeof n !== 'bigint') throw TypeError(INVALID + 'value');
                    // Minus zero?
                    n = n === 0 && 1 / n < 0 ? '-0' : String(n);
                }
                parse(x, n);
            }
            // Retain a reference to this Big constructor.
            // Shadow Big.prototype.constructor which points to Object.
            x.constructor = Big;
        }
        Big.prototype = P;
        Big.DP = DP;
        Big.RM = RM;
        Big.NE = NE;
        Big.PE = PE;
        Big.strict = STRICT;
        Big.roundDown = 0;
        Big.roundHalfUp = 1;
        Big.roundHalfEven = 2;
        Big.roundUp = 3;
        return Big;
    }
    /*
   * Parse the number or string value passed to a Big constructor.
   *
   * x {Big} A Big number instance.
   * n {number|string} A numeric value.
   */ function parse(x, n) {
        var e, i, nl;
        if (!NUMERIC.test(n)) throw Error(INVALID + 'number');
        // Determine sign.
        x.s = n.charAt(0) == '-' ? (n = n.slice(1), -1) : 1;
        // Decimal point?
        if ((e = n.indexOf('.')) > -1) n = n.replace('.', '');
        // Exponential form?
        if ((i = n.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +n.slice(i + 1);
            n = n.substring(0, i);
        } else if (e < 0) // Integer.
        e = n.length;
        nl = n.length;
        // Determine leading zeros.
        for(i = 0; i < nl && n.charAt(i) == '0';)++i;
        if (i == nl) // Zero.
        x.c = [
            x.e = 0
        ];
        else {
            // Determine trailing zeros.
            for(; nl > 0 && n.charAt(--nl) == '0';);
            x.e = e - i - 1;
            x.c = [];
            // Convert string to array of digits without leading/trailing zeros.
            for(e = 0; i <= nl;)x.c[e++] = +n.charAt(i++);
        }
        return x;
    }
    /*
   * Round Big x to a maximum of sd significant digits using rounding mode rm.
   *
   * x {Big} The Big to round.
   * sd {number} Significant digits: integer, 0 to MAX_DP inclusive.
   * rm {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   * [more] {boolean} Whether the result of division was truncated.
   */ function round(x, sd, rm, more) {
        var xc = x.c;
        if (rm === UNDEFINED) rm = x.constructor.RM;
        if (rm !== 0 && rm !== 1 && rm !== 2 && rm !== 3) throw Error(INVALID_RM);
        if (sd < 1) {
            more = rm === 3 && (more || !!xc[0]) || sd === 0 && (rm === 1 && xc[0] >= 5 || rm === 2 && (xc[0] > 5 || xc[0] === 5 && (more || xc[1] !== UNDEFINED)));
            xc.length = 1;
            if (more) {
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                x.e = x.e - sd + 1;
                xc[0] = 1;
            } else // Zero.
            xc[0] = x.e = 0;
        } else if (sd < xc.length) {
            // xc[sd] is the digit after the digit that may be rounded up.
            more = rm === 1 && xc[sd] >= 5 || rm === 2 && (xc[sd] > 5 || xc[sd] === 5 && (more || xc[sd + 1] !== UNDEFINED || xc[sd - 1] & 1)) || rm === 3 && (more || !!xc[0]);
            // Remove any digits after the required precision.
            xc.length = sd;
            // Round up?
            if (more) // Rounding up may mean the previous digit has to be rounded up.
            for(; ++xc[--sd] > 9;){
                xc[sd] = 0;
                if (sd === 0) {
                    ++x.e;
                    xc.unshift(1);
                    break;
                }
            }
            // Remove trailing zeros.
            for(sd = xc.length; !xc[--sd];)xc.pop();
        }
        return x;
    }
    /*
   * Return a string representing the value of Big x in normal or exponential notation.
   * Handles P.toExponential, P.toFixed, P.toJSON, P.toPrecision, P.toString and P.valueOf.
   */ function stringify(x, doExponential, isNonzero) {
        var e = x.e, s = x.c.join(''), n = s.length;
        // Exponential notation?
        if (doExponential) s = s.charAt(0) + (n > 1 ? '.' + s.slice(1) : '') + (e < 0 ? 'e' : 'e+') + e;
        else if (e < 0) {
            for(; ++e;)s = '0' + s;
            s = '0.' + s;
        } else if (e > 0) {
            if (++e > n) for(e -= n; e--;)s += '0';
            else if (e < n) s = s.slice(0, e) + '.' + s.slice(e);
        } else if (n > 1) s = s.charAt(0) + '.' + s.slice(1);
        return x.s < 0 && isNonzero ? '-' + s : s;
    }
    // Prototype/instance methods
    /*
   * Return a new Big whose value is the absolute value of this Big.
   */ P.abs = function() {
        var x = new this.constructor(this);
        x.s = 1;
        return x;
    };
    /*
   * Return 1 if the value of this Big is greater than the value of Big y,
   *       -1 if the value of this Big is less than the value of Big y, or
   *        0 if they have the same value.
   */ P.cmp = function(y) {
        var isneg, x = this, xc = x.c, yc = (y = new x.constructor(y)).c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either zero?
        if (!xc[0] || !yc[0]) return !xc[0] ? !yc[0] ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        isneg = i < 0;
        // Compare exponents.
        if (k != l) return k > l ^ isneg ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = -1; ++i < j;){
            if (xc[i] != yc[i]) return xc[i] > yc[i] ^ isneg ? 1 : -1;
        }
        // Compare lengths.
        return k == l ? 0 : k > l ^ isneg ? 1 : -1;
    };
    /*
   * Return a new Big whose value is the value of this Big divided by the value of Big y, rounded,
   * if necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
   */ P.div = function(y) {
        var x = this, Big = x.constructor, a = x.c, b = (y = new Big(y)).c, k = x.s == y.s ? 1 : -1, dp = Big.DP;
        if (dp !== ~~dp || dp < 0 || dp > MAX_DP) throw Error(INVALID_DP);
        // Divisor is zero?
        if (!b[0]) throw Error(DIV_BY_ZERO);
        // Dividend is 0? Return +-0.
        if (!a[0]) {
            y.s = k;
            y.c = [
                y.e = 0
            ];
            return y;
        }
        var bl, bt, n, cmp, ri, bz = b.slice(), ai = bl = b.length, al = a.length, r = a.slice(0, bl), rl = r.length, q = y, qc = q.c = [], qi = 0, p = dp + (q.e = x.e - y.e) + 1; // precision of the result
        q.s = k;
        k = p < 0 ? 0 : p;
        // Create version of divisor with leading zero.
        bz.unshift(0);
        // Add zeros to make remainder as long as divisor.
        for(; rl++ < bl;)r.push(0);
        do {
            // n is how many times the divisor goes into current remainder.
            for(n = 0; n < 10; n++){
                // Compare divisor and remainder.
                if (bl != (rl = r.length)) cmp = bl > rl ? 1 : -1;
                else {
                    for(ri = -1, cmp = 0; ++ri < bl;)if (b[ri] != r[ri]) {
                        cmp = b[ri] > r[ri] ? 1 : -1;
                        break;
                    }
                }
                // If divisor < remainder, subtract divisor from remainder.
                if (cmp < 0) {
                    // Remainder can't be more than 1 digit longer than divisor.
                    // Equalise lengths using divisor with extra leading zero?
                    for(bt = rl == bl ? b : bz; rl;){
                        if (r[--rl] < bt[rl]) {
                            ri = rl;
                            for(; ri && !r[--ri];)r[ri] = 9;
                            --r[ri];
                            r[rl] += 10;
                        }
                        r[rl] -= bt[rl];
                    }
                    for(; !r[0];)r.shift();
                } else break;
            }
            // Add the digit n to the result array.
            qc[qi++] = cmp ? n : ++n;
            // Update the remainder.
            if (r[0] && cmp) r[rl] = a[ai] || 0;
            else r = [
                a[ai]
            ];
        }while ((ai++ < al || r[0] !== UNDEFINED) && k--);
        // Leading zero? Do not remove if result is simply zero (qi == 1).
        if (!qc[0] && qi != 1) {
            // There can't be more than one zero.
            qc.shift();
            q.e--;
            p--;
        }
        // Round?
        if (qi > p) round(q, p, Big.RM, r[0] !== UNDEFINED);
        return q;
    };
    /*
   * Return true if the value of this Big is equal to the value of Big y, otherwise return false.
   */ P.eq = function(y) {
        return this.cmp(y) === 0;
    };
    /*
   * Return true if the value of this Big is greater than the value of Big y, otherwise return
   * false.
   */ P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Big is greater than or equal to the value of Big y, otherwise
   * return false.
   */ P.gte = function(y) {
        return this.cmp(y) > -1;
    };
    /*
   * Return true if the value of this Big is less than the value of Big y, otherwise return false.
   */ P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Big is less than or equal to the value of Big y, otherwise
   * return false.
   */ P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return a new Big whose value is the value of this Big minus the value of Big y.
   */ P.minus = P.sub = function(y) {
        var i, j, t, xlty, x = this, Big = x.constructor, a = x.s, b = (y = new Big(y)).s;
        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.plus(y);
        }
        var xc = x.c.slice(), xe = x.e, yc = y.c, ye = y.e;
        // Either zero?
        if (!xc[0] || !yc[0]) {
            if (yc[0]) y.s = -b;
            else if (xc[0]) y = new Big(x);
            else y.s = 1;
            return y;
        }
        // Determine which is the bigger number. Prepend zeros to equalise exponents.
        if (a = xe - ye) {
            if (xlty = a < 0) {
                a = -a;
                t = xc;
            } else {
                ye = xe;
                t = yc;
            }
            t.reverse();
            for(b = a; b--;)t.push(0);
            t.reverse();
        } else {
            // Exponents equal. Check digit by digit.
            j = ((xlty = xc.length < yc.length) ? xc : yc).length;
            for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                xlty = xc[b] < yc[b];
                break;
            }
        }
        // x < y? Point xc to the array of the bigger number.
        if (xlty) {
            t = xc;
            xc = yc;
            yc = t;
            y.s = -y.s;
        }
        /*
     * Append zeros to xc if shorter. No need to add zeros to yc if shorter as subtraction only
     * needs to start at yc.length.
     */ if ((b = (j = yc.length) - (i = xc.length)) > 0) for(; b--;)xc[i++] = 0;
        // Subtract yc from xc.
        for(b = i; j > a;){
            if (xc[--j] < yc[j]) {
                for(i = j; i && !xc[--i];)xc[i] = 9;
                --xc[i];
                xc[j] += 10;
            }
            xc[j] -= yc[j];
        }
        // Remove trailing zeros.
        for(; xc[--b] === 0;)xc.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xc[0] === 0;){
            xc.shift();
            --ye;
        }
        if (!xc[0]) {
            // n - n = +0
            y.s = 1;
            // Result must be zero.
            xc = [
                ye = 0
            ];
        }
        y.c = xc;
        y.e = ye;
        return y;
    };
    /*
   * Return a new Big whose value is the value of this Big modulo the value of Big y.
   */ P.mod = function(y) {
        var ygtx, x = this, Big = x.constructor, a = x.s, b = (y = new Big(y)).s;
        if (!y.c[0]) throw Error(DIV_BY_ZERO);
        x.s = y.s = 1;
        ygtx = y.cmp(x) == 1;
        x.s = a;
        y.s = b;
        if (ygtx) return new Big(x);
        a = Big.DP;
        b = Big.RM;
        Big.DP = Big.RM = 0;
        x = x.div(y);
        Big.DP = a;
        Big.RM = b;
        return this.minus(x.times(y));
    };
    /*
   * Return a new Big whose value is the value of this Big negated.
   */ P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s;
        return x;
    };
    /*
   * Return a new Big whose value is the value of this Big plus the value of Big y.
   */ P.plus = P.add = function(y) {
        var e, k, t, x = this, Big = x.constructor;
        y = new Big(y);
        // Signs differ?
        if (x.s != y.s) {
            y.s = -y.s;
            return x.minus(y);
        }
        var xe = x.e, xc = x.c, ye = y.e, yc = y.c;
        // Either zero?
        if (!xc[0] || !yc[0]) {
            if (!yc[0]) {
                if (xc[0]) y = new Big(x);
                else y.s = x.s;
            }
            return y;
        }
        xc = xc.slice();
        // Prepend zeros to equalise exponents.
        // Note: reverse faster than unshifts.
        if (e = xe - ye) {
            if (e > 0) {
                ye = xe;
                t = yc;
            } else {
                e = -e;
                t = xc;
            }
            t.reverse();
            for(; e--;)t.push(0);
            t.reverse();
        }
        // Point xc to the longer array.
        if (xc.length - yc.length < 0) {
            t = yc;
            yc = xc;
            xc = t;
        }
        e = yc.length;
        // Only start adding at yc.length - 1 as the further digits of xc can be left as they are.
        for(k = 0; e; xc[e] %= 10)k = (xc[--e] = xc[e] + yc[e] + k) / 10 | 0;
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        if (k) {
            xc.unshift(k);
            ++ye;
        }
        // Remove trailing zeros.
        for(e = xc.length; xc[--e] === 0;)xc.pop();
        y.c = xc;
        y.e = ye;
        return y;
    };
    /*
   * Return a Big whose value is the value of this Big raised to the power n.
   * If n is negative, round to a maximum of Big.DP decimal places using rounding
   * mode Big.RM.
   *
   * n {number} Integer, -MAX_POWER to MAX_POWER inclusive.
   */ P.pow = function(n) {
        var x = this, one = new x.constructor('1'), y = one, isneg = n < 0;
        if (n !== ~~n || n < -MAX_POWER || n > MAX_POWER) throw Error(INVALID + 'exponent');
        if (isneg) n = -n;
        for(;;){
            if (n & 1) y = y.times(x);
            n >>= 1;
            if (!n) break;
            x = x.times(x);
        }
        return isneg ? one.div(y) : y;
    };
    /*
   * Return a new Big whose value is the value of this Big rounded to a maximum precision of sd
   * significant digits using rounding mode rm, or Big.RM if rm is not specified.
   *
   * sd {number} Significant digits: integer, 1 to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   */ P.prec = function(sd, rm) {
        if (sd !== ~~sd || sd < 1 || sd > MAX_DP) throw Error(INVALID + 'precision');
        return round(new this.constructor(this), sd, rm);
    };
    /*
   * Return a new Big whose value is the value of this Big rounded to a maximum of dp decimal places
   * using rounding mode rm, or Big.RM if rm is not specified.
   * If dp is negative, round to an integer which is a multiple of 10**-dp.
   * If dp is not specified, round to 0 decimal places.
   *
   * dp? {number} Integer, -MAX_DP to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   */ P.round = function(dp, rm) {
        if (dp === UNDEFINED) dp = 0;
        else if (dp !== ~~dp || dp < -MAX_DP || dp > MAX_DP) throw Error(INVALID_DP);
        return round(new this.constructor(this), dp + this.e + 1, rm);
    };
    /*
   * Return a new Big whose value is the square root of the value of this Big, rounded, if
   * necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
   */ P.sqrt = function() {
        var r, c, t, x = this, Big = x.constructor, s = x.s, e = x.e, half = new Big('0.5');
        // Zero?
        if (!x.c[0]) return new Big(x);
        // Negative?
        if (s < 0) throw Error(NAME + 'No square root');
        // Estimate.
        s = Math.sqrt(+stringify(x, true, true));
        // Math.sqrt underflow/overflow?
        // Re-estimate: pass x coefficient to Math.sqrt as integer, then adjust the result exponent.
        if (s === 0 || s === 1 / 0) {
            c = x.c.join('');
            if (!(c.length + e & 1)) c += '0';
            s = Math.sqrt(c);
            e = ((e + 1) / 2 | 0) - (e < 0 || e & 1);
            r = new Big((s == 1 / 0 ? '5e' : (s = s.toExponential()).slice(0, s.indexOf('e') + 1)) + e);
        } else r = new Big(s + '');
        e = r.e + (Big.DP += 4);
        // Newton-Raphson iteration.
        do {
            t = r;
            r = half.times(t.plus(x.div(t)));
        }while (t.c.slice(0, e).join('') !== r.c.slice(0, e).join(''));
        return round(r, (Big.DP -= 4) + r.e + 1, Big.RM);
    };
    /*
   * Return a new Big whose value is the value of this Big times the value of Big y.
   */ P.times = P.mul = function(y) {
        var c, x = this, Big = x.constructor, xc = x.c, yc = (y = new Big(y)).c, a = xc.length, b = yc.length, i = x.e, j = y.e;
        // Determine sign of result.
        y.s = x.s == y.s ? 1 : -1;
        // Return signed 0 if either 0.
        if (!xc[0] || !yc[0]) {
            y.c = [
                y.e = 0
            ];
            return y;
        }
        // Initialise exponent of result as x.e + y.e.
        y.e = i + j;
        // If array xc has fewer digits than yc, swap xc and yc, and lengths.
        if (a < b) {
            c = xc;
            xc = yc;
            yc = c;
            j = a;
            a = b;
            b = j;
        }
        // Initialise coefficient array of result with zeros.
        for(c = new Array(j = a + b); j--;)c[j] = 0;
        // Multiply.
        // i is initially xc.length.
        for(i = b; i--;){
            b = 0;
            // a is yc.length.
            for(j = a + i; j > i;){
                // Current sum of products at this digit position, plus carry.
                b = c[j] + yc[i] * xc[j - i - 1] + b;
                c[j--] = b % 10;
                // carry
                b = b / 10 | 0;
            }
            c[j] = b;
        }
        // Increment result exponent if there is a final carry, otherwise remove leading zero.
        if (b) ++y.e;
        else c.shift();
        // Remove trailing zeros.
        for(i = c.length; !c[--i];)c.pop();
        y.c = c;
        return y;
    };
    /*
   * Return a string representing the value of this Big in exponential notation rounded to dp fixed
   * decimal places using rounding mode rm, or Big.RM if rm is not specified.
   *
   * dp? {number} Decimal places: integer, 0 to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   */ P.toExponential = function(dp, rm) {
        var x = this, n = x.c[0];
        if (dp !== UNDEFINED) {
            if (dp !== ~~dp || dp < 0 || dp > MAX_DP) throw Error(INVALID_DP);
            x = round(new x.constructor(x), ++dp, rm);
            for(; x.c.length < dp;)x.c.push(0);
        }
        return stringify(x, true, !!n);
    };
    /*
   * Return a string representing the value of this Big in normal notation rounded to dp fixed
   * decimal places using rounding mode rm, or Big.RM if rm is not specified.
   *
   * dp? {number} Decimal places: integer, 0 to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   */ P.toFixed = function(dp, rm) {
        var x = this, n = x.c[0];
        if (dp !== UNDEFINED) {
            if (dp !== ~~dp || dp < 0 || dp > MAX_DP) throw Error(INVALID_DP);
            x = round(new x.constructor(x), dp + x.e + 1, rm);
            // x.e may have changed if the value is rounded up.
            for(dp = dp + x.e + 1; x.c.length < dp;)x.c.push(0);
        }
        return stringify(x, false, !!n);
    };
    /*
   * Return a string representing the value of this Big.
   * Return exponential notation if this Big has a positive exponent equal to or greater than
   * Big.PE, or a negative exponent equal to or less than Big.NE.
   * Omit the sign for negative zero.
   */ P.toJSON = P.toString = function() {
        var x = this, Big = x.constructor;
        return stringify(x, x.e <= Big.NE || x.e >= Big.PE, !!x.c[0]);
    };
    /*
   * Return the value of this Big as a primitve number.
   */ P.toNumber = function() {
        var n = +stringify(this, true, true);
        if (this.constructor.strict === true && !this.eq(n.toString())) throw Error(NAME + 'Imprecise conversion');
        return n;
    };
    /*
   * Return a string representing the value of this Big rounded to sd significant digits using
   * rounding mode rm, or Big.RM if rm is not specified.
   * Use exponential notation if sd is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * sd {number} Significant digits: integer, 1 to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   */ P.toPrecision = function(sd, rm) {
        var x = this, Big = x.constructor, n = x.c[0];
        if (sd !== UNDEFINED) {
            if (sd !== ~~sd || sd < 1 || sd > MAX_DP) throw Error(INVALID + 'precision');
            x = round(new Big(x), sd, rm);
            for(; x.c.length < sd;)x.c.push(0);
        }
        return stringify(x, sd <= x.e || x.e <= Big.NE || x.e >= Big.PE, !!n);
    };
    /*
   * Return a string representing the value of this Big.
   * Return exponential notation if this Big has a positive exponent equal to or greater than
   * Big.PE, or a negative exponent equal to or less than Big.NE.
   * Include the sign for negative zero.
   */ P.valueOf = function() {
        var x = this, Big = x.constructor;
        if (Big.strict === true) throw Error(NAME + 'valueOf disallowed');
        return stringify(x, x.e <= Big.NE || x.e >= Big.PE, true);
    };
    // Export
    Big = _Big_();
    Big['default'] = Big.Big = Big;
    //AMD.
    if (typeof define === 'function' && define.amd) define(function() {
        return Big;
    });
    else if (0, $ad9e9f310a798519$exports) $ad9e9f310a798519$exports = Big;
    else GLOBAL.Big = Big;
})($ad9e9f310a798519$exports);


function $93b71ab6968650c1$export$3988ae62b71be9a3(map, key) {
    if (!map.has(key)) throw new Error(`Key ${key} not found in map`);
    return map.get(key);
}
function $93b71ab6968650c1$export$3205c97bcf96f7dc(...parts) {
    // Convert the components to strings.
    let sparts = parts.map((part)=>part.toString());
    // Join the parts with a hyphen.
    let id = sparts.join("-");
    // Replace any character that is not a letter (upper or lower case), a digit, a hyphen, or an underscore 
    // with an underscore. 
    let validId = id.replace(/[^a-zA-Z-_0-9]/g, '_');
    // If the first character is a digit, two hyphens, or a hyphen followed by a digit, add an underscore to 
    // the beginning of the ID.
    if (/^[0-9]|^--|-^[0-9]/.test(validId)) validId = '_' + validId;
    return validId;
}
function $93b71ab6968650c1$export$bd2782c820638828(min, range, newMin, newRange, value) {
    // The + 0.0 is to force the division to be a floating point division.
    //return (((value - min) / (range + 0.0)) * (newRange)) + newMin;
    return (value - min) * newRange / (range + 0.0) + newMin;
}
function $93b71ab6968650c1$export$dc22ec7f8e0b9ac(map, delimiter) {
    if (map == null) return "";
    if (delimiter == undefined) delimiter = ', ';
    return Array.from(map.entries()).map(([key, value])=>`${key == null ? "null" : key.toString()}(${value == null ? "null" : value.toString()})`).join(delimiter);
}
function $93b71ab6968650c1$export$4323cc4280d5be7(array, delimiter) {
    if (delimiter == undefined) delimiter = ', ';
    return array.map((value)=>value == null ? "null" : value.toString()).join(delimiter);
}
function $93b71ab6968650c1$export$736cc24a423eb64d(set, delimiter) {
    if (delimiter == undefined) delimiter = ', ';
    return Array.from(set).map((value)=>value == null ? "null" : value.toString()).join(delimiter);
}
function $93b71ab6968650c1$export$8cfbaad830aa9e0a(s) {
    let r = [];
    for(let i = 0; i < s.length; i++)r.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(s[i]));
    return r;
}
function $93b71ab6968650c1$export$e90fb89750dba83f(s) {
    try {
        let x = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(s);
        return true;
    } catch (e) {
        return false;
    }
}
function $93b71ab6968650c1$export$dba422ef505af222(s, delimiter) {
    if (delimiter == undefined) delimiter = ' ';
    return s.map((value)=>value.toString()).join(delimiter);
}
function $93b71ab6968650c1$export$8960430cfd85939f(x, y) {
    if (x == null) return y;
    if (x.lt(y)) return y;
    return x;
}
function $93b71ab6968650c1$export$96ec731ed4dcb222(x, y) {
    if (x == null) return y;
    if (x.gt(y)) return y;
    return x;
}



const $341c675b659c6d43$export$25280bc3a7ce098e = "button";
const $341c675b659c6d43$export$5117a7844205b9ac = "collapsible";
const $341c675b659c6d43$export$38aa1ab9c2935930 = "\u25BC"; // ▼
const $341c675b659c6d43$export$e5e81646ee331a9e = "\u25B2"; // ▲
const $341c675b659c6d43$export$8797b0c8298d191 = "select";
function $341c675b659c6d43$export$8b2cd46c11844202(id, divToAddTo, elementToInsertBefore, content, buttonLabel, componentMargin, margin) {
    let div = $341c675b659c6d43$export$331ff980f0d45cff(id, margin);
    let bid = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(id, $341c675b659c6d43$export$25280bc3a7ce098e);
    let b = $341c675b659c6d43$export$9b6d6ca62970729f(buttonLabel + " " + $341c675b659c6d43$export$38aa1ab9c2935930, bid, componentMargin);
    b.className = $341c675b659c6d43$export$5117a7844205b9ac;
    b.addEventListener('click', function() {
        let parts = b.textContent.split(' ');
        parts[parts.length - 1] = parts[parts.length - 1] === $341c675b659c6d43$export$38aa1ab9c2935930 ? $341c675b659c6d43$export$e5e81646ee331a9e : $341c675b659c6d43$export$38aa1ab9c2935930;
        b.textContent = parts.join(' ');
    });
    // Add the button and content to the div.
    div.appendChild(b);
    div.appendChild(content);
    if (elementToInsertBefore != null) divToAddTo.insertBefore(div, elementToInsertBefore);
    else divToAddTo.appendChild(div);
    $341c675b659c6d43$var$setCollapsibleEventListener(b);
    return div;
}
/**
 * For setting the event listener for a collapsible element.
 * @param e The element to add the event listener to.
 */ function $341c675b659c6d43$var$setCollapsibleEventListener(e) {
    // Remove any existing event listener.
    e.removeEventListener("click", $341c675b659c6d43$var$toggleCollapsible);
    // Add new event listener.
    e.addEventListener("click", $341c675b659c6d43$var$toggleCollapsible);
}
/**
 * For toggling the collapsible content.
 */ function $341c675b659c6d43$var$toggleCollapsible() {
    this.classList.toggle("active");
    let nes = this.nextElementSibling;
    if (nes != null) {
        if (nes instanceof HTMLDivElement) {
            if (nes.style.display === "block") nes.style.display = "none";
            else nes.style.display = "block";
        } else console.log("toggleCollapsible: nextElementSibling is not an HTMLDivElement");
    } else console.log("toggleCollapsible: nextElementSibling is null");
}
function $341c675b659c6d43$export$4e9ec2b27757d9dd(type, id, componentMargin, divMargin, func, value, labelTextContent) {
    let div = $341c675b659c6d43$export$78253536c0178a32(undefined, divMargin);
    let input = $341c675b659c6d43$export$cef1adc173ab7099(type, id, componentMargin, func, value);
    let label = $341c675b659c6d43$export$f2839682b8c07f35(labelTextContent, componentMargin);
    label.htmlFor = id;
    div.appendChild(label);
    div.appendChild(input);
    return div;
}
function $341c675b659c6d43$export$cef1adc173ab7099(type, id, margin, func, value) {
    let input = $341c675b659c6d43$export$d80fffb1deb3b97e(type, id, margin);
    input.onchange = func;
    input.value = value;
    $341c675b659c6d43$export$d43d96a9a8ad3e51(input);
    return input;
}
function $341c675b659c6d43$export$d80fffb1deb3b97e(type, id, margin) {
    let input = document.createElement('input');
    input.type = type;
    input.id = id;
    Object.assign(input.style, margin);
    input.style.fontSize = '1em'; // Set the font size with a relative unit.
    input.classList.add('auto-width');
    return input;
}
function $341c675b659c6d43$export$60fee6710ef6fb16(id, componentMargin, divMargin, func, value, labelTextContent) {
    let div = $341c675b659c6d43$export$78253536c0178a32(undefined, divMargin);
    let ta = $341c675b659c6d43$export$857bcd29dc5afb77(id, componentMargin, func, value);
    let label = $341c675b659c6d43$export$f2839682b8c07f35(labelTextContent, componentMargin);
    label.htmlFor = id;
    div.appendChild(label);
    div.appendChild(ta);
    return div;
}
function $341c675b659c6d43$export$857bcd29dc5afb77(id, margin, func, value) {
    let ta = $341c675b659c6d43$export$5b32cb28d9a29894(id, margin);
    ta.onchange = func;
    ta.value = value;
    $341c675b659c6d43$export$c5eaaac137ef25d0(ta);
    return ta;
}
function $341c675b659c6d43$export$5b32cb28d9a29894(id, margin) {
    let ta = document.createElement('textarea');
    ta.id = id;
    Object.assign(ta.style, margin);
    ta.style.fontSize = '1em'; // Set the font size with a relative unit.
    ta.classList.add('auto-width');
    return ta;
}
function $341c675b659c6d43$export$ff083c49da8fe0f9(attributes, tagName) {
    let s = "<" + tagName;
    if (attributes) for (let [key, value] of attributes)s += " " + key + "=\"" + value + "\"";
    return s + " />";
}
function $341c675b659c6d43$export$d43d96a9a8ad3e51(i, minSize) {
    if (minSize == undefined) minSize = 4;
    i.style.width = i.value.length + minSize + "ch";
}
function $341c675b659c6d43$export$fdd146df37959fe8(s, minSize) {
    if (minSize == undefined) minSize = 6;
    s.style.width = s.value.length + minSize + "ch";
}
function $341c675b659c6d43$export$c5eaaac137ef25d0(ta, minSize) {
    if (minSize == undefined) minSize = 6;
    ta.style.width = ta.value.length + minSize + "ch";
}
function $341c675b659c6d43$export$b89bf4b169286865(options, name, value, id, margin) {
    let select = document.createElement('select');
    options.forEach((option)=>{
        select.name = name;
        select.id = id;
        let optionElement = document.createElement('option');
        optionElement.value = option;
        optionElement.text = option;
        select.appendChild(optionElement);
    });
    select.value = value;
    select.style.fontSize = '1em'; // Set the font size with a relative unit.
    select.classList.add('auto-width');
    $341c675b659c6d43$export$fdd146df37959fe8(select);
    Object.assign(select.style, margin);
    return select;
}
function $341c675b659c6d43$export$4c3eba01cd3c5ba4(textContent, options, name, value, id, componentMargin, divMargin) {
    let div = $341c675b659c6d43$export$78253536c0178a32(id, divMargin);
    let label = $341c675b659c6d43$export$f2839682b8c07f35(textContent, componentMargin);
    div.appendChild(label);
    div.appendChild($341c675b659c6d43$export$b89bf4b169286865(options, name, value, (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(id, $341c675b659c6d43$export$8797b0c8298d191), componentMargin));
    return div;
}
function $341c675b659c6d43$export$9b6d6ca62970729f(textContent, id, margin) {
    let button = document.createElement('button');
    button.textContent = textContent;
    if (id != undefined) button.id = id;
    if (margin != undefined) Object.assign(button.style, margin);
    button.style.fontSize = '1em'; // Set the font size with a relative unit.
    return button;
}
function $341c675b659c6d43$export$717b1c3df34dc89e(labeltext, textContent, id, componentMargin, divMargin) {
    let div = $341c675b659c6d43$export$78253536c0178a32(undefined, divMargin);
    let label = $341c675b659c6d43$export$f2839682b8c07f35(labeltext, componentMargin);
    label.htmlFor = id;
    Object.assign(label.style, componentMargin);
    div.appendChild(label);
    div.appendChild($341c675b659c6d43$export$9b6d6ca62970729f(textContent, id, componentMargin));
    return div;
}
function $341c675b659c6d43$export$331ff980f0d45cff(id, margin) {
    let div = document.createElement("div");
    if (id != undefined) div.id = id;
    if (margin != undefined) Object.assign(div.style, margin);
    return div;
}
function $341c675b659c6d43$export$78253536c0178a32(id, margin) {
    let div = $341c675b659c6d43$export$331ff980f0d45cff(id, margin);
    div.style.display = 'flex';
    div.style.flexWrap = 'wrap';
    //div.classList.add('auto-width-flex');
    return div;
}
function $341c675b659c6d43$export$f2839682b8c07f35(textContent, margin) {
    let label = document.createElement("label");
    Object.assign(label.style, margin);
    label.textContent = textContent;
    label.style.fontSize = '1em'; // Set the font size with a relative unit.
    return label;
}
function $341c675b659c6d43$export$33bbb3ec7652e187(id, margin) {
    let table = document.createElement('table');
    table.id = id;
    Object.assign(table.style, margin);
    return table;
}
function $341c675b659c6d43$export$6c1065e21382520d(table, content) {
    let thead = table.createTHead();
    let headerRow = thead.insertRow();
    content.forEach((c)=>{
        let th = document.createElement("th");
        th.textContent = c;
        headerRow.appendChild(th);
    });
    return headerRow;
}
function $341c675b659c6d43$export$67d0e2fae00985e1(table, content) {
    let row = table.insertRow();
    content.forEach((c)=>{
        row.insertCell().textContent = c;
    });
    return row;
}



function $057fa7562ec736a9$export$735ee1799fd02602(xml, name) {
    let v = xml.getAttribute(name);
    if (!v) throw new Error(name + ' attribute not found');
    return v;
}
function $057fa7562ec736a9$export$91e73a91db22e6a2(element, tagName) {
    let el = element.getElementsByTagName(tagName)[0];
    if (el == null) throw new Error(tagName + ' element not found');
    return el;
}
function $057fa7562ec736a9$export$4e07613bf412feb7(element) {
    let cn = element.childNodes;
    if (cn == null) throw new Error('Element has no childNodes');
    return cn[0];
}
function $057fa7562ec736a9$export$13cb40e9b656ab9e(node) {
    let nodeValue = node.nodeValue;
    if (nodeValue == null) throw new Error('nodeValue is null');
    return nodeValue;
}
function $057fa7562ec736a9$export$433c819efd6b1ea5(e) {
    let s;
    let firstChildNode = $057fa7562ec736a9$export$4e07613bf412feb7(e);
    if (firstChildNode) s = $057fa7562ec736a9$export$13cb40e9b656ab9e(firstChildNode).trim();
    else s = "";
    return s;
}
class $057fa7562ec736a9$export$3288d34c523a1192 {
    /**
     * @param tagName The tag name.
     */ constructor(tagName){
        this.tagName = tagName;
    }
    /**
     * Get an XML like representation that instead of having a closing tag is a self closing tag.
     * Whilst not strictly XML, some consider self closing tags as XML.
     * @param padding The padding (optional).
     * @returns A self closing tag.
     */ toXML(padding) {
        let s = (0, $341c675b659c6d43$export$ff083c49da8fe0f9)(undefined, this.tagName);
        if (padding) return "\n" + padding + s;
        return s;
    }
}
class $057fa7562ec736a9$export$ca4ceee82ec565dc extends $057fa7562ec736a9$export$3288d34c523a1192 {
    /**
     * @param attributes The attributes.
     */ constructor(attributes, tagName){
        super(tagName);
        this.attributes = attributes;
    }
    /**
     * @returns A string representation.
     */ toString() {
        let r = this.tagName + `(`;
        if (this.attributes) this.attributes.forEach((value, key)=>{
            r += `${key}(${value}), `;
        });
        return r;
    }
    /**
     * Get an XML like representation that instead of having a closing tag is a self closing tag.
     * These are allowed and perhaps expected in MESMER XML format.
     * @param {string} padding The padding (Optional).
     * @returns An XML like representation.
     */ toXML(padding) {
        let s = "";
        if (padding != undefined) s += "\n" + padding;
        s += '<' + this.tagName;
        for (let [k, v] of this.attributes)s += ' ' + k + '="' + v.toString() + '"';
        return s + ' />';
    }
}
class $057fa7562ec736a9$export$8f67221c6fb2ad09 extends $057fa7562ec736a9$export$ca4ceee82ec565dc {
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, tagName, value){
        super(attributes, tagName);
        this.value = value;
    }
    /**
     * @returns A string representation.
     */ toString() {
        return super.toString() + `, ${this.value.toString()})`;
    }
    /**
     * Get the XML representation.
     * @param padding The padding (Optional).
     * @returns An XML representation.
     */ toXML(padding) {
        return $057fa7562ec736a9$export$dad497fe1f6e27c0(this.value.trim(), this.tagName, this.attributes, padding, false);
    }
}
class $057fa7562ec736a9$export$82583fad49645fc9 extends $057fa7562ec736a9$export$ca4ceee82ec565dc {
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, tagName, value){
        super(attributes, tagName);
        this.value = value;
    }
    /**
     * @returns A string representation.
     */ toString() {
        return super.toString() + `, ${this.value.toString()})`;
    }
    /**
     * Get the XML representation.
     * @param padding The padding (Optional).
     * @returns An XML representation.
     */ toXML(padding) {
        return $057fa7562ec736a9$export$dad497fe1f6e27c0(this.value.toString(), this.tagName, this.attributes, padding, false);
    }
}
class $057fa7562ec736a9$export$38d8ebe2767f8865 extends $057fa7562ec736a9$export$ca4ceee82ec565dc {
    /**
     * @param attributes The attributes.
     * @param tagName The tag name.
     * @param values The values.
     * @param delimiter The delimiter of the values (Optional - default will be ",").
     */ constructor(attributes, tagName, values, delimiter){
        super(attributes, tagName), /**
     * The delimiter of the values.
     */ this.delimiter = " ";
        this.values = values;
        if (delimiter != undefined) this.delimiter = delimiter;
    }
    /**
     * @returns The values.
     */ getValues() {
        return this.values;
    }
    /**
     * @returns A string representation.
     */ setValues(values) {
        this.values = values;
    }
    /**
     * @returns A string representation.
     */ toString() {
        return super.toString() + `, ${this.values.toString()})`;
    }
    /**
     * Set the delimiter.
     * @param delimiter The delimiter.
     */ setDelimiter(delimiter) {
        this.delimiter = delimiter;
    }
    /**
     * Get the XML representation.
     * @param padding The padding (Optional).
     * @returns An XML representation.
     */ toXML(padding) {
        return $057fa7562ec736a9$export$dad497fe1f6e27c0((0, $93b71ab6968650c1$export$dba422ef505af222)(this.values, this.delimiter), this.tagName, this.attributes, padding, false);
    }
}
class $057fa7562ec736a9$export$bd431b64ad3b0433 extends $057fa7562ec736a9$export$ca4ceee82ec565dc {
    /**
     * @param attributes The attributes.
     * @param tagName The tag name.
     */ constructor(attributes, tagName){
        super(attributes, tagName);
        this.nodes = new Map();
    }
    /**
     * Add a node.
     * @param {Tag | TagWithAttributes | NodeWithNodes} node The node.
     * @returns The index of the node added.
     */ addNode(node) {
        this.nodes.set(this.nodes.size, node);
    }
    /**
     * @returns A string representation.
     */ toString() {
        let s = super.toString();
        this.nodes.forEach((v, k)=>{
            s += `, ${v.toString()}`;
        });
        return s + ")";
    }
    /**
     * Get the XML representation.
     * @param pad The pad (Optional).
     * @param padding The padding (Optional).
     * @returns An XML representation.
     */ toXML(pad, padding) {
        let padding1;
        if (pad != undefined && padding != undefined) padding1 = padding + pad;
        let s = "";
        if (this.nodes.size > 0) {
            let i = 0;
            this.nodes.forEach((v)=>{
                if (v == undefined) console.warn("Node " + i.toString() + " is undefined this.nodes.size = " + this.nodes.size);
                else {
                    if (v instanceof $057fa7562ec736a9$export$bd431b64ad3b0433) s += v.toXML(pad, padding1);
                    else if (v instanceof $057fa7562ec736a9$export$ca4ceee82ec565dc) s += v.toXML(padding1);
                    else s += v.toXML(padding1);
                }
                i++;
            });
            return $057fa7562ec736a9$export$dad497fe1f6e27c0(s, this.tagName, this.attributes, padding, true);
        } else {
            let s = (0, $341c675b659c6d43$export$ff083c49da8fe0f9)(this.attributes, this.tagName);
            if (padding != undefined) return "\n" + padding + s;
            return s;
        }
    }
}
function $057fa7562ec736a9$export$2cd488e9ab180ce2(tagName, attributes, padding) {
    let s = "";
    if (padding != undefined) s += "\n" + padding;
    s += '<' + tagName;
    if (attributes) for (let [k, v] of attributes)s += ' ' + k + '="' + v.toString() + '"';
    return s + '>';
}
function $057fa7562ec736a9$export$34b7e1ae786b72b0(tagName, padding, padValue) {
    let s = "";
    if (padValue) {
        if (padding != undefined) s += "\n" + padding;
    }
    return s + '</' + tagName + '>';
}
function $057fa7562ec736a9$export$dad497fe1f6e27c0(content, tagName, attributes, padding, padValue) {
    let startTag = $057fa7562ec736a9$export$2cd488e9ab180ce2(tagName, attributes, padding);
    let endTag = $057fa7562ec736a9$export$34b7e1ae786b72b0(tagName, padding, padValue);
    return startTag + content + endTag;
}
function $057fa7562ec736a9$export$fe94072fee8a6976(element) {
    let attributeNames = element.getAttributeNames();
    let attributes = new Map();
    attributeNames.forEach(function(attributeName) {
        let attributeValue = element.getAttribute(attributeName);
        if (attributeValue != null) attributes.set(attributeName.trim(), attributeValue.trim());
    });
    return attributes;
}
function $057fa7562ec736a9$export$b7531b8ff18dc588(xml, tagName) {
    let e = xml.getElementsByTagName(tagName);
    if (e.length != 1) throw new Error("Expecting 1 " + tagName + " but finding " + e.length);
    return e[0];
}








class $012df152aa25e440$export$877cee35188549c7 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * Tag name.
     */ this.tagName = 'me:eigenvalue';
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes, value){
        super(attributes, $012df152aa25e440$export$877cee35188549c7.tagName, value);
    }
}
class $012df152aa25e440$export$f681829d43cbf50e extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * Tag name.
     */ this.tagName = 'me:eigenvalueList';
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes, eigenvalues){
        super(attributes, $012df152aa25e440$export$f681829d43cbf50e.tagName);
        if (eigenvalues) eigenvalues.forEach((eigenvalue)=>{
            this.addNode(eigenvalue);
        });
    }
    /**
     * Add an eigenvalue.
     */ addEigenvalue(e) {
        this.addNode(e);
    }
}
class $012df152aa25e440$export$910c21a5819ebc2e extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * Tag name.
     */ this.tagName = 'me:pop';
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $012df152aa25e440$export$910c21a5819ebc2e.tagName, value);
    }
}
class $012df152aa25e440$export$9764fff2991ff94a extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * Tag name.
     */ this.tagName = 'me:population';
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes, pops){
        super(attributes, $012df152aa25e440$export$9764fff2991ff94a.tagName);
    }
    /**
     * Add a pop.
     */ addPop(p) {
        this.addNode(p);
    }
}
class $012df152aa25e440$export$8f9a53be9a409418 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * Tag name.
     */ this.tagName = 'me:populationList';
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes, populations){
        super(attributes, $012df152aa25e440$export$8f9a53be9a409418.tagName);
        if (populations) populations.forEach((population)=>{
            this.addNode(population);
        });
    }
    /**
     * Add a population.
     */ addPopulation(p) {
        this.addNode(p);
    }
}
class $012df152aa25e440$export$2450ca15ad4d2ed0 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * Tag name.
     */ this.tagName = 'me:firstOrderLoss';
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $012df152aa25e440$export$2450ca15ad4d2ed0.tagName, value);
    }
}
class $012df152aa25e440$export$984142e8329468e6 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * Tag name.
     */ this.tagName = 'me:firstOrderRate';
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $012df152aa25e440$export$984142e8329468e6.tagName, value);
    }
}
class $012df152aa25e440$export$f449a9e759d0ecf8 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * Tag name.
     */ this.tagName = 'me:secondOrderRate';
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $012df152aa25e440$export$f449a9e759d0ecf8.tagName, value);
    }
}
class $012df152aa25e440$export$9cdf0fcb7c05190f extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * Tag name.
     */ this.tagName = 'me:rateList';
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes, firstOrderLosses, firstOrderRates, secondOrderRates){
        super(attributes, $012df152aa25e440$export$9cdf0fcb7c05190f.tagName);
        this.index = new Map();
        this.folIndex = new Map();
        if (firstOrderLosses) {
            let i = 0;
            firstOrderLosses.forEach((fol)=>{
                this.index.set($012df152aa25e440$export$2450ca15ad4d2ed0.tagName + i.toString(), this.nodes.size);
                this.folIndex.set(this.folIndex.size, this.nodes.size);
                this.addNode(fol);
                i++;
            });
            this.fols = firstOrderLosses;
        } else this.fols = [];
        this.forIndex = new Map();
        if (firstOrderRates) {
            let i = 0;
            firstOrderRates.forEach((forr)=>{
                this.index.set($012df152aa25e440$export$984142e8329468e6.tagName + i.toString(), this.nodes.size);
                this.forIndex.set(this.forIndex.size, this.nodes.size);
                this.addNode(forr);
                i++;
            });
            this.fors = firstOrderRates;
        } else this.fors = [];
        this.sorIndex = new Map();
        if (secondOrderRates) {
            let i = 0;
            secondOrderRates.forEach((sor)=>{
                this.index.set($012df152aa25e440$export$f449a9e759d0ecf8.tagName + i.toString(), this.nodes.size);
                this.sorIndex.set(this.sorIndex.size, this.nodes.size);
                this.addNode(sor);
                i++;
            });
            this.sors = secondOrderRates;
        } else this.sors = [];
    }
    /**
     * Set temperature.
     * @param T The temperature.
     */ setTemperature(T) {
        this.attributes.set('T', T.toString());
    }
    /**
     * Set concentration.
     * @param conc The concentration.
     */ setConcentration(conc) {
        this.attributes.set('conc', conc.toString());
    }
    /**
     * Set bath gas.
     * @param bathGas The bath gas.
     */ setBathGas(bathGas) {
        this.attributes.set('bathGas', bathGas);
    }
    /**
     * Set units.
     * @param units The units.
     */ setUnits(units) {
        this.attributes.set('units', units);
    }
    /**
     * Add a first order loss.
     */ addFirstOrderLoss(f) {
        this.folIndex.set(this.folIndex.size, this.nodes.size);
        this.index.set($012df152aa25e440$export$2450ca15ad4d2ed0.tagName + this.folIndex.size.toString(), this.nodes.size);
        this.fols.push(f);
        this.addNode(f);
    }
    /**
     * Add a first order rate.
     */ addFirstOrderRate(f) {
        this.forIndex.set(this.forIndex.size, this.nodes.size);
        this.index.set($012df152aa25e440$export$984142e8329468e6.tagName + this.forIndex.size.toString(), this.nodes.size);
        this.fors.push(f);
        this.addNode(f);
    }
    /**
     * Add a second order rate.
     */ addSecondOrderRate(s) {
        this.sorIndex.set(this.sorIndex.size, this.nodes.size);
        this.index.set($012df152aa25e440$export$f449a9e759d0ecf8.tagName + this.sorIndex.size.toString(), this.nodes.size);
        this.sors.push(s);
        this.addNode(s);
    }
}
class $012df152aa25e440$export$c4c153dc94cc96b4 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * Tag name.
     */ this.tagName = 'me:analysis';
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes, description, els, pls, rls){
        super(attributes, $012df152aa25e440$export$9cdf0fcb7c05190f.tagName);
        this.index = new Map();
        if (description) {
            this.index.set((0, $ccef02370f58a770$export$393edc798c47379d).tagName, this.nodes.size);
            this.addNode(description);
        }
        this.elIndex = new Map();
        if (els) {
            els.forEach((el)=>{
                this.index.set($012df152aa25e440$export$f681829d43cbf50e.tagName, this.nodes.size);
                this.elIndex.set(this.elIndex.size, this.nodes.size);
                this.addNode(el);
            });
            this.els = els;
        } else this.els = [];
        this.plIndex = new Map();
        if (pls) {
            pls.forEach((pl)=>{
                this.index.set($012df152aa25e440$export$8f9a53be9a409418.tagName, this.nodes.size);
                this.plIndex.set(this.plIndex.size, this.nodes.size);
                this.addNode(pl);
            });
            this.pls = pls;
        } else this.pls = [];
        this.rlIndex = new Map();
        if (rls) {
            rls.forEach((rl)=>{
                this.index.set($012df152aa25e440$export$9cdf0fcb7c05190f.tagName, this.nodes.size);
                this.rlIndex.set(this.rlIndex.size, this.nodes.size);
                this.addNode(rl);
            });
            this.rls = rls;
        } else this.rls = [];
    }
    /**
     * Get the description.
     */ getDescription() {
        if (this.index.has((0, $ccef02370f58a770$export$393edc798c47379d).tagName)) {
            let i = this.index.get((0, $ccef02370f58a770$export$393edc798c47379d).tagName);
            return this.nodes.get(i);
        }
    }
    /**
     * @param description The description.
     */ setDescription(description) {
        if (this.index.has((0, $ccef02370f58a770$export$393edc798c47379d).tagName)) {
            let i = this.index.get((0, $ccef02370f58a770$export$393edc798c47379d).tagName);
            this.nodes.set(i, description);
        } else {
            this.index.set((0, $ccef02370f58a770$export$393edc798c47379d).tagName, this.nodes.size);
            this.addNode(description);
        }
    }
    /**
     * @param eigenvalueList The eigenvalue list.
     */ addEigenvalueList(eigenvalueList) {
        this.elIndex.set(this.elIndex.size, this.nodes.size);
        this.addNode(eigenvalueList);
        this.els.push(eigenvalueList);
    }
    /**
     * @param populationList The population list.
     */ addPopulationList(populationList) {
        this.plIndex.set(this.plIndex.size, this.nodes.size);
        this.addNode(populationList);
        this.pls.push(populationList);
    }
    /**
     * @param rateList The rate list.
     */ addRateList(rateList) {
        this.rlIndex.set(this.rlIndex.size, this.nodes.size);
        this.addNode(rateList);
        this.rls.push(rateList);
    }
}




class $5b710835528e7170$export$b33a132661f4be58 extends (0, $057fa7562ec736a9$export$8f67221c6fb2ad09) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:bathGas";
    }
    /**
     * @param attributes The attributes.
     * @param moleculeID The moleculeID.
     */ constructor(attributes, moleculeID){
        super(attributes, $5b710835528e7170$export$b33a132661f4be58.tagName, moleculeID);
    }
}
class $5b710835528e7170$export$cdeafdd1d936ed5b extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:experimentalRate";
    }
    static{
        /**
     * The key to the ref1 attribute value.
     */ this.s_ref1 = "ref1";
    }
    static{
        /**
     * The key to the ref2 attribute value.
     */ this.s_ref2 = "ref2";
    }
    static{
        /**
     * The key to the refReaction attribute value.
     */ this.s_refReaction = "refReaction";
    }
    static{
        /**
     * The key to the error attribute value.
     */ this.s_error = "error";
    }
    /**
     * @param attributes The attributes. 
     * @param value The value. 
     */ constructor(attributes, value){
        super(attributes, $5b710835528e7170$export$cdeafdd1d936ed5b.tagName, value);
    /*
        if (!this.attributes.has(ExperimentalRate.s_ref1)) {
            console.error("ExperimentalRate.constructor: ref1 attribute is missing.");
        }
        if (!this.attributes.has(ExperimentalRate.s_ref2)) {
            console.error("ExperimentalRate.constructor: ref2 attribute is missing.");
        }
        if (!this.attributes.has(ExperimentalRate.s_refReaction)) {
            console.error("ExperimentalRate.constructor: refReaction attribute is missing.");
        }
        if (!this.attributes.has(ExperimentalRate.s_error)) {
            console.error("ExperimentalRate.constructor: error attribute is missing.");
        }
        */ }
    /**
     * @returns The ref1 attribute or undefined if there is no ref1 attribute.
     */ getRef1() {
        return this.attributes.get($5b710835528e7170$export$cdeafdd1d936ed5b.s_ref1);
    }
    /**
     * Set the ref1 attribute.
     * @param ref1 The ref1.
     */ setRef1(ref1) {
        this.attributes.set($5b710835528e7170$export$cdeafdd1d936ed5b.s_ref1, ref1);
    }
    /**
     * @returns The ref2 attribute or undefined if there is no ref2 attribute.
     */ getRef2() {
        return this.attributes.get($5b710835528e7170$export$cdeafdd1d936ed5b.s_ref2);
    }
    /**
     * Set the ref2 attribute.
     * @param ref2 The ref2.
     */ setRef2(ref2) {
        this.attributes.set($5b710835528e7170$export$cdeafdd1d936ed5b.s_ref2, ref2);
    }
    /**
     * @returns The refReaction attribute or undefined if there is no refReaction attribute.
     */ getRefReaction() {
        return this.attributes.get($5b710835528e7170$export$cdeafdd1d936ed5b.s_refReaction);
    }
    /**
     * Set the refReaction attribute.
     * @param refReaction The refReaction.
     */ setRefReaction(refReaction) {
        this.attributes.set($5b710835528e7170$export$cdeafdd1d936ed5b.s_refReaction, refReaction);
    }
    /**
     * @returns The error attribute or undefined if there is no error attribute.
     */ getError() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(this.attributes.get($5b710835528e7170$export$cdeafdd1d936ed5b.s_error));
    }
    /**
     * Set the error attribute.
     * @param error The error.
     */ setError(error) {
        this.attributes.set($5b710835528e7170$export$cdeafdd1d936ed5b.s_error, error.toString());
    }
}
class $5b710835528e7170$export$c291f4faacd745a6 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:experimentalYield";
    }
    static{
        /**
     * The key to the ref attribute value.
     */ this.s_ref = "ref";
    }
    static{
        /**
     * The key to the error attribute value.
     */ this.s_error = "error";
    }
    static{
        /**
     * The key to the yieldTime attribute value.
     */ this.s_yieldTime = "yieldTime";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $5b710835528e7170$export$c291f4faacd745a6.tagName, value);
    }
    /**
     * @returns The ref attribute or undefined if there is no ref attribute.
     */ getRef() {
        return this.attributes.get($5b710835528e7170$export$c291f4faacd745a6.s_ref);
    }
    /**
     * Set the ref attribute.
     * @param ref The ref.
     */ setRef(ref) {
        this.attributes.set($5b710835528e7170$export$c291f4faacd745a6.s_ref, ref);
    }
    /**
     * @returns The error attribute or undefined if there is no error attribute.
     */ getError() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(this.attributes.get($5b710835528e7170$export$c291f4faacd745a6.s_error));
    }
    /**
     * Set the error attribute.
     * @param error The error.
     */ setError(error) {
        this.attributes.set($5b710835528e7170$export$c291f4faacd745a6.s_error, error.toString());
    }
    /**
     * @returns The yieldTime attribute or undefined if there is no yieldTime attribute.
     */ getYieldTime() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(this.attributes.get($5b710835528e7170$export$c291f4faacd745a6.s_yieldTime));
    }
    /**
     * Set the yieldTime attribute.
     * @param yieldTime The yieldTime.
     */ setYieldTime(yieldTime) {
        this.attributes.set($5b710835528e7170$export$c291f4faacd745a6.s_yieldTime, yieldTime.toString());
    }
}
class $5b710835528e7170$export$ed9dfbc127680fd1 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
    * The tag name.
    */ this.tagName = "me:experimentalEigenvalue";
    }
    static{
        /**
     * The key to the EigenvalueID attribute value.
     */ this.s_EigenvalueID = "EigenvalueID";
    }
    static{
        /**
     * The key to the error attribute value.
     */ this.s_error = "error";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $5b710835528e7170$export$ed9dfbc127680fd1.tagName, value);
    /*
        if (!this.attributes.has(ExperimentalEigenvalue.s_EigenvalueID)) {
            console.error("ExperimentalEigenvalue.constructor: EigenvalueID attribute is missing.");
        }
        if (!this.attributes.has(ExperimentalEigenvalue.s_error)) {
            console.error("ExperimentalEigenvalue.constructor: error attribute is missing.");
        }
        */ }
    /**
     * @returns The EigenvalueID attribute.
     */ getEigenvalueID() {
        return this.attributes.get($5b710835528e7170$export$ed9dfbc127680fd1.s_EigenvalueID);
    }
    /**
     * Set the EigenvalueID attribute.
     * @param EigenvalueID The EigenvalueID.
     */ setEigenvalueID(EigenvalueID) {
        this.attributes.set($5b710835528e7170$export$ed9dfbc127680fd1.s_EigenvalueID, EigenvalueID);
    }
    /**
     * @returns The error attribute or undefined if there is no error attribute.
     */ getError() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(this.attributes.get($5b710835528e7170$export$ed9dfbc127680fd1.s_error));
    }
    /**
     * Set the error attribute.
     * @param error The error.
     */ setError(error) {
        this.attributes.set($5b710835528e7170$export$ed9dfbc127680fd1.s_error, error.toString());
    }
}
class $5b710835528e7170$export$284227145ed02b04 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:excessReactantConc";
    }
    static{
        /**
     * The key to the percent attribute value.
     */ this.s_percent = "percent";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $5b710835528e7170$export$284227145ed02b04.tagName, value);
    }
    /**
     * @returns The percent attribute or undefined if there is no percent attribute.
     */ getPercent() {
        return this.attributes.get($5b710835528e7170$export$284227145ed02b04.s_percent);
    }
    /**
     * Set the percent attribute.
     * @param percent The percent.
     */ setPercent(percent) {
        this.attributes.set($5b710835528e7170$export$284227145ed02b04.s_percent, percent);
    }
}
class $5b710835528e7170$export$3fe97ecb6b172244 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:PTpair";
    }
    static{
        /**
     * The key to the P attribute value.
     */ this.s_P = "P";
    }
    static{
        /**
     * The key to the T attribute value.
     */ this.s_T = "T";
    }
    static{
        /**
     * The key to the precision attribute value.
     */ this.s_precision = "precision";
    }
    static{
        /**
     * The key to the excessReactantConc attribute value.
     */ this.s_excessReactantConc = "excessReactantConc";
    }
    static{
        /**
     * The key to the percentExcessReactantConc attribute value.
     */ this.s_percentExcessReactantConc = "percentExcessReactantConc";
    }
    /**
     * @param attributes The attributes.
     * @param bathGas The bath gas.
     * @param experimentRate The experiment rate.
     */ constructor(attributes, bathGas, experimentRate, experimentalYield, experimentalEigenvalue){
        super(attributes, $5b710835528e7170$export$3fe97ecb6b172244.tagName);
        this.index = new Map();
        if (bathGas != undefined) {
            this.index.set($5b710835528e7170$export$b33a132661f4be58.tagName, this.nodes.size);
            this.addNode(bathGas);
        }
        if (experimentRate != undefined) {
            this.index.set($5b710835528e7170$export$cdeafdd1d936ed5b.tagName, this.nodes.size);
            this.addNode(experimentRate);
        }
        if (experimentalYield != undefined) {
            this.index.set($5b710835528e7170$export$c291f4faacd745a6.tagName, this.nodes.size);
            this.addNode(experimentalYield);
        }
        if (experimentalEigenvalue != undefined) {
            this.index.set($5b710835528e7170$export$ed9dfbc127680fd1.tagName, this.nodes.size);
            this.addNode(experimentalEigenvalue);
        }
    }
    /**
     * @returns The Pressure.
     */ getP() {
        let p = this.attributes.get($5b710835528e7170$export$3fe97ecb6b172244.s_P);
        if (p !== undefined) return new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(p);
    }
    /**
     * Set The Pressure
     */ setP(p) {
        this.attributes.set($5b710835528e7170$export$3fe97ecb6b172244.s_P, p.toString());
    }
    /**
     * @returns The Temperature.
     */ getT() {
        let t = this.attributes.get($5b710835528e7170$export$3fe97ecb6b172244.s_T);
        if (t !== undefined) return new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(t);
    }
    /**
     * Set The Temperature.
     */ setT(t) {
        this.attributes.set($5b710835528e7170$export$3fe97ecb6b172244.s_T, t.toString());
    }
    /**
     * @returns The precision attribute or undefined if there is no precision attribute.
     */ getPrecision() {
        return this.attributes.get($5b710835528e7170$export$3fe97ecb6b172244.s_precision);
    }
    /**
     * Set the precision attribute.
     * @param precision The precision.
     */ setPrecision(precision) {
        this.attributes.set($5b710835528e7170$export$3fe97ecb6b172244.s_precision, precision);
    }
    /**
     * @returns The bath gas.
     */ getBathGas() {
        let i = this.index.get($5b710835528e7170$export$b33a132661f4be58.tagName);
        if (i != undefined) return this.nodes.get(i);
        else return undefined;
    }
    /**
     * @param bathGas The bath gas.
     */ setBathGas(bathGas) {
        let i = this.index.get($5b710835528e7170$export$b33a132661f4be58.tagName);
        if (i != undefined) this.nodes.set(i, bathGas);
        else {
            this.index.set($5b710835528e7170$export$b33a132661f4be58.tagName, this.nodes.size);
            this.addNode(bathGas);
        }
    }
    /**
     * Remove the bath gas.
     */ removeBathGas() {
        let i = this.index.get($5b710835528e7170$export$b33a132661f4be58.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($5b710835528e7170$export$b33a132661f4be58.tagName);
        }
    }
    /**
     * @returns The experiment rate.
     */ getExperimentalRate() {
        let i = this.index.get($5b710835528e7170$export$cdeafdd1d936ed5b.tagName);
        if (i != undefined) return this.nodes.get(i);
        else return undefined;
    }
    /**
     * @param experimentRate The experiment rate.
     */ setExperimentalRate(experimentRate) {
        let i = this.index.get($5b710835528e7170$export$cdeafdd1d936ed5b.tagName);
        if (i != undefined) this.nodes.set(i, experimentRate);
        else {
            this.index.set($5b710835528e7170$export$cdeafdd1d936ed5b.tagName, this.nodes.size);
            this.addNode(experimentRate);
        }
    }
    /**
     * Remove the experiment rate.
     */ removeExperimentalRate() {
        let i = this.index.get($5b710835528e7170$export$cdeafdd1d936ed5b.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($5b710835528e7170$export$cdeafdd1d936ed5b.tagName);
        }
    }
    /**
     * @returns The experimental yield.
     */ getExperimentalYield() {
        let i = this.index.get($5b710835528e7170$export$c291f4faacd745a6.tagName);
        if (i != undefined) return this.nodes.get(i);
        else return undefined;
    }
    /**
     * @param experimentalYield The experimental yield.
     */ setExperimentalYield(experimentalYield) {
        let i = this.index.get($5b710835528e7170$export$c291f4faacd745a6.tagName);
        if (i != undefined) this.nodes.set(i, experimentalYield);
        else {
            this.index.set($5b710835528e7170$export$c291f4faacd745a6.tagName, this.nodes.size);
            this.addNode(experimentalYield);
        }
    }
    /**
     * Remove the experimental yield.
     */ removeExperimentalYield() {
        let i = this.index.get($5b710835528e7170$export$c291f4faacd745a6.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($5b710835528e7170$export$c291f4faacd745a6.tagName);
        }
    }
    /**
     * @returns The experimental eigenvalue.
     */ getExperimentalEigenvalue() {
        let i = this.index.get($5b710835528e7170$export$ed9dfbc127680fd1.tagName);
        if (i != undefined) return this.nodes.get(i);
        else return undefined;
    }
    /**
     * @param experimentalEigenvalue The experimental eigenvalue.
     */ setExperimentalEigenvalue(experimentalEigenvalue) {
        let i = this.index.get($5b710835528e7170$export$ed9dfbc127680fd1.tagName);
        if (i != undefined) this.nodes.set(i, experimentalEigenvalue);
        else {
            this.index.set($5b710835528e7170$export$ed9dfbc127680fd1.tagName, this.nodes.size);
            this.addNode(experimentalEigenvalue);
        }
    }
    /**
     * Remove the experimental eigenvalue.
     */ removeExperimentalEigenvalue() {
        let i = this.index.get($5b710835528e7170$export$ed9dfbc127680fd1.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($5b710835528e7170$export$ed9dfbc127680fd1.tagName);
        }
    }
    /**
     * @returns this.attributes.get("excessReactantConc").
     */ getExcessReactantConc() {
        return this.attributes.get($5b710835528e7170$export$3fe97ecb6b172244.s_excessReactantConc);
    }
    /**
     * this.attributes.set("excessReactantConc", excessReactantConc).
     */ setExcessReactantConc(excessReactantConc) {
        this.attributes.set($5b710835528e7170$export$3fe97ecb6b172244.s_excessReactantConc, excessReactantConc);
    }
    /**
     * @returns this.attributes.get("percentExcessReactantConc").
     */ getPercentExcessReactantConc() {
        return this.attributes.get($5b710835528e7170$export$3fe97ecb6b172244.s_percentExcessReactantConc);
    }
    /**
     * this.attributes.set("percentExcessReactantConc", percentExcessReactantConc).
     */ setPercentExcessReactantConc(percentExcessReactantConc) {
        this.attributes.set($5b710835528e7170$export$3fe97ecb6b172244.s_percentExcessReactantConc, percentExcessReactantConc);
    }
}
class $5b710835528e7170$export$3be0efe793283834 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:PTs";
    }
    /**
     * @param attributes The attributes.
     * @param pTs The PTs.
     */ constructor(attributes, pTpairs){
        super(attributes, $5b710835528e7170$export$3be0efe793283834.tagName);
        if (pTpairs != undefined) {
            pTpairs.forEach((pTpair)=>{
                this.addNode(pTpair);
            });
            this.ptps = pTpairs;
        } else this.ptps = [];
    }
    /**
     * Get the PTpair at the given index.
     * 
     * @param i The index of the PTpair to return. 
     * @returns The PTpair at the given index or undefined if the index is out of range.
     */ get(i) {
        return this.ptps[i];
    }
    /**
     * Set the PTpair at the given index.
     * 
     * @param i The index.
     * @returns The PT pairs.
     */ set(i, pTpair) {
        this.nodes.set(i, pTpair);
        this.ptps[i] = pTpair;
    }
    /**
     * Add a PTpair.
     * 
     * @param pTPair The PTpair to add.
     * @returns The index of this.pTPairs where pTPair is added.
     */ add(pTpair) {
        this.addNode(pTpair);
        this.ptps.push(pTpair);
        return this.nodes.size - 1;
    }
    /**
     * Remove the PTpair at the given index.
     * 
     * @param i The index.
     */ remove(i) {
        this.nodes.delete(i);
        this.ptps.splice(i, 1);
    }
    /**
     * Initialise.
     * 
     * @param pTPair The PTpair to add.
     */ init(ptps) {
        this.clear();
        ptps.forEach((ptp)=>{
            this.addNode(ptp);
            this.ptps.push(ptp);
        });
    }
    /**
     * Clear.
     */ clear() {
        this.nodes.clear();
        this.ptps = [];
    }
}
class $5b710835528e7170$export$363c7374d425f4ad extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:conditions";
    }
    /**
     * @param attributes The attributes.
     * @param bathGases The bath gases.
     * @param pTs The PTs - the Pressure, Temperature, BathGas, ExperimentRate instances.
     */ constructor(attributes, id, bathGases, pTs){
        super(attributes, $5b710835528e7170$export$363c7374d425f4ad.tagName);
        this.id = id;
        this.index = new Map();
        this.bathGasesIndex = new Map();
        this.bathGases = new Map();
        if (bathGases != undefined) {
            this.index.set($5b710835528e7170$export$b33a132661f4be58.tagName, this.nodes.size);
            bathGases.forEach((bathGas)=>{
                this.bathGasesIndex.set(bathGas.value, this.nodes.size);
                this.addNode(bathGas);
                this.bathGases.set(bathGas, bathGases.size);
            });
        }
        if (pTs != undefined) {
            this.index.set($5b710835528e7170$export$3be0efe793283834.tagName, this.nodes.size);
            this.addNode(pTs);
        }
    }
    /**
     * @returns The bath gases.
     */ getBathGases() {
        return this.bathGases;
    }
    /**
     * @param bathGas The bath gas to add.
     */ addBathGas(bathGas) {
        if (!this.bathGases.has(bathGas)) {
            let index = this.bathGases.size;
            this.bathGases.set(bathGas, index);
            this.bathGasesIndex.set(bathGas.value, this.nodes.size);
            this.addNode(bathGas);
            return index;
        } else return this.bathGases.get(bathGas);
    }
    /**
     * @param bathGas The bath gas to remove.
     */ removeBathGas(bathGas) {
        if (this.bathGases.has(bathGas)) {
            this.bathGases.delete(bathGas);
            this.nodes.delete(this.bathGasesIndex.get(bathGas.value));
        } else console.warn("Conditions.removeBathGas: bathGas not found to remove.");
    }
    /**
     * @returns The Pressure and Temperature pairs.
     */ getPTs() {
        let i = this.index.get($5b710835528e7170$export$3be0efe793283834.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param pTs The PTs.
     */ setPTs(pTs) {
        let i = this.index.get($5b710835528e7170$export$3be0efe793283834.tagName);
        if (i != undefined) this.nodes.set(i, pTs);
        else {
            this.index.set($5b710835528e7170$export$3be0efe793283834.tagName, this.nodes.size);
            this.addNode(pTs);
        }
    }
}




class $085f2478c495b249$export$7d9247c9879133fb extends (0, $057fa7562ec736a9$export$3288d34c523a1192) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:calculateRateCoefficientsOnly";
    }
    constructor(){
        super($085f2478c495b249$export$7d9247c9879133fb.tagName);
    }
}
class $085f2478c495b249$export$60b233651e162b60 extends (0, $057fa7562ec736a9$export$3288d34c523a1192) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:printCellDOS";
    }
    constructor(){
        super($085f2478c495b249$export$60b233651e162b60.tagName);
    }
}
class $085f2478c495b249$export$7e63e5104be309ff extends (0, $057fa7562ec736a9$export$3288d34c523a1192) {
    static{
        /**
    * The tag name.
    */ this.tagName = "me:printCellTransitionStateFlux";
    }
    constructor(){
        super($085f2478c495b249$export$7e63e5104be309ff.tagName);
    }
}
class $085f2478c495b249$export$a915db169f144f37 extends (0, $057fa7562ec736a9$export$3288d34c523a1192) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:printReactionOperatorColumnSums";
    }
    constructor(){
        super($085f2478c495b249$export$a915db169f144f37.tagName);
    }
}
class $085f2478c495b249$export$e7fff349901f700d extends (0, $057fa7562ec736a9$export$3288d34c523a1192) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:printGrainBoltzmann";
    }
    constructor(){
        super($085f2478c495b249$export$e7fff349901f700d.tagName);
    }
}
class $085f2478c495b249$export$d23243bda4dfae2b extends (0, $057fa7562ec736a9$export$3288d34c523a1192) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:printGrainDOS";
    }
    constructor(){
        super($085f2478c495b249$export$d23243bda4dfae2b.tagName);
    }
}
class $085f2478c495b249$export$55888ef4e813a34d extends (0, $057fa7562ec736a9$export$3288d34c523a1192) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:printGrainkbE";
    }
    constructor(){
        super($085f2478c495b249$export$55888ef4e813a34d.tagName);
    }
}
class $085f2478c495b249$export$f8d814a406a0ff5b extends (0, $057fa7562ec736a9$export$3288d34c523a1192) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:printGrainkfE";
    }
    constructor(){
        super($085f2478c495b249$export$f8d814a406a0ff5b.tagName);
    }
}
class $085f2478c495b249$export$3627f2b606ffd3cb extends (0, $057fa7562ec736a9$export$3288d34c523a1192) {
    static{
        /**
    * The tag name.
    */ this.tagName = "me:printTSsos";
    }
    constructor(){
        super($085f2478c495b249$export$3627f2b606ffd3cb.tagName);
    }
}
class $085f2478c495b249$export$c5481d114fddc81c extends (0, $057fa7562ec736a9$export$3288d34c523a1192) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:printGrainedSpeciesProfile";
    }
    constructor(){
        super($085f2478c495b249$export$c5481d114fddc81c.tagName);
    }
}
class $085f2478c495b249$export$ec7c00ae1b17b2ab extends (0, $057fa7562ec736a9$export$3288d34c523a1192) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:printGrainTransitionStateFlux";
    }
    constructor(){
        super($085f2478c495b249$export$ec7c00ae1b17b2ab.tagName);
    }
}
class $085f2478c495b249$export$8420ab6988728a65 extends (0, $057fa7562ec736a9$export$3288d34c523a1192) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:printReactionOperatorSize";
    }
    constructor(){
        super($085f2478c495b249$export$8420ab6988728a65.tagName);
    }
}
class $085f2478c495b249$export$ed9b9e07e51c2ac1 extends (0, $057fa7562ec736a9$export$3288d34c523a1192) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:printSpeciesProfile";
    }
    constructor(){
        super($085f2478c495b249$export$ed9b9e07e51c2ac1.tagName);
    }
}
class $085f2478c495b249$export$9f7939759d8efd9f extends (0, $057fa7562ec736a9$export$3288d34c523a1192) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:printPhenomenologicalEvolution";
    }
    constructor(){
        super($085f2478c495b249$export$9f7939759d8efd9f.tagName);
    }
}
class $085f2478c495b249$export$fc99460819e23ac5 extends (0, $057fa7562ec736a9$export$3288d34c523a1192) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:printTunnelingCoefficients";
    }
    constructor(){
        super($085f2478c495b249$export$fc99460819e23ac5.tagName);
    }
}
class $085f2478c495b249$export$2f2eaac8983031ef extends (0, $057fa7562ec736a9$export$3288d34c523a1192) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:printCrossingCoefficients";
    }
    constructor(){
        super($085f2478c495b249$export$2f2eaac8983031ef.tagName);
    }
}
class $085f2478c495b249$export$a3d7e677521f681f extends (0, $057fa7562ec736a9$export$3288d34c523a1192) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:testDOS";
    }
    constructor(){
        super($085f2478c495b249$export$a3d7e677521f681f.tagName);
    }
}
class $085f2478c495b249$export$980e5abe9a459423 extends (0, $057fa7562ec736a9$export$3288d34c523a1192) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:testRateConstant";
    }
    constructor(){
        super($085f2478c495b249$export$980e5abe9a459423.tagName);
    }
}
class $085f2478c495b249$export$5d7dbeba4bf49655 extends (0, $057fa7562ec736a9$export$3288d34c523a1192) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:useTheSameCellNumberForAllConditions";
    }
    constructor(){
        super($085f2478c495b249$export$5d7dbeba4bf49655.tagName);
    }
}
class $085f2478c495b249$export$6ffea14bdffd427f extends (0, $057fa7562ec736a9$export$3288d34c523a1192) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:ForceMacroDetailedBalance";
    }
    constructor(){
        super($085f2478c495b249$export$6ffea14bdffd427f.tagName);
    }
}
class $085f2478c495b249$export$9d51752a8549e2d6 extends (0, $057fa7562ec736a9$export$3288d34c523a1192) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:hideInactive";
    }
    constructor(){
        super($085f2478c495b249$export$9d51752a8549e2d6.tagName);
    }
}
class $085f2478c495b249$export$f0bfd84d03c3a22d extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:calcMethod";
    }
    static{
        /**
     * The possible values.
     */ this.options = [
            "simpleCalc",
            "gridSearch",
            "fitting",
            "marquardt",
            "analyticalRepresentation",
            "ThermodynamicTable",
            "sensitivityAnalysis",
            "me:simpleCalc",
            "me:gridSearch",
            "me:fitting",
            "me:marquardt",
            "me:analyticalRepresentation",
            "me:ThermodynamicTable",
            "me:sensitivityAnalysis"
        ];
    }
    /**
     * @param value The value.
     */ constructor(attributes){
        super(attributes, $085f2478c495b249$export$f0bfd84d03c3a22d.tagName);
    }
}
class $085f2478c495b249$export$afd374542f6f3da6 extends $085f2478c495b249$export$f0bfd84d03c3a22d {
    static{
        /**
     * The xsi_type.
     */ this.xsi_type = "me:simpleCalc";
    }
    static{
        /**
     * The xsi_type2.
     */ this.xsi_type2 = "simpleCalc";
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes){
        super(attributes);
    }
}
class $085f2478c495b249$export$271191b096a55e63 extends $085f2478c495b249$export$f0bfd84d03c3a22d {
    static{
        /**
    * The xsi_type.
    */ this.xsi_type = "me:gridSearch";
    }
    static{
        /**
     * The xsi_type2.
     */ this.xsi_type2 = "gridSearch";
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes){
        super(attributes);
    }
}
class $085f2478c495b249$export$830a50cd13af6e84 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
    * The tag name.
    */ this.tagName = "me:fittingIterations";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$830a50cd13af6e84.tagName, value);
    }
}
class $085f2478c495b249$export$654b70df01671c79 extends $085f2478c495b249$export$f0bfd84d03c3a22d {
    static{
        /**
     * The xsi_type.
     */ this.xsi_type = "me:fitting";
    }
    static{
        /**
     * The xsi_type2.
     */ this.xsi_type2 = "fitting";
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes, fittingIterations){
        super(attributes);
        if (fittingIterations != undefined) this.addNode(fittingIterations);
    }
    /**
     * @returns The fittingIterations or undefined.
     */ getFittingIterations() {
        return this.nodes.get(0);
    }
    /**
     * @param fittingIterations The fittingIterations.
     */ setFittingIterations(fittingIterations) {
        this.nodes.set(0, fittingIterations);
    }
    /**
     * Remove the fittingIterations.
     */ removeFittingIterations() {
        this.nodes.delete(0);
    }
}
class $085f2478c495b249$export$9f699e98369d9591 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:MarquardtIterations";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$9f699e98369d9591.tagName, value);
    }
}
class $085f2478c495b249$export$ca1e6c3ff9fd3627 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:MarquardtTolerance";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$ca1e6c3ff9fd3627.tagName, value);
    }
}
class $085f2478c495b249$export$d3887b529debf19d extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:MarquardtDerivDelta";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$d3887b529debf19d.tagName, value);
    }
}
class $085f2478c495b249$export$7968aa666bcf62fa extends $085f2478c495b249$export$f0bfd84d03c3a22d {
    static{
        /**
     * The tag name.
     */ this.xsi_type = "me:marquardt";
    }
    static{
        /**
     * The tag name.
     */ this.xsi_type2 = "marquardt";
    }
    static{
        this.MarquardtDerivDeltaDefault = "1.e-03";
    }
    static{
        this.MarquardtTolerance = "1.e-03";
    }
    static{
        this.MarquardtLambda = "1.0";
    }
    static{
        this.MarquardtLambdaScale = "10.0";
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes, marquardtIterations, marquardtTolerance, marquardtDerivDelta){
        super(attributes);
        this.index = new Map();
        if (marquardtIterations != undefined) {
            this.index.set($085f2478c495b249$export$9f699e98369d9591.tagName, this.nodes.size);
            this.addNode(marquardtIterations);
        }
        if (marquardtTolerance != undefined) {
            this.index.set($085f2478c495b249$export$ca1e6c3ff9fd3627.tagName, this.nodes.size);
            this.addNode(marquardtTolerance);
        }
        if (marquardtDerivDelta != undefined) {
            this.index.set($085f2478c495b249$export$d3887b529debf19d.tagName, this.nodes.size);
            this.addNode(marquardtDerivDelta);
        }
    }
    /**
     * @returns The marquardtIterations or undefined.
     */ getMarquardtIterations() {
        let i = this.index.get($085f2478c495b249$export$9f699e98369d9591.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param marquardtIterations The marquardtIterations.
     */ setMarquardtIterations(marquardtIterations) {
        let i = this.index.get($085f2478c495b249$export$9f699e98369d9591.tagName);
        if (i != undefined) this.nodes.set(i, marquardtIterations);
        else {
            this.index.set($085f2478c495b249$export$9f699e98369d9591.tagName, this.nodes.size);
            this.addNode(marquardtIterations);
        }
    }
    /**
     * Remove the marquardtIterations.
     */ removeMarquardtIterations() {
        let i = this.index.get($085f2478c495b249$export$9f699e98369d9591.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$9f699e98369d9591.tagName);
        }
    }
    /**
     * @returns The marquardtTolerance or undefined.
     */ getMarquardtTolerance() {
        let i = this.index.get($085f2478c495b249$export$ca1e6c3ff9fd3627.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param marquardtTolerance The marquardtTolerance.
     */ setMarquardtTolerance(marquardtTolerance) {
        let i = this.index.get($085f2478c495b249$export$ca1e6c3ff9fd3627.tagName);
        if (i != undefined) this.nodes.set(i, marquardtTolerance);
        else {
            this.index.set($085f2478c495b249$export$ca1e6c3ff9fd3627.tagName, this.nodes.size);
            this.addNode(marquardtTolerance);
        }
    }
    /**
     * Remove the marquardtTolerance.
     */ removeMarquardtTolerance() {
        let i = this.index.get($085f2478c495b249$export$ca1e6c3ff9fd3627.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$ca1e6c3ff9fd3627.tagName);
        }
    }
    /**
     * @returns The marquardtDerivDelta or undefined.
     */ getMarquardtDerivDelta() {
        let i = this.index.get($085f2478c495b249$export$d3887b529debf19d.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param marquardtDerivDelta The marquardtDerivDelta.
     */ setMarquardtDerivDelta(marquardtDerivDelta) {
        let i = this.index.get($085f2478c495b249$export$d3887b529debf19d.tagName);
        if (i != undefined) this.nodes.set(i, marquardtDerivDelta);
        else {
            this.index.set($085f2478c495b249$export$d3887b529debf19d.tagName, this.nodes.size);
            this.addNode(marquardtDerivDelta);
        }
    }
    /**
     * Remove the marquardtDerivDelta.
     */ removeMarquardtDerivDelta() {
        let i = this.index.get($085f2478c495b249$export$d3887b529debf19d.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$d3887b529debf19d.tagName);
        }
    }
}
class $085f2478c495b249$export$85eca882ff5fb66 extends (0, $057fa7562ec736a9$export$3288d34c523a1192) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:useTraceWeighting";
    }
    constructor(){
        super($085f2478c495b249$export$85eca882ff5fb66.tagName);
    }
}
class $085f2478c495b249$export$93514d28bd18d75a extends (0, $057fa7562ec736a9$export$8f67221c6fb2ad09) {
    static{
        /**
    * The tag name.
    */ this.tagName = "me:format";
    }
    static{
        /**
     * The options.
     */ this.options = [
            "cantera",
            "chemkin"
        ];
    }
    static{
        /**
     * The rateUnits.
     */ this.rateUnits = "rateUnits";
    }
    static{
        /**
     * The rateUnits options.
     */ this.rateUnitsOptions = [
            "cm3mole-1s-1",
            "cm3molecule-1s-1"
        ];
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$93514d28bd18d75a.tagName, value);
    }
    /**
     * @returns The value of the "rateUnits" attribute or undefined.
     */ getRateUnits() {
        return this.attributes.get($085f2478c495b249$export$93514d28bd18d75a.rateUnits);
    }
    /**
     * @param rateUnits The value of the "rateUnits" attribute.
     */ setRateUnits(rateUnits) {
        this.attributes.set($085f2478c495b249$export$93514d28bd18d75a.rateUnits, rateUnits);
    }
    /**
     * Remove the "rateUnits" attribute.
     */ removeRateUnits() {
        this.attributes.delete($085f2478c495b249$export$93514d28bd18d75a.rateUnits);
    }
}
class $085f2478c495b249$export$be201676156f3e60 extends (0, $057fa7562ec736a9$export$8f67221c6fb2ad09) {
    static{
        /**
    * The tag name.
    */ this.tagName = "me:precision";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$be201676156f3e60.tagName, value);
    }
}
class $085f2478c495b249$export$19d20f3642d82681 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
    * The tag name.
    */ this.tagName = "me:chebNumTemp";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$19d20f3642d82681.tagName, value);
    }
}
class $085f2478c495b249$export$906be0805438fd80 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
    * The tag name.
    */ this.tagName = "me:chebNumConc";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$906be0805438fd80.tagName, value);
    }
}
class $085f2478c495b249$export$6ab4fe1621c91452 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
    * The tag name.
    */ this.tagName = "me:chebMaxTemp";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$6ab4fe1621c91452.tagName, value);
    }
}
class $085f2478c495b249$export$e9853d49316ae9ae extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
    * The tag name.
    */ this.tagName = "me:chebMinTemp";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$e9853d49316ae9ae.tagName, value);
    }
}
class $085f2478c495b249$export$39eacc768d7e9bb extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
    * The tag name.
    */ this.tagName = "me:chebMaxConc";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$39eacc768d7e9bb.tagName, value);
    }
    /**
     * @returns The units.
     */ getUnits() {
        return this.attributes.get("units");
    }
    /**
     * @param units The units.
     */ setUnits(units) {
        this.attributes.set("units", units);
    }
}
class $085f2478c495b249$export$78194e57ce26d99a extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
    * The tag name.
    */ this.tagName = "me:chebMinConc";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$78194e57ce26d99a.tagName, value);
    }
}
class $085f2478c495b249$export$96094ac7e31a750e extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
    * The tag name.
    */ this.tagName = "me:chebTExSize";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$96094ac7e31a750e.tagName, value);
    }
}
class $085f2478c495b249$export$ae695595d3952700 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
    * The tag name.
    */ this.tagName = "me:chebPExSize";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$ae695595d3952700.tagName, value);
    }
}
class $085f2478c495b249$export$fe9781900d201bdf extends $085f2478c495b249$export$f0bfd84d03c3a22d {
    static{
        /**
     * The tag name.
     */ this.xsi_type = "me:analyticalRepresentation";
    }
    static{
        /**
     * The tag name.
     */ this.xsi_type2 = "analyticalRepresentation";
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes, format, precision, chebNumTemp, chebNumConc, chebMaxTemp, chebMinTemp, chebMaxConc, chebMinConc, chebTExSize, chebPExSize){
        super(attributes);
        this.index = new Map();
        if (format != undefined) {
            this.index.set($085f2478c495b249$export$93514d28bd18d75a.tagName, this.nodes.size);
            this.addNode(format);
        }
        if (precision != undefined) {
            this.index.set($085f2478c495b249$export$be201676156f3e60.tagName, this.nodes.size);
            this.addNode(precision);
        }
        if (chebNumTemp != undefined) {
            this.index.set($085f2478c495b249$export$19d20f3642d82681.tagName, this.nodes.size);
            this.addNode(chebNumTemp);
        }
        if (chebNumConc != undefined) {
            this.index.set($085f2478c495b249$export$906be0805438fd80.tagName, this.nodes.size);
            this.addNode(chebNumConc);
        }
        if (chebMaxTemp != undefined) {
            this.index.set($085f2478c495b249$export$6ab4fe1621c91452.tagName, this.nodes.size);
            this.addNode(chebMaxTemp);
        }
        if (chebMinTemp != undefined) {
            this.index.set($085f2478c495b249$export$e9853d49316ae9ae.tagName, this.nodes.size);
            this.addNode(chebMinTemp);
        }
        if (chebMaxConc != undefined) {
            this.index.set($085f2478c495b249$export$39eacc768d7e9bb.tagName, this.nodes.size);
            this.addNode(chebMaxConc);
        }
        if (chebMinConc != undefined) {
            this.index.set($085f2478c495b249$export$78194e57ce26d99a.tagName, this.nodes.size);
            this.addNode(chebMinConc);
        }
        if (chebTExSize != undefined) {
            this.index.set($085f2478c495b249$export$96094ac7e31a750e.tagName, this.nodes.size);
            this.addNode(chebTExSize);
        }
        if (chebPExSize != undefined) {
            this.index.set($085f2478c495b249$export$ae695595d3952700.tagName, this.nodes.size);
            this.addNode(chebPExSize);
        }
    }
    /**
     * @returns The format or undefined.
     */ getFormat() {
        let i = this.index.get($085f2478c495b249$export$93514d28bd18d75a.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param format The format.
     */ setFormat(format) {
        let i = this.index.get($085f2478c495b249$export$93514d28bd18d75a.tagName);
        if (i != undefined) this.nodes.set(i, format);
        else {
            this.index.set($085f2478c495b249$export$93514d28bd18d75a.tagName, this.nodes.size);
            this.addNode(format);
        }
    }
    /**
     * Remove the format.
     */ removeFormat() {
        let i = this.index.get($085f2478c495b249$export$93514d28bd18d75a.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$93514d28bd18d75a.tagName);
        }
    }
    /**
     * @returns The precision or undefined.
     */ getPrecision() {
        let i = this.index.get($085f2478c495b249$export$be201676156f3e60.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param precision The precision.
     */ setPrecision(precision) {
        let i = this.index.get($085f2478c495b249$export$be201676156f3e60.tagName);
        if (i != undefined) this.nodes.set(i, precision);
        else {
            this.index.set($085f2478c495b249$export$be201676156f3e60.tagName, this.nodes.size);
            this.addNode(precision);
        }
    }
    /**
     * Remove the precision.
     */ removePrecision() {
        let i = this.index.get($085f2478c495b249$export$be201676156f3e60.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$be201676156f3e60.tagName);
        }
    }
    /**
     * @returns The chebNumTemp or undefined.
     */ getChebNumTemp() {
        let i = this.index.get($085f2478c495b249$export$19d20f3642d82681.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param chebNumTemp The chebNumTemp.
     */ setChebNumTemp(chebNumTemp) {
        let i = this.index.get($085f2478c495b249$export$19d20f3642d82681.tagName);
        if (i != undefined) this.nodes.set(i, chebNumTemp);
        else {
            this.index.set($085f2478c495b249$export$19d20f3642d82681.tagName, this.nodes.size);
            this.addNode(chebNumTemp);
        }
    }
    /**
     * Remove the chebNumTemp.
     */ removeChebNumTemp() {
        let i = this.index.get($085f2478c495b249$export$19d20f3642d82681.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$19d20f3642d82681.tagName);
        }
    }
    /**
     * @returns The chebNumConc or undefined.
     */ getChebNumConc() {
        let i = this.index.get($085f2478c495b249$export$906be0805438fd80.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param chebNumConc The chebNumConc.
     */ setChebNumConc(chebNumConc) {
        let i = this.index.get($085f2478c495b249$export$906be0805438fd80.tagName);
        if (i != undefined) this.nodes.set(i, chebNumConc);
        else {
            this.index.set($085f2478c495b249$export$906be0805438fd80.tagName, this.nodes.size);
            this.addNode(chebNumConc);
        }
    }
    /**
     * Remove the chebNumConc.
     */ removeChebNumConc() {
        let i = this.index.get($085f2478c495b249$export$906be0805438fd80.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$906be0805438fd80.tagName);
        }
    }
    /**
     * @returns The chebMaxTemp or undefined.
     */ getChebMaxTemp() {
        let i = this.index.get($085f2478c495b249$export$6ab4fe1621c91452.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param chebMaxTemp The chebMaxTemp.
     */ setChebMaxTemp(chebMaxTemp) {
        let i = this.index.get($085f2478c495b249$export$6ab4fe1621c91452.tagName);
        if (i != undefined) this.nodes.set(i, chebMaxTemp);
        else {
            this.index.set($085f2478c495b249$export$6ab4fe1621c91452.tagName, this.nodes.size);
            this.addNode(chebMaxTemp);
        }
    }
    /**
     * Remove the chebMaxTemp.
     */ removeChebMaxTemp() {
        let i = this.index.get($085f2478c495b249$export$6ab4fe1621c91452.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$6ab4fe1621c91452.tagName);
        }
    }
    /**
     * @returns The chebMinTemp or undefined.
     */ getChebMinTemp() {
        let i = this.index.get($085f2478c495b249$export$e9853d49316ae9ae.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param chebMinTemp The chebMinTemp.
     */ setChebMinTemp(chebMinTemp) {
        let i = this.index.get($085f2478c495b249$export$e9853d49316ae9ae.tagName);
        if (i != undefined) this.nodes.set(i, chebMinTemp);
        else {
            this.index.set($085f2478c495b249$export$e9853d49316ae9ae.tagName, this.nodes.size);
            this.addNode(chebMinTemp);
        }
    }
    /**
     * Remove the chebMinTemp.
     */ removeChebMinTemp() {
        let i = this.index.get($085f2478c495b249$export$e9853d49316ae9ae.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$e9853d49316ae9ae.tagName);
        }
    }
    /**
     * @returns The chebMaxConc or undefined.
     */ getChebMaxConc() {
        let i = this.index.get($085f2478c495b249$export$39eacc768d7e9bb.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param chebMaxConc The chebMaxConc.
     */ setChebMaxConc(chebMaxConc) {
        let i = this.index.get($085f2478c495b249$export$39eacc768d7e9bb.tagName);
        if (i != undefined) this.nodes.set(i, chebMaxConc);
        else {
            this.index.set($085f2478c495b249$export$39eacc768d7e9bb.tagName, this.nodes.size);
            this.addNode(chebMaxConc);
        }
    }
    /**
     * Remove the chebMaxConc.
     */ removeChebMaxConc() {
        let i = this.index.get($085f2478c495b249$export$39eacc768d7e9bb.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$39eacc768d7e9bb.tagName);
        }
    }
    /**
     * @returns The chebMinConc or undefined.
     */ getChebMinConc() {
        let i = this.index.get($085f2478c495b249$export$78194e57ce26d99a.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param chebMinConc The chebMinConc.
     */ setChebMinConc(chebMinConc) {
        let i = this.index.get($085f2478c495b249$export$78194e57ce26d99a.tagName);
        if (i != undefined) this.nodes.set(i, chebMinConc);
        else {
            this.index.set($085f2478c495b249$export$78194e57ce26d99a.tagName, this.nodes.size);
            this.addNode(chebMinConc);
        }
    }
    /**
     * Remove the chebMinConc.
     */ removeChebMinConc() {
        let i = this.index.get($085f2478c495b249$export$78194e57ce26d99a.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$78194e57ce26d99a.tagName);
        }
    }
    /**
     * @returns The chebTExSize or undefined.
     */ getChebTExSize() {
        let i = this.index.get($085f2478c495b249$export$96094ac7e31a750e.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param chebTExSize The chebTExSize.
     */ setChebTExSize(chebTExSize) {
        let i = this.index.get($085f2478c495b249$export$96094ac7e31a750e.tagName);
        if (i != undefined) this.nodes.set(i, chebTExSize);
        else {
            this.index.set($085f2478c495b249$export$96094ac7e31a750e.tagName, this.nodes.size);
            this.addNode(chebTExSize);
        }
    }
    /**
     * Remove the chebTExSize.
     */ removeChebTExSize() {
        let i = this.index.get($085f2478c495b249$export$96094ac7e31a750e.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$96094ac7e31a750e.tagName);
        }
    }
    /**
     * @returns The chebPExSize or undefined.
     */ getChebPExSize() {
        let i = this.index.get($085f2478c495b249$export$ae695595d3952700.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param chebPExSize The chebPExSize.
     */ setChebPExSize(chebPExSize) {
        let i = this.index.get($085f2478c495b249$export$ae695595d3952700.tagName);
        if (i != undefined) this.nodes.set(i, chebPExSize);
        else {
            this.index.set($085f2478c495b249$export$ae695595d3952700.tagName, this.nodes.size);
            this.addNode(chebPExSize);
        }
    }
    /**
     * Remove the chebPExSize.
     */ removeChebPExSize() {
        let i = this.index.get($085f2478c495b249$export$ae695595d3952700.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$ae695595d3952700.tagName);
        }
    }
}
class $085f2478c495b249$export$7be1a36e1f74dbc7 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:Tmin";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$7be1a36e1f74dbc7.tagName, value);
    }
}
class $085f2478c495b249$export$ac2eb7df727f506d extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:Tmid";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$ac2eb7df727f506d.tagName, value);
    }
}
class $085f2478c495b249$export$58c8f4b7ec654137 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:Tmax";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$58c8f4b7ec654137.tagName, value);
    }
}
class $085f2478c495b249$export$7b8cfe3a6a460886 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:Tstep";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$7b8cfe3a6a460886.tagName, value);
    }
}
class $085f2478c495b249$export$16ef3f79998b60b4 extends $085f2478c495b249$export$f0bfd84d03c3a22d {
    static{
        /**
     * The tag name.
     */ this.xsi_type = "me:ThermodynamicTable";
    }
    static{
        /**
     * The tag name.
     */ this.xsi_type2 = "ThermodynamicTable";
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes, tmin, tmid, tmax, tstep){
        super(attributes);
        this.index = new Map();
        if (tmin != undefined) {
            this.index.set($085f2478c495b249$export$7be1a36e1f74dbc7.tagName, this.nodes.size);
            this.addNode(tmin);
        }
        if (tmid != undefined) {
            this.index.set($085f2478c495b249$export$ac2eb7df727f506d.tagName, this.nodes.size);
            this.addNode(tmid);
        }
        if (tmax != undefined) {
            this.index.set($085f2478c495b249$export$58c8f4b7ec654137.tagName, this.nodes.size);
            this.addNode(tmax);
        }
        if (tstep != undefined) {
            this.index.set($085f2478c495b249$export$7b8cfe3a6a460886.tagName, this.nodes.size);
            this.addNode(tstep);
        }
    }
    /**
     * @returns The tmin or undefined.
     */ getTmin() {
        let i = this.index.get($085f2478c495b249$export$7be1a36e1f74dbc7.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param tmin The tmin.
     */ setTmin(tmin) {
        let i = this.index.get($085f2478c495b249$export$7be1a36e1f74dbc7.tagName);
        if (i != undefined) this.nodes.set(i, tmin);
        else {
            this.index.set($085f2478c495b249$export$7be1a36e1f74dbc7.tagName, this.nodes.size);
            this.addNode(tmin);
        }
    }
    /**
     * Remove the tmin.
     */ removeTmin() {
        let i = this.index.get($085f2478c495b249$export$7be1a36e1f74dbc7.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$7be1a36e1f74dbc7.tagName);
        }
    }
    /**
     * @returns The tmid or undefined.
     */ getTmid() {
        let i = this.index.get($085f2478c495b249$export$ac2eb7df727f506d.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param tmid The tmid.
     */ setTmid(tmid) {
        let i = this.index.get($085f2478c495b249$export$ac2eb7df727f506d.tagName);
        if (i != undefined) this.nodes.set(i, tmid);
        else {
            this.index.set($085f2478c495b249$export$ac2eb7df727f506d.tagName, this.nodes.size);
            this.addNode(tmid);
        }
    }
    /**
     * Remove the tmid.
     */ removeTmid() {
        let i = this.index.get($085f2478c495b249$export$ac2eb7df727f506d.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$ac2eb7df727f506d.tagName);
        }
    }
    /**
     * @returns The tmax or undefined.
     */ getTmax() {
        let i = this.index.get($085f2478c495b249$export$58c8f4b7ec654137.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param tmax The tmax.
     */ setTmax(tmax) {
        let i = this.index.get($085f2478c495b249$export$58c8f4b7ec654137.tagName);
        if (i != undefined) this.nodes.set(i, tmax);
        else {
            this.index.set($085f2478c495b249$export$58c8f4b7ec654137.tagName, this.nodes.size);
            this.addNode(tmax);
        }
    }
    /**
     * Remove the tmax.
     */ removeTmax() {
        let i = this.index.get($085f2478c495b249$export$58c8f4b7ec654137.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$58c8f4b7ec654137.tagName);
        }
    }
    /**
     * @returns The tstep or undefined.
     */ getTstep() {
        let i = this.index.get($085f2478c495b249$export$7b8cfe3a6a460886.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param tstep The tstep.
     */ setTstep(tstep) {
        let i = this.index.get($085f2478c495b249$export$7b8cfe3a6a460886.tagName);
        if (i != undefined) this.nodes.set(i, tstep);
        else {
            this.index.set($085f2478c495b249$export$7b8cfe3a6a460886.tagName, this.nodes.size);
            this.addNode(tstep);
        }
    }
    /**
     * Remove the tstep.
     */ removeTstep() {
        let i = this.index.get($085f2478c495b249$export$7b8cfe3a6a460886.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$7b8cfe3a6a460886.tagName);
        }
    }
}
class $085f2478c495b249$export$37d0520a9fac7849 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:sensitivityAnalysisSamples";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$37d0520a9fac7849.tagName, value);
    }
}
class $085f2478c495b249$export$9a832710e54827ea extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:sensitivityAnalysisOrder";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$9a832710e54827ea.tagName, value);
    }
}
class $085f2478c495b249$export$b43b57458ce8fb96 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:sensitivityNumVarRedIters";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$b43b57458ce8fb96.tagName, value);
    }
}
class $085f2478c495b249$export$e98aeac6c6b1df09 extends (0, $057fa7562ec736a9$export$8f67221c6fb2ad09) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:sensitivityVarRedMethod";
    }
    static{
        /**
     * The options.
     */ this.options = [
            "AdditiveControl",
            "RatioControl"
        ];
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$e98aeac6c6b1df09.tagName, value);
    }
}
class $085f2478c495b249$export$a532500cc43efbef extends $085f2478c495b249$export$f0bfd84d03c3a22d {
    static{
        /**
    * The xsi_type.
    */ this.xsi_type = "me:sensitivityAnalysis";
    }
    static{
        /**
     * The xsi_type2.
     */ this.xsi_type2 = "sensitivityAnalysis";
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes, sensitivityAnalysisSamples, sensitivityAnalysisOrder, sensitivityNumVarRedIters, sensitivityVarRedMethod){
        super(attributes);
        this.index = new Map();
        if (sensitivityAnalysisSamples != undefined) {
            this.index.set($085f2478c495b249$export$37d0520a9fac7849.tagName, this.nodes.size);
            this.addNode(sensitivityAnalysisSamples);
        }
        if (sensitivityAnalysisOrder != undefined) {
            this.index.set($085f2478c495b249$export$9a832710e54827ea.tagName, this.nodes.size);
            this.addNode(sensitivityAnalysisOrder);
        }
        if (sensitivityNumVarRedIters != undefined) {
            this.index.set($085f2478c495b249$export$b43b57458ce8fb96.tagName, this.nodes.size);
            this.addNode(sensitivityNumVarRedIters);
        }
        if (sensitivityVarRedMethod != undefined) {
            this.index.set($085f2478c495b249$export$e98aeac6c6b1df09.tagName, this.nodes.size);
            this.addNode(sensitivityVarRedMethod);
        }
    }
    /**
     * @returns The sensitivityAnalysisSamples or undefined.
     */ getSensitivityAnalysisSamples() {
        let i = this.index.get($085f2478c495b249$export$37d0520a9fac7849.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param sensitivityAnalysisSamples The sensitivityAnalysisSamples.
     */ setSensitivityAnalysisSamples(sensitivityAnalysisSamples) {
        let i = this.index.get($085f2478c495b249$export$37d0520a9fac7849.tagName);
        if (i != undefined) this.nodes.set(i, sensitivityAnalysisSamples);
        else {
            this.index.set($085f2478c495b249$export$37d0520a9fac7849.tagName, this.nodes.size);
            this.addNode(sensitivityAnalysisSamples);
        }
    }
    /**
     * Remove the sensitivityAnalysisSamples.
     */ removeSensitivityAnalysisSamples() {
        let i = this.index.get($085f2478c495b249$export$37d0520a9fac7849.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$37d0520a9fac7849.tagName);
        }
    }
    /**
     * @returns The sensitivityAnalysisOrder or undefined.
     */ getSensitivityAnalysisOrder() {
        let i = this.index.get($085f2478c495b249$export$9a832710e54827ea.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param sensitivityAnalysisOrder The sensitivityAnalysisOrder.
     */ setSensitivityAnalysisOrder(sensitivityAnalysisOrder) {
        let i = this.index.get($085f2478c495b249$export$9a832710e54827ea.tagName);
        if (i != undefined) this.nodes.set(i, sensitivityAnalysisOrder);
        else {
            this.index.set($085f2478c495b249$export$9a832710e54827ea.tagName, this.nodes.size);
            this.addNode(sensitivityAnalysisOrder);
        }
    }
    /**
     * Remove the sensitivityAnalysisOrder.
     */ removeSensitivityAnalysisOrder() {
        let i = this.index.get($085f2478c495b249$export$9a832710e54827ea.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$9a832710e54827ea.tagName);
        }
    }
    /**
     * @returns The sensitivityNumVarRedIters or undefined.
     */ getSensitivityNumVarRedIters() {
        let i = this.index.get($085f2478c495b249$export$b43b57458ce8fb96.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param sensitivityNumVarRedIters The sensitivityNumVarRedIters.
     */ setSensitivityNumVarRedIters(sensitivityNumVarRedIters) {
        let i = this.index.get($085f2478c495b249$export$b43b57458ce8fb96.tagName);
        if (i != undefined) this.nodes.set(i, sensitivityNumVarRedIters);
        else {
            this.index.set($085f2478c495b249$export$b43b57458ce8fb96.tagName, this.nodes.size);
            this.addNode(sensitivityNumVarRedIters);
        }
    }
    /**
     * Remove the sensitivityNumVarRedIters.
     */ removeSensitivityNumVarRedIters() {
        let i = this.index.get($085f2478c495b249$export$b43b57458ce8fb96.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$b43b57458ce8fb96.tagName);
        }
    }
    /**
     * @returns The sensitivityVarRedMethod or undefined.
     */ getSensitivityVarRedMethod() {
        let i = this.index.get($085f2478c495b249$export$e98aeac6c6b1df09.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param sensitivityVarRedMethod The sensitivityVarRedMethod.
     */ setSensitivityVarRedMethod(sensitivityVarRedMethod) {
        let i = this.index.get($085f2478c495b249$export$e98aeac6c6b1df09.tagName);
        if (i != undefined) this.nodes.set(i, sensitivityVarRedMethod);
        else {
            this.index.set($085f2478c495b249$export$e98aeac6c6b1df09.tagName, this.nodes.size);
            this.addNode(sensitivityVarRedMethod);
        }
    }
    /**
     * Remove the sensitivityVarRedMethod.
     */ removeSensitivityVarRedMethod() {
        let i = this.index.get($085f2478c495b249$export$e98aeac6c6b1df09.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$e98aeac6c6b1df09.tagName);
        }
    }
}
class $085f2478c495b249$export$2453e311f702d9c7 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:eigenvalues";
    }
    constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$2453e311f702d9c7.tagName, value);
    }
}
class $085f2478c495b249$export$421603058c6718db extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:shortestTimeOfInterest";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$421603058c6718db.tagName, value);
    }
}
class $085f2478c495b249$export$b51d7314540831ed extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:MaximumEvolutionTime";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$b51d7314540831ed.tagName, value);
    }
}
class $085f2478c495b249$export$576b56ca6e34780b extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:automaticallySetMaxEne";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$576b56ca6e34780b.tagName, value);
    }
}
class $085f2478c495b249$export$159b5d3263f1049a extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:diagramEnergyOffset";
    }
    /**
      * @param attributes The attributes.
      * @param value The value.
      */ constructor(attributes, value){
        super(attributes, $085f2478c495b249$export$159b5d3263f1049a.tagName, value);
    }
}
class $085f2478c495b249$export$1f37c7c73e401f31 extends (0, $057fa7562ec736a9$export$ca4ceee82ec565dc) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:testMicroRates";
    }
    static{
        this.s_Tmin = "Tmin";
    }
    static{
        this.s_Tmax = "Tmax";
    }
    static{
        this.s_Tstep = "Tstep";
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes){
        super(attributes, $085f2478c495b249$export$1f37c7c73e401f31.tagName);
        this.tMin = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(attributes.get($085f2478c495b249$export$1f37c7c73e401f31.s_Tmin));
        this.tMax = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(attributes.get($085f2478c495b249$export$1f37c7c73e401f31.s_Tmax));
        this.tStep = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(attributes.get($085f2478c495b249$export$1f37c7c73e401f31.s_Tstep));
    }
    /**
     * @returns The maximum temperature.
     */ getTmin() {
        return this.tMin;
    }
    /**
     * @param tMin The minimum temperature.
     */ setTmin(tMin) {
        this.tMin = tMin;
        this.attributes?.set("Tmin", tMin.toString());
    }
    /**
     * @returns The maximum temperature.
     */ getTmax() {
        return this.tMax;
    }
    /**
     * @param tMax The maximum temperature.
     */ setTmax(tMax) {
        this.tMax = tMax;
        this.attributes?.set("Tmax", tMax.toString());
    }
    /**
     * @returns The temperature step.
     */ getTstep() {
        return this.tStep;
    }
    /**
     * @param tStep The temperature step.
     */ setTstep(tStep) {
        this.tStep = tStep;
        this.attributes?.set("Tstep", tStep.toString());
    }
}
class $085f2478c495b249$export$7a7fa4424cb20976 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:control";
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes, id){
        super(attributes, $085f2478c495b249$export$7a7fa4424cb20976.tagName);
        this.id = id;
        this.index = new Map();
    }
    /**
     * @returns The calculateRateCoefficientsOnly or undefined.
     */ getCalculateRateCoefficientsOnly() {
        let i = this.index.get($085f2478c495b249$export$7d9247c9879133fb.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param calculateRateCoefficientsOnly The calculateRateCoefficientsOnly.
     */ setCalculateRateCoefficientsOnly(calculateRateCoefficientsOnly) {
        let i = this.index.get($085f2478c495b249$export$7d9247c9879133fb.tagName);
        if (i != undefined) this.nodes.set(i, calculateRateCoefficientsOnly);
        else {
            this.index.set($085f2478c495b249$export$7d9247c9879133fb.tagName, this.nodes.size);
            this.addNode(calculateRateCoefficientsOnly);
        }
    }
    /**
     * Remove the calculateRateCoefficientsOnly.
     */ removeCalculateRateCoefficientsOnly() {
        let i = this.index.get($085f2478c495b249$export$7d9247c9879133fb.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$7d9247c9879133fb.tagName);
        }
    }
    /**
     * @returns The printCellDOS or undefined.
     */ getPrintCellDOS() {
        let i = this.index.get($085f2478c495b249$export$60b233651e162b60.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param printCellDOS The printCellDOS.
     */ setPrintCellDOS(printCellDOS) {
        let i = this.index.get($085f2478c495b249$export$60b233651e162b60.tagName);
        if (i != undefined) this.nodes.set(i, printCellDOS);
        else {
            this.index.set($085f2478c495b249$export$60b233651e162b60.tagName, this.nodes.size);
            this.addNode(printCellDOS);
        }
    }
    /**
     * Remove the printCellDOS.
     */ removePrintCellDOS() {
        let i = this.index.get($085f2478c495b249$export$60b233651e162b60.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$60b233651e162b60.tagName);
        }
    }
    /**
     * @returns The printCellTransitionStateFlux or undefined.
     */ getPrintCellTransitionStateFlux() {
        let i = this.index.get($085f2478c495b249$export$7e63e5104be309ff.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param printCellTransitionStateFlux The printCellTransitionStateFlux.
     */ setPrintCellTransitionStateFlux(printCellTransitionStateFlux) {
        let i = this.index.get($085f2478c495b249$export$7e63e5104be309ff.tagName);
        if (i != undefined) this.nodes.set(i, printCellTransitionStateFlux);
        else {
            this.index.set($085f2478c495b249$export$7e63e5104be309ff.tagName, this.nodes.size);
            this.addNode(printCellTransitionStateFlux);
        }
    }
    /**
     * Remove the printCellTransitionStateFlux.
     */ removePrintCellTransitionStateFlux() {
        let i = this.index.get($085f2478c495b249$export$7e63e5104be309ff.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$7e63e5104be309ff.tagName);
        }
    }
    /**
     * @returns The printReactionOperatorColumnSums or undefined.
     */ getPrintReactionOperatorColumnSums() {
        let i = this.index.get($085f2478c495b249$export$a915db169f144f37.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param printReactionOperatorColumnSums The printReactionOperatorColumnSums.
     */ setPrintReactionOperatorColumnSums(printReactionOperatorColumnSums) {
        let i = this.index.get($085f2478c495b249$export$a915db169f144f37.tagName);
        if (i != undefined) this.nodes.set(i, printReactionOperatorColumnSums);
        else {
            this.index.set($085f2478c495b249$export$a915db169f144f37.tagName, this.nodes.size);
            this.addNode(printReactionOperatorColumnSums);
        }
    }
    /**
     * Remove the printReactionOperatorColumnSums.
     */ removePrintReactionOperatorColumnSums() {
        let i = this.index.get($085f2478c495b249$export$a915db169f144f37.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$a915db169f144f37.tagName);
        }
    }
    /**
     * @returns The printGrainBoltzmann or undefined.
     */ getPrintGrainBoltzmann() {
        let i = this.index.get($085f2478c495b249$export$e7fff349901f700d.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param printGrainBoltzmann The printGrainBoltzmann.
     */ setPrintGrainBoltzmann(printGrainBoltzmann) {
        let i = this.index.get($085f2478c495b249$export$e7fff349901f700d.tagName);
        if (i != undefined) this.nodes.set(i, printGrainBoltzmann);
        else {
            this.index.set($085f2478c495b249$export$e7fff349901f700d.tagName, this.nodes.size);
            this.addNode(printGrainBoltzmann);
        }
    }
    /**
     * Remove the printGrainBoltzmann.
     */ removePrintGrainBoltzmann() {
        let i = this.index.get($085f2478c495b249$export$e7fff349901f700d.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$e7fff349901f700d.tagName);
        }
    }
    /**
     * @returns The printGrainDOS or undefined.
     */ getPrintGrainDOS() {
        let i = this.index.get($085f2478c495b249$export$d23243bda4dfae2b.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param printGrainDOS The printGrainDOS.
     */ setPrintGrainDOS(printGrainDOS) {
        let i = this.index.get($085f2478c495b249$export$d23243bda4dfae2b.tagName);
        if (i != undefined) this.nodes.set(i, printGrainDOS);
        else {
            this.index.set($085f2478c495b249$export$d23243bda4dfae2b.tagName, this.nodes.size);
            this.addNode(printGrainDOS);
        }
    }
    /**
     * Remove the printGrainDOS.
     */ removePrintGrainDOS() {
        let i = this.index.get($085f2478c495b249$export$d23243bda4dfae2b.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$d23243bda4dfae2b.tagName);
        }
    }
    /**
     * @returns The printGrainkbE or undefined.
     */ getPrintGrainkbE() {
        let i = this.index.get($085f2478c495b249$export$55888ef4e813a34d.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param printGrainkbE The printGrainkbE.
     */ setPrintGrainkbE(printGrainkbE) {
        let i = this.index.get($085f2478c495b249$export$55888ef4e813a34d.tagName);
        if (i != undefined) this.nodes.set(i, printGrainkbE);
        else {
            this.index.set($085f2478c495b249$export$55888ef4e813a34d.tagName, this.nodes.size);
            this.addNode(printGrainkbE);
        }
    }
    /**
     * Remove the printGrainkbE.
     */ removePrintGrainkbE() {
        let i = this.index.get($085f2478c495b249$export$55888ef4e813a34d.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$55888ef4e813a34d.tagName);
        }
    }
    /**
     * @returns The printGrainkfE or undefined.
     */ getPrintGrainkfE() {
        let i = this.index.get($085f2478c495b249$export$f8d814a406a0ff5b.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param printGrainkfE The printGrainkfE.
     */ setPrintGrainkfE(printGrainkfE) {
        let i = this.index.get($085f2478c495b249$export$f8d814a406a0ff5b.tagName);
        if (i != undefined) this.nodes.set(i, printGrainkfE);
        else {
            this.index.set($085f2478c495b249$export$f8d814a406a0ff5b.tagName, this.nodes.size);
            this.addNode(printGrainkfE);
        }
    }
    /**
     * Remove the printGrainkfE.
     */ removePrintGrainkfE() {
        let i = this.index.get($085f2478c495b249$export$f8d814a406a0ff5b.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$f8d814a406a0ff5b.tagName);
        }
    }
    /**
     * @returns The printTSsos or undefined.
     */ getPrintTSsos() {
        let i = this.index.get($085f2478c495b249$export$3627f2b606ffd3cb.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param printTSsos The printTSsos.
     */ setPrintTSsos(printTSsos) {
        let i = this.index.get($085f2478c495b249$export$3627f2b606ffd3cb.tagName);
        if (i != undefined) this.nodes.set(i, printTSsos);
        else {
            this.index.set($085f2478c495b249$export$3627f2b606ffd3cb.tagName, this.nodes.size);
            this.addNode(printTSsos);
        }
    }
    /**
     * Remove the printTSsos.
     */ removePrintTSsos() {
        let i = this.index.get($085f2478c495b249$export$3627f2b606ffd3cb.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$3627f2b606ffd3cb.tagName);
        }
    }
    /**
     * @returns The printGrainedSpeciesProfile or undefined.
     */ getPrintGrainedSpeciesProfile() {
        let i = this.index.get($085f2478c495b249$export$c5481d114fddc81c.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param printGrainedSpeciesProfile The printGrainedSpeciesProfile.
     */ setPrintGrainedSpeciesProfile(printGrainedSpeciesProfile) {
        let i = this.index.get($085f2478c495b249$export$c5481d114fddc81c.tagName);
        if (i != undefined) this.nodes.set(i, printGrainedSpeciesProfile);
        else {
            this.index.set($085f2478c495b249$export$c5481d114fddc81c.tagName, this.nodes.size);
            this.addNode(printGrainedSpeciesProfile);
        }
    }
    /**
     * Remove the printGrainedSpeciesProfile.
     */ removePrintGrainedSpeciesProfile() {
        let i = this.index.get($085f2478c495b249$export$c5481d114fddc81c.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$c5481d114fddc81c.tagName);
        }
    }
    /**
     * @returns The printGrainTransitionStateFlux or undefined.
     */ getPrintGrainTransitionStateFlux() {
        let i = this.index.get($085f2478c495b249$export$ec7c00ae1b17b2ab.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param printGrainTransitionStateFlux The printGrainTransitionStateFlux.
     */ setPrintGrainTransitionStateFlux(printGrainTransitionStateFlux) {
        let i = this.index.get($085f2478c495b249$export$ec7c00ae1b17b2ab.tagName);
        if (i != undefined) this.nodes.set(i, printGrainTransitionStateFlux);
        else {
            this.index.set($085f2478c495b249$export$ec7c00ae1b17b2ab.tagName, this.nodes.size);
            this.addNode(printGrainTransitionStateFlux);
        }
    }
    /**
     * Remove the printGrainTransitionStateFlux.
     */ removePrintGrainTransitionStateFlux() {
        let i = this.index.get($085f2478c495b249$export$ec7c00ae1b17b2ab.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$ec7c00ae1b17b2ab.tagName);
        }
    }
    /**
     * @returns The printReactionOperatorSize or undefined.
     */ getPrintReactionOperatorSize() {
        let i = this.index.get($085f2478c495b249$export$8420ab6988728a65.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param printReactionOperatorSize The printReactionOperatorSize.
     */ setPrintReactionOperatorSize(printReactionOperatorSize) {
        let i = this.index.get($085f2478c495b249$export$8420ab6988728a65.tagName);
        if (i != undefined) this.nodes.set(i, printReactionOperatorSize);
        else {
            this.index.set($085f2478c495b249$export$8420ab6988728a65.tagName, this.nodes.size);
            this.addNode(printReactionOperatorSize);
        }
    }
    /**
     * Remove the printReactionOperatorSize.
     */ removePrintReactionOperatorSize() {
        let i = this.index.get($085f2478c495b249$export$8420ab6988728a65.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$8420ab6988728a65.tagName);
        }
    }
    /**
     * @returns The printSpeciesProfile or undefined.
     */ getPrintSpeciesProfile() {
        let i = this.index.get($085f2478c495b249$export$ed9b9e07e51c2ac1.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param printSpeciesProfile The printSpeciesProfile.
     */ setPrintSpeciesProfile(printSpeciesProfile) {
        let i = this.index.get($085f2478c495b249$export$ed9b9e07e51c2ac1.tagName);
        if (i != undefined) this.nodes.set(i, printSpeciesProfile);
        else {
            this.index.set($085f2478c495b249$export$ed9b9e07e51c2ac1.tagName, this.nodes.size);
            this.addNode(printSpeciesProfile);
        }
    }
    /**
     * Remove the printSpeciesProfile.
     */ removePrintSpeciesProfile() {
        let i = this.index.get($085f2478c495b249$export$ed9b9e07e51c2ac1.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$ed9b9e07e51c2ac1.tagName);
        }
    }
    /**
     * @returns The printPhenomenologicalEvolution or undefined.
     */ getPrintPhenomenologicalEvolution() {
        let i = this.index.get($085f2478c495b249$export$9f7939759d8efd9f.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param printPhenomenologicalEvolution The printPhenomenologicalEvolution.
     */ setPrintPhenomenologicalEvolution(printPhenomenologicalEvolution) {
        let i = this.index.get($085f2478c495b249$export$9f7939759d8efd9f.tagName);
        if (i != undefined) this.nodes.set(i, printPhenomenologicalEvolution);
        else {
            this.index.set($085f2478c495b249$export$9f7939759d8efd9f.tagName, this.nodes.size);
            this.addNode(printPhenomenologicalEvolution);
        }
    }
    /**
     * Remove the printPhenomenologicalEvolution.
     */ removePrintPhenomenologicalEvolution() {
        let i = this.index.get($085f2478c495b249$export$9f7939759d8efd9f.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$9f7939759d8efd9f.tagName);
        }
    }
    /**
     * @returns The printTunnelingCoefficients or undefined.
     */ getPrintTunnelingCoefficients() {
        let i = this.index.get($085f2478c495b249$export$fc99460819e23ac5.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param printTunnelingCoefficients The printTunnelingCoefficients.
     */ setPrintTunnelingCoefficients(printTunnelingCoefficients) {
        let i = this.index.get($085f2478c495b249$export$fc99460819e23ac5.tagName);
        if (i != undefined) this.nodes.set(i, printTunnelingCoefficients);
        else {
            this.index.set($085f2478c495b249$export$fc99460819e23ac5.tagName, this.nodes.size);
            this.addNode(printTunnelingCoefficients);
        }
    }
    /**
     * Remove the printTunnelingCoefficients.
     */ removePrintTunnelingCoefficients() {
        let i = this.index.get($085f2478c495b249$export$fc99460819e23ac5.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$fc99460819e23ac5.tagName);
        }
    }
    /**
     * @returns The printCrossingCoefficients or undefined.
     */ getPrintCrossingCoefficients() {
        let i = this.index.get($085f2478c495b249$export$2f2eaac8983031ef.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param printCrossingCoefficients The printCrossingCoefficients.
     */ setPrintCrossingCoefficients(printCrossingCoefficients) {
        let i = this.index.get($085f2478c495b249$export$2f2eaac8983031ef.tagName);
        if (i != undefined) this.nodes.set(i, printCrossingCoefficients);
        else {
            this.index.set($085f2478c495b249$export$2f2eaac8983031ef.tagName, this.nodes.size);
            this.addNode(printCrossingCoefficients);
        }
    }
    /**
     * Remove the printCrossingCoefficients.
     */ removePrintCrossingCoefficients() {
        let i = this.index.get($085f2478c495b249$export$2f2eaac8983031ef.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$2f2eaac8983031ef.tagName);
        }
    }
    /**
     * @returns The testDOS or undefined.
     */ getTestDOS() {
        let i = this.index.get($085f2478c495b249$export$a3d7e677521f681f.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param testDOS The testDOS.
     */ setTestDOS(testDOS) {
        let i = this.index.get($085f2478c495b249$export$a3d7e677521f681f.tagName);
        if (i != undefined) this.nodes.set(i, testDOS);
        else {
            this.index.set($085f2478c495b249$export$a3d7e677521f681f.tagName, this.nodes.size);
            this.addNode(testDOS);
        }
    }
    /**
     * Remove the testDOS.
     */ removeTestDOS() {
        let i = this.index.get($085f2478c495b249$export$a3d7e677521f681f.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$a3d7e677521f681f.tagName);
        }
    }
    /**
     * @returns The testRateConstant or undefined.
     */ getTestRateConstants() {
        let i = this.index.get($085f2478c495b249$export$980e5abe9a459423.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param testRateConstant The testRateConstant.
     */ setTestRateConstants(testRateConstant) {
        let i = this.index.get($085f2478c495b249$export$980e5abe9a459423.tagName);
        if (i != undefined) this.nodes.set(i, testRateConstant);
        else {
            this.index.set($085f2478c495b249$export$980e5abe9a459423.tagName, this.nodes.size);
            this.addNode(testRateConstant);
        }
    }
    /**
     * Remove the testRateConstant.
     */ removeTestRateConstants() {
        let i = this.index.get($085f2478c495b249$export$980e5abe9a459423.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$980e5abe9a459423.tagName);
        }
    }
    /**
     * @returns The useTheSameCellNumberForAllConditions or undefined.
     */ getUseTheSameCellNumberForAllConditions() {
        let i = this.index.get($085f2478c495b249$export$5d7dbeba4bf49655.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param useTheSameCellNumberForAllConditions The useTheSameCellNumberForAllConditions.
     */ setUseTheSameCellNumberForAllConditions(useTheSameCellNumberForAllConditions) {
        let i = this.index.get($085f2478c495b249$export$5d7dbeba4bf49655.tagName);
        if (i != undefined) this.nodes.set(i, useTheSameCellNumberForAllConditions);
        else {
            this.index.set($085f2478c495b249$export$5d7dbeba4bf49655.tagName, this.nodes.size);
            this.addNode(useTheSameCellNumberForAllConditions);
        }
    }
    /**
     * Remove the useTheSameCellNumberForAllConditions.
     */ removeUseTheSameCellNumberForAllConditions() {
        let i = this.index.get($085f2478c495b249$export$5d7dbeba4bf49655.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$5d7dbeba4bf49655.tagName);
        }
    }
    /**
     * @returns The hideInactive or undefined.
     */ getHideInactive() {
        let i = this.index.get($085f2478c495b249$export$9d51752a8549e2d6.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param hideInactive The hideInactive.
     */ setHideInactive(hideInactive) {
        let i = this.index.get($085f2478c495b249$export$9d51752a8549e2d6.tagName);
        if (i != undefined) this.nodes.set(i, hideInactive);
        else {
            this.index.set($085f2478c495b249$export$9d51752a8549e2d6.tagName, this.nodes.size);
            this.addNode(hideInactive);
        }
    }
    /**
     * Remove the hideInactive.
     */ removeHideInactive() {
        let i = this.index.get($085f2478c495b249$export$9d51752a8549e2d6.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$9d51752a8549e2d6.tagName);
        }
    }
    /**
     * @returns The ForceMacroDetailedBalance or undefined.
     */ getForceMacroDetailedBalance() {
        let i = this.index.get($085f2478c495b249$export$6ffea14bdffd427f.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param forceMacroDetailedBalance The forceMacroDetailedBalance.
     */ setForceMacroDetailedBalance(forceMacroDetailedBalance) {
        let i = this.index.get($085f2478c495b249$export$6ffea14bdffd427f.tagName);
        if (i != undefined) this.nodes.set(i, forceMacroDetailedBalance);
        else {
            this.index.set($085f2478c495b249$export$6ffea14bdffd427f.tagName, this.nodes.size);
            this.addNode(forceMacroDetailedBalance);
        }
    }
    /**
     * Remove the forceMacroDetailedBalance.
     */ removeForceMacroDetailedBalance() {
        let i = this.index.get($085f2478c495b249$export$6ffea14bdffd427f.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$6ffea14bdffd427f.tagName);
        }
    }
    /**
     * @returns The calcMethod or undefined.
     */ getCalcMethod() {
        let i = this.index.get($085f2478c495b249$export$f0bfd84d03c3a22d.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param calcMethod The calcMethod.
     */ setCalcMethod(calcMethod) {
        let i = this.index.get($085f2478c495b249$export$f0bfd84d03c3a22d.tagName);
        if (i != undefined) this.nodes.set(i, calcMethod);
        else {
            this.index.set($085f2478c495b249$export$f0bfd84d03c3a22d.tagName, this.nodes.size);
            this.addNode(calcMethod);
        }
    }
    /**
     * Remove the calcMethod.
     */ removeCalcMethod() {
        let i = this.index.get($085f2478c495b249$export$f0bfd84d03c3a22d.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$f0bfd84d03c3a22d.tagName);
        }
    }
    /**
     * @returns The eigenvalues or undefined.
     */ getEigenvalues() {
        let i = this.index.get($085f2478c495b249$export$2453e311f702d9c7.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param eigenvalues The eigenvalues.
     */ setEigenvalues(eigenvalues) {
        let i = this.index.get($085f2478c495b249$export$2453e311f702d9c7.tagName);
        if (i != undefined) this.nodes.set(i, eigenvalues);
        else {
            this.index.set($085f2478c495b249$export$2453e311f702d9c7.tagName, this.nodes.size);
            this.addNode(eigenvalues);
        }
    }
    /**
     * Remove the eigenvalues.
     */ removeEigenvalues() {
        let i = this.index.get($085f2478c495b249$export$2453e311f702d9c7.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$2453e311f702d9c7.tagName);
        }
    }
    /**
     * @returns The shortestTimeOfInterest.
     */ getShortestTimeOfInterest() {
        let i = this.index.get($085f2478c495b249$export$421603058c6718db.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param shortestTimeOfInterest The shortestTimeOfInterest.
     */ setShortestTimeOfInterest(shortestTimeOfInterest) {
        let i = this.index.get($085f2478c495b249$export$421603058c6718db.tagName);
        if (i != undefined) this.nodes.set(i, shortestTimeOfInterest);
        else {
            this.index.set($085f2478c495b249$export$421603058c6718db.tagName, this.nodes.size);
            this.addNode(shortestTimeOfInterest);
        }
    }
    /**
     * Remove the shortestTimeOfInterest.
     */ removeShortestTimeOfInterest() {
        let i = this.index.get($085f2478c495b249$export$421603058c6718db.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$421603058c6718db.tagName);
        }
    }
    /**
     * @returns The MaximumEvolutionTime.
     */ getMaximumEvolutionTime() {
        let i = this.index.get($085f2478c495b249$export$b51d7314540831ed.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param maximumEvolutionTime The MaximumEvolutionTime.
     */ setMaximumEvolutionTime(maximumEvolutionTime) {
        let i = this.index.get($085f2478c495b249$export$b51d7314540831ed.tagName);
        if (i != undefined) this.nodes.set(i, maximumEvolutionTime);
        else {
            this.index.set($085f2478c495b249$export$b51d7314540831ed.tagName, this.nodes.size);
            this.addNode(maximumEvolutionTime);
        }
    }
    /**
     * Remove the MaximumEvolutionTime.
     */ removeMaximumEvolutionTime() {
        let i = this.index.get($085f2478c495b249$export$b51d7314540831ed.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$b51d7314540831ed.tagName);
        }
    }
    /**
     * @returns The automaticallySetMaxEne.
     */ getAutomaticallySetMaxEne() {
        let i = this.index.get($085f2478c495b249$export$576b56ca6e34780b.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param automaticallySetMaxEne The automaticallySetMaxEne.
     */ setAutomaticallySetMaxEne(automaticallySetMaxEne) {
        let i = this.index.get($085f2478c495b249$export$576b56ca6e34780b.tagName);
        if (i != undefined) this.nodes.set(i, automaticallySetMaxEne);
        else {
            this.index.set($085f2478c495b249$export$576b56ca6e34780b.tagName, this.nodes.size);
            this.addNode(automaticallySetMaxEne);
        }
    }
    /**
     * Remove the automaticallySetMaxEne.
     */ removeAutomaticallySetMaxEne() {
        let i = this.index.get($085f2478c495b249$export$576b56ca6e34780b.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$576b56ca6e34780b.tagName);
        }
    }
    /**
     * @returns The diagramEnergyOffset.
     */ getDiagramEnergyOffset() {
        let i = this.index.get($085f2478c495b249$export$159b5d3263f1049a.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param diagramEnergyOffset The diagramEnergyOffset.
     */ setDiagramEnergyOffset(diagramEnergyOffset) {
        let i = this.index.get($085f2478c495b249$export$159b5d3263f1049a.tagName);
        if (i != undefined) this.nodes.set(i, diagramEnergyOffset);
        else {
            this.index.set($085f2478c495b249$export$159b5d3263f1049a.tagName, this.nodes.size);
            this.addNode(diagramEnergyOffset);
        }
    }
    /**
     * Remove the diagramEnergyOffset.
     */ removeDiagramEnergyOffset() {
        let i = this.index.get($085f2478c495b249$export$159b5d3263f1049a.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$159b5d3263f1049a.tagName);
        }
    }
    /**
     * @returns The testMicroRates or undefined.
     */ getTestMicroRates() {
        let i = this.index.get($085f2478c495b249$export$1f37c7c73e401f31.tagName);
        if (i != undefined) return this.nodes.get(i);
        return undefined;
    }
    /**
     * @param testMicroRates The testMicroRates.
     */ setTestMicroRates(testMicroRates) {
        let i = this.index.get($085f2478c495b249$export$1f37c7c73e401f31.tagName);
        if (i != undefined) this.nodes.set(i, testMicroRates);
        else {
            this.index.set($085f2478c495b249$export$1f37c7c73e401f31.tagName, this.nodes.size);
            this.addNode(testMicroRates);
        }
    }
    /**
     * Remove the testMicroRates.
     */ removeTestMicroRates() {
        let i = this.index.get($085f2478c495b249$export$1f37c7c73e401f31.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($085f2478c495b249$export$1f37c7c73e401f31.tagName);
        }
    }
}



class $cb35636d41d8f309$export$e7adebdc1ebd2fed extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * Tag name.
     */ this.tagName = 'metadata';
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes){
        super(attributes, $cb35636d41d8f309$export$e7adebdc1ebd2fed.tagName);
    }
    /**
     * Get string for label.
     */ getLabelText() {
        let label = '';
        this.attributes.forEach((value, key)=>{
            label += key + ': ' + value + ' ';
        });
        return label;
    }
}
class $cb35636d41d8f309$export$7969c02c126c11b8 extends (0, $057fa7562ec736a9$export$8f67221c6fb2ad09) {
    static{
        /**
     * Tag name.
     */ this.tagName = 'dc:title';
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes, value){
        super(attributes, $cb35636d41d8f309$export$7969c02c126c11b8.tagName, value);
    }
}
class $cb35636d41d8f309$export$c78a95f4a27bad68 extends (0, $057fa7562ec736a9$export$8f67221c6fb2ad09) {
    static{
        /**
     * Tag name.
     */ this.tagName = 'dc:source';
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes, value){
        super(attributes, $cb35636d41d8f309$export$c78a95f4a27bad68.tagName, value);
    }
}
class $cb35636d41d8f309$export$61180682f135a7f2 extends (0, $057fa7562ec736a9$export$8f67221c6fb2ad09) {
    static{
        /**
     * Tag name.
     */ this.tagName = 'dc:creator';
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes, value){
        super(attributes, $cb35636d41d8f309$export$61180682f135a7f2.tagName, value);
    }
}
class $cb35636d41d8f309$export$bf6d63a1cea4a33c extends (0, $057fa7562ec736a9$export$8f67221c6fb2ad09) {
    static{
        /**
     * Tag name.
     */ this.tagName = 'dc:date';
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes, value){
        super(attributes, $cb35636d41d8f309$export$bf6d63a1cea4a33c.tagName, value);
    }
}
class $cb35636d41d8f309$export$2b747e617c849cca extends (0, $057fa7562ec736a9$export$8f67221c6fb2ad09) {
    static{
        /**
     * Tag name.
     */ this.tagName = 'dc:contributor';
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes, value){
        super(attributes, $cb35636d41d8f309$export$2b747e617c849cca.tagName, value);
    }
}
class $cb35636d41d8f309$export$3e18a603070a78a extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * Tag name.
     */ this.tagName = 'metadataList';
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes, title, source, creator, date, contributor){
        super(attributes, $cb35636d41d8f309$export$3e18a603070a78a.tagName);
        this.index = new Map();
        this.metadataIndex = new Map();
        if (title) {
            this.index.set($cb35636d41d8f309$export$7969c02c126c11b8.tagName, this.nodes.size);
            this.addNode(title);
        }
        if (source) {
            this.index.set($cb35636d41d8f309$export$c78a95f4a27bad68.tagName, this.nodes.size);
            this.addNode(source);
        }
        if (creator) {
            this.index.set($cb35636d41d8f309$export$61180682f135a7f2.tagName, this.nodes.size);
            this.addNode(creator);
        }
        if (date) {
            this.index.set($cb35636d41d8f309$export$bf6d63a1cea4a33c.tagName, this.nodes.size);
            this.addNode(date);
        }
        if (contributor) {
            this.index.set($cb35636d41d8f309$export$2b747e617c849cca.tagName, this.nodes.size);
            this.addNode(contributor);
        }
    }
    /**
     * Get the title.
     */ getTitle() {
        if (this.index.has($cb35636d41d8f309$export$7969c02c126c11b8.tagName)) {
            let i = this.index.get($cb35636d41d8f309$export$7969c02c126c11b8.tagName);
            return this.nodes.get(i);
        }
    }
    /**
     * @param title The title.
     */ setTitle(title) {
        if (this.index.has($cb35636d41d8f309$export$7969c02c126c11b8.tagName)) {
            let i = this.index.get($cb35636d41d8f309$export$7969c02c126c11b8.tagName);
            this.nodes.set(i, title);
        } else {
            this.index.set($cb35636d41d8f309$export$7969c02c126c11b8.tagName, this.nodes.size);
            this.addNode(title);
        }
    }
    /**
     * Get the source.
     */ getSource() {
        if (this.index.has($cb35636d41d8f309$export$c78a95f4a27bad68.tagName)) {
            let i = this.index.get($cb35636d41d8f309$export$c78a95f4a27bad68.tagName);
            return this.nodes.get(i);
        }
    }
    /**
     * @param source The source.
     */ setSource(source) {
        if (this.index.has($cb35636d41d8f309$export$c78a95f4a27bad68.tagName)) {
            let i = this.index.get($cb35636d41d8f309$export$c78a95f4a27bad68.tagName);
            this.nodes.set(i, source);
        } else {
            this.index.set($cb35636d41d8f309$export$c78a95f4a27bad68.tagName, this.nodes.size);
            this.addNode(source);
        }
    }
    /**
     * Get the creator.
     */ getCreator() {
        if (this.index.has($cb35636d41d8f309$export$61180682f135a7f2.tagName)) {
            let i = this.index.get($cb35636d41d8f309$export$61180682f135a7f2.tagName);
            return this.nodes.get(i);
        }
    }
    /**
     * @param creator The creator.
     */ setCreator(creator) {
        if (this.index.has($cb35636d41d8f309$export$61180682f135a7f2.tagName)) {
            let i = this.index.get($cb35636d41d8f309$export$61180682f135a7f2.tagName);
            this.nodes.set(i, creator);
        } else {
            this.index.set($cb35636d41d8f309$export$61180682f135a7f2.tagName, this.nodes.size);
            this.addNode(creator);
        }
    }
    /**
     * Get the date.
     */ getDate() {
        if (this.index.has($cb35636d41d8f309$export$bf6d63a1cea4a33c.tagName)) {
            let i = this.index.get($cb35636d41d8f309$export$bf6d63a1cea4a33c.tagName);
            return this.nodes.get(i);
        }
    }
    /**
     * @param date The date.
     */ setDate(date) {
        if (this.index.has($cb35636d41d8f309$export$bf6d63a1cea4a33c.tagName)) {
            let i = this.index.get($cb35636d41d8f309$export$bf6d63a1cea4a33c.tagName);
            this.nodes.set(i, date);
        } else {
            this.index.set($cb35636d41d8f309$export$bf6d63a1cea4a33c.tagName, this.nodes.size);
            this.addNode(date);
        }
    }
    /**
     * Get the contributor.
     */ getContributor() {
        if (this.index.has($cb35636d41d8f309$export$2b747e617c849cca.tagName)) {
            let i = this.index.get($cb35636d41d8f309$export$2b747e617c849cca.tagName);
            return this.nodes.get(i);
        }
    }
    /**
     * @param contributor The contributor.
     */ setContributor(contributor) {
        if (this.index.has($cb35636d41d8f309$export$2b747e617c849cca.tagName)) {
            let i = this.index.get($cb35636d41d8f309$export$2b747e617c849cca.tagName);
            this.nodes.set(i, contributor);
        } else {
            this.index.set($cb35636d41d8f309$export$2b747e617c849cca.tagName, this.nodes.size);
            this.addNode(contributor);
        }
    }
    /**
     * Add metadata.
     * @param metadata The metadata.
     */ addMetadata(metadata) {
        this.metadataIndex.set(this.metadataIndex.size, this.nodes.size);
        this.addNode(metadata);
    }
    /**
     * Get metadata.
     */ getMetadata() {
        let metadata = [];
        for(let i = 0; i < this.metadataIndex.size; i++){
            let j = this.metadataIndex.get(i);
            metadata.push(this.nodes.get(j));
        }
        return metadata;
    }
}



class $6ab526da66ecf283$export$26e33f0df9ce919d extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:grainSize";
    }
    /**
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $6ab526da66ecf283$export$26e33f0df9ce919d.tagName, value);
    }
}
class $6ab526da66ecf283$export$576b56ca6e34780b extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:automaticallySetMaxEne";
    }
    /**
     * @para attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $6ab526da66ecf283$export$576b56ca6e34780b.tagName, value);
    }
}
class $6ab526da66ecf283$export$aa73446724166cdb extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:energyAboveTheTopHill";
    }
    /**
     * @para attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $6ab526da66ecf283$export$aa73446724166cdb.tagName, value);
    }
}
class $6ab526da66ecf283$export$f9c72965e4ddfc8e extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:maxTemperature";
    }
    /**
     * @para attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $6ab526da66ecf283$export$f9c72965e4ddfc8e.tagName, value);
    }
}
class $6ab526da66ecf283$export$77f098867dc64198 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:modelParameters";
    }
    /**
     * @param attributes The attributes.
     * @param grainSize The grain size.
     * @param automaticallySetMaxEne The automatically set max energy.
     * @param energyAboveTheTopHill The energy above the top hill.
     * @param maxTemperature The max temperature.
     */ constructor(attributes, id, grainSize, automaticallySetMaxEne, energyAboveTheTopHill, maxTemperature){
        super(attributes, $6ab526da66ecf283$export$77f098867dc64198.tagName);
        this.id = id;
        this.index = new Map();
        if (grainSize != undefined) {
            this.index.set($6ab526da66ecf283$export$26e33f0df9ce919d.tagName, this.nodes.size);
            this.addNode(grainSize);
        }
        if (automaticallySetMaxEne != undefined) {
            this.index.set($6ab526da66ecf283$export$576b56ca6e34780b.tagName, this.nodes.size);
            this.addNode(automaticallySetMaxEne);
        }
        if (energyAboveTheTopHill != undefined) {
            this.index.set($6ab526da66ecf283$export$aa73446724166cdb.tagName, this.nodes.size);
            this.addNode(energyAboveTheTopHill);
        }
        if (maxTemperature != undefined) {
            this.index.set($6ab526da66ecf283$export$f9c72965e4ddfc8e.tagName, this.nodes.size);
            this.addNode(maxTemperature);
        }
    }
    /**
     * @returns The grain size or undefined.
     */ getGrainSize() {
        console.log("getGrainSize");
        let i = this.index.get($6ab526da66ecf283$export$26e33f0df9ce919d.tagName);
        if (i != undefined) return this.nodes.get(i);
        console.log("XgetGrainSize");
    }
    /**
     * @param grainSize The grain size.
     */ setGrainSize(grainSize) {
        console.log("setGrainSize");
        let i = this.index.get($6ab526da66ecf283$export$26e33f0df9ce919d.tagName);
        if (i != undefined) this.nodes.set(i, grainSize);
        else {
            this.index.set($6ab526da66ecf283$export$26e33f0df9ce919d.tagName, this.nodes.size);
            this.addNode(grainSize);
        }
    }
    /**
     * Removes the grain size.
     */ removeGrainSize() {
        let i = this.index.get($6ab526da66ecf283$export$26e33f0df9ce919d.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($6ab526da66ecf283$export$26e33f0df9ce919d.tagName);
        }
    }
    /**
     * @returns The automatically set max energy or undefined.
     */ getAutomaticallySetMaxEne() {
        let i = this.index.get($6ab526da66ecf283$export$576b56ca6e34780b.tagName);
        if (i) return this.nodes.get(i);
    }
    /**
     * @param automaticallySetMaxEne The automatically set max energy.
     */ setAutomaticallySetMaxEne(automaticallySetMaxEne) {
        let i = this.index.get($6ab526da66ecf283$export$576b56ca6e34780b.tagName);
        if (i) this.nodes.set(i, automaticallySetMaxEne);
        else {
            this.index.set($6ab526da66ecf283$export$576b56ca6e34780b.tagName, this.nodes.size);
            this.addNode(automaticallySetMaxEne);
        }
    }
    /**
     * Removes the automatically set max energy.
     */ removeAutomaticallySetMaxEne() {
        let i = this.index.get($6ab526da66ecf283$export$576b56ca6e34780b.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($6ab526da66ecf283$export$576b56ca6e34780b.tagName);
        }
    }
    /**
     * @returns The energy above the top hill or undefined.
     */ getEnergyAboveTheTopHill() {
        let i = this.index.get($6ab526da66ecf283$export$aa73446724166cdb.tagName);
        if (i) return this.nodes.get(i);
    }
    /**
     * @param energyAboveTheTopHill The energy above the top hill.
     */ setEnergyAboveTheTopHill(energyAboveTheTopHill) {
        let i = this.index.get($6ab526da66ecf283$export$aa73446724166cdb.tagName);
        if (i) this.nodes.set(i, energyAboveTheTopHill);
        else {
            this.index.set($6ab526da66ecf283$export$aa73446724166cdb.tagName, this.nodes.size);
            this.addNode(energyAboveTheTopHill);
        }
    }
    /**
     * Removes the energy above the top hill.
     */ removeEnergyAboveTheTopHill() {
        let i = this.index.get($6ab526da66ecf283$export$aa73446724166cdb.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($6ab526da66ecf283$export$aa73446724166cdb.tagName);
        }
    }
    /**
     * @returns The max temperature or undefined.
     */ getMaxTemperature() {
        let i = this.index.get($6ab526da66ecf283$export$f9c72965e4ddfc8e.tagName);
        if (i) return this.nodes.get(i);
    }
    /**
     * @param maxTemperature The max temperature.
     */ setMaxTemperature(maxTemperature) {
        let i = this.index.get($6ab526da66ecf283$export$f9c72965e4ddfc8e.tagName);
        if (i) this.nodes.set(i, maxTemperature);
        else {
            this.index.set($6ab526da66ecf283$export$f9c72965e4ddfc8e.tagName, this.nodes.size);
            this.addNode(maxTemperature);
        }
    }
    /**
     * Removes the max temperature.
     */ removeMaxTemperature() {
        let i = this.index.get($6ab526da66ecf283$export$f9c72965e4ddfc8e.tagName);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete($6ab526da66ecf283$export$f9c72965e4ddfc8e.tagName);
        }
    }
}



class $ccef02370f58a770$export$f99233281efd08a0 extends (0, $057fa7562ec736a9$export$8f67221c6fb2ad09) {
    static{
        this.tagName = "me:title";
    }
    /**
     * @param value 
     */ constructor(attributes, value){
        super(attributes, $ccef02370f58a770$export$f99233281efd08a0.tagName, value);
    }
}
class $ccef02370f58a770$export$19d70f3647dee606 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "moleculeList";
    }
    /**
     * @param attributes The attributes.
     * @param molecules The molecules.
     */ constructor(attributes, molecules){
        super(attributes, $ccef02370f58a770$export$19d70f3647dee606.tagName);
        this.index = new Map();
        if (molecules != undefined) molecules.forEach((molecule)=>{
            this.nodes.set(this.nodes.size, molecule);
            this.index.set(molecule.getID(), this.nodes.size - 1);
        });
    }
    /**
     * @param id The id of the molecule.
     * @returns The molecule.
     */ getMolecule(id) {
        let i = this.index.get(id);
        if (i == undefined) return undefined;
        return this.nodes.get(i);
    }
    /**
     * Remove a molecule.
     * @param id The id of the molecule to remove.
     */ removeMolecule(id) {
        let i = this.index.get(id);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete(id);
        }
    }
    /**
     * Add a molecule.
     * @param molecule The molecule.
     */ addMolecule(molecule) {
        let mID = molecule.getID();
        let index = this.index.get(mID);
        if (index !== undefined) {
            this.nodes.set(index, molecule);
            console.log('Replaced molecule with id ' + mID);
        } else {
            this.nodes.set(this.nodes.size, molecule);
            this.index.set(mID, this.nodes.size - 1);
        }
    }
}
class $ccef02370f58a770$export$44466a39ca846289 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "reactionList";
    }
    /**
     * @param attributes The attributes.
     * @param reactions The reactions.
     */ constructor(attributes, reactions){
        super(attributes, $ccef02370f58a770$export$44466a39ca846289.tagName);
        this.index = new Map();
        if (reactions != undefined) reactions.forEach((reaction)=>{
            this.nodes.set(this.nodes.size, reaction);
            this.index.set(reaction.id, this.nodes.size - 1);
        });
    }
    /**
     * @param id The id of the reaction.
     * @returns The reaction.
     */ getReaction(id) {
        let i = this.index.get(id);
        if (i == undefined) return undefined;
        return this.nodes.get(i);
    }
    /**
     * Remove a reaction.
     * @param id The id of the reaction to remove.
     */ removeReaction(id) {
        let i = this.index.get(id);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete(id);
        }
    }
    /**
     * Add a reaction.
     * @param reaction The reaction.
     */ addReaction(reaction) {
        let index = this.index.get(reaction.id);
        if (index !== undefined) {
            this.nodes.set(index, reaction);
            console.log('Replaced reaction with id ' + reaction.id);
        } else {
            this.nodes.set(this.nodes.size, reaction);
            this.index.set(reaction.id, this.nodes.size - 1);
        }
    }
    /**
     * @returns The next control id.
     */ getNextReactionID() {
        let id = 1;
        // Sort the control index by key and go through these and take the next available id.
        let sortedKeys = Array.from(this.index.keys()).sort((a, b)=>{
            // Extract the number parts from the keys
            let matchA = a.match(/\d+/);
            let matchB = b.match(/\d+/);
            let numberA = matchA ? parseInt(matchA[0]) : 0;
            let numberB = matchB ? parseInt(matchB[0]) : 0;
            // Compare the number parts
            return numberA - numberB;
        });
        //console.log("sortedKeys " + arrayToString(sortedKeys));
        sortedKeys.forEach((key)=>{
            let key2 = parseInt(key.match(/\d+/)[0]);
            if (key2 > id) return id;
            id++;
        });
        return id;
    }
}
class $ccef02370f58a770$export$3139ebae3f570365 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "conditionsList";
    }
    /**
     * @param attributes The attributes.
     * @param conditionss The conditions.
     */ constructor(attributes, conditionss){
        super(attributes, $ccef02370f58a770$export$2be1c851e287a6b1.tagName);
        this.index = new Map();
        if (conditionss != undefined) conditionss.forEach((conditions)=>{
            this.nodes.set(this.nodes.size, conditions);
            this.index.set(conditions.id, this.nodes.size - 1);
        });
    }
    /**
     * @param id The id of the control.
     * @returns The conditions.
     */ getConditions(id) {
        let i = this.index.get(id);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * Remove a control.
     * @param id The id of the control to remove.
     */ removeConditions(id) {
        let i = this.index.get(id);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete(id);
        }
    }
    /**
     * Add a conditions.
     * @param conditions The conditions.
     */ addConditions(conditions) {
        let index = this.index.get(conditions.id);
        if (index != undefined) {
            this.nodes.set(index, conditions);
            console.log('Replaced conditions with id ' + conditions.id);
        } else {
            this.nodes.set(this.nodes.size, conditions);
            this.index.set(conditions.id, this.nodes.size - 1);
        }
    }
}
class $ccef02370f58a770$export$a46a5ec84602acfd extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "modelParametersList";
    }
    /**
     * @param attributes The attributes.
     * @param modelParameterss The modelParameters.
     */ constructor(attributes, modelParameterss){
        super(attributes, $ccef02370f58a770$export$a46a5ec84602acfd.tagName);
        this.index = new Map();
        if (modelParameterss != undefined) modelParameterss.forEach((modelParameters)=>{
            this.nodes.set(this.nodes.size, modelParameters);
            this.index.set(modelParameters.id, this.nodes.size - 1);
        });
    }
    /**
     * @param id The id of the modelParameters.
     * @returns The modelParameters.
     */ getModelParameters(id) {
        let i = this.index.get(id);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * Remove a modelParameters.
     * @param id The id of the modelParameters to remove.
     */ removeModelParameters(id) {
        let i = this.index.get(id);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete(id);
        }
    }
    /**
     * Add a modelParameters.
     * @param modelParameters The modelParameters.
     */ addModelParameters(modelParameters) {
        let index = this.index.get(modelParameters.id);
        if (index != undefined) {
            this.nodes.set(index, modelParameters);
            console.log('Replaced modelParameters with id ' + modelParameters.id);
        } else {
            this.nodes.set(this.nodes.size, modelParameters);
            this.index.set(modelParameters.id, this.nodes.size - 1);
        }
    }
}
class $ccef02370f58a770$export$2be1c851e287a6b1 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "controlList";
    }
    /**
     * @param attributes The attributes.
     * @param controls The controls.
     */ constructor(attributes, controls){
        super(attributes, $ccef02370f58a770$export$2be1c851e287a6b1.tagName);
        this.index = new Map();
        if (controls != undefined) controls.forEach((control)=>{
            this.nodes.set(this.nodes.size, control);
            this.index.set(control.id, this.nodes.size - 1);
        });
    }
    /**
     * @param id The id of the control.
     * @returns The control.
     */ getControl(id) {
        let i = this.index.get(id);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * Remove a control.
     * @param id The id of the control to remove.
     */ removeControl(id) {
        let i = this.index.get(id);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete(id);
        }
    }
    /**
     * Add a control.
     * @param control The control.
     */ addControl(control) {
        let index = this.index.get(control.id);
        if (index !== undefined) {
            this.nodes.set(index, control);
            console.log('Replaced control with id ' + control.id);
        } else {
            this.nodes.set(this.nodes.size, control);
            this.index.set(control.id, this.nodes.size - 1);
        }
    }
}
class $ccef02370f58a770$export$692079bb871c6039 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        this.tagName = "me:mesmer";
    }
    static{
        /**
     * Precision options.
     */ this.precisionOptions = [
            "d",
            "dd",
            "qd",
            "double",
            "double-double",
            "quad-double"
        ];
    }
    static{
        /**
     * Pressure units.
     */ this.pressureUnits = [
            "Torr",
            "PPCC",
            "atm",
            "mbar",
            "psi",
            "mols/cc"
        ];
    }
    static{
        /**
     * Energy units.
     */ this.energyUnits = [
            "kJ/mol",
            "kJ per mol",
            "cm-1",
            "wavenumber",
            "kcal/mol",
            "kcal per mol",
            "Hartree",
            "au"
        ];
    }
    static{
        /**
     * Frequency units.
     */ this.frequencyUnits = [
            "cm-1",
            "GHz",
            "amuA^2"
        ];
    }
    static{
        /**
     * Mass units.
     */ this.massUnits = [
            "amu",
            "g/mol",
            "kg/mol"
        ];
    }
    static{
        /**
     * Temperature units.
     */ this.temperatureUnits = [
            "K"
        ];
    }
    static{
        /**
     * Time units.
     */ this.timeUnits = [
            "fs",
            "ps",
            "ns",
            "s"
        ];
    }
    static{
        /**
     * Length units.
     */ this.lengthUnits = [
            "\xc5",
            "nm",
            "um",
            "mm",
            "cm",
            "m"
        ];
    }
    static{
        /**
     * Hessian units.
     */ this.hessianUnits = [
            "kJ/mol/\xc52",
            "kcal/mol/\xc52",
            "Hartree/\xc52"
        ];
    }
    static{
        /**
     * EinsteinAUnits units.
     */ this.EinsteinAUnits = [
            "s-1"
        ];
    }
    static{
        /**
     * EinsteinBUnits units.
     */ this.EinsteinBUnits = [
            "m3/J/s2"
        ];
    }
    static{
        /**
     * The atoms with 1 to 118 protons inclusive.
     * (source: https://query.wikidata.org/#SELECT%20%3Felement%20%3Fsymbol%20%20%3Fprotons%0AWHERE%0A%7B%0A%20%20%3Felement%20wdt%3AP31%20wd%3AQ11344%20%3B%0A%20%20%20%20%20%20%20%20%20%20%20wdt%3AP1086%20%3Fprotons%20%3B%0A%20%20%20%20%20%20%20%20%20%20%20wdt%3AP246%20%3Fsymbol%20.%0A%7D%0A%0AORDER%20BY%20%3Fprotons)
     */ this.elementTypes = [
            "H",
            "He",
            "Li",
            "Be",
            "B",
            "C",
            "N",
            "O",
            "F",
            "Ne",
            "Na",
            "Mg",
            "Al",
            "Si",
            "P",
            "S",
            "Cl",
            "Ar",
            "K",
            "Ca",
            "Sc",
            "Ti",
            "V",
            "Cr",
            "Mn",
            "Fe",
            "Co",
            "Ni",
            "Cu",
            "Zn",
            "Ga",
            "Ge",
            "As",
            "Se",
            "Br",
            "Kr",
            "Rb",
            "Sr",
            "Y",
            "Zr",
            "Nb",
            "Mo",
            "Tc",
            "Ru",
            "Rh",
            "Pd",
            "Ag",
            "Cd",
            "In",
            "Sn",
            "Sb",
            "Te",
            "I",
            "Xe",
            "Cs",
            "Ba",
            "La",
            "Ce",
            "Pr",
            "Nd",
            "Pm",
            "Sm",
            "Eu",
            "Gd",
            "Tb",
            "Dy",
            "Ho",
            "Er",
            "Tm",
            "Yb",
            "Lu",
            "Hf",
            "Ta",
            "W",
            "Re",
            "Os",
            "Ir",
            "Pt",
            "Au",
            "Hg",
            "Tl",
            "Pb",
            "Bi",
            "Po",
            "At",
            "Rn",
            "Fr",
            "Ra",
            "Ac",
            "Th",
            "Pa",
            "U",
            "Np",
            "Pu",
            "Am",
            "Cm",
            "Bk",
            "Cf",
            "Es",
            "Fm",
            "Md",
            "No",
            "Lr",
            "Rf",
            "Db",
            "Sg",
            "Bh",
            "Hs",
            "Mt",
            "Ds",
            "Rg",
            "Cn",
            "Nh",
            "Fl",
            "Mc",
            "Lv",
            "Ts",
            "Og"
        ];
    }
    static{
        /**
     * Atomic mass map for atoms. The keys are element symbols, the values are the atomic mass according to a periodic table.
     * (This is initialised in the constructor.)
     */ this.atomMasses = new Map();
    }
    static{
        /**
     * Atomic radius map for atoms. The keys are element symbols, the values are the atomic radii according to a periodic table.
     * (This is initialised in the constructor.)
     */ this.atomRadii = new Map();
    }
    static{
        /**
     * Colour map for atoms. The keys are element symbols, the values are the colours the element is assigned.
     * (This is initialised in the constructor.)
     */ this.atomColors = new Map();
    }
    static{
        /**
     * Colour map for bonds. The keys are bond order, the values are the colours the bond order is assigned.
     * (This is initialised in the constructor.)
     */ this.bondColors = new Map();
    }
    static{
        /**
     * The header of the XML file.
     */ this.header = `<?xml version="1.0" encoding="utf-8" ?>
<?xml-stylesheet type='text/xsl' href='../../mesmer2.xsl' media='other'?>
<?xml-stylesheet type='text/xsl' href='../../mesmer1.xsl' media='screen'?>`;
    }
    /**
     * @param attributes The attributes.
     * @param moleculeList The molecule list.
     * @param reactionList The reaction list.
     * @param conditions The conditions.
     * @param modelParameters The model parameters.
     * @param controls The controls.
     */ constructor(attributes, title, moleculeList, reactionList, conditionss, modelParameterss, controls, metadataList, analysis){
        super(attributes, $ccef02370f58a770$export$692079bb871c6039.tagName);
        let elements = [
            "H",
            "O",
            "C",
            "N",
            "Cl",
            "S",
            "Ph",
            "Fe"
        ];
        let colors = [
            "White",
            "Red",
            "DarkGrey",
            "Blue",
            "Green",
            "Yellow",
            "Orange",
            "Brown"
        ];
        for(let i = 0; i < elements.length; i++)$ccef02370f58a770$export$692079bb871c6039.atomColors.set(elements[i], colors[i]);
        // Atomic mass units (amu)
        let masses = [
            1.00784,
            15.999,
            12.011,
            14.007,
            35.453,
            32.06,
            77.845,
            55.845
        ]; // Atomic masses (see https://en.wikipedia.org/wiki/Periodic_table).
        for(let i = 0; i < elements.length; i++)$ccef02370f58a770$export$692079bb871c6039.atomMasses.set(elements[i], masses[i]);
        // Picometers (pm),
        let radii = [
            37,
            66,
            67,
            56,
            99,
            102,
            110,
            124
        ]; // Calculated radii between two atoms of the same type in a molecule (https://en.wikipedia.org/wiki/Atomic_radii_of_the_elements_(data_page)).
        for(let i = 0; i < elements.length; i++)$ccef02370f58a770$export$692079bb871c6039.atomRadii.set(elements[i], radii[i]);
        let bondOrders = [
            1,
            1.5,
            2,
            2.5,
            3,
            3.5,
            4,
            4.5,
            5,
            5.5,
            6
        ];
        colors = [
            "Black",
            "Red",
            "DarkRed",
            "Blue",
            "DarkBlue",
            "Green",
            "DarkGreen",
            "Yellow",
            "DarkYellow",
            "Orange",
            "DarkOrange"
        ];
        for(let i = 0; i < bondOrders.length; i++)$ccef02370f58a770$export$692079bb871c6039.bondColors.set(bondOrders[i], colors[i]);
        this.index = new Map();
        if (title != undefined) {
            this.index.set($ccef02370f58a770$export$f99233281efd08a0.tagName, this.nodes.size);
            this.addNode(title);
        }
        if (moleculeList != undefined) {
            this.index.set($ccef02370f58a770$export$19d70f3647dee606.tagName, this.nodes.size);
            this.addNode(moleculeList);
        }
        if (reactionList != undefined) {
            this.index.set($ccef02370f58a770$export$44466a39ca846289.tagName, this.nodes.size);
            this.addNode(reactionList);
        }
        this.conditionsIndex = new Map();
        if (conditionss != undefined) conditionss.forEach((conditions)=>{
            this.index.set((0, $5b710835528e7170$export$363c7374d425f4ad).tagName + conditions.id, this.nodes.size);
            this.conditionsIndex.set(conditions.id, this.nodes.size);
            this.addNode(conditions);
        });
        this.modelParametersIndex = new Map();
        if (modelParameterss != undefined) modelParameterss.forEach((modelParameters)=>{
            this.index.set((0, $6ab526da66ecf283$export$77f098867dc64198).tagName + modelParameters.id, this.nodes.size);
            this.modelParametersIndex.set(modelParameters.id, this.nodes.size);
            this.addNode(modelParameters);
        });
        this.controlIndex = new Map();
        if (controls != undefined) controls.forEach((control)=>{
            this.index.set((0, $085f2478c495b249$export$7a7fa4424cb20976).tagName + control.id, this.nodes.size);
            this.controlIndex.set(control.id, this.nodes.size);
            this.addNode(control);
        });
        if (metadataList != undefined) {
            this.index.set((0, $cb35636d41d8f309$export$3e18a603070a78a).tagName, this.nodes.size);
            this.addNode(metadataList);
        }
        if (analysis != undefined) {
            this.index.set((0, $012df152aa25e440$export$c4c153dc94cc96b4).tagName, this.nodes.size);
            this.addNode(analysis);
        }
    }
    /**
     * @returns The title.
     */ getTitle() {
        let i = this.index.get($ccef02370f58a770$export$f99233281efd08a0.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * Set the title.
     * @param title The title.
     */ setTitle(title) {
        let i = this.index.get($ccef02370f58a770$export$f99233281efd08a0.tagName);
        if (i != undefined) this.nodes.set(i, title);
        else {
            this.index.set($ccef02370f58a770$export$f99233281efd08a0.tagName, this.nodes.size);
            this.addNode(title);
        }
    }
    /**
     * @returns The molecule list.
     */ getMoleculeList() {
        let i = this.index.get($ccef02370f58a770$export$19d70f3647dee606.tagName);
        if (i != undefined) return this.nodes.get(i);
        else {
            let moleculeList = new $ccef02370f58a770$export$19d70f3647dee606(new Map());
            this.index.set($ccef02370f58a770$export$19d70f3647dee606.tagName, this.nodes.size);
            this.addNode(moleculeList);
            return moleculeList;
        }
    }
    /**
     * Set the molecule list.
     * @param moleculeList The molecule list.
     */ setMoleculeList(moleculeList) {
        let i = this.index.get($ccef02370f58a770$export$19d70f3647dee606.tagName);
        if (i != undefined) this.nodes.set(i, moleculeList);
        else {
            this.index.set($ccef02370f58a770$export$19d70f3647dee606.tagName, this.nodes.size);
            this.addNode(moleculeList);
        }
    }
    /**
     * @returns The next control id.
     *
    getNextReactionID(): number {
        let id = 1;
        if (this.getReactionList() == undefined) {
            return id;
        }
        // Sort the control index by key and go through these and take the next available id.
        let sortedKeys = Array.from(this.getReactionList()!.index.keys()).sort((a, b) => {
            // Extract the number parts from the keys
            let matchA = a.match(/\d+/);
            let matchB = b.match(/\d+/);
            let numberA = matchA ? parseInt(matchA[0]) : 0;
            let numberB = matchB ? parseInt(matchB[0]) : 0;
            // Compare the number parts
            return numberA - numberB;
        });
        //console.log("sortedKeys " + arrayToString(sortedKeys));
        sortedKeys.forEach((key) => {
            let key2 = parseInt(key.match(/\d+/)![0]);
            if (key2 > id) {
                return id;
            }
            id++;
        });
        return id;
    }

    /**
     * @param reaction The reaction to add.
     *
    addReaction(reaction: Reaction) {
        let id = Reaction.tagName + reaction.id;
        let i: number | undefined = this.index.get(id);
        if (i != undefined) {
            this.nodes.set(i, reaction);
        } else {
            this.index.set(id, this.nodes.size);
            this.addNode(reaction);
        }
    }

    /**
     * @param reactionID The id of the reaction to remove.
     *
    removeReaction(reactionID: number) {
        let i: number | undefined = this.index.get(Reaction.tagName + reactionID);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete(Reaction.tagName + reactionID);
        }
    }

    /**
     * @returns The reaction list.
     */ getReactionList() {
        let i = this.index.get($ccef02370f58a770$export$44466a39ca846289.tagName);
        if (i != undefined) return this.nodes.get(i);
        else {
            let reactionList = new $ccef02370f58a770$export$44466a39ca846289(new Map());
            this.index.set($ccef02370f58a770$export$44466a39ca846289.tagName, this.nodes.size);
            this.addNode(reactionList);
            return reactionList;
        }
    }
    /**
     * Set the reaction list.
     * @param reactionList The reaction list.
     */ setReactionList(reactionList) {
        let i = this.index.get($ccef02370f58a770$export$44466a39ca846289.tagName);
        if (i != undefined) this.nodes.set(i, reactionList);
        else {
            this.index.set($ccef02370f58a770$export$44466a39ca846289.tagName, this.nodes.size);
            this.addNode(reactionList);
        }
    }
    /**
     * Add a Conditions.
     * @param conditions The Conditions.
     */ addConditions(conditions) {
        let id = (0, $5b710835528e7170$export$363c7374d425f4ad).tagName + conditions.id;
        let i = this.index.get(id);
        if (i != undefined) this.nodes.set(i, conditions);
        else {
            this.index.set(id, this.nodes.size);
            this.conditionsIndex.set(conditions.id, this.nodes.size);
            this.addNode(conditions);
        }
    }
    /**
     * @param conditionsID The id of the conditions.
     * @returns The conditions for the conditionsID.
     */ getConditions(conditionsID) {
        let i = this.conditionsIndex.get(conditionsID);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @returns The conditions as a Conditions[].
     */ getConditionss() {
        let conditionss = [];
        this.conditionsIndex.forEach((index, conditionsID)=>{
            conditionss.push(this.nodes.get(index));
        });
        return conditionss;
    }
    /**
     * Set the conditions.
     * @param conditionss The Conditions[].
     */ setConditionss(conditionss) {
        conditionss.forEach((conditions)=>{
            this.addConditions(conditions);
        });
    }
    /**
     * @returns The next control id.
     */ getNextConditionsID() {
        let id = 0;
        // Sort the control index by key and go through these and take the next available id.
        let sortedKeys = Array.from(this.conditionsIndex.keys()).sort((a, b)=>a - b);
        //console.log("sortedKeys " + arrayToString(sortedKeys));
        sortedKeys.forEach((key)=>{
            if (key > id) return id;
            id++;
        });
        return id;
    }
    /**
     * Remove a conditions.
     * @param conditionsID The id of the conditions to remove.
     */ removeConditions(conditionsID) {
        let i = this.conditionsIndex.get(conditionsID);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete((0, $5b710835528e7170$export$363c7374d425f4ad).tagName + conditionsID);
            this.conditionsIndex.delete(conditionsID);
        }
    }
    /**
     * Add a ModelParameters.
     * @param modelParameters The ModelParameters.
     */ addModelParameters(modelParameters) {
        let id = (0, $6ab526da66ecf283$export$77f098867dc64198).tagName + modelParameters.id;
        let i = this.index.get(id);
        if (i != undefined) this.nodes.set(i, modelParameters);
        else {
            this.index.set(id, this.nodes.size);
            this.modelParametersIndex.set(modelParameters.id, this.nodes.size);
            this.addNode(modelParameters);
        }
    }
    /**
     * @param modelParametersID The id of the modelParameters.
     * @returns The modelParameters for the modelParametersID.
     */ getModelParameters(modelParametersID) {
        let i = this.modelParametersIndex.get(modelParametersID);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @returns The modelParameters as a ModelParameters[].
     */ getModelParameterss() {
        let modelParameterss = [];
        this.modelParametersIndex.forEach((index, modelParametersID)=>{
            modelParameterss.push(this.nodes.get(index));
        });
        return modelParameterss;
    }
    /**
     * Set the modelParameters.
     * @param modelParameterss The ModelParameters[].
     */ setModelParameterss(modelParameterss) {
        modelParameterss.forEach((modelParameters)=>{
            this.addModelParameters(modelParameters);
        });
    }
    /**
     * @returns The next modelParameters id.
     */ getNextModelParametersID() {
        let id = 0;
        // Sort the control index by key and go through these and take the next available id.
        let sortedKeys = Array.from(this.modelParametersIndex.keys()).sort((a, b)=>a - b);
        //console.log("sortedKeys " + arrayToString(sortedKeys));
        sortedKeys.forEach((key)=>{
            if (key > id) return id;
            id++;
        });
        return id;
    }
    /**
     * Remove a modelParameters.
     * @param modelParametersID The id of the modelParameters to remove.
     */ removeModelParameters(modelParametersID) {
        let i = this.modelParametersIndex.get(modelParametersID);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete((0, $6ab526da66ecf283$export$77f098867dc64198).tagName + modelParametersID);
            this.modelParametersIndex.delete(modelParametersID);
        }
    }
    /**
     * Add a Control.
     * @param control The Control.
     */ addControl(control) {
        let id = (0, $085f2478c495b249$export$7a7fa4424cb20976).tagName + control.id;
        let i = this.index.get(id);
        if (i != undefined) this.nodes.set(i, control);
        else {
            this.index.set(id, this.nodes.size);
            this.controlIndex.set(control.id, this.nodes.size);
            this.addNode(control);
        }
    }
    /**
     * @returns The control.
     */ getControl(controlID) {
        let i = this.controlIndex.get(controlID);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @returns The controls.
     */ getControls() {
        let controls = [];
        this.controlIndex.forEach((index, controlID)=>{
            controls.push(this.nodes.get(index));
        });
        return controls;
    }
    /**
     * Set the controls.
     * @param controls The controls.
     */ setControls(controls) {
        controls.forEach((control)=>{
            this.addControl(control);
        });
    }
    /**
     * @returns The next control id.
     */ getNextControlID() {
        let id = 0;
        // Sort the control index by key and go through these and take the next available id.
        let sortedKeys = Array.from(this.controlIndex.keys()).sort((a, b)=>a - b);
        //console.log("sortedKeys " + arrayToString(sortedKeys));
        sortedKeys.forEach((key)=>{
            if (key > id) return id;
            id++;
        });
        return id;
    }
    /**
     * Remove a control.
     * @param controlID The id of the control to remove.
     */ removeControl(controlID) {
        let i = this.controlIndex.get(controlID);
        //console.log("removeControl " + controlID + " " + i);
        //console.log("controlIndex " + arrayToString(Array.from(this.controlIndex.keys())));
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete((0, $085f2478c495b249$export$7a7fa4424cb20976).tagName + controlID);
            this.controlIndex.delete(controlID);
        }
    }
    /**
     * @returns The metadata list.
     */ getMetadataList() {
        let i = this.index.get((0, $cb35636d41d8f309$export$3e18a603070a78a).tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param metadataList The metadata list.
     */ setMetadataList(metadataList) {
        let i = this.index.get((0, $cb35636d41d8f309$export$3e18a603070a78a).tagName);
        if (i != undefined) this.nodes.set(i, metadataList);
        else {
            this.index.set((0, $cb35636d41d8f309$export$3e18a603070a78a).tagName, this.nodes.size);
            this.addNode(metadataList);
        }
    }
    /**
     * @returns The analysis.
     */ getAnalysis() {
        let i = this.index.get((0, $012df152aa25e440$export$c4c153dc94cc96b4).tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param analysis The analysis.
     */ setAnalysis(analysis) {
        let i = this.index.get((0, $012df152aa25e440$export$c4c153dc94cc96b4).tagName);
        if (i != undefined) this.nodes.set(i, analysis);
        else {
            this.index.set((0, $012df152aa25e440$export$c4c153dc94cc96b4).tagName, this.nodes.size);
            this.addNode(analysis);
        }
    }
}
class $ccef02370f58a770$export$393edc798c47379d extends (0, $057fa7562ec736a9$export$8f67221c6fb2ad09) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:description";
    }
    /**
     * @param attributes The attributes.
     * @param description The description.
     */ constructor(attributes, description){
        super(attributes, $ccef02370f58a770$export$393edc798c47379d.tagName, description);
    }
}
class $ccef02370f58a770$export$971d5caa766a69d7 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:T";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $ccef02370f58a770$export$971d5caa766a69d7.tagName, value);
    }
}






class $3e7c52c9467308b9$export$d0e9917d83c120a0 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The key for the units attribute.
     */ this.s_units = "units";
    }
    static{
        /**
     * The key for the lower attribute.
     */ this.s_lower = "lower";
    }
    static{
        /**
     * The key for the upper attribute.
     */ this.s_upper = "upper";
    }
    static{
        /**
     * The key for the stepsize attribute.
     */ this.s_stepsize = "stepsize";
    }
    /**
     * @param attributes The attributes.
     * @param tagName The tag name.
     * @param value The value.
     */ constructor(attributes, tagName, value){
        super(attributes, tagName, value);
    }
    /**
     * @param value The value of the Range.
     */ setValue(value) {
        this.value = value;
    }
    /**
     * @returns The units of the Range.
     */ getUnits() {
        return this.attributes.get($3e7c52c9467308b9$export$d0e9917d83c120a0.s_units);
    }
    /**
     * @param units The units of the Range.
     */ setUnits(units) {
        this.attributes.set($3e7c52c9467308b9$export$d0e9917d83c120a0.s_units, units);
    }
    /**
     * Remove the units attribute.
     */ removeUnits() {
        this.attributes.delete($3e7c52c9467308b9$export$d0e9917d83c120a0.s_units);
    }
    /**
     * @returns The lower of the Range.
     */ getLower() {
        let lower = this.attributes.get($3e7c52c9467308b9$export$d0e9917d83c120a0.s_lower);
        if (lower != undefined) return new (0, $ad9e9f310a798519$exports.Big)(lower);
    }
    /**
     * @param lower The lower of the Range.
     */ setLower(lower) {
        this.attributes.set($3e7c52c9467308b9$export$d0e9917d83c120a0.s_lower, lower.toString());
    }
    /**
     * Remove the lower attribute.
     */ removeLower() {
        this.attributes.delete($3e7c52c9467308b9$export$d0e9917d83c120a0.s_lower);
    }
    /**
     * @returns The upper of the Range.
     */ getUpper() {
        let upper = this.attributes.get($3e7c52c9467308b9$export$d0e9917d83c120a0.s_upper);
        if (upper != undefined) return new (0, $ad9e9f310a798519$exports.Big)(upper);
    }
    /**
     * @param upper The upper of the Range.
     */ setUpper(upper) {
        this.attributes.set($3e7c52c9467308b9$export$d0e9917d83c120a0.s_upper, upper.toString());
    }
    /**
     * Remove the upper attribute.
     */ removeUpper() {
        this.attributes.delete($3e7c52c9467308b9$export$d0e9917d83c120a0.s_upper);
    }
    /**
     * @returns The stepsize of the Range.
     */ getStepsize() {
        let stepsize = this.attributes.get($3e7c52c9467308b9$export$d0e9917d83c120a0.s_stepsize);
        if (stepsize != undefined) return new (0, $ad9e9f310a798519$exports.Big)(stepsize);
    }
    /**
     * @param stepsize The stepsize of the Range.
     */ setStepsize(stepsize) {
        this.attributes.set($3e7c52c9467308b9$export$d0e9917d83c120a0.s_stepsize, stepsize.toString());
    }
    /**
     * Remove the stepsize attribute.
     */ removeStepsize() {
        this.attributes.delete($3e7c52c9467308b9$export$d0e9917d83c120a0.s_stepsize);
    }
}






class $597d59a3d37b5b3f$export$80986e6afdd7e0cb extends (0, $057fa7562ec736a9$export$ca4ceee82ec565dc) {
    static{
        /**
     * The tag name.
     */ this.tagName = "atom";
    }
    static{
        /**
     * The key for the id attribute.
     */ this.s_id = "id";
    }
    static{
        /**
     * The key for the elementType attribute.
     */ this.s_elementType = "elementType";
    }
    static{
        /**
     * The key for the x3 attribute.
     */ this.s_x3 = "x3";
    }
    static{
        /**
     * The key for the y3 attribute.
     */ this.s_y3 = "y3";
    }
    static{
        /**
     * The key for the z3 attribute.
     */ this.s_z3 = "z3";
    }
    /**
     * @param attributes The attributes. If there is no "elementType" key an error will be thrown.
     */ constructor(attributes, molecule){
        super(attributes, $597d59a3d37b5b3f$export$80986e6afdd7e0cb.tagName);
        this.molecule = molecule;
    }
    /**
     * @returns True if the atom has coordinates.
     */ hasCoordinates() {
        if (this.attributes.get($597d59a3d37b5b3f$export$80986e6afdd7e0cb.s_x3) != undefined && this.attributes.get($597d59a3d37b5b3f$export$80986e6afdd7e0cb.s_y3) != undefined && this.attributes.get($597d59a3d37b5b3f$export$80986e6afdd7e0cb.s_z3) != undefined) return true;
        return false;
    }
    /**
     * @returns The id.
     */ getID() {
        return this.attributes.get($597d59a3d37b5b3f$export$80986e6afdd7e0cb.s_id);
    }
    /**
     * @param id The id.
     */ setID(id) {
        this.attributes.set($597d59a3d37b5b3f$export$80986e6afdd7e0cb.s_id, id);
    }
    /**
     * @returns The element type.
     */ getElementType() {
        return this.attributes.get($597d59a3d37b5b3f$export$80986e6afdd7e0cb.s_elementType);
    }
    /**
     * @param elementType The element type.
     */ setElementType(elementType) {
        this.attributes.set($597d59a3d37b5b3f$export$80986e6afdd7e0cb.s_elementType, elementType);
    }
    /**
     * @returns The x3 attribute value as a Big or undefined.
     */ getX3() {
        let x3 = this.attributes.get($597d59a3d37b5b3f$export$80986e6afdd7e0cb.s_x3);
        if (x3 != undefined) return new (0, $ad9e9f310a798519$exports.Big)(x3);
    }
    /**
     * @param x3 The x3 attribute value.
     */ setX3(x3) {
        this.attributes.set($597d59a3d37b5b3f$export$80986e6afdd7e0cb.s_x3, x3.toString());
    }
    /**
     * Removes the x3 attribute.
     */ removeX3() {
        this.attributes.delete($597d59a3d37b5b3f$export$80986e6afdd7e0cb.s_x3);
    }
    /**
     * @returns The y3 attribute value as a Big or undefined.
     */ getY3() {
        let y3 = this.attributes.get($597d59a3d37b5b3f$export$80986e6afdd7e0cb.s_y3);
        if (y3 != undefined) return new (0, $ad9e9f310a798519$exports.Big)(y3);
    }
    /**
     * @param y3 The y3 attribute value.
     */ setY3(y3) {
        this.attributes.set($597d59a3d37b5b3f$export$80986e6afdd7e0cb.s_y3, y3.toString());
    }
    /**
     * Removes the y3 attribute.
     */ removeY3() {
        this.attributes.delete($597d59a3d37b5b3f$export$80986e6afdd7e0cb.s_y3);
    }
    /**
     * @returns The z3 attribute value as a Big or undefined.
     */ getZ3() {
        let z3 = this.attributes.get($597d59a3d37b5b3f$export$80986e6afdd7e0cb.s_z3);
        if (z3 != undefined) return new (0, $ad9e9f310a798519$exports.Big)(z3);
    }
    /**
     * @param z3 The z3 attribute value.
     */ setZ3(z3) {
        this.attributes.set("z3", z3.toString());
    }
    /**
     * Removes the x3 attribute.
     */ removeZ3() {
        this.attributes.delete("z3");
    }
}
class $597d59a3d37b5b3f$export$9cea715eceba39a0 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
    * The tag name.
    */ this.tagName = "atomArray";
    }
    /**
     * @param attributes The attributes.
     * @param atoms The atoms.
     */ constructor(attributes, atoms){
        super(attributes, $597d59a3d37b5b3f$export$9cea715eceba39a0.tagName);
        this.index = new Map();
        this.reverseIndex = new Map();
        if (atoms == undefined) this.atoms = new Map();
        else {
            this.atoms = atoms;
            atoms.forEach((atom, id)=>{
                this.index.set(id, this.nodes.size);
                this.reverseIndex.set(this.nodes.size, id);
                this.nodes.set(this.nodes.size, atom);
            });
        }
    }
    /**
     * @param id The id of the atom to get.
     * @returns The atom with the given id.
     */ getAtom(id) {
        return this.atoms.get(id);
    }
    /**
     * @param atom The atom to add.
     * @returns The id of the atom.
     */ addAtom(atom, aID) {
        //console.log('Adding atom...');
        if (aID == undefined) {
            let id = atom.getID();
            if (id == undefined) {
                id = this.getNextAtomID();
                atom.setID(id);
            } else if (this.atoms.has(id)) {
                let newID = this.getNextAtomID();
                console.warn('Atom with id ' + id + ' already exists, adding with id ' + newID);
                atom.setID(newID);
                id = newID;
            }
            aID = id;
        } else if (this.atoms.has(aID)) {
            //let newID: string = this.getNextAtomID();
            console.warn('Atom with id ' + aID + ' will be replaced');
            let i = this.index.get(aID);
            this.nodes.set(i, atom);
            this.atoms.set(aID, atom);
            return aID;
        }
        //console.log('Atom id: ' + id);
        this.index.set(aID, this.nodes.size);
        this.reverseIndex.set(this.nodes.size, aID);
        this.nodes.set(this.nodes.size, atom);
        this.atoms.set(aID, atom);
        /*
        console.log('this.index.size ' + this.index.size);
        console.log('this.nodes.size ' + this.nodes.size);
        console.log('this.atoms.size ' + this.atoms.size);
        console.log('this.index.keys() ' + Array.from(this.index.keys()));
        console.log('this.index.values() ' + Array.from(this.index.values()));
        console.log('this.reverseIndex.keys() ' + Array.from(this.reverseIndex.keys()));
        console.log('this.reverseIndex.values() ' + Array.from(this.reverseIndex.values()));
        console.log('this.nodes.keys() ' + Array.from(this.nodes.keys()));
        console.log('this.atoms.keys() ' + Array.from(this.atoms.keys()));
        */ return aID;
    }
    /**
     * @returns The atomId.
     */ getNextAtomID() {
        let i = 1;
        let id = "a" + i.toString();
        if (this.atoms.has(id)) while(this.atoms.has(id)){
            i++;
            id = "a" + i.toString();
        }
        return id;
    }
    /**
     * @param id The id of the atom to remove.
     */ removeAtom(id) {
        let i = this.index.get(id);
        if (i == undefined) throw new Error('Atom with id ' + id + ' does not exist!');
        console.log('Removing atom with id ' + id);
        this.atoms.delete(id);
        //this.index.delete(id);
        //this.nodes.delete(i);
        this.deleteNodeAndReindex(i, id);
    /*
        console.log('i ' + i);
        console.log('this.index.size ' + this.index.size);
        console.log('this.nodes.size ' + this.nodes.size);
        console.log('this.atoms.size ' + this.atoms.size);
        console.log('this.index.keys() ' + Array.from(this.index.keys()));
        console.log('this.index.values() ' + Array.from(this.index.values()));
        console.log('this.nodes.keys() ' + Array.from(this.nodes.keys()));
        console.log('this.atoms.keys() ' + Array.from(this.atoms.keys()));
        */ }
    /**
     * @param i The index of the atom to remove.
     * @param id The id of the atom to remove.
     */ deleteNodeAndReindex(i, id) {
        this.nodes.delete(i);
        this.index.delete(id);
        this.reverseIndex.delete(i);
        let newNodes = new Map();
        let newIndex = new Map();
        let newReverseIndex = new Map();
        this.index.forEach((value, key)=>{
            if (value > i) {
                newNodes.set(value - 1, this.nodes.get(value));
                newIndex.set(key, value - 1);
                newReverseIndex.set(value - 1, key);
            } else {
                newNodes.set(value, this.nodes.get(value));
                newIndex.set(key, value);
                newReverseIndex.set(value, key);
            }
        });
        this.nodes = newNodes;
        this.index = newIndex;
        this.reverseIndex = newReverseIndex;
    }
}
class $597d59a3d37b5b3f$export$153327fc99ac0c53 extends (0, $057fa7562ec736a9$export$ca4ceee82ec565dc) {
    static{
        /**
     * The tag name.
     */ this.tagName = "bond";
    }
    static{
        /**
     * The key for the atomRefs2 attribute.
     */ this.s_atomRefs2 = "atomRefs2";
    }
    static{
        /**
     * The key for the id attribute.
     */ this.s_id = "id";
    }
    static{
        /**
     * The key for the order attribute.
     */ this.s_order = "order";
    }
    static{
        /**
     * The order options.
     */ this.orderOptions = [
            "1",
            "1.5",
            "2",
            "2.5",
            "3",
            "3.5",
            "4",
            "4.5",
            "5",
            "5.5",
            "6"
        ];
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes, molecule){
        super(attributes, $597d59a3d37b5b3f$export$153327fc99ac0c53.tagName);
        this.molecule = molecule;
    }
    /**
     * @returns The atomRefs2.
     */ getAtomRefs2() {
        let atomRefs2 = this.attributes.get($597d59a3d37b5b3f$export$153327fc99ac0c53.s_atomRefs2);
        let atomRefs = atomRefs2?.split(" ") || [];
        if (atomRefs2 == undefined) return "a1 a1";
        return atomRefs2;
    }
    /**
     * @param atomRefs2 The atomRefs2 to set.
     */ setAtomRefs2(atomRefs2) {
        this.attributes.set($597d59a3d37b5b3f$export$153327fc99ac0c53.s_atomRefs2, atomRefs2);
    }
    /**
     * @returns The id.
     */ getID() {
        return this.attributes.get($597d59a3d37b5b3f$export$153327fc99ac0c53.s_id);
    }
    /**
     * @param id The id to set the attribute value referred to by "id".
     */ setID(id) {
        this.attributes.set($597d59a3d37b5b3f$export$153327fc99ac0c53.s_id, id);
    }
    /**
     * @returns The attribute value referred to by "order" as a number or undefined.
     */ getOrder() {
        let order = this.attributes.get($597d59a3d37b5b3f$export$153327fc99ac0c53.s_order);
        if (order != undefined) return parseFloat(order);
    }
    /**
     * @param order The order to set the attribute value referred to by "order".
     */ setOrder(order) {
        this.attributes.set($597d59a3d37b5b3f$export$153327fc99ac0c53.s_order, order.toString());
    }
}
class $597d59a3d37b5b3f$export$746fba2e30d93fe6 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "bondArray";
    }
    /**
     * @param attributes The attributes.
     * @param bonds The bonds.
     */ constructor(attributes, bonds){
        super(attributes, $597d59a3d37b5b3f$export$746fba2e30d93fe6.tagName);
        this.index = new Map();
        this.reverseIndex = new Map();
        if (bonds == undefined) this.bonds = new Map();
        else {
            this.bonds = bonds;
            bonds.forEach((bond, id)=>{
                this.index.set(id, this.nodes.size);
                this.reverseIndex.set(this.nodes.size, id);
                this.nodes.set(this.nodes.size, bond);
            });
        }
    }
    /**
     * @returns The bond ids.
     */ getBondIds() {
        return Array.from(this.bonds.keys());
    }
    /**
     * @param id The id of the bond to get.
     * @returns The bond with the given id.
     */ getBond(id) {
        return this.bonds.get(id);
    }
    /**
     * Adds a bond to the array.
     * @param bond The bond to add.
     * @param bID The id of the bond to add if it already exists.
     * @returns The id of the bond.
     */ addBond(bond, bID) {
        if (bID == undefined) {
            let id = bond.getID();
            if (id == undefined) {
                id = this.getNextBondID();
                bond.setID(id);
            } else if (this.bonds.has(id)) {
                let newID = this.getNextBondID();
                console.log('Bond with id ' + id + ' already exists, adding with id ' + newID);
                bond.setID(newID);
                id = newID;
            }
            bID = id;
        } else if (this.bonds.has(bID)) {
            //let newID: string = this.getNextBondID();
            console.log('Bond with id ' + bID + ' will be replaced');
            let i = this.index.get(bID);
            this.nodes.set(i, bond);
            this.bonds.set(bID, bond);
            return bID;
        }
        //console.log('Bond id: ' + id);
        this.index.set(bID, this.nodes.size);
        this.reverseIndex.set(this.nodes.size, bID);
        this.nodes.set(this.nodes.size, bond);
        this.bonds.set(bID, bond);
        /*
        console.log('this.index.size ' + this.index.size);
        console.log('this.nodes.size ' + this.nodes.size);
        console.log('this.atoms.size ' + this.atoms.size);
        console.log('this.index.keys() ' + Array.from(this.index.keys()));
        console.log('this.index.values() ' + Array.from(this.index.values()));
        console.log('this.reverseIndex.keys() ' + Array.from(this.reverseIndex.keys()));
        console.log('this.reverseIndex.values() ' + Array.from(this.reverseIndex.values()));
        console.log('this.nodes.keys() ' + Array.from(this.nodes.keys()));
        console.log('this.atoms.keys() ' + Array.from(this.atoms.keys()));
        */ return bID;
    }
    /**
     * @returns The atomId.
     */ getNextBondID() {
        let i = 1;
        let id = "b" + i.toString();
        while(this.bonds.has(id)){
            i++;
            id = "b" + i.toString();
        }
        return id;
    }
    /**
     * @param id The id of the atom to remove.
     */ removeBond(id) {
        let i = this.index.get(id);
        if (i == undefined) throw new Error('Bond with id ' + id + ' does not exist!');
        console.log('Removing bond with id ' + id);
        this.bonds.delete(id);
        //this.index.delete(id);
        //this.nodes.delete(i);
        this.deleteNodeAndReindex(i, id);
    /*
        console.log('i ' + i);
        console.log('this.index.size ' + this.index.size);
        console.log('this.nodes.size ' + this.nodes.size);
        console.log('this.atoms.size ' + this.atoms.size);
        console.log('this.index.keys() ' + Array.from(this.index.keys()));
        console.log('this.index.values() ' + Array.from(this.index.values()));
        console.log('this.nodes.keys() ' + Array.from(this.nodes.keys()));
        console.log('this.atoms.keys() ' + Array.from(this.atoms.keys()));
        */ }
    /**
     * @param i The index of the bond to remove.
     * @param id The id of the bond to remove.
     */ deleteNodeAndReindex(i, id) {
        this.nodes.delete(i);
        this.index.delete(id);
        this.reverseIndex.delete(i);
        let newNodes = new Map();
        let newIndex = new Map();
        let newReverseIndex = new Map();
        this.index.forEach((value, key)=>{
            if (value > i) {
                newNodes.set(value - 1, this.nodes.get(value));
                newIndex.set(key, value - 1);
                newReverseIndex.set(value - 1, key);
            } else {
                newNodes.set(value, this.nodes.get(value));
                newIndex.set(key, value);
                newReverseIndex.set(value, key);
            }
        });
        this.nodes = newNodes;
        this.index = newIndex;
        this.reverseIndex = newReverseIndex;
    }
}
class $597d59a3d37b5b3f$export$eb6936faa5f138bb extends (0, $057fa7562ec736a9$export$8f67221c6fb2ad09) {
    static{
        /**
     * The tag name.
     */ this.tagName = "scalar";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $597d59a3d37b5b3f$export$eb6936faa5f138bb.tagName, value);
    }
    /**
     * @returns The value.
     */ getValue() {
        return this.value;
    }
    /**
     * Sets the value.
     * @param val The value.
     */ setValue(val) {
        this.value = val;
    }
}
class $597d59a3d37b5b3f$export$742f9ce317ef8ba3 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "scalar";
    }
    static{
        /**
     * The key for the units attribute.
     */ this.s_units = "units";
    }
    static{
        /**
     * The property dictionary references.
     */ this.propertyDictRefs = new Set([
            "me:ZPE",
            "me:Hf0",
            "me:HfAT0",
            "me:Hf298",
            "me:symmetryNumber",
            "me:TSOpticalSymmetryNumber",
            "me:frequenciesScaleFactor",
            "me:MW",
            "me:spinMultiplicity",
            "me:epsilon",
            "me:sigma"
        ]);
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $597d59a3d37b5b3f$export$742f9ce317ef8ba3.tagName, value);
    }
    /**
     * This updates the units of the property. It does not do any unit conversion.
     * It simply updates the specified units of a property
     * @param units Updates the units of the property.
     */ updateUnits(units) {
        // Check the units are the same and if not replace the units...
        if (units) {
            let existingUnits = this.attributes.get($597d59a3d37b5b3f$export$742f9ce317ef8ba3.s_units);
            if (existingUnits != undefined) {
                if (existingUnits != units) //console.log('Units are not the same, changing units...');
                this.attributes.set($597d59a3d37b5b3f$export$742f9ce317ef8ba3.s_units, units);
            }
        }
    }
    /**
     * @returns The value.
     */ getValue() {
        return this.value;
    }
    /**
     * Sets the value.
     * @param val The value.
     */ setValue(val) {
        this.value = val;
    }
}
class $597d59a3d37b5b3f$export$9f93a3fdf2490572 extends (0, $057fa7562ec736a9$export$38d8ebe2767f8865) {
    static{
        /**
     * The tag name.
     */ this.tagName = "array";
    }
    static{
        /**
     * The key for the units attribute.
     */ this.s_units = "units";
    }
    static{
        /**
     * The property dictionary references.
     */ this.propertyDictRefs = new Set([
            "me:rotConsts",
            "me:vibFreqs",
            "me:EinsteinAij",
            "me:EinsteinBij"
        ]);
    }
    /**
     * @param attributes The attributes.
     * @param values The values.
     * @param delimiter The delimiter of the values (Optional - default will be ",").
     */ constructor(attributes, values, delimiter){
        super(attributes, $597d59a3d37b5b3f$export$9f93a3fdf2490572.tagName, values, delimiter);
    }
    /**
     * This updates the units of the property. It does not do any unit conversion.
     * It simply updates the specified units of a property
     * @param units Updates the units of the property.
     */ updateUnits(units) {
        // Check the units are the same and if not replace the units...
        if (units) {
            let existingUnits = this.attributes.get($597d59a3d37b5b3f$export$9f93a3fdf2490572.s_units);
            if (existingUnits != undefined) {
                if (existingUnits != units) {
                    this.attributes.set($597d59a3d37b5b3f$export$9f93a3fdf2490572.s_units, units);
                    console.log('Units changed from ' + existingUnits + ' to ' + units);
                }
            }
        }
    }
    /**
     * Sets the size of the array.
     * @param size The size of the array.
     */ setSize(size) {
        let values = [];
        for(let i = 0; i < size; i++)values.push(new (0, $ad9e9f310a798519$exports.Big)(0));
        this.setValues(values);
    }
}
class $597d59a3d37b5b3f$export$a5a2be813176eb0e extends (0, $057fa7562ec736a9$export$38d8ebe2767f8865) {
    static{
        /**
     * The tag name.
     */ this.tagName = "matrix";
    }
    static{
        /**
     * The key for the rows attribute.
     */ this.s_rows = "rows";
    }
    static{
        /**
     * The key for the matrixType attribute.
     */ this.s_matrixType = "matrixType";
    }
    static{
        /**
     * The key for the units attribute.
     */ this.s_units = "units";
    }
    static{
        /**
     * The property dictionary references.
     */ this.propertyDictRefs = new Set([
            "me:hessian"
        ]);
    }
    /**
     * @param attributes The attributes.
     * @param values The values.
     * @param delimiter The delimiter of the values (Optional - default will be ",").
     */ constructor(attributes, values, delimiter){
        super(attributes, $597d59a3d37b5b3f$export$9f93a3fdf2490572.tagName, values, delimiter);
    }
    /**
     * This updates the units of the property. It does not do any unit conversion.
     * It simply updates the specified units of a property
     * @param units Updates the units of the property.
     */ updateUnits(units) {
        // Check the units are the same and if not replace the units...
        if (units) {
            let existingUnits = this.attributes.get($597d59a3d37b5b3f$export$9f93a3fdf2490572.s_units);
            if (existingUnits != undefined) {
                if (existingUnits != units) {
                    this.attributes.set($597d59a3d37b5b3f$export$9f93a3fdf2490572.s_units, units);
                    console.log('Units changed from ' + existingUnits + ' to ' + units);
                }
            }
        }
    }
    /**
     * Sets the size of the array.
     * @param rows The number of rows in the matrix.
     * @param columns The number of columns in the matrix.
     */ setSize(rows, columns) {
        let values = [];
        for(let i = 0; i < rows; i++)for(let j = 0; j < columns; j++)values.push(new (0, $ad9e9f310a798519$exports.Big)(0));
        this.setValues(values);
    }
}
class $597d59a3d37b5b3f$export$41b04b3a73e7216d extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "property";
    }
    static{
        /**
     * The key for the dictRef attribute.
     */ this.s_dictRef = "dictRef";
    }
    /**
     * @param attributes The attributes.
     * @param property The property.
     */ constructor(attributes, property){
        super(attributes, $597d59a3d37b5b3f$export$41b04b3a73e7216d.tagName);
        let dictRef = attributes.get($597d59a3d37b5b3f$export$41b04b3a73e7216d.s_dictRef);
        if (dictRef == undefined) {
            // If there is no dictRef, then try setting this from the "title" attribute.
            let title = attributes.get("title");
            if (title == undefined) throw new Error($597d59a3d37b5b3f$export$41b04b3a73e7216d.s_dictRef + ' and title are undefined!');
            else {
                if (title == "MW") dictRef = "me:MW";
                else if (title == "Hf298") dictRef = "me:Hf298";
                else if (title == "Hf0") dictRef = "me:Hf0";
                else if (title == "program") dictRef = "program";
                else if (title == "basis") dictRef = "basis";
                else if (title == "method") dictRef = "method";
                else if (title == "File Format") dictRef = "File Format";
                else throw new Error('Title ' + title + 'not recognised!');
            }
        }
        this.dictRef = dictRef;
        if (property) this.nodes.set(0, property);
    }
    /**
     * @returns The property.
     */ getProperty() {
        return this.nodes.get(0);
    }
    /**
     * Set the property.
     * @param property The property.
     */ setProperty(property) {
        this.nodes.set(0, property);
    }
}
class $597d59a3d37b5b3f$export$95174cf0748f45cd extends $597d59a3d37b5b3f$export$41b04b3a73e7216d {
    static{
        /**
     * The dictionary reference.
     */ this.dictRef = "me:ZPE";
    }
    /**
     * @param attributes The attributes.
     * @param property The property.
     */ constructor(attributes, property){
        super(attributes, property);
    }
    /**
     * @param units The units.
     * Should be one of Mesmer.energyUnits.
     */ setUnits(units) {
        this.getProperty().updateUnits(units);
    }
}
class $597d59a3d37b5b3f$export$90bccbae54bb6d4f extends $597d59a3d37b5b3f$export$41b04b3a73e7216d {
    static{
        /**
     * The dictionary reference.
     */ this.dictRef = "me:Hf0";
    }
    /**
     * @param attributes The attributes.
     * @param property The property.
     */ constructor(attributes, property){
        super(attributes, property);
    }
    /**
     * @param units The units.
     * Should be one of Mesmer.energyUnits.
     */ setUnits(units) {
        this.getProperty().updateUnits(units);
    }
}
class $597d59a3d37b5b3f$export$a4fe62a56eafa45d extends $597d59a3d37b5b3f$export$41b04b3a73e7216d {
    static{
        /**
     * The dictionary reference.
     */ this.dictRef = "me:HfAT0";
    }
    /**
     * @param attributes The attributes.
     * @param property The property.
     */ constructor(attributes, property){
        super(attributes, property);
    }
    /**
     * @param units The units.
     * Should be one of Mesmer.energyUnits.
     */ setUnits(units) {
        this.getProperty().updateUnits(units);
    }
}
class $597d59a3d37b5b3f$export$e7df60530792b964 extends $597d59a3d37b5b3f$export$41b04b3a73e7216d {
    static{
        /**
     * The dictionary reference.
     */ this.dictRef = "me:Hf298";
    }
    /**
     * @param attributes The attributes.
     * @param property The property.
     */ constructor(attributes, property){
        super(attributes, property);
    }
    /**
     * @param units The units.
     * Should be one of Mesmer.energyUnits.
     */ setUnits(units) {
        this.getProperty().updateUnits(units);
    }
}
class $597d59a3d37b5b3f$export$984abe26ded13ee0 extends $597d59a3d37b5b3f$export$41b04b3a73e7216d {
    static{
        /**
     * The dictionary reference.
     */ this.dictRef = "me:rotConsts";
    }
    static{
        /**
     * The units.
     */ this.unitOptions = [
            "cm-1",
            "GHz",
            "amuA^2"
        ];
    }
    /**
     * @param attributes The attributes.
     * @param property The property.
     */ constructor(attributes, property){
        super(attributes, property);
    }
}
class $597d59a3d37b5b3f$export$d1d1720eff14586a extends $597d59a3d37b5b3f$export$41b04b3a73e7216d {
    static{
        /**
    * The dictionary reference.
    */ this.dictRef = "me:symmetryNumber";
    }
    /**
     * @param attributes The attributes.
     * @param property The property.
     */ constructor(attributes, property){
        super(attributes, property);
    }
}
class $597d59a3d37b5b3f$export$886461cafebcdaed extends $597d59a3d37b5b3f$export$41b04b3a73e7216d {
    static{
        /**
    * The dictionary reference.
    */ this.dictRef = "me:TSOpticalSymmetryNumber";
    }
    /**
     * @param attributes The attributes.
     * @param property The property.
     */ constructor(attributes, property){
        super(attributes, property);
    }
}
class $597d59a3d37b5b3f$export$1288989e9be37590 extends $597d59a3d37b5b3f$export$41b04b3a73e7216d {
    static{
        /**
     * The dictionary reference.
     */ this.dictRef = "me:frequenciesScaleFactor";
    }
    /**
     * @param attributes The attributes.
     * @param property The property.
     */ constructor(attributes, property){
        super(attributes, property);
    }
}
class $597d59a3d37b5b3f$export$2762c8fbc03043ca extends $597d59a3d37b5b3f$export$41b04b3a73e7216d {
    static{
        /**
     * The dictionary reference.
     */ this.dictRef = "me:vibFreqs";
    }
    /**
     * @param attributes The attributes.
     * @param property The property.
     */ constructor(attributes, property){
        super(attributes, property);
    }
}
class $597d59a3d37b5b3f$export$a3772f6eb527275b extends $597d59a3d37b5b3f$export$41b04b3a73e7216d {
    static{
        /**
     * The dictionary reference.
     */ this.dictRef = "me:MW";
    }
    /**
     * @param attributes The attributes.
     * @param property The property.
     */ constructor(attributes, property){
        super(attributes, property);
    }
}
class $597d59a3d37b5b3f$export$415ad1120b60f9f3 extends $597d59a3d37b5b3f$export$41b04b3a73e7216d {
    static{
        /**
     * The dictionary reference.
     */ this.dictRef = "me:spinMultiplicity";
    }
    /**
     * @param attributes The attributes.
     * @param property The property.
     */ constructor(attributes, property){
        super(attributes, property);
    }
}
class $597d59a3d37b5b3f$export$cb998ac70542b2c3 extends $597d59a3d37b5b3f$export$41b04b3a73e7216d {
    static{
        /**
    * The dictionary reference.
    */ this.dictRef = "me:epsilon";
    }
    /**
     * @param attributes The attributes.
     * @param property The property.
     */ constructor(attributes, property){
        super(attributes, property);
    }
}
class $597d59a3d37b5b3f$export$79e850ed2864d13d extends $597d59a3d37b5b3f$export$41b04b3a73e7216d {
    static{
        /**
    * The dictionary reference.
    */ this.dictRef = "me:sigma";
    }
    /**
     * @param attributes The attributes.
     * @param property The property.
     */ constructor(attributes, property){
        super(attributes, property);
    }
}
class $597d59a3d37b5b3f$export$789e4dcdcb815c05 extends $597d59a3d37b5b3f$export$41b04b3a73e7216d {
    static{
        /**
     * The dictionary reference.
     */ this.dictRef = "me:hessian";
    }
    static{
        /**
     * The units.
     */ this.unitOptions = [
            "kJ/mol/\xc52",
            "kcal/mol/\xc52",
            "Hartree/\xc52"
        ];
    }
    /**
     * @param attributes The attributes.
     * @param property The property.
     */ constructor(attributes, property){
        super(attributes, property);
    }
}
class $597d59a3d37b5b3f$export$f3e9ef5020c299b5 extends $597d59a3d37b5b3f$export$41b04b3a73e7216d {
    static{
        /**
     * The dictionary reference.
     */ this.dictRef = "me:EinsteinAij";
    }
    /**
     * @param attributes The attributes.
     * @param property The property.
     */ constructor(attributes, property){
        super(attributes, property);
    }
}
class $597d59a3d37b5b3f$export$25f02bc420569a7e extends $597d59a3d37b5b3f$export$41b04b3a73e7216d {
    static{
        /**
     * The dictionary reference.
     */ this.dictRef = "me:EinsteinBij";
    }
    /**
     * @param attributes The attributes.
     * @param property The property.
     */ constructor(attributes, property){
        super(attributes, property);
    }
}
class $597d59a3d37b5b3f$export$2e66a7dc5ebae8a1 extends $597d59a3d37b5b3f$export$41b04b3a73e7216d {
    static{
        /**
     * The dictionary reference.
     */ this.dictRef = "me:electronicExcitation";
    }
    /**
     * @param attributes The attributes.
     * @param property The property.
     */ constructor(attributes, property){
        super(attributes, property);
    }
}
class $597d59a3d37b5b3f$export$22995ecd2bdeb2 extends $597d59a3d37b5b3f$export$41b04b3a73e7216d {
    static{
        /**
     * The dictionary reference.
     */ this.dictRef = "me:imFreqs";
    }
    /**
     * @param attributes The attributes.
     * @param property The property.
     */ constructor(attributes, property){
        super(attributes, property);
    }
}
class $597d59a3d37b5b3f$export$4e0d1ad7ad6a0802 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "propertyList";
    }
    /**
     * @param attributes The attributes.
     * @param properties The properties (optional).
     */ constructor(attributes, properties){
        super(attributes, $597d59a3d37b5b3f$export$4e0d1ad7ad6a0802.tagName);
        this.index = new Map();
        if (properties != undefined) properties.forEach((property)=>{
            this.nodes.set(this.nodes.size, property);
            this.index.set(property.dictRef, this.nodes.size - 1);
        });
    }
    /**
     * @returns The properties as a Map<string, Property> where each key is the dictRef of the Property value.
     */ getProperties() {
        let properties = new Map();
        this.nodes.forEach((node)=>{
            let p = node;
            properties.set(p.dictRef, p);
        });
        return properties;
    }
    /**
     * @param dictRef The dictRef of the property.
     * @returns The property.
     */ getProperty(dictRef) {
        let i = this.index.get(dictRef);
        if (i != undefined) return this.nodes.get(i);
        else //throw new Error('Property ' + dictRef + ' does not exist');
        return undefined;
    }
    /**
     * Set the property.
     * @param property The property.
     */ setProperty(property) {
        let i = this.index.get(property.dictRef);
        if (i == undefined) {
            console.log('Property ' + property.dictRef + ' does not exist, adding...');
            //console.log('property.toString() ' + property.toString());
            //console.log('property.getProperty().toString() ' + property.getProperty().toString());
            //console.log('mapToString(property.attributes) ' + mapToString(property.attributes));
            this.nodes.set(this.nodes.size, property);
            this.index.set(property.dictRef, this.nodes.size - 1);
        } else {
            console.log('Property ' + property.dictRef + ' already exists, updating...');
            this.nodes.set(i, property);
        }
    }
    /**
     * @param dictRef The dictRef of the property.
     */ removeProperty(dictRef) {
        let i = this.index.get(dictRef);
        if (i != undefined) {
            this.nodes.delete(i);
            this.index.delete(dictRef);
            let newIndex = new Map();
            this.index.forEach((value, key)=>{
                if (value > i) newIndex.set(key, value - 1);
                else newIndex.set(key, value);
            });
            this.index = newIndex;
        }
    }
}
class $597d59a3d37b5b3f$export$16fc56ab40b12b45 extends (0, $3e7c52c9467308b9$export$d0e9917d83c120a0) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:deltaEDown";
    }
    static{
        /**
     * The key for the bathGas attribute.
     */ this.s_bathGas = "bathGas";
    }
    /**
     * @param attributes The attributes.
     * @param units The units.
     */ constructor(attributes, value){
        super(attributes, $597d59a3d37b5b3f$export$16fc56ab40b12b45.tagName, value);
    }
    /**
     * @returns The bath gas of the DeltaEDown.
     */ getBathGas() {
        return this.attributes.get($597d59a3d37b5b3f$export$16fc56ab40b12b45.s_bathGas);
    }
    /**
     * @param bathGas The bath gas of the DeltaEDown.
     */ setBathGas(bathGas) {
        this.attributes.set($597d59a3d37b5b3f$export$16fc56ab40b12b45.s_bathGas, bathGas);
    }
}
class $597d59a3d37b5b3f$export$1aede585378507cb extends $597d59a3d37b5b3f$export$16fc56ab40b12b45 {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:deltaEDown2";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, value);
    }
}
class $597d59a3d37b5b3f$export$f8ecc5f7f62d6fbf extends (0, $3e7c52c9467308b9$export$d0e9917d83c120a0) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:deltaEDownTExponent";
    }
    static{
        /**
     * The referenceTemperature attribute key.
     */ this.s_referenceTemperature = "referenceTemperature";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $597d59a3d37b5b3f$export$f8ecc5f7f62d6fbf.tagName, value);
    }
    /**
     * @returns The referenceTemperature.
     */ getReferenceTemperature() {
        return parseFloat((0, $93b71ab6968650c1$export$3988ae62b71be9a3)(this.attributes, $597d59a3d37b5b3f$export$f8ecc5f7f62d6fbf.s_referenceTemperature));
    }
    /**
     * @param referenceTemperature The referenceTemperature.
     */ setReferenceTemperature(referenceTemperature) {
        this.attributes.set($597d59a3d37b5b3f$export$f8ecc5f7f62d6fbf.s_referenceTemperature, referenceTemperature.toString());
    }
}
class $597d59a3d37b5b3f$export$fbea747a02da7eb8 extends (0, $3e7c52c9467308b9$export$d0e9917d83c120a0) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:deltaEDownLinEne";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $597d59a3d37b5b3f$export$fbea747a02da7eb8.tagName, value);
    }
}
class $597d59a3d37b5b3f$export$499950da20810ac9 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:energyTransferModel";
    }
    /**
     * @param attributes The attributes.
     * @param deltaEDowns The DeltaEDowns.
     */ constructor(attributes, deltaEDowns){
        super(attributes, $597d59a3d37b5b3f$export$499950da20810ac9.tagName);
        if (deltaEDowns != undefined) deltaEDowns.forEach((deltaEDown)=>{
            this.nodes.set(this.nodes.size, deltaEDown);
        });
    }
    /**
     * @returns The DeltaEDowns.
     */ getDeltaEDowns() {
        let deltaEDowns = [];
        this.nodes.forEach((node)=>{
            if (node instanceof $597d59a3d37b5b3f$export$16fc56ab40b12b45) deltaEDowns.push(node);
        });
        return deltaEDowns;
    }
    /**
     * @param deltaEDowns The DeltaEDowns.
     */ setDeltaEDowns(deltaEDowns) {
        this.nodes.clear();
        deltaEDowns.forEach((deltaEDown)=>{
            this.nodes.set(this.nodes.size, deltaEDown);
        });
    }
    /**
     * @param index The index of the DeltaEDown to return.
     * @returns The DeltaEDown at the given index.
     */ getDeltaEDown(index) {
        if (index < 0 || index >= this.nodes.size) throw new Error('index out of range');
        return this.nodes.get(index);
    }
    /**
     * Set the DeltaEDown at the given index.
     * @param index The index to set the DeltaEDown at.
     * @param deltaEDown The DeltaEDown to set at the index.
     */ setDeltaEDown(index, deltaEDown) {
        this.nodes.set(index, deltaEDown);
    }
    /**
     * Add a DeltaEDown.
     * @param deltaEDown The DeltaEDown.
     * @returns The index of the DeltaEDown added.
     */ addDeltaEDown(deltaEDown) {
        this.nodes.set(this.nodes.size, deltaEDown);
        return this.nodes.size - 1;
    }
    /**
     * Remove a DeltaEDown.
     * @param index The index of the DeltaEDown to remove.
     */ removeDeltaEDown(index) {
        this.nodes.delete(index);
    }
}
class $597d59a3d37b5b3f$export$bbdce6c921702068 extends (0, $057fa7562ec736a9$export$ca4ceee82ec565dc) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:DOSCMethod";
    }
    static{
        /**
     * The options for the "xsi:type" or "name" attribute value.
     */ this.xsi_typeOptions = [
            "ClassicalRotors",
            "QMRotors",
            "DefinedStatesRotors",
            "me:ClassicalRotors",
            "me:QMRotors",
            "me:DefinedStatesRotors"
        ];
    }
    static{
        /**
     * The key for the "xsi:type" attribute value.
     */ this.s_xsi_type = "xsi:type";
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes){
        super(attributes, $597d59a3d37b5b3f$export$bbdce6c921702068.tagName);
        if (attributes.get($597d59a3d37b5b3f$export$bbdce6c921702068.s_xsi_type) == undefined) {
            let name = attributes.get("name");
            if (name == undefined) throw new Error('Neither xsi:type or name are defined.');
            else attributes.set($597d59a3d37b5b3f$export$bbdce6c921702068.s_xsi_type, name);
        }
    }
    /**
     * @returns The xsi:type.
     */ getXsiType() {
        return this.attributes.get($597d59a3d37b5b3f$export$bbdce6c921702068.s_xsi_type);
    }
    /**
     * @param xsiType The xsi:type.
     */ setXsiType(xsiType) {
        this.attributes.set($597d59a3d37b5b3f$export$bbdce6c921702068.s_xsi_type, xsiType);
    }
}
class $597d59a3d37b5b3f$export$aef8e5ad5552fd72 extends (0, $057fa7562ec736a9$export$8f67221c6fb2ad09) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:bondRef";
    }
    /**
     * @param attributes The attributes.
     * @param bondRef The bondRef.
     */ constructor(attributes, bondRef){
        super(attributes, $597d59a3d37b5b3f$export$aef8e5ad5552fd72.tagName, bondRef);
    }
}
class $597d59a3d37b5b3f$export$86ca5149fcde8feb extends (0, $057fa7562ec736a9$export$ca4ceee82ec565dc) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:PotentialPoint";
    }
    static{
        /**
     * The key angle attribute.
     */ this.s_angle = "angle";
    }
    static{
        /**
     * The key potential attribute.
     */ this.s_potential = "potential";
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes){
        super(attributes, $597d59a3d37b5b3f$export$86ca5149fcde8feb.tagName);
    }
    /**
     * @returns The angle.
     */ getAngle() {
        return this.attributes.get($597d59a3d37b5b3f$export$86ca5149fcde8feb.s_angle);
    }
    /**
     * @param angle The angle of the PotentialPoint.
     */ setAngle(angle) {
        this.attributes.set($597d59a3d37b5b3f$export$86ca5149fcde8feb.s_angle, angle.toString());
    }
    /**
     * @returns The potential.
     */ getPotential() {
        return this.attributes.get($597d59a3d37b5b3f$export$86ca5149fcde8feb.s_potential);
    }
    /**
     * @param potential The potential of the PotentialPoint.
     */ setPotential(potential) {
        this.attributes.set($597d59a3d37b5b3f$export$86ca5149fcde8feb.s_potential, potential.toString());
    }
}
class $597d59a3d37b5b3f$export$3f9657e7f71262a extends (0, $057fa7562ec736a9$export$ca4ceee82ec565dc) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:DistributionCalcMethod";
    }
    static{
        /**
     * The key for the default attribute.
     */ this.s_default = "default";
    }
    static{
        /**
     * The key for the name attribute.
     */ this.s_name = "name";
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes){
        super(attributes, $597d59a3d37b5b3f$export$3f9657e7f71262a.tagName);
    }
    /**
     * @returns The default.
     */ getDefault() {
        return this.attributes.get($597d59a3d37b5b3f$export$3f9657e7f71262a.s_default);
    }
    /**
     * @param default The default.
     *
    setDefault(defaultValue: string): void {
        this.attributes.set(DistributionCalcMethod.s_default, defaultValue);
    }
    */ /**
     * @returns The name.
     */ getName() {
        return this.attributes.get($597d59a3d37b5b3f$export$3f9657e7f71262a.s_name);
    }
}
class $597d59a3d37b5b3f$export$3ee0c201412b230 extends (0, $057fa7562ec736a9$export$ca4ceee82ec565dc) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:thermoValue";
    }
    static{
        /**
     * The key for the T attribute.
     */ this.s_T = "T";
    }
    static{
        /**
     * The key for the H attribute.
     */ this.s_H = "H";
    }
    static{
        /**
     * The key for the S attribute.
     */ this.s_S = "S";
    }
    static{
        /**
     * The key for the G attribute.
     */ this.s_G = "G";
    }
    static{
        /**
     * The key for the Cp attribute.
     */ this.s_Cp = "Cp";
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes){
        super(attributes, $597d59a3d37b5b3f$export$80986e6afdd7e0cb.tagName);
    }
    /**
     * @returns The temperature.
     */ getT() {
        return this.attributes.get($597d59a3d37b5b3f$export$3ee0c201412b230.s_T);
    }
    /**
     * @param T The temperature.
     *
    setT(T: Big): void {
        this.attributes.set(ThermoValue.s_T, T.toString());
    }

    /**
     * @returns The enthalpy.
     */ getH() {
        return this.attributes.get($597d59a3d37b5b3f$export$3ee0c201412b230.s_H);
    }
    /**
     * @param H The enthalpy.
     *
    setH(H: Big): void {
        this.attributes.set(ThermoValue.s_H, H.toString());
    }

    /**
     * @returns The entropy.
     */ getS() {
        return this.attributes.get($597d59a3d37b5b3f$export$3ee0c201412b230.s_S);
    }
    /**
     * @param S The entropy.
     *
    setS(S: Big): void {
        this.attributes.set(ThermoValue.s_S, S.toString());
    }

    /**
     * @returns The Gibbs free energy.
     */ getG() {
        return this.attributes.get($597d59a3d37b5b3f$export$3ee0c201412b230.s_G);
    }
    /**
     * @param G The Gibbs free energy.
     *
    setG(G: Big): void {
        this.attributes.set(ThermoValue.s_G, G.toString());
    }

    /**
     * @returns The heat capacity.
     */ getCp() {
        return this.attributes.get($597d59a3d37b5b3f$export$3ee0c201412b230.s_Cp);
    }
    /**
     * @param Cp The heat capacity.
     *
    setCp(Cp: Big): void {
        this.attributes.set(ThermoValue.s_Cp, Cp.toString());
    }

    /**
     * @returns The ThermoValue as a string array.
     */ toStringArray() {
        return [
            this.getT(),
            this.getH(),
            this.getS(),
            this.getG(),
            this.getCp()
        ];
    }
    /**
     * @returns The ThermoValue as a CSV string.
     */ toCSV() {
        //console.log(this.toStringArray());
        //console.log(this.toStringArray().join(","));
        return this.toStringArray().join(",");
    }
}
class $597d59a3d37b5b3f$export$96f29f03cf201f97 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:thermoTable";
    }
    static{
        /**
     * The key for the unitsT attribute.
     */ this.s_unitsT = "unitsT";
    }
    static{
        /**
     * The key for the unitsH attribute.
     */ this.s_unitsH = "unitsH";
    }
    static{
        /**
     * The key for the unitsS attribute.
     */ this.s_unitsS = "unitsS";
    }
    static{
        /**
     * The key for the unitsG attribute.
     */ this.s_unitsG = "unitsG";
    }
    static{
        /**
     * The key for the unitsCp attribute.
     */ this.s_unitsCp = "unitsCp";
    }
    /**
     * @param attributes The attributes.
     * @param tvs The ThermoValue array.
     */ constructor(attributes, tvs){
        super(attributes, $597d59a3d37b5b3f$export$96f29f03cf201f97.tagName);
        if (tvs != undefined) {
            tvs.forEach((tv)=>{
                this.addNode(tv);
            });
            this.tvs = tvs;
        } else this.tvs = [];
    }
    /**
     * Retrieves a ThermoValue from the tvs array at a specific index.
     * 
     * @param i The index of the ThermoValue to return. 
     * @returns The ThermoValue at the given index.
     * @throws IndexError if i is out of the bounds of the tvs array.
     * @throws TypeError if tvs is null or undefined.
     */ get(i) {
        return this.tvs[i];
    }
    /**
     * Set the ThermoValue in t.
     * 
     * @param i The index of the ThermoValue to set.
     * @returns The PT pairs.
     */ set(i, tv) {
        this.nodes.set(i, tv);
        this.tvs[i] = tv;
    }
    /**
     * Add a ThermoValue.
     * 
     * @param tv The ThermoValue to add.
     * @returns The index of this.pTPairs where pTPair is added.
     */ add(tv) {
        this.addNode(tv);
        this.tvs.push(tv);
        return this.nodes.size - 1;
    }
    /**
     * Remove the ThermoValue at the given index.
     * 
     * @param i The index.
     */ remove(i) {
        this.nodes.delete(i);
        this.tvs.splice(i, 1);
    }
    /**
     * Initialise tvs.
     * 
     * @param tvs The tvs to be set.
     */ init(tvs) {
        this.clear();
        tvs.forEach((tv)=>{
            this.addNode(tv);
            this.tvs.push(tv);
        });
    }
    /**
     * Clear.
     */ clear() {
        this.nodes.clear();
        this.tvs = [];
    }
    /**
     * @returns The ThermoTable header as a string array.
     */ getHeader() {
        return [
            "T (" + this.attributes.get($597d59a3d37b5b3f$export$96f29f03cf201f97.s_unitsT) + ")",
            "H(T)-H(0) (" + this.attributes.get($597d59a3d37b5b3f$export$96f29f03cf201f97.s_unitsH) + ")",
            "S(T) (" + this.attributes.get($597d59a3d37b5b3f$export$96f29f03cf201f97.s_unitsS) + ")",
            "G(T) (" + this.attributes.get($597d59a3d37b5b3f$export$96f29f03cf201f97.s_unitsG) + ")",
            "Cp(T) (" + this.attributes.get($597d59a3d37b5b3f$export$96f29f03cf201f97.s_unitsCp) + ")"
        ];
    }
    /**
     * @returns The ThermoTable as a CSV string.
     */ toCSV() {
        let csv = this.getHeader().join(",") + "\n";
        this.tvs.forEach((tv)=>{
            csv += tv.toCSV() + "\n";
        });
        return csv;
    }
}
class $597d59a3d37b5b3f$export$9b8e857b9a081d2 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:HinderedRotorPotential";
    }
    static{
        /**
     * The permitted formats.
     */ this.formats = new Set([
            "numerical",
            "analytical"
        ]);
    }
    static{
        /**
     * The key for the format attribute value.
     */ this.s_format = "format";
    }
    static{
        /**
     * The key for the units attribute value.
     */ this.s_units = "units";
    }
    static{
        /**
     * The key for the expansionSize attribute value.
     */ this.s_expansionSize = "expansionSize";
    }
    static{
        /**
     * The key for the useSineTerms attribute value.
     */ this.s_useSineTerms = "useSineTerms";
    }
    /**
     * @param attributes The attributes.
     * @param potentialPoints The PotentialPoints.
     */ constructor(attributes, potentialPoints){
        super(attributes, $597d59a3d37b5b3f$export$9b8e857b9a081d2.tagName);
        let format = attributes.get($597d59a3d37b5b3f$export$9b8e857b9a081d2.s_format);
        if (format == undefined) throw new Error($597d59a3d37b5b3f$export$9b8e857b9a081d2.s_format + ' is undefined!');
        this.format = format;
        let units = attributes.get($597d59a3d37b5b3f$export$9b8e857b9a081d2.s_units);
        if (units == undefined) throw new Error($597d59a3d37b5b3f$export$9b8e857b9a081d2.s_units + ' is undefined!');
        this.units = units;
        if (potentialPoints != undefined) potentialPoints.forEach((p)=>{
            this.nodes.set(this.nodes.size, p);
        });
        let useSineTerms = attributes.get($597d59a3d37b5b3f$export$9b8e857b9a081d2.s_useSineTerms);
        if (useSineTerms == undefined) this.useSineTerms = false;
        else this.useSineTerms = true;
    //this.useSineTerms = (useSineTerms == "yes");
    }
    /**
     * @returns The format of the HinderedRotorPotential.
     * Should be one of ["numerical", "analytical"].
     */ getFormat() {
        return this.format;
    }
    /**
     * @param format The format of the HinderedRotorPotential.
     * Should be one of ["numerical", "analytical"].
     */ setFormat(format) {
        this.format = format;
        this.attributes.set($597d59a3d37b5b3f$export$9b8e857b9a081d2.s_format, format);
    }
    /**
     * @returns The units of the HinderedRotorPotential.
     * Should be one of Mesmer.energyUnits.
     */ getUnits() {
        return this.units;
    }
    /**
     * @param units The units of the HinderedRotorPotential.
     * Should be one of ["kJ/mol", "cm-1", "Hartree"].
     */ setUnits(units) {
        this.units = units;
        this.attributes.set($597d59a3d37b5b3f$export$9b8e857b9a081d2.s_units, units);
    }
    /**
     * @returns The expansionSize of the HinderedRotorPotential.
     */ getExpansionSize() {
        return this.attributes.get($597d59a3d37b5b3f$export$9b8e857b9a081d2.s_expansionSize);
    }
    /**
     * @param expansionSize The expansionSize of the HinderedRotorPotential.
     */ setExpansionSize(expansionSize) {
        console.log(expansionSize.toString());
        this.attributes.set($597d59a3d37b5b3f$export$9b8e857b9a081d2.s_expansionSize, expansionSize.toString());
    }
    /**
     * @returns The useSineTerms of the HinderedRotorPotential.
     */ getUseSineTerms() {
        return this.useSineTerms;
    }
    /**
     * @param useSineTerms The useSineTerms of the HinderedRotorPotential.
     */ setUseSineTerms(useSineTerms) {
        this.useSineTerms = useSineTerms;
        this.attributes.set($597d59a3d37b5b3f$export$9b8e857b9a081d2.s_useSineTerms, useSineTerms ? "yes" : "no");
    }
    /**
     * @returns The potential point with the given index.
     */ getPotentialPoint(i) {
        return this.nodes.get(i);
    }
    /**
     * Set the potential point at the given index.
     * @param i The index to set the potential point at.
     * @param p The potential point to set at the index.
     */ setPotentialPoint(i, p) {
        this.nodes.set(i, p);
    }
    /**
     * Sets the potential points.
     * @param potentialPoints The potential points.
     */ setPotentialPoints(potentialPoints) {
        this.nodes.clear();
        potentialPoints.forEach((p)=>{
            this.nodes.set(this.nodes.size, p);
        });
    }
    /**
     * Add the potential point.
     * @param p The potential point.
     * @returns The index of the potential point added.
     */ addPotentialPoint(p) {
        this.nodes.set(this.nodes.size, p);
        return this.nodes.size - 1;
    }
    /**
     * @param i The index of the potential point to remove.
     */ removePotentialPoint(i) {
        this.nodes.delete(i);
    }
}
class $597d59a3d37b5b3f$export$9513c16afdf7d852 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        this.tagName = "me:periodicity";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $597d59a3d37b5b3f$export$9513c16afdf7d852.tagName, value);
    }
}
class $597d59a3d37b5b3f$export$ae98b7db6376163d extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:ExtraDOSCMethod";
    }
    /**
     * @param attributes The attributes.
     * @param bondRef The bondRef.
     * @param hinderedRotorPotential The HinderedRotorPotential.
     * @param periodicity The Periodicity.
     */ constructor(attributes, bondRef, hinderedRotorPotential, periodicity){
        super(attributes, $597d59a3d37b5b3f$export$ae98b7db6376163d.tagName);
        this.index = new Map();
        if (bondRef) {
            this.nodes.set(this.nodes.size, bondRef);
            this.index.set($597d59a3d37b5b3f$export$aef8e5ad5552fd72.tagName, this.nodes.size - 1);
        }
        if (hinderedRotorPotential) {
            this.nodes.set(this.nodes.size, hinderedRotorPotential);
            this.index.set($597d59a3d37b5b3f$export$9b8e857b9a081d2.tagName, this.nodes.size - 1);
        }
        if (periodicity) {
            this.nodes.set(this.nodes.size, periodicity);
            this.index.set($597d59a3d37b5b3f$export$9513c16afdf7d852.tagName, this.nodes.size - 1);
        }
    }
    /**
     * @returns The bondRef.
     */ getBondRef() {
        let i = this.index.get($597d59a3d37b5b3f$export$aef8e5ad5552fd72.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * Set the bondRef.
     * @param bondRef The bondRef.
     */ setBondRef(bondRef) {
        let i = this.index.get($597d59a3d37b5b3f$export$aef8e5ad5552fd72.tagName);
        if (i != undefined) this.nodes.set(i, bondRef);
        else {
            this.nodes.set(this.nodes.size, bondRef);
            this.index.set($597d59a3d37b5b3f$export$aef8e5ad5552fd72.tagName, this.nodes.size - 1);
        }
    }
    /**
     * @returns The hindered rotor potential of the molecule.
     */ getHinderedRotorPotential() {
        let i = this.index.get($597d59a3d37b5b3f$export$9b8e857b9a081d2.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * Set the hindered rotor potential.
     * @param hinderedRotorPotential The hindered rotor potential.
     */ setHinderedRotorPotential(hinderedRotorPotential) {
        let i = this.index.get($597d59a3d37b5b3f$export$9b8e857b9a081d2.tagName);
        if (i != undefined) this.nodes.set(i, hinderedRotorPotential);
        else {
            this.nodes.set(this.nodes.size, hinderedRotorPotential);
            this.index.set($597d59a3d37b5b3f$export$9b8e857b9a081d2.tagName, this.nodes.size - 1);
        }
    }
    /**
     * @returns The periodicity of the molecule.
     */ getPeriodicity() {
        let i = this.index.get($597d59a3d37b5b3f$export$9513c16afdf7d852.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * Set the periodicity.
     * @param periodicity The periodicity.
     */ setPeriodicity(periodicity) {
        let i = this.index.get($597d59a3d37b5b3f$export$9513c16afdf7d852.tagName);
        if (i != undefined) this.nodes.set(i, periodicity);
        else {
            this.nodes.set(this.nodes.size, periodicity);
            this.index.set($597d59a3d37b5b3f$export$9513c16afdf7d852.tagName, this.nodes.size - 1);
        }
    }
}
class $597d59a3d37b5b3f$export$97850fe2f2906f00 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:reservoirSize";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $597d59a3d37b5b3f$export$97850fe2f2906f00.tagName, value);
    }
}
class $597d59a3d37b5b3f$export$656e8af5996be26 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:qtot";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $597d59a3d37b5b3f$export$656e8af5996be26.tagName, value);
    }
}
class $597d59a3d37b5b3f$export$c8de58561fc3a710 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:sumc";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $597d59a3d37b5b3f$export$c8de58561fc3a710.tagName, value);
    }
}
class $597d59a3d37b5b3f$export$159051b21d796f59 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:sumg";
    }
    /**
     * @param attributes The attributes.
     * @param value The value.
     */ constructor(attributes, value){
        super(attributes, $597d59a3d37b5b3f$export$159051b21d796f59.tagName, value);
    }
}
class $597d59a3d37b5b3f$export$126b026a4280c589 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:densityOfStates";
    }
    static{
        /**
     * The header.
     */ this.header = [
            (0, $ccef02370f58a770$export$971d5caa766a69d7).tagName,
            $597d59a3d37b5b3f$export$656e8af5996be26.tagName,
            $597d59a3d37b5b3f$export$c8de58561fc3a710.tagName,
            $597d59a3d37b5b3f$export$159051b21d796f59.tagName
        ];
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes){
        super(attributes, $597d59a3d37b5b3f$export$126b026a4280c589.tagName);
        this.index = new Map();
    }
    /**
     * @returns The T.
     */ getT() {
        let i = this.index.get((0, $ccef02370f58a770$export$971d5caa766a69d7).tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * Set the T.
     * @param T The T.
     */ setT(T) {
        let i = this.index.get(T.tagName);
        if (i != undefined) this.nodes.set(i, T);
        else {
            this.nodes.set(this.nodes.size, T);
            this.index.set(T.tagName, this.nodes.size - 1);
        }
    }
    /**
     * @returns The Qtot.
     */ getQtot() {
        let i = this.index.get($597d59a3d37b5b3f$export$656e8af5996be26.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * Set the Qtot.
     * @param Qtot The Qtot.
     */ setQtot(Qtot) {
        let i = this.index.get(Qtot.tagName);
        if (i != undefined) this.nodes.set(i, Qtot);
        else {
            this.nodes.set(this.nodes.size, Qtot);
            this.index.set(Qtot.tagName, this.nodes.size - 1);
        }
    }
    /**
     * @returns The Sumc.
     */ getSumc() {
        let i = this.index.get($597d59a3d37b5b3f$export$c8de58561fc3a710.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * Set the Sumc.
     * @param Sumc The Sumc.
     */ setSumc(Sumc) {
        let i = this.index.get(Sumc.tagName);
        if (i != undefined) this.nodes.set(i, Sumc);
        else {
            this.nodes.set(this.nodes.size, Sumc);
            this.index.set(Sumc.tagName, this.nodes.size - 1);
        }
    }
    /**
     * @returns The Sumg.
     */ getSumg() {
        let i = this.index.get($597d59a3d37b5b3f$export$159051b21d796f59.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * Set the Sumg.
     * @param Sumg The Sumg.
     */ setSumg(Sumg) {
        let i = this.index.get(Sumg.tagName);
        if (i != undefined) this.nodes.set(i, Sumg);
        else {
            this.nodes.set(this.nodes.size, Sumg);
            this.index.set(Sumg.tagName, this.nodes.size - 1);
        }
    }
    /**
     * @returns The density of states as a string array.
     */ toStringArray() {
        return [
            this.getT().value.toString(),
            this.getQtot().value.toString(),
            this.getSumc().value.toString(),
            this.getSumg().value.toString()
        ];
    }
}
class $597d59a3d37b5b3f$export$dcce836c71a83df extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
    * The tag name.
    */ this.tagName = "me:densityOfStatesList";
    }
    /**
     * @param attributes The attributes.
     * @param description The description.
     * @param densityOfStates The densityOfStates.
     */ constructor(attributes, description, densityOfStates){
        super(attributes, $597d59a3d37b5b3f$export$dcce836c71a83df.tagName);
        this.index = new Map();
        this.dosIndex = new Map();
        if (description) {
            this.nodes.set(this.nodes.size, description);
            this.index.set((0, $ccef02370f58a770$export$393edc798c47379d).tagName, this.nodes.size - 1);
        }
        if (densityOfStates) {
            let i = 0;
            densityOfStates.forEach((dos)=>{
                this.dosIndex.set(i, this.nodes.size);
                this.nodes.set(this.nodes.size, dos);
                i++;
            });
        }
    }
    /**
     * @returns The description.
     */ getDescription() {
        let i = this.index.get((0, $ccef02370f58a770$export$393edc798c47379d).tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * Set the description.
     * @param description The description.
     */ setDescription(description) {
        let i = this.index.get((0, $ccef02370f58a770$export$393edc798c47379d).tagName);
        if (i != undefined) this.nodes.set(i, description);
        else {
            this.nodes.set(this.nodes.size, description);
            this.index.set((0, $ccef02370f58a770$export$393edc798c47379d).tagName, this.nodes.size - 1);
        }
    }
    /**
     * @returns The density of states at the given index.
     */ getDensityOfStates(i) {
        let j = this.dosIndex.get(i);
        if (j != undefined) return this.nodes.get(j);
    }
    /**
     * Set the density of states at the given index.
     * @param i The index.
     * @param dos The density of states.
     */ setDensityOfStates(i, dos) {
        let j = this.dosIndex.get(i);
        if (j != undefined) this.nodes.set(j, dos);
        else {
            this.nodes.set(this.nodes.size, dos);
            this.dosIndex.set(i, this.nodes.size - 1);
        }
    }
    /**
     * Add the density of states.
     * @param dos The density of states.
     * @returns The index of the density of states added.
     */ addDensityOfStates(dos) {
        this.nodes.set(this.nodes.size, dos);
        let i = this.nodes.size - 1;
        this.dosIndex.set(i, this.nodes.size - 1);
        return i;
    }
    /**
     * Remove the density of states at the given index.
     * @param i The index.
     */ removeDensityOfStates(i) {
        let j = this.dosIndex.get(i);
        if (j != undefined) this.nodes.delete(j);
    }
    /**
     * @returns The density of states list as a CSV string.
     */ toCSV() {
        let csv = "";
        let header = $597d59a3d37b5b3f$export$126b026a4280c589.header;
        csv += header.join(",") + "\n";
        this.nodes.forEach((dos)=>{
            csv += dos.toStringArray().join(",") + "\n";
        });
        return csv;
    }
}
class $597d59a3d37b5b3f$export$47283907dceba392 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:States";
    }
    /**
     * @param attributes The attributes.
     */ constructor(attributes, states){
        super(attributes, $597d59a3d37b5b3f$export$47283907dceba392.tagName);
        this.index = new Map();
        if (states) {
            let i = 0;
            states.forEach((state)=>{
                this.nodes.set(this.nodes.size, state); // Add the state to the nodes.
                this.index.set(state.id, i); // Add the index of the state to the index.
                i++;
            });
        }
    }
    /**
     * @returns The next id.
     */ getNextId() {
        let i = 0;
        while(this.index.has(i))i++;
        return i;
    }
    /**
     * @returns The states.
     */ getStates() {
        let states = [];
        this.nodes.forEach((node)=>{
            states.push(node);
        });
        return states;
    }
    /**
     * @param id The id of the state.
     * @returns The state at the given index.
     */ getState(id) {
        return this.nodes.get(this.index.get(id));
    }
    /**
     * Set the state at the given index.
     * @param i The index.
     * @param state The state.
     */ setState(i, state) {
        this.nodes.set(this.index.get(state.id), state);
    }
    /**
     * Add the state.
     * @param state The state.
     * @returns The index of the state added.
     */ addState(state) {
        let i;
        if (this.index.has(state.id)) {
            // A state with this id already exists, replace it.
            i = this.index.get(state.id);
            this.nodes.set(i, state);
        } else {
            // Add the state to the nodes.
            i = this.nodes.size;
            this.index.set(state.id, i);
            this.nodes.set(i, state);
        }
        return this.nodes.size - 1;
    }
    /**
     * Remove the state at the given index.
     * @param id The id of the state to remove.
     */ removeState(id) {
        console.log("Removing state with id " + id);
        let i = this.index.get(id);
        console.log("Removing state at index " + i);
        this.nodes.delete(i);
    }
}
class $597d59a3d37b5b3f$export$7254cc27399e90bd extends (0, $057fa7562ec736a9$export$ca4ceee82ec565dc) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:State";
    }
    static{
        /**
     * The key for the energy attribute value.
     */ this.s_energy = "energy";
    }
    static{
        /**
     * The key for the degeneracy attribute value.
     */ this.s_degeneracy = "degeneracy";
    }
    /**
     * @param attributes The attributes.
     * @param id The index.
     */ constructor(attributes, id){
        super(attributes, $597d59a3d37b5b3f$export$7254cc27399e90bd.tagName);
        this.id = id;
    }
    /**
     * @returns The energy of the state.
     */ getEnergy() {
        return new (0, $ad9e9f310a798519$exports.Big)(this.attributes.get($597d59a3d37b5b3f$export$7254cc27399e90bd.s_energy));
    }
    /**
     * @param energy The energy of the state.
     */ setEnergy(energy) {
        this.attributes.set($597d59a3d37b5b3f$export$7254cc27399e90bd.s_energy, energy.toString());
    }
    /**
     * Remove the energy attribute. 
     */ removeEnergy() {
        this.attributes.delete($597d59a3d37b5b3f$export$7254cc27399e90bd.s_energy);
    }
    /**
     * @returns The degeneracy of the state.
     */ getDegeneracy() {
        return new (0, $ad9e9f310a798519$exports.Big)(this.attributes.get($597d59a3d37b5b3f$export$7254cc27399e90bd.s_degeneracy));
    }
    /**
     * @param degeneracy The degeneracy of the state.
     */ setDegeneracy(degeneracy) {
        this.attributes.set($597d59a3d37b5b3f$export$7254cc27399e90bd.s_degeneracy, degeneracy.toString());
    }
    /**
     * Remove the degeneracy attribute. 
     */ removeDegeneracy() {
        this.attributes.delete($597d59a3d37b5b3f$export$7254cc27399e90bd.s_degeneracy);
    }
}
class $597d59a3d37b5b3f$export$3da9759ad07746a3 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "molecule";
    }
    static{
        /**
     * The key for the id attribute value.
     */ this.s_id = "id";
    }
    static{
        /**
     * The key for the description attribute value.
     */ this.s_description = "description";
    }
    static{
        /**
     * The key for the active attribute value.
     */ this.s_active = "active";
    }
    /**
     * This is either just the attribute id, or a composite of the attribute id and the molecule id.
     */ //label: string;
    /**
     * Create a molecule.
     * @param attributes The attributes. This will also include an "id".
     * Additional attributes may include: "description" and "active" (and possibly others), but these do not exist for all molecules.
     * @param id The molecule ID which is to be unique.
     * @param metadataList The metadata list.
     * @param atoms The atom or atoms.
     * @param bonds The bonds.
     * @param properties The properties.
     * @param energyTransferModel The energy transfer model.
     * @param dOSCMethod The method for calculating density of states.
     * @param extraDOSCMethods The extra DOSC methods for calculating density of states.
     * @param reservoirSize The reservoir size.
     * @param tt The thermo table.
     */ constructor(attributes, id, metadataList, atoms, bonds, properties, energyTransferModel, dOSCMethod, distributionCalcMethod, extraDOSCMethods, reservoirSize, tt, states){
        super(attributes, $597d59a3d37b5b3f$export$3da9759ad07746a3.tagName);
        //this.label = this.getID();
        this.index = new Map();
        this.edmindex = new Map();
        this.id = id;
        let i = 0;
        // MetadataList
        if (metadataList) {
            this.nodes.set(i, metadataList);
            this.index.set((0, $cb35636d41d8f309$export$3e18a603070a78a).tagName, i);
            i++;
        }
        // Atoms
        if (atoms) {
            this.nodes.set(i, atoms);
            this.index.set($597d59a3d37b5b3f$export$9cea715eceba39a0.tagName, i);
            i++;
        }
        // Bonds
        if (bonds) {
            this.nodes.set(i, bonds);
            this.index.set($597d59a3d37b5b3f$export$746fba2e30d93fe6.tagName, i);
            i++;
        }
        // Properties
        if (properties) {
            this.nodes.set(i, properties);
            this.index.set($597d59a3d37b5b3f$export$4e0d1ad7ad6a0802.tagName, i);
            i++;
        }
        // EnergyTransferModel
        if (energyTransferModel) {
            this.nodes.set(i, energyTransferModel);
            this.index.set($597d59a3d37b5b3f$export$499950da20810ac9.tagName, i);
            i++;
        }
        // DOSCMethod
        if (dOSCMethod) {
            this.nodes.set(i, dOSCMethod);
            this.index.set($597d59a3d37b5b3f$export$bbdce6c921702068.tagName, i);
            i++;
        }
        // DistributionCalcMethod
        if (distributionCalcMethod) {
            this.nodes.set(i, distributionCalcMethod);
            this.index.set($597d59a3d37b5b3f$export$3f9657e7f71262a.tagName, i);
            i++;
        }
        // ExtraDOSCMethod
        if (extraDOSCMethods) extraDOSCMethods.forEach((edm)=>{
            this.nodes.set(i, edm);
            this.edmindex.set(i, i);
            i++;
        });
        // ReservoirSize
        if (reservoirSize) {
            this.nodes.set(i, reservoirSize);
            this.index.set($597d59a3d37b5b3f$export$97850fe2f2906f00.tagName, i);
            i++;
        }
        // ThermoTable
        if (tt) {
            this.nodes.set(i, tt);
            this.index.set($597d59a3d37b5b3f$export$96f29f03cf201f97.tagName, i);
        }
        // States
        if (states) {
            this.nodes.set(i, states);
            this.index.set($597d59a3d37b5b3f$export$47283907dceba392.tagName, i);
        }
    }
    /**
     * @returns The id of the molecule.
     */ getLabel() {
        //return this.getID() + " " + this.id.toString();
        return this.getID();
    }
    /**
     * @returns The id of the molecule.
     */ getID() {
        return this.attributes.get($597d59a3d37b5b3f$export$3da9759ad07746a3.s_id);
    }
    /**
     * @param id The id of the molecule.
     */ setID(id) {
        this.attributes.set($597d59a3d37b5b3f$export$3da9759ad07746a3.s_id, id);
    }
    /**
     * Get the description or the id of the molecule.
     * @returns The description of the molecule, or the id if it is not set.
     */ getDescription() {
        let description = this.attributes.get($597d59a3d37b5b3f$export$3da9759ad07746a3.s_description);
        if (description != undefined) return description;
        return this.getID();
    }
    /**
     * Set the description of the molecule.
     * @param description The description of the molecule.
     */ setDescription(description) {
        this.attributes.set($597d59a3d37b5b3f$export$3da9759ad07746a3.s_description, description);
    }
    /**
     * Get the active status of the molecule.
     * @returns The active status of the molecule, or undefined if it is not set.
     */ getActive() {
        let active = this.attributes.get($597d59a3d37b5b3f$export$3da9759ad07746a3.s_active);
        if (active != undefined) {
            if (active == "true") return true;
            else return false;
        }
    }
    /**
     * Set the active status of the molecule.
     * @param active The active status of the molecule.
     */ setActive(active) {
        this.attributes.set($597d59a3d37b5b3f$export$3da9759ad07746a3.s_active, active.toString());
    }
    /**
     * @returns The metadata list of the molecule.
     */ getMetadataList() {
        let i = this.index.get((0, $cb35636d41d8f309$export$3e18a603070a78a).tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * Set the metadata list.
     * @param metadataList The metadata list.
     */ setMetadataList(metadataList) {
        let i = this.index.get((0, $cb35636d41d8f309$export$3e18a603070a78a).tagName);
        if (i == undefined) {
            this.index.set((0, $cb35636d41d8f309$export$3e18a603070a78a).tagName, this.nodes.size);
            this.addNode(metadataList);
        } else this.nodes.set(i, metadataList);
    }
    /**
     * @returns The properties of the molecule.
     */ getPropertyList() {
        let i = this.index.get($597d59a3d37b5b3f$export$4e0d1ad7ad6a0802.tagName);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * @param properties The properties.
     */ setPropertyList(properties) {
        let i = this.index.get($597d59a3d37b5b3f$export$4e0d1ad7ad6a0802.tagName);
        if (i == undefined) {
            this.index.set($597d59a3d37b5b3f$export$4e0d1ad7ad6a0802.tagName, this.nodes.size);
            this.addNode(properties);
        } else this.nodes.set(i, properties);
    }
    /**
     * Get a property.
     * @param dictRef The dictRef of the property.
     * @returns The property.
     */ getProperty(dictRef) {
        let pl = this.getPropertyList();
        if (pl != undefined) return pl.getProperty(dictRef);
    }
    /**
     * Set the property.
     * @param p The property.
     *
    setProperty(p: Property): void {
        console.log("setProperty " + p.toString() + " in Molecule.");
        this.getPropertyList()!.setProperty(p);
    }*/ /**
     * @param atomId The id of the atom.
     * @returns The atom for the given atomId.
     */ getAtom(atomId) {
        return this.getAtoms().getAtom(atomId);
    }
    /**
     * @returns The atoms of the molecule.
     */ getAtoms() {
        let i = this.index.get($597d59a3d37b5b3f$export$9cea715eceba39a0.tagName);
        return this.nodes.get(i);
    }
    /**
     * @param atoms The atoms.
     */ setAtoms(atoms) {
        this.index.set($597d59a3d37b5b3f$export$9cea715eceba39a0.tagName, this.nodes.size);
        this.nodes.set(this.nodes.size, atoms);
    }
    /**
     * @param bondId The id of the bond.
     * @returns The bond for the given bondId.
     */ getBond(bondId) {
        return this.getBonds().getBond(bondId);
    }
    /**
     * @returns The bonds of the molecule.
     */ getBonds() {
        let i = this.index.get($597d59a3d37b5b3f$export$746fba2e30d93fe6.tagName);
        return this.nodes.get(i);
    }
    /**
     * @param bonds The bonds.
     */ setBonds(bonds) {
        this.index.set($597d59a3d37b5b3f$export$746fba2e30d93fe6.tagName, this.nodes.size);
        this.nodes.set(this.nodes.size, bonds);
    }
    /**
     * @returns The energy transfer model of the molecule.
     */ getEnergyTransferModel() {
        let i = this.index.get($597d59a3d37b5b3f$export$499950da20810ac9.tagName);
        if (i == undefined) return undefined;
        else return this.nodes.get(i);
    }
    /**
     * Set the energy transfer model.
     * @param energyTransferModel The energy transfer model.
     */ setEnergyTransferModel(energyTransferModel) {
        let i = this.index.get($597d59a3d37b5b3f$export$499950da20810ac9.tagName);
        if (i == undefined) {
            this.index.set($597d59a3d37b5b3f$export$499950da20810ac9.tagName, this.nodes.size);
            this.addNode(energyTransferModel);
        } else this.nodes.set(i, energyTransferModel);
    }
    /**
     * @returns The DOSC method of the molecule.
     */ getDOSCMethod() {
        let i = this.index.get($597d59a3d37b5b3f$export$bbdce6c921702068.tagName);
        if (i == undefined) return undefined;
        else return this.nodes.get(i);
    }
    /**
     * Set the DOSC method.
     * @param dOSCMethod The DOSC method.
     */ setDOSCMethod(dOSCMethod) {
        let i = this.index.get($597d59a3d37b5b3f$export$bbdce6c921702068.tagName);
        if (i == undefined) {
            this.index.set($597d59a3d37b5b3f$export$bbdce6c921702068.tagName, this.nodes.size);
            this.addNode(dOSCMethod);
        } else this.nodes.set(i, dOSCMethod);
    }
    /**
     * @returns The distribution calculation method of the molecule.
     */ getDistributionCalcMethod() {
        let i = this.index.get($597d59a3d37b5b3f$export$3f9657e7f71262a.tagName);
        if (i == undefined) return undefined;
        else return this.nodes.get(i);
    }
    /**
     * Set the distribution calculation method.
     * @param distributionCalcMethod The distribution calculation method.
     */ setDistributionCalcMethod(distributionCalcMethod) {
        let i = this.index.get($597d59a3d37b5b3f$export$3f9657e7f71262a.tagName);
        if (i == undefined) {
            this.index.set($597d59a3d37b5b3f$export$3f9657e7f71262a.tagName, this.nodes.size);
            this.addNode(distributionCalcMethod);
        } else this.nodes.set(i, distributionCalcMethod);
    }
    /**
     * @returns The extra DOSC method of the molecule.
     */ getExtraDOSCMethod(index) {
        let i = this.edmindex.get(index);
        if (i != undefined) return this.nodes.get(i);
    }
    /**
     * Set the extra DOSC method.
     * @param extraDOSCMethod The extra DOSC method.
     */ setExtraDOSCMethod(index, extraDOSCMethod) {
        let i = this.edmindex.get(index);
        if (i == undefined) {
            this.edmindex.set(index, this.nodes.size);
            this.nodes.set(this.nodes.size, extraDOSCMethod);
        } else this.nodes.set(i, extraDOSCMethod);
    }
    /**
     * @returns The reservoir size of the molecule.
     */ getReservoirSize() {
        let i = this.index.get($597d59a3d37b5b3f$export$97850fe2f2906f00.tagName);
        if (i == undefined) return undefined;
        else return this.nodes.get(i);
    }
    /**
     * Set the reservoir size.
     * @param reservoirSize The reservoir size.
     */ setReservoirSize(reservoirSize) {
        let i = this.index.get($597d59a3d37b5b3f$export$97850fe2f2906f00.tagName);
        if (i == undefined) {
            this.index.set($597d59a3d37b5b3f$export$97850fe2f2906f00.tagName, this.nodes.size);
            this.addNode(reservoirSize);
        } else this.nodes.set(i, reservoirSize);
    }
    /**
     * @returns The density of states list of the molecule.
     */ getDensityOfStatesList() {
        let i = this.index.get($597d59a3d37b5b3f$export$dcce836c71a83df.tagName);
        if (i == undefined) return undefined;
        else return this.nodes.get(i);
    }
    /**
     * Set the density of states list.
     * @param densityOfStatesList The density of states list.
     */ setDensityOfStatesList(densityOfStatesList) {
        let i = this.index.get($597d59a3d37b5b3f$export$dcce836c71a83df.tagName);
        if (i == undefined) {
            this.index.set($597d59a3d37b5b3f$export$dcce836c71a83df.tagName, this.nodes.size);
            this.addNode(densityOfStatesList);
        } else this.nodes.set(i, densityOfStatesList);
    }
    /**
     * @returns The thermo table of the molecule.
     */ getThermoTable() {
        let i = this.index.get($597d59a3d37b5b3f$export$96f29f03cf201f97.tagName);
        if (i == undefined) return undefined;
        else return this.nodes.get(i);
    }
    /**
     * Set the thermo table.
     * @param tt The thermo table.
     */ setThermoTable(tt) {
        let i = this.index.get($597d59a3d37b5b3f$export$96f29f03cf201f97.tagName);
        if (i == undefined) {
            this.index.set($597d59a3d37b5b3f$export$96f29f03cf201f97.tagName, this.nodes.size);
            this.addNode(tt);
        } else this.nodes.set(i, tt);
    }
    /**
     * @returns The states of the molecule.
     */ getStates() {
        let i = this.index.get($597d59a3d37b5b3f$export$47283907dceba392.tagName);
        if (i == undefined) return undefined;
        else return this.nodes.get(i);
    }
    /**
     * Set the states.
     * @param states The states.
     */ setStates(states) {
        let i = this.index.get($597d59a3d37b5b3f$export$47283907dceba392.tagName);
        if (i == undefined) {
            this.index.set($597d59a3d37b5b3f$export$47283907dceba392.tagName, this.nodes.size);
            this.addNode(states);
        } else this.nodes.set(i, states);
    }
    /**
     * Get the ZPE value of the molecule.
     */ getEnergy() {
        let p;
        p = this.getProperty($597d59a3d37b5b3f$export$95174cf0748f45cd.dictRef);
        if (p == undefined) {
            p = this.getProperty($597d59a3d37b5b3f$export$90bccbae54bb6d4f.dictRef);
            if (p == undefined) {
                p = this.getProperty($597d59a3d37b5b3f$export$a4fe62a56eafa45d.dictRef);
                if (p == undefined) {
                    p = this.getProperty($597d59a3d37b5b3f$export$e7df60530792b964.dictRef);
                    if (p == undefined) return (0, $ad9e9f310a798519$exports.Big)(0);
                }
            }
        }
        return p.getProperty().value;
    }
}













function $9eedba3564ea6a49$export$12aafb9570dfb660(mlDiv, mIDM, molecules) {
    let addMoleculeButton = (0, $341c675b659c6d43$export$9b6d6ca62970729f)((0, $dc4240e6100248ae$export$1bb8965d05fbf467), undefined, (0, $dc4240e6100248ae$export$39c84188a71202f7));
    mlDiv.appendChild(addMoleculeButton);
    addMoleculeButton.addEventListener('click', ()=>{
        let mid = $9eedba3564ea6a49$export$194bfe7da61d65(true, undefined, undefined, molecules);
        if (mid == undefined) return;
        console.log("mid=" + mid);
        let m = new (0, $597d59a3d37b5b3f$export$3da9759ad07746a3)(new Map(), mid);
        m.setID(mid);
        molecules.set(mid, m);
        //m.label = mid;
        //addMolecule(m, molecules);
        m.setAtoms(new (0, $597d59a3d37b5b3f$export$9cea715eceba39a0)(new Map()));
        m.setBonds(new (0, $597d59a3d37b5b3f$export$746fba2e30d93fe6)(new Map()));
        let mDivID = mIDM.addID((0, $597d59a3d37b5b3f$export$3da9759ad07746a3).tagName, mid);
        let mDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(mDivID);
        // Create collapsible Molecule HTMLDivElement.
        let mcDivID = mIDM.addID(mDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
        let mcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(mcDivID, mlDiv, addMoleculeButton, mDiv, mid, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        // Add the molecule to the BathGas select elements.
        (0, $dc4240e6100248ae$export$a30e0f90a7434924)((0, $5b710835528e7170$export$b33a132661f4be58).tagName, mid);
        // Add Edit ID button.
        $9eedba3564ea6a49$var$addEditIDButton(m, molecules, mcDiv.querySelector((0, $341c675b659c6d43$export$25280bc3a7ce098e)), mIDM, mDiv, (0, $dc4240e6100248ae$export$39c84188a71202f7));
        // Add description.
        mDiv.appendChild($9eedba3564ea6a49$var$processDescription(mIDM.addID(mDivID, (0, $dc4240e6100248ae$export$666359451816b0e7)), mIDM, m.getDescription.bind(m), m.setDescription.bind(m), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7)));
        // Add atomArray.
        let aaDivID = mIDM.addID(mDivID, (0, $597d59a3d37b5b3f$export$9cea715eceba39a0).tagName);
        let aaDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(aaDivID);
        let aacDivID = mIDM.addID(aaDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
        let aacDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(aacDivID, mDiv, null, aaDiv, (0, $597d59a3d37b5b3f$export$9cea715eceba39a0).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        aaDiv.appendChild($9eedba3564ea6a49$var$getAddAtomButton(mIDM, m, aaDiv, (0, $597d59a3d37b5b3f$export$80986e6afdd7e0cb).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7)));
        // Add bondArray.
        let baDivID = mIDM.addID(mDivID, (0, $597d59a3d37b5b3f$export$746fba2e30d93fe6).tagName);
        let baDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(baDivID);
        let bacDivID = mIDM.addID(baDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
        let bacDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(bacDivID, mDiv, null, baDiv, (0, $597d59a3d37b5b3f$export$746fba2e30d93fe6).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        baDiv.appendChild($9eedba3564ea6a49$var$getAddBondButton(mIDM, m, baDiv, (0, $597d59a3d37b5b3f$export$153327fc99ac0c53).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7)));
        $9eedba3564ea6a49$export$7aad7e61c4f49964(mIDM, m, mDiv, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        // Add properties.
        let plDivID = mIDM.addID(mDivID, (0, $597d59a3d37b5b3f$export$4e0d1ad7ad6a0802).tagName);
        let plDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(plDivID);
        let plcDivID = mIDM.addID(plDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
        let plcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(plcDivID, mDiv, null, plDiv, (0, $597d59a3d37b5b3f$export$4e0d1ad7ad6a0802).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        let pl = m.getPropertyList();
        if (pl == undefined) {
            console.log("PropertyList is undefined for molecule " + m.getLabel());
            pl = new (0, $597d59a3d37b5b3f$export$4e0d1ad7ad6a0802)(new Map());
            m.setPropertyList(pl);
        }
        console.log("pl.index.size" + pl.index.size);
        $9eedba3564ea6a49$export$3ec2b56b5fdfd561(true, m, mIDM, plDiv, pl);
        // Add me:EnergyTransferModel.
        let etmDivID = mIDM.addID(mDivID, (0, $597d59a3d37b5b3f$export$499950da20810ac9).tagName);
        let etmDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(etmDivID);
        let etmcDivID = mIDM.addID(etmDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
        let etmcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(etmcDivID, mDiv, null, etmDiv, (0, $597d59a3d37b5b3f$export$499950da20810ac9).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        let etm = m.getEnergyTransferModel();
        if (etm == undefined) {
            etm = new (0, $597d59a3d37b5b3f$export$499950da20810ac9)(new Map());
            m.setEnergyTransferModel(etm);
        }
        console.log("etm.index.size" + etm.nodes.size);
        // Add an add me.deltaEDown button.
        let addDeltaEDownButton = (0, $341c675b659c6d43$export$9b6d6ca62970729f)((0, $dc4240e6100248ae$export$1bb8965d05fbf467), (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(etmDivID, (0, $597d59a3d37b5b3f$export$16fc56ab40b12b45).tagName, (0, $dc4240e6100248ae$export$1bb8965d05fbf467), (0, $341c675b659c6d43$export$25280bc3a7ce098e)), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        etmDiv.appendChild(addDeltaEDownButton);
        addDeltaEDownButton.addEventListener('click', ()=>{
            let value = (0, $dc4240e6100248ae$export$a94c859b6fc3ec52);
            let ded = new (0, $597d59a3d37b5b3f$export$16fc56ab40b12b45)(new Map(), value);
            let index = etm.addDeltaEDown(ded);
            let dedDivID = mIDM.addID(etmDivID, (0, $597d59a3d37b5b3f$export$16fc56ab40b12b45).tagName, etm.nodes.size);
            let dedDiv = (0, $341c675b659c6d43$export$78253536c0178a32)(dedDivID);
            etmDiv.insertBefore(dedDiv, addDeltaEDownButton);
            let lwi = (0, $341c675b659c6d43$export$4e9ec2b27757d9dd)((0, $597d59a3d37b5b3f$export$16fc56ab40b12b45).tagName, dedDivID, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7), (event)=>{
                let target = event.target;
                // Check the input is a number.
                if ((0, $93b71ab6968650c1$export$e90fb89750dba83f)(target.value)) {
                    value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(target.value);
                    ded.setValue(value);
                } else {
                    // Reset.
                    alert("Input is not a number, resetting...");
                    target.value = ded.value.toString() ?? (0, $dc4240e6100248ae$export$2f2abd8810196a7);
                }
                (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
            }, ded.value.toString(), (0, $597d59a3d37b5b3f$export$16fc56ab40b12b45).tagName);
            dedDiv.appendChild(lwi);
            // Add a remove me.deltaEDown button.
            (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(dedDiv, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), ()=>{
                etm.removeDeltaEDown(index);
                etmDiv.removeChild(dedDiv);
            });
        });
        /*
        // Add me:DOSCMethod.
        let doscm: DOSCMethod | undefined = m.getDOSCMethod();
        if (doscm == undefined) {
            doscm = new DOSCMethod(new Map());
            m.setDOSCMethod(doscm);
        }
        mDiv.appendChild(
            createLabelWithSelect(DOSCMethod.tagName, DOSCMethod.xsi_typeOptions, DOSCMethod.tagName,
                doscm.getXsiType(), mIDM.addID(mDivID, DOSCMethod.tagName), boundary1, level1));
        */ /*
        addDOSCMethod(m, mIDM, plDiv, pl);
        // Add me:ExtraDOSCMethod
        addExtraDOSCMethod(m, mIDM, plDiv, pl);
        // Add me:Periodicity
        addPeriodicity(m, mIDM, plDiv, pl);
        // Add me:PotentialPoint
        addPotentialPoint(m, mIDM, plDiv, pl);
        // Add me:ReservoirSize
        addReservoirSize(m, mIDM, plDiv, pl);
        */ // Add me:States
        let statesDivID = mIDM.addID(mDivID, (0, $597d59a3d37b5b3f$export$47283907dceba392).tagName);
        let statesDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(statesDivID);
        let statescDivID = mIDM.addID(statesDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
        let statescDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(statescDivID, mDiv, null, statesDiv, (0, $597d59a3d37b5b3f$export$47283907dceba392).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        let states = m.getStates();
        if (states == undefined) {
            states = new (0, $597d59a3d37b5b3f$export$47283907dceba392)(new Map());
            m.setStates(states);
        }
        console.log("states.index.size" + states.nodes.size);
        // Add an add me:State button.
        $9eedba3564ea6a49$var$addAddStateButton(mIDM, statesDiv, states, statesDivID, (0, $dc4240e6100248ae$export$39c84188a71202f7));
        // Add a remove molecule button.
        (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(mDiv, (0, $dc4240e6100248ae$export$39c84188a71202f7), ()=>{
            $9eedba3564ea6a49$var$removeMolecule(mlDiv, mcDiv, mIDM, molecules, mDivID, m);
        });
    });
    return addMoleculeButton;
}
/**
 * Adds an add state button.
 * @param mIDM The IDManager for molecule divs.
 * @param statesDiv The States HTMLDivElement.
 * @param states The States.
 * @param statesDivID The States div ID.
 * @param margin The margin.
 */ function $9eedba3564ea6a49$var$addAddStateButton(mIDM, statesDiv, states, statesDivID, margin) {
    let addStateButton = (0, $341c675b659c6d43$export$9b6d6ca62970729f)((0, $dc4240e6100248ae$export$1bb8965d05fbf467), (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(statesDivID, (0, $597d59a3d37b5b3f$export$7254cc27399e90bd).tagName, (0, $dc4240e6100248ae$export$1bb8965d05fbf467), (0, $341c675b659c6d43$export$25280bc3a7ce098e)), margin);
    statesDiv.appendChild(addStateButton);
    addStateButton.addEventListener('click', ()=>{
        let stateAttributes = new Map();
        stateAttributes.set((0, $597d59a3d37b5b3f$export$7254cc27399e90bd).s_energy, "0");
        stateAttributes.set((0, $597d59a3d37b5b3f$export$7254cc27399e90bd).s_degeneracy, "0");
        let stateId = states.getNextId();
        let state = new (0, $597d59a3d37b5b3f$export$7254cc27399e90bd)(stateAttributes, stateId);
        console.log("stateId=" + stateId);
        let index = states.addState(state);
        let stateDivID = mIDM.addID(statesDivID, (0, $597d59a3d37b5b3f$export$7254cc27399e90bd).tagName, state.id);
        let stateDiv = (0, $341c675b659c6d43$export$78253536c0178a32)(stateDivID);
        statesDiv.insertBefore(stateDiv, addStateButton);
        // Add energy.
        let energyDivID = mIDM.addID(stateDivID, (0, $597d59a3d37b5b3f$export$7254cc27399e90bd).s_energy);
        let energyDiv = (0, $341c675b659c6d43$export$78253536c0178a32)(energyDivID);
        stateDiv.appendChild(energyDiv);
        let energyValue = state.getEnergy();
        let elwi = (0, $341c675b659c6d43$export$4e9ec2b27757d9dd)((0, $597d59a3d37b5b3f$export$7254cc27399e90bd).s_energy, energyDivID, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7), (event)=>{
            let target = event.target;
            // Check the input is a number.
            if ((0, $93b71ab6968650c1$export$e90fb89750dba83f)(target.value)) {
                energyValue = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(target.value);
                state.setEnergy(energyValue);
            } else {
                // Reset.
                alert("Input is not a number, resetting...");
                target.value = energyValue.toString() ?? (0, $dc4240e6100248ae$export$2f2abd8810196a7);
            }
            (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
        }, energyValue.toString(), (0, $597d59a3d37b5b3f$export$7254cc27399e90bd).s_energy);
        energyDiv.appendChild(elwi);
        // Add degeneracy.
        let degeneracyDivID = mIDM.addID(stateDivID, (0, $597d59a3d37b5b3f$export$7254cc27399e90bd).s_degeneracy);
        let degeneracyDiv = (0, $341c675b659c6d43$export$78253536c0178a32)(degeneracyDivID);
        stateDiv.appendChild(degeneracyDiv);
        let degeneracyValue = state.getDegeneracy();
        let dlwi = (0, $341c675b659c6d43$export$4e9ec2b27757d9dd)((0, $597d59a3d37b5b3f$export$7254cc27399e90bd).s_degeneracy, degeneracyDivID, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (event)=>{
            let target = event.target;
            // Check the input is a number.
            if ((0, $93b71ab6968650c1$export$e90fb89750dba83f)(target.value)) {
                degeneracyValue = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(target.value);
                state.setDegeneracy(degeneracyValue);
            } else {
                // Reset.
                alert("Input is not a number, resetting...");
                target.value = degeneracyValue.toString() ?? (0, $dc4240e6100248ae$export$2f2abd8810196a7);
            }
            (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
        }, degeneracyValue.toString(), (0, $597d59a3d37b5b3f$export$7254cc27399e90bd).s_degeneracy);
        degeneracyDiv.appendChild(dlwi);
        // Add a remove me:State button.
        (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(stateDiv, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), ()=>{
            states.removeState(index);
            statesDiv.removeChild(stateDiv);
        });
    });
}
function $9eedba3564ea6a49$export$3ec2b56b5fdfd561(deselect, m, mIDM, plDiv, pl) {
    // "me:ZPE", scalar, Mesmer.energyUnits.
    $9eedba3564ea6a49$var$addPropertyScalar(deselect, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$95174cf0748f45cd).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).energyUnits);
    //console.log("pl.index.size" + pl.index.size);
    //console.log("Property " + m.getPropertyList()!.getProperty(ZPE.dictRef)?.toString);
    // "me:Hf0", scalar, Mesmer.energyUnits.
    $9eedba3564ea6a49$var$addPropertyScalar(deselect, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$90bccbae54bb6d4f).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).energyUnits);
    // "me:HfAT0", scalar, Mesmer.energyUnits.
    $9eedba3564ea6a49$var$addPropertyScalar(deselect, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$a4fe62a56eafa45d).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).energyUnits);
    // "me:Hf298", scalar, Mesmer.energyUnits.
    $9eedba3564ea6a49$var$addPropertyScalar(deselect, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$e7df60530792b964).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).energyUnits);
    // "me:rotConsts", array, Mesmer.frequencyUnits.
    $9eedba3564ea6a49$var$addPropertyArray(deselect, false, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$984abe26ded13ee0).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).frequencyUnits);
    // "me:symmetryNumber", scalar, No units.
    $9eedba3564ea6a49$var$addPropertyScalar(deselect, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$d1d1720eff14586a).dictRef, undefined);
    // "me:TSOpticalSymmetryNumber", scalar, No units.
    $9eedba3564ea6a49$var$addPropertyScalar(deselect, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$886461cafebcdaed).dictRef, undefined);
    // "me:frequenciesScaleFactor", scalar, No units.
    $9eedba3564ea6a49$var$addPropertyScalar(deselect, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$1288989e9be37590).dictRef, undefined);
    // "me:vibFreqs", array, cm-1.
    $9eedba3564ea6a49$var$addPropertyArray(deselect, false, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$2762c8fbc03043ca).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).frequencyUnits);
    // "me:MW", scalar, amu.
    $9eedba3564ea6a49$var$addPropertyScalar(deselect, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$a3772f6eb527275b).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).massUnits);
    // "me:spinMultiplicity", scalar, No units.
    $9eedba3564ea6a49$var$addPropertyScalar(deselect, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$415ad1120b60f9f3).dictRef, undefined);
    // "me:epsilon", scalar, K (fixed).
    $9eedba3564ea6a49$var$addPropertyScalar(deselect, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$cb998ac70542b2c3).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).temperatureUnits);
    // "me:sigma", scalar, Å (fixed).
    $9eedba3564ea6a49$var$addPropertyScalar(deselect, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$79e850ed2864d13d).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).lengthUnits);
    // "me:hessian", matrix, kJ/mol/Å2 or kcal/mol/Å2 or Hartree/Å2.
    $9eedba3564ea6a49$var$addPropertyMatrix(deselect, false, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$789e4dcdcb815c05).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).hessianUnits);
    // "me:EinsteinAij", array, s-1 (fixed).
    $9eedba3564ea6a49$var$addPropertyArray(deselect, false, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$f3e9ef5020c299b5).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).EinsteinAUnits);
    // "me:EinsteinBij", array, m3/J/s2 (fixed).
    $9eedba3564ea6a49$var$addPropertyArray(deselect, false, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$25f02bc420569a7e).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).EinsteinBUnits);
    // "me:electronicExcitation">, scalar, cm-1.
    $9eedba3564ea6a49$var$addPropertyScalar(deselect, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$2e66a7dc5ebae8a1).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).frequencyUnits);
}
/**
 * @param deselect If true the button is clicked and the propert removed.
 * @param m The molecule.
 * @param mIDM The molecule IDManager.
 * @param plDiv The PropertyList HTMLDivElement.
 * @param pl The PropertyList.
 * @param dictRef The dictRef.
 * @param units The units. 
 */ function $9eedba3564ea6a49$var$addPropertyScalar(deselect, m, mIDM, plDiv, pl, dictRef, units) {
    let pAttributes;
    let psAttributes;
    let ps;
    let p;
    let div;
    pAttributes = new Map();
    pAttributes.set((0, $597d59a3d37b5b3f$export$41b04b3a73e7216d).s_dictRef, dictRef);
    psAttributes = new Map();
    if (units != undefined) psAttributes.set((0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).s_units, units[0]);
    ps = new (0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3)(psAttributes, (0, $dc4240e6100248ae$export$a94c859b6fc3ec52));
    p = new (0, $597d59a3d37b5b3f$export$41b04b3a73e7216d)(pAttributes, ps);
    m.getPropertyList().setProperty(p);
    console.log("pl.index.size" + pl.index.size);
    div = (0, $dc4240e6100248ae$export$17d48ee8ddbf2d44)(plDiv.id, mIDM, dictRef, ps.getValue.bind(ps), (value)=>$9eedba3564ea6a49$export$c1dce3e534360efd(dictRef, pl, ps, value), ()=>pl.removeProperty(p.dictRef), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
    (0, $dc4240e6100248ae$export$2b2254f82abcc900)(units, psAttributes, div, div.querySelector((0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $dc4240e6100248ae$export$bea69a603fae01a6)(plDiv.id, dictRef, (0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).s_units), dictRef, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    plDiv.appendChild(div);
    // Deselect
    if (deselect) {
        let b = div.querySelector((0, $341c675b659c6d43$export$25280bc3a7ce098e));
        b.click();
        pl.removeProperty(dictRef);
    }
    return div;
}
function $9eedba3564ea6a49$export$c1dce3e534360efd(dictRef, pl, ps, value) {
    if (pl.getProperty(dictRef) == undefined) {
        let pAttributes;
        let p;
        pAttributes = new Map();
        pAttributes.set((0, $597d59a3d37b5b3f$export$41b04b3a73e7216d).s_dictRef, dictRef);
        p = new (0, $597d59a3d37b5b3f$export$41b04b3a73e7216d)(pAttributes, ps);
        pl.setProperty(p);
        console.log("Set property " + dictRef);
    } else console.log("Property " + dictRef + " already exists.");
    //console.log("Value " + ps.getValue());
    ps.setValue.bind(ps)(value);
    if (dictRef == (0, $597d59a3d37b5b3f$export$95174cf0748f45cd).dictRef || dictRef == (0, $597d59a3d37b5b3f$export$90bccbae54bb6d4f).dictRef || dictRef == (0, $597d59a3d37b5b3f$export$a4fe62a56eafa45d).dictRef || dictRef == (0, $597d59a3d37b5b3f$export$e7df60530792b964).dictRef) (0, $dc4240e6100248ae$export$e7cd7bead34ef747)();
//console.log("Value " + ps.getValue());
}
/**
 * @param deselect If true the button is clicked and the propert removed.
 * @param m The molecule.
 * @param mIDM The molecule IDManager.
 * @param plDiv The PropertyList HTMLDivElement.
 * @param pl The PropertyList.
 * @param dictRef The dictRef.
 * @param units The units. 
 */ function $9eedba3564ea6a49$var$addPropertyArray(deselect, setSize, m, mIDM, plDiv, pl, dictRef, units) {
    let pAttributes;
    let paAttributes;
    let pa;
    let p;
    let div;
    pAttributes = new Map();
    pAttributes.set((0, $597d59a3d37b5b3f$export$41b04b3a73e7216d).s_dictRef, dictRef);
    paAttributes = new Map();
    if (units != undefined) paAttributes.set((0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).s_units, units[0]);
    // Init values.
    let values = [];
    if (setSize) $9eedba3564ea6a49$export$b7771d60d308862f(dictRef, values);
    pa = new (0, $597d59a3d37b5b3f$export$9f93a3fdf2490572)(paAttributes, values);
    p = new (0, $597d59a3d37b5b3f$export$41b04b3a73e7216d)(pAttributes, pa);
    m.getPropertyList().setProperty(p);
    console.log("pl.index.size" + pl.index.size);
    div = $9eedba3564ea6a49$export$e5600fc4ea245d6d(plDiv, mIDM, dictRef, pa, pa.getValues.bind(pa), (values)=>$9eedba3564ea6a49$export$3de90924239ae34e(dictRef, pl, pa, values), ()=>pl.removeProperty(p.dictRef), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
    (0, $dc4240e6100248ae$export$2b2254f82abcc900)(units, paAttributes, div, div.querySelector((0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $dc4240e6100248ae$export$bea69a603fae01a6)(plDiv.id, dictRef, (0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).s_units), dictRef, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    plDiv.appendChild(div);
    // Deselect
    if (deselect) {
        let b = div.querySelector((0, $341c675b659c6d43$export$25280bc3a7ce098e));
        b.click();
        pl.removeProperty(dictRef);
    }
}
function $9eedba3564ea6a49$export$b7771d60d308862f(dictRef, values) {
    let n = (0, $dc4240e6100248ae$export$88ed5e596ed31b40)("Please enter the number of elements in the " + dictRef + " array");
    for(let i = 0; i < n; i++)values.push((0, $dc4240e6100248ae$export$a94c859b6fc3ec52));
}
function $9eedba3564ea6a49$export$3de90924239ae34e(dictRef, pl, paom, values) {
    if (pl.getProperty(dictRef) == undefined) {
        let pAttributes;
        let p;
        pAttributes = new Map();
        pAttributes.set((0, $597d59a3d37b5b3f$export$41b04b3a73e7216d).s_dictRef, dictRef);
        p = new (0, $597d59a3d37b5b3f$export$41b04b3a73e7216d)(pAttributes, paom);
        //setValues(dictRef, values);
        pl.setProperty(p);
        console.log("Set property " + dictRef);
    } else console.log("Property " + dictRef + " already exists.");
    console.log("Value " + paom.getValues());
    paom.setValues.bind(paom)(values);
    console.log("Value " + paom.getValues());
}
/**
 * @param deselect If true the button is clicked and the propert removed.
 * @param m The molecule.
 * @param mIDM The molecule IDManager.
 * @param plDiv The PropertyList HTMLDivElement.
 * @param pl The PropertyList.
 * @param dictRef The dictRef.
 * @param units The units. 
 */ function $9eedba3564ea6a49$var$addPropertyMatrix(deselect, setSize, m, mIDM, plDiv, pl, dictRef, units) {
    let pAttributes;
    let pmAttributes;
    let pm;
    let p;
    let div;
    pAttributes = new Map();
    pAttributes.set((0, $597d59a3d37b5b3f$export$41b04b3a73e7216d).s_dictRef, dictRef);
    pmAttributes = new Map();
    if (units != undefined) pmAttributes.set((0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).s_units, units[0]);
    // Init values.
    let values = [];
    if (setSize) $9eedba3564ea6a49$export$b7771d60d308862f(dictRef, values);
    pm = new (0, $597d59a3d37b5b3f$export$a5a2be813176eb0e)(pmAttributes, values);
    p = new (0, $597d59a3d37b5b3f$export$41b04b3a73e7216d)(pAttributes, pm);
    m.getPropertyList().setProperty(p);
    console.log("pl.index.size" + pl.index.size);
    div = $9eedba3564ea6a49$export$e5600fc4ea245d6d(plDiv, mIDM, dictRef, pm, pm.getValues.bind(pm), (values)=>$9eedba3564ea6a49$export$3de90924239ae34e(dictRef, pl, pm, values), ()=>pl.removeProperty(p.dictRef), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
    (0, $dc4240e6100248ae$export$2b2254f82abcc900)(units, pmAttributes, div, div.querySelector((0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $dc4240e6100248ae$export$bea69a603fae01a6)(plDiv.id, dictRef, (0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).s_units), dictRef, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    plDiv.appendChild(div);
    // Deselect
    if (deselect) {
        let b = div.querySelector((0, $341c675b659c6d43$export$25280bc3a7ce098e));
        b.click();
        pl.removeProperty(dictRef);
    }
}
function $9eedba3564ea6a49$export$1f1b9bc888fe9f4c(mlDiv, amb, mIDM, molecules) {
    let addFromLibraryButton = (0, $341c675b659c6d43$export$9b6d6ca62970729f)((0, $dc4240e6100248ae$export$b071b08ccb05fd2), undefined, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    mlDiv.appendChild(addFromLibraryButton);
    // Add event listener for the button.
    addFromLibraryButton.addEventListener('click', ()=>{
        // Create a select element to select a libraryMolecule.
        let selectDivID = mIDM.addID((0, $597d59a3d37b5b3f$export$3da9759ad07746a3).tagName, "div");
        (0, $dc4240e6100248ae$export$cd7f480d6b8286c3)(selectDivID);
        let selectDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(selectDivID, (0, $dc4240e6100248ae$export$39c84188a71202f7));
        if ((0, $dc4240e6100248ae$export$7c97c73a2c729cf9) == undefined) {
            alert("There are no additional molecules to add, please load data...");
            return;
        }
        let options = Array.from((0, $dc4240e6100248ae$export$5ac38056c0103baa)((0, $dc4240e6100248ae$export$7c97c73a2c729cf9)));
        if (options.length == 0) {
            alert("There are no additional molecules to add, please load data...");
            return;
        }
        console.log("options.length=" + options.length);
        (0, $dc4240e6100248ae$export$10de1fc8385eec4a)(options, true);
        let selectID = mIDM.addID(selectDivID, (0, $341c675b659c6d43$export$8797b0c8298d191));
        (0, $dc4240e6100248ae$export$cd7f480d6b8286c3)(selectID);
        let select = (0, $341c675b659c6d43$export$b89bf4b169286865)(options, "Select molecule", (0, $dc4240e6100248ae$export$d8b8827abc8ab7e7), selectID, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
        select.classList.add((0, $597d59a3d37b5b3f$export$3da9759ad07746a3).tagName);
        selectDiv.appendChild(select);
        mlDiv.insertBefore(selectDiv, amb);
        (0, $dc4240e6100248ae$export$3b08dcba56872ec6)(options, select);
        select.addEventListener('change', (event)=>{
            let target = event.target;
            let selectedOption = target.options[target.selectedIndex];
            let label = selectedOption.value;
            let molecule = (0, $dc4240e6100248ae$export$7c97c73a2c729cf9).get(label);
            //let molecule: Molecule = getMolecule(label, libmols)!;
            let mid = molecule.getID();
            while(true){
                mid = $9eedba3564ea6a49$export$194bfe7da61d65(true, mid, molecule, molecules);
                if (mid != undefined) break;
            }
            molecules.set(mid, molecule);
            // Add molecule to the MoleculeList.
            let mDivID = mIDM.addID((0, $597d59a3d37b5b3f$export$3da9759ad07746a3).tagName, molecules.size);
            let moleculeDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(mDivID);
            // Create collapsible Molecule HTMLDivElement.
            let mcDivID = mIDM.addID(mDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
            let mcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(mcDivID, mlDiv, amb, moleculeDiv, molecule.getLabel(), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            // Add the molecule to the BathGas select elements.
            (0, $dc4240e6100248ae$export$a30e0f90a7434924)((0, $5b710835528e7170$export$b33a132661f4be58).tagName, molecule.getID());
            // Add edit Name button.
            $9eedba3564ea6a49$var$addEditIDButton(molecule, molecules, mcDiv.querySelector((0, $341c675b659c6d43$export$25280bc3a7ce098e)), mIDM, moleculeDiv, (0, $dc4240e6100248ae$export$39c84188a71202f7));
            // Description
            moleculeDiv.appendChild($9eedba3564ea6a49$var$processDescription(mIDM.addID(mDivID, (0, $dc4240e6100248ae$export$666359451816b0e7)), mIDM, molecule.getDescription.bind(molecule), molecule.setDescription.bind(molecule), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7)));
            // Create collapsible MetadataList HTMLDivElement.
            let mlistDivID = mIDM.addID(mDivID, (0, $cb35636d41d8f309$export$3e18a603070a78a).tagName);
            let mlistDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(mlistDivID, (0, $dc4240e6100248ae$export$39c84188a71202f7));
            //let mlistcDivID = mIDM.addID(mlistDivID, s_container);
            let mlistcDivID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(mlistDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
            let mlistcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(mlistcDivID, moleculeDiv, null, mlistDiv, (0, $cb35636d41d8f309$export$3e18a603070a78a).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            // Add metadata.
            let metadataList = molecule.getMetadataList();
            if (metadataList != undefined) metadataList.getMetadata().forEach((md)=>{
                let mdDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)();
                mlistDiv.appendChild(mdDiv);
                mdDiv.appendChild((0, $341c675b659c6d43$export$f2839682b8c07f35)(md.getLabelText(), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b)));
            });
            // Create collapsible AtomArray HTMLDivElement.
            let aaDivID = mIDM.addID(mDivID, (0, $597d59a3d37b5b3f$export$9cea715eceba39a0).tagName);
            let aaDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(aaDivID);
            let aacDivID = mIDM.addID(aaDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
            let aacDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(aacDivID, moleculeDiv, null, aaDiv, (0, $597d59a3d37b5b3f$export$9cea715eceba39a0).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            // Add atoms.
            let aa = molecule.getAtoms();
            if (aa != undefined) aa.atoms.forEach((a)=>{
                aaDiv.appendChild($9eedba3564ea6a49$var$addAtom(false, mIDM, molecule, aaDivID, aa, a, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7)));
            });
            aaDiv.appendChild($9eedba3564ea6a49$var$getAddAtomButton(mIDM, molecule, aaDiv, (0, $597d59a3d37b5b3f$export$80986e6afdd7e0cb).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7)));
            // Create collapsible BondArray HTMLDivElement.
            let baDivID = mIDM.addID(mDivID, (0, $597d59a3d37b5b3f$export$746fba2e30d93fe6).tagName);
            let baDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(baDivID);
            let bacDivID = mIDM.addID(baDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
            let bacDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(bacDivID, moleculeDiv, null, baDiv, (0, $597d59a3d37b5b3f$export$746fba2e30d93fe6).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            // Add bonds.
            let ba = molecule.getBonds();
            if (ba != undefined) ba.bonds.forEach((b)=>{
                if (aa == undefined) throw new Error("Atoms are not defined for molecule " + molecule.getLabel());
                baDiv.appendChild($9eedba3564ea6a49$var$addBond(false, mIDM, molecule, baDivID, aa.atoms, ba, b, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7)));
            });
            baDiv.appendChild($9eedba3564ea6a49$var$getAddBondButton(mIDM, molecule, baDiv, (0, $597d59a3d37b5b3f$export$153327fc99ac0c53).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7)));
            $9eedba3564ea6a49$export$7aad7e61c4f49964(mIDM, molecule, moleculeDiv, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            // Create collapsible Properties HTMLDivElement.
            let plDivID = mIDM.addID(mDivID, (0, $597d59a3d37b5b3f$export$4e0d1ad7ad6a0802).tagName);
            let plDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(plDivID);
            let plcDivID = mIDM.addID(plDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
            let plcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(plcDivID, moleculeDiv, null, plDiv, (0, $597d59a3d37b5b3f$export$4e0d1ad7ad6a0802).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            let pl = molecule.getPropertyList();
            let properties = pl.getProperties();
            //console.log("properties.size=" + properties.size);
            let dictRefs = new Set(properties.keys());
            //console.log("Molecule " + molecule.getDescription());
            let pID;
            let deselect = true;
            // "me:ZPE", scalar, Mesmer.energyUnits.
            if (!dictRefs.has((0, $597d59a3d37b5b3f$export$95174cf0748f45cd).dictRef)) $9eedba3564ea6a49$var$addPropertyScalar(deselect, molecule, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$95174cf0748f45cd).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).energyUnits);
            else {
                pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$95174cf0748f45cd).dictRef);
                let p = pl.getProperty((0, $597d59a3d37b5b3f$export$95174cf0748f45cd).dictRef);
                let ps = p.getProperty();
                let div = (0, $dc4240e6100248ae$export$17d48ee8ddbf2d44)(pID, mIDM, p.dictRef, ps.getValue.bind(ps), (value)=>$9eedba3564ea6a49$export$c1dce3e534360efd(p.dictRef, pl, ps, value), ()=>pl.removeProperty(p.dictRef), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                (0, $dc4240e6100248ae$export$2b2254f82abcc900)((0, $ccef02370f58a770$export$692079bb871c6039).energyUnits, ps.attributes, div, div.querySelector((0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(pID, (0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).s_units), p.dictRef, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
                plDiv.appendChild(div);
            }
            // "me:Hf0", scalar, Mesmer.energyUnits.
            if (!dictRefs.has((0, $597d59a3d37b5b3f$export$90bccbae54bb6d4f).dictRef)) $9eedba3564ea6a49$var$addPropertyScalar(deselect, molecule, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$90bccbae54bb6d4f).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).energyUnits);
            else {
                pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$90bccbae54bb6d4f).dictRef);
                let p = pl.getProperty((0, $597d59a3d37b5b3f$export$90bccbae54bb6d4f).dictRef);
                let ps = p.getProperty();
                let div = (0, $dc4240e6100248ae$export$17d48ee8ddbf2d44)(pID, mIDM, p.dictRef, ps.getValue.bind(ps), (value)=>$9eedba3564ea6a49$export$c1dce3e534360efd(p.dictRef, pl, ps, value), ()=>pl.removeProperty(p.dictRef), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                (0, $dc4240e6100248ae$export$2b2254f82abcc900)((0, $ccef02370f58a770$export$692079bb871c6039).energyUnits, ps.attributes, div, div.querySelector((0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(pID, (0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).s_units), p.dictRef, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
                plDiv.appendChild(div);
            }
            // "me:HfAT0", scalar, Mesmer.energyUnits.
            if (!dictRefs.has((0, $597d59a3d37b5b3f$export$a4fe62a56eafa45d).dictRef)) $9eedba3564ea6a49$var$addPropertyScalar(deselect, molecule, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$a4fe62a56eafa45d).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).energyUnits);
            else {
                pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$a4fe62a56eafa45d).dictRef);
                let p = pl.getProperty((0, $597d59a3d37b5b3f$export$a4fe62a56eafa45d).dictRef);
                let ps = p.getProperty();
                let div = (0, $dc4240e6100248ae$export$17d48ee8ddbf2d44)(pID, mIDM, p.dictRef, ps.getValue.bind(ps), (value)=>$9eedba3564ea6a49$export$c1dce3e534360efd(p.dictRef, pl, ps, value), ()=>pl.removeProperty(p.dictRef), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                (0, $dc4240e6100248ae$export$2b2254f82abcc900)((0, $ccef02370f58a770$export$692079bb871c6039).energyUnits, ps.attributes, div, div.querySelector((0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(pID, (0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).s_units), p.dictRef, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
                plDiv.appendChild(div);
            }
            // "me:Hf298", scalar, Mesmer.energyUnits.
            if (!dictRefs.has((0, $597d59a3d37b5b3f$export$e7df60530792b964).dictRef)) $9eedba3564ea6a49$var$addPropertyScalar(deselect, molecule, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$e7df60530792b964).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).energyUnits);
            else {
                pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$e7df60530792b964).dictRef);
                let p = pl.getProperty((0, $597d59a3d37b5b3f$export$e7df60530792b964).dictRef);
                let ps = p.getProperty();
                let div = (0, $dc4240e6100248ae$export$17d48ee8ddbf2d44)(pID, mIDM, p.dictRef, ps.getValue.bind(ps), (value)=>$9eedba3564ea6a49$export$c1dce3e534360efd(p.dictRef, pl, ps, value), ()=>pl.removeProperty(p.dictRef), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                (0, $dc4240e6100248ae$export$2b2254f82abcc900)((0, $ccef02370f58a770$export$692079bb871c6039).energyUnits, ps.attributes, div, div.querySelector((0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(pID, (0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).s_units), p.dictRef, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
                plDiv.appendChild(div);
            }
            // "me:rotConsts", array, Mesmer.frequencyUnits.
            if (!dictRefs.has((0, $597d59a3d37b5b3f$export$984abe26ded13ee0).dictRef)) $9eedba3564ea6a49$var$addPropertyArray(deselect, false, molecule, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$984abe26ded13ee0).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).frequencyUnits);
            else {
                pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$984abe26ded13ee0).dictRef);
                let p = pl.getProperty((0, $597d59a3d37b5b3f$export$984abe26ded13ee0).dictRef);
                let pa = p.getProperty();
                let div = $9eedba3564ea6a49$export$e5600fc4ea245d6d(plDiv, mIDM, p.dictRef, pa, pa.getValues.bind(pa), (values)=>$9eedba3564ea6a49$export$3de90924239ae34e(p.dictRef, pl, pa, values), ()=>pl.removeProperty(p.dictRef), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                (0, $dc4240e6100248ae$export$2b2254f82abcc900)((0, $ccef02370f58a770$export$692079bb871c6039).frequencyUnits, pa.attributes, div, div.querySelector((0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(pID, (0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).s_units), p.dictRef, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
                plDiv.appendChild(div);
            }
            // "me:symmetryNumber", scalar, No units.
            if (!dictRefs.has((0, $597d59a3d37b5b3f$export$d1d1720eff14586a).dictRef)) $9eedba3564ea6a49$var$addPropertyScalar(deselect, molecule, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$d1d1720eff14586a).dictRef, undefined);
            else {
                pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$d1d1720eff14586a).dictRef);
                let p = pl.getProperty((0, $597d59a3d37b5b3f$export$d1d1720eff14586a).dictRef);
                let ps = p.getProperty();
                let div = (0, $dc4240e6100248ae$export$17d48ee8ddbf2d44)(pID, mIDM, p.dictRef, ps.getValue.bind(ps), (value)=>$9eedba3564ea6a49$export$c1dce3e534360efd(p.dictRef, pl, ps, value), ()=>pl.removeProperty(p.dictRef), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                plDiv.appendChild(div);
            }
            // "me:TSOpticalSymmetryNumber", scalar, No units.
            if (!dictRefs.has((0, $597d59a3d37b5b3f$export$886461cafebcdaed).dictRef)) $9eedba3564ea6a49$var$addPropertyScalar(deselect, molecule, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$886461cafebcdaed).dictRef, undefined);
            else {
                pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$886461cafebcdaed).dictRef);
                let p = pl.getProperty((0, $597d59a3d37b5b3f$export$886461cafebcdaed).dictRef);
                let ps = p.getProperty();
                let div = (0, $dc4240e6100248ae$export$17d48ee8ddbf2d44)(pID, mIDM, p.dictRef, ps.getValue.bind(ps), (value)=>$9eedba3564ea6a49$export$c1dce3e534360efd(p.dictRef, pl, ps, value), ()=>pl.removeProperty(p.dictRef), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                plDiv.appendChild(div);
            }
            // "me:frequenciesScaleFactor", scalar, No units.
            if (!dictRefs.has((0, $597d59a3d37b5b3f$export$1288989e9be37590).dictRef)) $9eedba3564ea6a49$var$addPropertyScalar(deselect, molecule, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$1288989e9be37590).dictRef, undefined);
            else {
                pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$1288989e9be37590).dictRef);
                let p = pl.getProperty((0, $597d59a3d37b5b3f$export$1288989e9be37590).dictRef);
                let ps = p.getProperty();
                let div = (0, $dc4240e6100248ae$export$17d48ee8ddbf2d44)(pID, mIDM, p.dictRef, ps.getValue.bind(ps), (value)=>$9eedba3564ea6a49$export$c1dce3e534360efd(p.dictRef, pl, ps, value), ()=>pl.removeProperty(p.dictRef), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                plDiv.appendChild(div);
            }
            // "me:vibFreqs", array, cm-1.
            if (!dictRefs.has((0, $597d59a3d37b5b3f$export$2762c8fbc03043ca).dictRef)) $9eedba3564ea6a49$var$addPropertyArray(deselect, false, molecule, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$2762c8fbc03043ca).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).frequencyUnits);
            else {
                pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$2762c8fbc03043ca).dictRef);
                let p = pl.getProperty((0, $597d59a3d37b5b3f$export$2762c8fbc03043ca).dictRef);
                let pa = p.getProperty();
                let div = $9eedba3564ea6a49$export$e5600fc4ea245d6d(plDiv, mIDM, p.dictRef, pa, pa.getValues.bind(pa), (values)=>$9eedba3564ea6a49$export$3de90924239ae34e(p.dictRef, pl, pa, values), ()=>pl.removeProperty(p.dictRef), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                (0, $dc4240e6100248ae$export$2b2254f82abcc900)((0, $ccef02370f58a770$export$692079bb871c6039).frequencyUnits, pa.attributes, div, div.querySelector((0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(pID, (0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).s_units), p.dictRef, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
                plDiv.appendChild(div);
            }
            // "me:MW", scalar, amu.
            if (!dictRefs.has((0, $597d59a3d37b5b3f$export$a3772f6eb527275b).dictRef)) $9eedba3564ea6a49$var$addPropertyScalar(deselect, molecule, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$a3772f6eb527275b).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).massUnits);
            else {
                pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$a3772f6eb527275b).dictRef);
                let p = pl.getProperty((0, $597d59a3d37b5b3f$export$a3772f6eb527275b).dictRef);
                let ps = p.getProperty();
                let div = (0, $dc4240e6100248ae$export$17d48ee8ddbf2d44)(pID, mIDM, p.dictRef, ps.getValue.bind(ps), (value)=>$9eedba3564ea6a49$export$c1dce3e534360efd(p.dictRef, pl, ps, value), ()=>pl.removeProperty(p.dictRef), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                (0, $dc4240e6100248ae$export$2b2254f82abcc900)((0, $ccef02370f58a770$export$692079bb871c6039).massUnits, ps.attributes, div, div.querySelector((0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(pID, (0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).s_units), p.dictRef, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
                plDiv.appendChild(div);
            }
            // "me:spinMultiplicity", scalar, No units.
            if (!dictRefs.has((0, $597d59a3d37b5b3f$export$415ad1120b60f9f3).dictRef)) $9eedba3564ea6a49$var$addPropertyScalar(deselect, molecule, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$415ad1120b60f9f3).dictRef, undefined);
            else {
                pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$415ad1120b60f9f3).dictRef);
                let p = pl.getProperty((0, $597d59a3d37b5b3f$export$415ad1120b60f9f3).dictRef);
                let ps = p.getProperty();
                let div = (0, $dc4240e6100248ae$export$17d48ee8ddbf2d44)(pID, mIDM, p.dictRef, ps.getValue.bind(ps), (value)=>$9eedba3564ea6a49$export$c1dce3e534360efd(p.dictRef, pl, ps, value), ()=>pl.removeProperty(p.dictRef), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                plDiv.appendChild(div);
            }
            // "me:epsilon", scalar, K (fixed).
            if (!dictRefs.has((0, $597d59a3d37b5b3f$export$cb998ac70542b2c3).dictRef)) $9eedba3564ea6a49$var$addPropertyScalar(deselect, molecule, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$cb998ac70542b2c3).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).temperatureUnits);
            else {
                pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$cb998ac70542b2c3).dictRef);
                let p = pl.getProperty((0, $597d59a3d37b5b3f$export$cb998ac70542b2c3).dictRef);
                let ps = p.getProperty();
                let div = (0, $dc4240e6100248ae$export$17d48ee8ddbf2d44)(pID, mIDM, p.dictRef, ps.getValue.bind(ps), (value)=>$9eedba3564ea6a49$export$c1dce3e534360efd(p.dictRef, pl, ps, value), ()=>pl.removeProperty(p.dictRef), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                plDiv.appendChild(div);
            }
            // "me:sigma", scalar, Å (fixed).
            if (!dictRefs.has((0, $597d59a3d37b5b3f$export$79e850ed2864d13d).dictRef)) $9eedba3564ea6a49$var$addPropertyScalar(deselect, molecule, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$79e850ed2864d13d).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).lengthUnits);
            else {
                pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$79e850ed2864d13d).dictRef);
                let p = pl.getProperty((0, $597d59a3d37b5b3f$export$79e850ed2864d13d).dictRef);
                let ps = p.getProperty();
                let div = (0, $dc4240e6100248ae$export$17d48ee8ddbf2d44)(pID, mIDM, p.dictRef, ps.getValue.bind(ps), (value)=>$9eedba3564ea6a49$export$c1dce3e534360efd(p.dictRef, pl, ps, value), ()=>pl.removeProperty(p.dictRef), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                plDiv.appendChild(div);
            }
            // "me:hessian", matrix, kJ/mol/Å2 or kcal/mol/Å2 or Hartree/Å2.
            if (!dictRefs.has((0, $597d59a3d37b5b3f$export$789e4dcdcb815c05).dictRef)) $9eedba3564ea6a49$var$addPropertyMatrix(deselect, false, molecule, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$789e4dcdcb815c05).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).hessianUnits);
            else {
                pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$789e4dcdcb815c05).dictRef);
                let p = pl.getProperty((0, $597d59a3d37b5b3f$export$789e4dcdcb815c05).dictRef);
                let pm = p.getProperty();
                let div = $9eedba3564ea6a49$export$e5600fc4ea245d6d(plDiv, mIDM, p.dictRef, pm, pm.getValues.bind(pm), (values)=>$9eedba3564ea6a49$export$3de90924239ae34e(p.dictRef, pl, pm, values), ()=>pl.removeProperty(p.dictRef), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                (0, $dc4240e6100248ae$export$2b2254f82abcc900)((0, $ccef02370f58a770$export$692079bb871c6039).hessianUnits, pm.attributes, div, div.querySelector((0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(pID, (0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).s_units), p.dictRef, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
                plDiv.appendChild(div);
            }
            // "me:EinsteinAij", array, s-1 (fixed).
            if (!dictRefs.has((0, $597d59a3d37b5b3f$export$f3e9ef5020c299b5).dictRef)) $9eedba3564ea6a49$var$addPropertyArray(deselect, false, molecule, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$f3e9ef5020c299b5).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).EinsteinAUnits);
            else {
                pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$f3e9ef5020c299b5).dictRef);
                let p = pl.getProperty((0, $597d59a3d37b5b3f$export$f3e9ef5020c299b5).dictRef);
                let pa = p.getProperty();
                let div = $9eedba3564ea6a49$export$e5600fc4ea245d6d(plDiv, mIDM, p.dictRef, pa, pa.getValues.bind(pa), (values)=>$9eedba3564ea6a49$export$3de90924239ae34e(p.dictRef, pl, pa, values), ()=>pl.removeProperty(p.dictRef), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                (0, $dc4240e6100248ae$export$2b2254f82abcc900)((0, $ccef02370f58a770$export$692079bb871c6039).EinsteinAUnits, pa.attributes, div, div.querySelector((0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(pID, (0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).s_units), p.dictRef, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
                plDiv.appendChild(div);
            }
            // "me:EinsteinBij", array, m3/J/s2 (fixed).
            if (!dictRefs.has((0, $597d59a3d37b5b3f$export$25f02bc420569a7e).dictRef)) $9eedba3564ea6a49$var$addPropertyArray(deselect, false, molecule, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$25f02bc420569a7e).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).EinsteinBUnits);
            else {
                pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$25f02bc420569a7e).dictRef);
                let p = pl.getProperty((0, $597d59a3d37b5b3f$export$25f02bc420569a7e).dictRef);
                let pa = p.getProperty();
                let div = $9eedba3564ea6a49$export$e5600fc4ea245d6d(plDiv, mIDM, p.dictRef, pa, pa.getValues.bind(pa), (values)=>$9eedba3564ea6a49$export$3de90924239ae34e(p.dictRef, pl, pa, values), ()=>pl.removeProperty(p.dictRef), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                (0, $dc4240e6100248ae$export$2b2254f82abcc900)((0, $ccef02370f58a770$export$692079bb871c6039).EinsteinBUnits, pa.attributes, div, div.querySelector((0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(pID, (0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).s_units), p.dictRef, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
                plDiv.appendChild(div);
            }
            // "me:ElectronicExcitation", scalar, cm-1.
            if (!dictRefs.has((0, $597d59a3d37b5b3f$export$2e66a7dc5ebae8a1).dictRef)) $9eedba3564ea6a49$var$addPropertyScalar(deselect, molecule, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$2e66a7dc5ebae8a1).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).frequencyUnits);
            else {
                pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$2e66a7dc5ebae8a1).dictRef);
                let p = pl.getProperty((0, $597d59a3d37b5b3f$export$2e66a7dc5ebae8a1).dictRef);
                let ps = p.getProperty();
                let div = (0, $dc4240e6100248ae$export$17d48ee8ddbf2d44)(pID, mIDM, p.dictRef, ps.getValue.bind(ps), (value)=>$9eedba3564ea6a49$export$c1dce3e534360efd(p.dictRef, pl, ps, value), ()=>pl.removeProperty(p.dictRef), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                (0, $dc4240e6100248ae$export$2b2254f82abcc900)((0, $ccef02370f58a770$export$692079bb871c6039).frequencyUnits, ps.attributes, div, div.querySelector((0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(pID, (0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).s_units), p.dictRef, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
                plDiv.appendChild(div);
            }
            /*
            // Add me:DOSCMethod.
            let doscm: DOSCMethod | undefined = molecule.getDOSCMethod();
            if (doscm == undefined) {
                doscm = new DOSCMethod(new Map());
                molecule.setDOSCMethod(doscm);
            }
            moleculeDiv.appendChild(
                createLabelWithSelect(DOSCMethod.tagName, DOSCMethod.xsi_typeOptions, DOSCMethod.tagName,
                doscm.getXsiType(), mIDM.addID(mDivID, DOSCMethod.tagName), boundary1, level1));
            */ // Organise States.
            let ssDivID = mIDM.addID(mDivID, (0, $597d59a3d37b5b3f$export$7254cc27399e90bd).tagName);
            let ssDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(ssDivID);
            let sscDivID = mIDM.addID(ssDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
            let sscDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(sscDivID, moleculeDiv, null, ssDiv, (0, $597d59a3d37b5b3f$export$47283907dceba392).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            // Add states.
            let states = molecule.getStates();
            if (states != undefined) states.getStates().forEach((s)=>{
                console.log(s.toString());
                // Add state.
                let sDivID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(ssDivID, (0, $597d59a3d37b5b3f$export$7254cc27399e90bd).tagName, s.id);
                let sDiv = (0, $341c675b659c6d43$export$78253536c0178a32)(sDivID);
                ssDiv.appendChild(sDiv);
                // Add energy.
                let energyDivID = mIDM.addID(sDivID, (0, $597d59a3d37b5b3f$export$7254cc27399e90bd).s_energy);
                let energy = s.getEnergy();
                let elwi = (0, $341c675b659c6d43$export$4e9ec2b27757d9dd)((0, $597d59a3d37b5b3f$export$7254cc27399e90bd).s_energy, energyDivID, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7), (event)=>{
                    let target = event.target;
                    // Check the input is a number.
                    if ((0, $93b71ab6968650c1$export$e90fb89750dba83f)(target.value)) {
                        energy = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(target.value);
                        s.setEnergy(energy);
                    } else {
                        // Reset.
                        alert("Input is not a number, resetting...");
                        target.value = energy.toString() ?? (0, $dc4240e6100248ae$export$2f2abd8810196a7);
                    }
                    (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
                }, energy.toString(), (0, $597d59a3d37b5b3f$export$7254cc27399e90bd).s_energy);
                sDiv.appendChild(elwi);
                // Add degeneracy.
                let degeneracyDivID = mIDM.addID(sDivID, (0, $597d59a3d37b5b3f$export$7254cc27399e90bd).s_degeneracy);
                let degeneracy = s.getDegeneracy();
                let dlwi = (0, $341c675b659c6d43$export$4e9ec2b27757d9dd)((0, $597d59a3d37b5b3f$export$7254cc27399e90bd).s_degeneracy, degeneracyDivID, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (event)=>{
                    let target = event.target;
                    // Check the input is a number.
                    if ((0, $93b71ab6968650c1$export$e90fb89750dba83f)(target.value)) {
                        degeneracy = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(target.value);
                        s.setDegeneracy(degeneracy);
                    } else {
                        // Reset.
                        alert("Input is not a number, resetting...");
                        target.value = degeneracy.toString() ?? (0, $dc4240e6100248ae$export$2f2abd8810196a7);
                    }
                    (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
                }, degeneracy.toString(), (0, $597d59a3d37b5b3f$export$7254cc27399e90bd).s_degeneracy);
                sDiv.appendChild(dlwi);
                // Add a remove state button.
                (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(sDiv, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), ()=>{
                    states.removeState(s.id);
                    sDiv.remove();
                });
            /*
                    // Add a move up button.
                    sDiv.appendChild(getMoveUpButton(mIDM, molecule, ssDiv, State.tagName, sDiv, s));
                    // Add a move down button.
                    sDiv.appendChild(getMoveDownButton(mIDM, molecule, ssDiv, State.tagName, sDiv, s));
                    */ });
            // Add an add state button.
            //ssDiv.appendChild(getAddStateButton(mIDM, molecule, ssDiv, State.tagName, boundary1, level1));
            // Remove the select element.
            selectDiv.remove();
            // Add a remove molecule button.
            (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(moleculeDiv, (0, $dc4240e6100248ae$export$39c84188a71202f7), ()=>{
                $9eedba3564ea6a49$var$removeMolecule(mlDiv, mcDiv, mIDM, molecules, mDivID, molecule);
            });
        });
    });
    return addFromLibraryButton;
}
function $9eedba3564ea6a49$export$194bfe7da61d65(ask, mid, molecule, molecules) {
    let mid2;
    while(true){
        // Ask the user to specify the molecule ID.
        if (ask) mid2 = prompt("Please enter a name for the molecule", mid);
        else mid2 = mid;
        if (mid2 == null) //alert("The molecule ID cannot be null.");
        return undefined;
        else if (mid2 == "") alert("The molecule ID cannot be empty.");
        else if (molecules.has(mid2)) {
            //if (mid == mid2) {
            //    if (molecule != undefined) {
            //        molecule.setID(mid);
            //        molecules.set(mid, molecule);
            //    }
            //    return mid;
            //} else {
            alert("The molecule ID " + mid2 + " is already in use.");
            ask = true;
        //}
        } else {
            mid = mid2;
            if (molecule != undefined) {
                molecule.setID(mid);
                molecules.set(mid, molecule);
            }
            return mid;
        }
    }
}
/**
 * Adds a button to edit the molecule ID.
 * @param molecule The molecule.
 * @param molecules The molecules map.
 * @param button The button to add the event listener to.
 * @param mDiv 
 * @param level 
 */ function $9eedba3564ea6a49$var$addEditIDButton(molecule, molecules, button, mIDM, mDiv, level) {
    let s_editName = (0, $dc4240e6100248ae$export$96d8a15ea1620cf4) + " Edit id";
    let editNameButtonID = mIDM.addID(mDiv.id, s_editName, (0, $341c675b659c6d43$export$25280bc3a7ce098e));
    let editNameButton = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(s_editName, editNameButtonID, level);
    mDiv.appendChild(editNameButton);
    editNameButton.addEventListener('click', ()=>{
        let mid = molecule.getID();
        // Update the BathGas select elements.
        (0, $dc4240e6100248ae$export$8f4af86541f72bfe)((0, $5b710835528e7170$export$b33a132661f4be58).tagName, molecule.getID());
        molecules.delete(mid);
        while(true){
            mid = $9eedba3564ea6a49$export$194bfe7da61d65(true, mid, molecule, molecules);
            if (mid != undefined) break;
        }
        // Update the BathGas select elements.
        (0, $dc4240e6100248ae$export$a30e0f90a7434924)((0, $5b710835528e7170$export$b33a132661f4be58).tagName, mid);
        button.textContent = molecule.getLabel() + " " + (0, $341c675b659c6d43$export$e5e81646ee331a9e);
    });
}
/**
 * Process description.
 * @param id The id.
 * @param decription The description.
 * @param getter The getter function to call.
 * @param setter The setter function to call.
 * @param margin The boundary.
 */ function $9eedba3564ea6a49$var$processDescription(id, mIDM, getter, setter, marginComponent, marginDiv) {
    let div = (0, $341c675b659c6d43$export$78253536c0178a32)(undefined, marginDiv);
    let buttonTextContentSelected = (0, $dc4240e6100248ae$export$666359451816b0e7) + (0, $dc4240e6100248ae$export$f0fb6e9d3fd6cf72);
    let buttonTextContentDeselected = (0, $dc4240e6100248ae$export$666359451816b0e7) + (0, $dc4240e6100248ae$export$b758aa9bd161846e);
    let button = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(buttonTextContentDeselected, mIDM.addID(id, (0, $341c675b659c6d43$export$25280bc3a7ce098e)), marginComponent);
    div.appendChild(button);
    button.classList.add((0, $dc4240e6100248ae$export$50cc31b59b02e033));
    button.classList.add((0, $dc4240e6100248ae$export$d52efe23389358db));
    let inputId = mIDM.addID(id, (0, $dc4240e6100248ae$export$666359451816b0e7), (0, $dc4240e6100248ae$export$58785e0018b77d4a));
    let value = getter();
    if (value == undefined) {
        button.textContent = buttonTextContentDeselected;
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
    } else {
        $9eedba3564ea6a49$var$addDescription(div, inputId, value, setter, marginComponent);
        button.textContent = buttonTextContentSelected;
        button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
    }
    // Add event listener for the button.
    button.addEventListener('click', (event)=>{
        if (document.getElementById(inputId) == null) {
            $9eedba3564ea6a49$var$addDescription(div, inputId, value, setter, marginComponent);
            button.textContent = buttonTextContentSelected;
        } else {
            // Remove existing.
            document.getElementById(inputId)?.remove();
            console.log("Removed " + inputId);
            button.textContent = buttonTextContentDeselected;
        }
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
        button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
    });
    return div;
}
/**
 * @param div The div to add the input to.
 * @param id The id.
 * @param value The description value.
 * @param setter The setter function to call.
 * @param margin The margin.
 */ function $9eedba3564ea6a49$var$addDescription(div, id, value, setter, margin) {
    let valueString;
    if (value == undefined) valueString = "";
    else valueString = value;
    let input = (0, $341c675b659c6d43$export$d80fffb1deb3b97e)("text", id, margin);
    input.addEventListener('change', (event)=>{
        let target = event.target;
        setter(target.value);
        console.log(id + " changed from " + value + " to " + target.value);
        (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
    });
    input.value = valueString;
    (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(input);
    div.appendChild(input);
}
/**
 * 
 * Creates and returns a button for adding a new atom. This will add a new atom div to the atomArrayDiv. The atom div added
 * will have: label (atom id); editable details (elementType, x3, y3, z3); and a remove button. Select elements that allow 
 * for selecting atoms are updated so options reflect any added or removed atoms.
 * 
 * @param molecule The molecule.
 * @param aaDiv The atom array div.
 * @param typeID The type incorporated into an id.
 * @param boundary The margin for components.
 * @param level The margin for the div.
 * @returns The add bond button.
 */ function $9eedba3564ea6a49$var$getAddAtomButton(mIDM, molecule, aaDiv, typeID, boundary, level) {
    // Create an add atom button.
    let button = (0, $341c675b659c6d43$export$9b6d6ca62970729f)((0, $dc4240e6100248ae$export$1bb8965d05fbf467), mIDM.addID(aaDiv.id, "Add" + typeID + "Button"), level);
    button.addEventListener('click', ()=>{
        let attributes = new Map();
        let a = new (0, $597d59a3d37b5b3f$export$80986e6afdd7e0cb)(attributes, molecule);
        //let aID: string = molecule.getAtoms().addAtom(a);
        aaDiv.insertBefore($9eedba3564ea6a49$var$addAtom(true, mIDM, molecule, aaDiv.id, molecule.getAtoms(), a, boundary, level), button);
    });
    return button;
}
/**
 * Adds metadata.
 * @param m The molecule.
 * @param md The metadata.
 * @param ml The metadata list.
 * @param mdDivID The metadata div id.
 * @param boundary The margin for components.
 * @param level The margin for the div.
 * @returns The metadata div.
 */ function $9eedba3564ea6a49$var$addMetadata(m, md, ml, mdDivID, boundary, level) {
    ml.addMetadata(md);
    let mdDiv = (0, $341c675b659c6d43$export$78253536c0178a32)(mdDivID, level);
    mdDiv.appendChild((0, $341c675b659c6d43$export$f2839682b8c07f35)(m.getLabel(), boundary));
    return mdDiv;
}
/**
 * Adds an atom.
 * 
 * @param molecule The molecule.
 * @param a The atom to add.
 * @param boundary The margin for components.
 * @param level The margin for the div.
 * @returns A new div for the atom.
 */ function $9eedba3564ea6a49$var$addAtom(addToArray, mIDM, molecule, aaDivID, aa, a, boundary, level) {
    let aID;
    if (addToArray) aID = aa.addAtom(a, a.getID());
    else aID = a.getID();
    //let aDivID: string = mIDM.addID(aaDivID, aID);
    let aDivID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(aaDivID, aID);
    let aDiv = (0, $341c675b659c6d43$export$78253536c0178a32)(aDivID, level);
    aDiv.appendChild((0, $341c675b659c6d43$export$f2839682b8c07f35)(aID, boundary));
    // elementType.
    $9eedba3564ea6a49$var$processElementType(mIDM, a, aDiv, true, boundary);
    // Coordinates.
    $9eedba3564ea6a49$var$processCoordinates(mIDM, a, aDiv, boundary, boundary);
    (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(aDiv, boundary, $9eedba3564ea6a49$var$removeAtom, molecule, aID, mIDM);
    // Get elements with Bond.s_atomRefs2 className. These select elements are to be updated to include the new atom option.
    (0, $dc4240e6100248ae$export$a30e0f90a7434924)((0, $597d59a3d37b5b3f$export$153327fc99ac0c53).s_atomRefs2, aID);
    return aDiv;
}
/**
 * Remove an atom from the AtomArray.
 * @param molecule The molecule.
 * @param aID The atom id to remove.
 */ function $9eedba3564ea6a49$var$removeAtom(molecule, aID, aIDs) {
    molecule.getAtoms().removeAtom(aID);
    aIDs.forEach((x)=>{
        console.log("Removing " + x);
        (0, $dc4240e6100248ae$export$cd7f480d6b8286c3)(x);
    });
    (0, $dc4240e6100248ae$export$8f4af86541f72bfe)((0, $597d59a3d37b5b3f$export$153327fc99ac0c53).s_atomRefs2, aID);
    molecule.getBonds().bonds.forEach((bond)=>{
        let atomRefs2 = bond.getAtomRefs2();
        let atomRefs = atomRefs2.split(" ");
        if (atomRefs[0] == atomRefs[1]) {
            let bondId = bond.getID();
            //console.log("Removing bond " + bondId + " as it references atom " + id);
            molecule.getBonds().removeBond(bondId);
            (0, $dc4240e6100248ae$export$8f4af86541f72bfe)((0, $597d59a3d37b5b3f$export$153327fc99ac0c53).tagName, bondId);
            // remove the bondDiv element.
            let bID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)((0, $597d59a3d37b5b3f$export$3da9759ad07746a3).tagName, molecule.id, (0, $597d59a3d37b5b3f$export$746fba2e30d93fe6).tagName, bondId);
            let bondDiv = document.getElementById(bID);
            if (bondDiv == null) throw new Error("Bond div with id " + bID + " not found.");
            else bondDiv.remove();
        }
    });
}
/**
 * For processing the elementType of an Atom.
 * @param a The atom.
 * @param aDiv The atom div which is appended to.
 * @param first If true, an option is added with instructions for the selection.
 * @param margin The margin for the components.
 * @returns A HTMLDivElement containing the HTMLLabelElement and HTMLSelectElement elements.
 */ function $9eedba3564ea6a49$var$processElementType(mIDM, a, aDiv, first, margin) {
    let elementType = a.getElementType();
    //console.log("Atom.s_elementType " + elementType);
    let selectTypes = (0, $ccef02370f58a770$export$692079bb871c6039).elementTypes;
    // Select.
    if (elementType == undefined) {
        elementType = (0, $dc4240e6100248ae$export$d8b8827abc8ab7e7);
        (0, $dc4240e6100248ae$export$10de1fc8385eec4a)(selectTypes, first);
    //console.log("Atom.s_elementTypes " + arrayToString(Atom.elementTypes));
    }
    //let id = mIDM.addID(aDiv.id, Atom.s_elementType);
    let id = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(aDiv.id, (0, $597d59a3d37b5b3f$export$80986e6afdd7e0cb).s_elementType);
    let lws = (0, $341c675b659c6d43$export$4c3eba01cd3c5ba4)((0, $597d59a3d37b5b3f$export$80986e6afdd7e0cb).s_elementType, selectTypes, (0, $597d59a3d37b5b3f$export$80986e6afdd7e0cb).s_elementType, elementType, id, margin, margin);
    let select = lws.querySelector('select');
    select.addEventListener('change', (event)=>{
        let target = event.target;
        a.setElementType(target.value);
        (0, $341c675b659c6d43$export$fdd146df37959fe8)(target);
    });
    select.value = elementType;
    (0, $341c675b659c6d43$export$fdd146df37959fe8)(select);
    (0, $dc4240e6100248ae$export$3b08dcba56872ec6)(selectTypes, select);
    aDiv.appendChild(lws);
    return lws;
}
/**
 * Process atom coordinates.
 * @param a The atom.
 * @param aDiv The atom div.
 * @param aIDs The atom ids.
 * @param marginComponent The margin for the components.
 * @param margin The margin.
 */ function $9eedba3564ea6a49$var$processCoordinates(mIDM, a, aDiv, marginComponent, margin) {
    let id;
    //id = mIDM.addID(aDiv.id, Atom.s_x3);
    id = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(aDiv.id, (0, $597d59a3d37b5b3f$export$80986e6afdd7e0cb).s_x3);
    aDiv.appendChild((0, $dc4240e6100248ae$export$17d48ee8ddbf2d44)(id, mIDM, (0, $597d59a3d37b5b3f$export$80986e6afdd7e0cb).s_x3, a.getX3.bind(a), a.setX3.bind(a), a.removeX3, marginComponent, margin));
    //id = mIDM.addID(aDiv.id, Atom.s_y3);
    id = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(aDiv.id, (0, $597d59a3d37b5b3f$export$80986e6afdd7e0cb).s_y3);
    aDiv.appendChild((0, $dc4240e6100248ae$export$17d48ee8ddbf2d44)(id, mIDM, (0, $597d59a3d37b5b3f$export$80986e6afdd7e0cb).s_y3, a.getY3.bind(a), a.setY3.bind(a), a.removeY3, marginComponent, margin));
    //id = mIDM.addID(aDiv.id, Atom.s_z3);
    id = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(aDiv.id, (0, $597d59a3d37b5b3f$export$80986e6afdd7e0cb).s_z3);
    aDiv.appendChild((0, $dc4240e6100248ae$export$17d48ee8ddbf2d44)(id, mIDM, (0, $597d59a3d37b5b3f$export$80986e6afdd7e0cb).s_z3, a.getZ3.bind(a), a.setZ3.bind(a), a.removeZ3, marginComponent, margin));
}
/**
 * Creates and returns a button for adding a new bond. This will add a new bond div to the bondArrayDiv. The bond div added
 * will have: label (bond id); editable details (atomRefs2 and order); and a remove button. Select elements that allow for 
 * selecting bonds are updated so options reflect any added or removed bonds.
 * 
 * @param molecule The molecule.
 * @param baDiv The bond array div.
 * @param typeID The type incorporated into an id.
 * @param boundary The margin for components.
 * @param level The margin for the div.
 * @returns The add bond button.
 */ function $9eedba3564ea6a49$var$getAddBondButton(mIDM, molecule, baDiv, typeID, boundary, level) {
    // Create an add button.
    let id = mIDM.addID(baDiv.id, typeID, (0, $341c675b659c6d43$export$25280bc3a7ce098e));
    let button = (0, $341c675b659c6d43$export$9b6d6ca62970729f)((0, $dc4240e6100248ae$export$1bb8965d05fbf467), id, level);
    button.addEventListener('click', ()=>{
        let atoms = molecule.getAtoms().atoms;
        if (atoms.size < 2) {
            alert("There must be at least 2 atoms to create a bond.");
            return;
        }
        let attributes = new Map();
        let atomRefs2 = Array.from(atoms.keys()).slice(0, 2).join(" ");
        attributes.set((0, $597d59a3d37b5b3f$export$153327fc99ac0c53).s_atomRefs2, atomRefs2);
        let b = new (0, $597d59a3d37b5b3f$export$153327fc99ac0c53)(attributes, molecule);
        baDiv.insertBefore($9eedba3564ea6a49$var$addBond(true, mIDM, molecule, baDiv.id, atoms, molecule.getBonds(), b, boundary, level), button);
    });
    baDiv.appendChild(button);
    return button;
}
/**
 * Add a bond.
 * @param molecule The molecule.
 * @param atoms The atoms.
 * @param b The bond.
 * @param boundary The margin for components.
 * @param level The margin for the div.
 * @returns The a new div for the bond.
 */ function $9eedba3564ea6a49$var$addBond(addToArray, mIDM, molecule, baDivID, atoms, ba, b, boundary, level) {
    let bID;
    if (addToArray) bID = ba.addBond(b, b.getID());
    else bID = b.getID();
    let bDivID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(baDivID, bID);
    let bDiv = (0, $341c675b659c6d43$export$78253536c0178a32)(bDivID, level);
    bDiv.appendChild((0, $341c675b659c6d43$export$f2839682b8c07f35)(bID, boundary));
    // atomRefs2.
    $9eedba3564ea6a49$var$processAtomRefs2(mIDM, molecule, bDiv, b, boundary);
    // order.
    $9eedba3564ea6a49$var$processOrder(mIDM, bDiv, b, boundary);
    // Add to the classlists so that bondDivs involving particular atoms can be found.
    Array.from(atoms.keys()).forEach((atomId)=>{
        bDiv.classList.add(atomId);
    });
    // Add remove button.
    let removeBond = (id)=>molecule.getBonds().removeBond(id);
    (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(bDiv, boundary, removeBond, bID);
    // Get elements with Bond className. These select elements are to be updated to include the new bond option.
    (0, $dc4240e6100248ae$export$a30e0f90a7434924)((0, $597d59a3d37b5b3f$export$153327fc99ac0c53).tagName, bID);
    return bDiv;
}
/**
 * For processing the atomRefs2 of a Bond.
 * 
 * @param molecule The molecule.
 * @param bDiv The bond div.
 * @param bond The bond.
 * @param inputId The input id.
 * @param margin The margin for the components.
 */ function $9eedba3564ea6a49$var$processAtomRefs2(mIDM, molecule, bDiv, bond, margin) {
    //let id = mIDM.addID(bDiv.id, Bond.s_atomRefs2);
    let id = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(bDiv.id, (0, $597d59a3d37b5b3f$export$153327fc99ac0c53).s_atomRefs2);
    //bIDs.add(id);
    let atomRefs2 = bond.getAtomRefs2();
    let atomRefs = atomRefs2.split(" ");
    let atomRefOptions = Array.from(molecule.getAtoms().atoms.keys());
    // alws.
    //let alwsID: string = mIDM.addID(id, 0);
    let alwsID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(id, 0);
    //bIDs.add(alwsID);
    let alws = (0, $341c675b659c6d43$export$4c3eba01cd3c5ba4)((0, $597d59a3d37b5b3f$export$153327fc99ac0c53).s_atomRefs2 + "[0]", atomRefOptions, (0, $597d59a3d37b5b3f$export$80986e6afdd7e0cb).tagName, atomRefs[0], alwsID, margin, margin);
    let aselect = alws.querySelector('select');
    aselect.classList.add((0, $597d59a3d37b5b3f$export$153327fc99ac0c53).s_atomRefs2);
    aselect.addEventListener('change', (event)=>{
        let target = event.target;
        let atomRefs2 = target.value + " " + atomRefs[1];
        console.log((0, $597d59a3d37b5b3f$export$153327fc99ac0c53).s_atomRefs2 + " changed to " + atomRefs2);
        bond.setAtomRefs2(atomRefs2);
        (0, $341c675b659c6d43$export$fdd146df37959fe8)(target);
    });
    aselect.value = atomRefs[0];
    (0, $341c675b659c6d43$export$fdd146df37959fe8)(aselect);
    bDiv.appendChild(alws);
    // blws.
    //let blwsID: string = mIDM.addID(id, 1);
    let blwsID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(id, 1);
    //bIDs.add(blwsID);
    let blws = (0, $341c675b659c6d43$export$4c3eba01cd3c5ba4)((0, $597d59a3d37b5b3f$export$153327fc99ac0c53).s_atomRefs2 + "[1]", atomRefOptions, (0, $597d59a3d37b5b3f$export$80986e6afdd7e0cb).tagName, atomRefs[1], blwsID, margin, margin);
    let bselect = blws.querySelector('select');
    bselect.classList.add((0, $597d59a3d37b5b3f$export$153327fc99ac0c53).s_atomRefs2);
    bselect.addEventListener('change', (event)=>{
        let target = event.target;
        let atomRefs2 = atomRefs[0] + " " + target.value;
        console.log((0, $597d59a3d37b5b3f$export$153327fc99ac0c53).s_atomRefs2 + " changed to " + atomRefs2);
        bond.setAtomRefs2(atomRefs2);
        (0, $341c675b659c6d43$export$fdd146df37959fe8)(target);
    });
    bselect.value = atomRefs[1];
    (0, $341c675b659c6d43$export$fdd146df37959fe8)(bselect);
    bDiv.appendChild(blws);
}
/**
 * Process an order.
 * @param bondDiv The bond div.
 * @param bond The bond.
 * @param margin The margin for components.
 */ function $9eedba3564ea6a49$var$processOrder(mIDM, bondDiv, bond, margin) {
    //let id = mIDM.addID(bondDiv.id, Bond.s_order);
    let id = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(bondDiv.id, (0, $597d59a3d37b5b3f$export$153327fc99ac0c53).s_order);
    let div = (0, $341c675b659c6d43$export$78253536c0178a32)(undefined, margin);
    bondDiv.appendChild(div);
    let buttonTextContentSelected = (0, $597d59a3d37b5b3f$export$153327fc99ac0c53).s_order + (0, $dc4240e6100248ae$export$f0fb6e9d3fd6cf72);
    let buttonTextContentDeselected = (0, $597d59a3d37b5b3f$export$153327fc99ac0c53).s_order + (0, $dc4240e6100248ae$export$b758aa9bd161846e);
    let button = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(buttonTextContentDeselected, undefined, margin);
    div.appendChild(button);
    button.classList.add((0, $dc4240e6100248ae$export$50cc31b59b02e033));
    button.classList.add((0, $dc4240e6100248ae$export$d52efe23389358db));
    let value = bond.getOrder();
    if (value == undefined) {
        button.textContent = buttonTextContentDeselected;
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
    } else {
        $9eedba3564ea6a49$var$addOrder(div, bond, id, value, margin);
        button.textContent = buttonTextContentSelected;
        button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
    }
    // Add event listener for the button.
    button.addEventListener('click', (event)=>{
        if (document.getElementById(id) == null) {
            if (value == undefined) value = 1;
            $9eedba3564ea6a49$var$addOrder(div, bond, id, value, margin);
            button.textContent = buttonTextContentSelected;
        } else {
            // Remove any existing div.
            document.getElementById(id)?.remove();
            console.log("Removed " + id);
            button.textContent = buttonTextContentDeselected;
        }
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
        button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
    });
}
/**
 * @param div The div to add the input to.
 * @param bond The bond.
 * @param id The id.
 * @param value The order value.
 * @param boundary The boundary.
 */ function $9eedba3564ea6a49$var$addOrder(div, bond, id, value, boundary) {
    let valueString = value.toString();
    let select = (0, $341c675b659c6d43$export$b89bf4b169286865)((0, $597d59a3d37b5b3f$export$153327fc99ac0c53).orderOptions, (0, $597d59a3d37b5b3f$export$153327fc99ac0c53).s_order, valueString, id, boundary);
    select.addEventListener('change', (event)=>{
        let target = event.target;
        bond.setOrder(parseFloat(target.value));
        console.log((0, $597d59a3d37b5b3f$export$153327fc99ac0c53).s_order + " changed from " + valueString + " to " + target.value);
        (0, $341c675b659c6d43$export$fdd146df37959fe8)(target);
    });
    select.value = valueString;
    (0, $341c675b659c6d43$export$fdd146df37959fe8)(select);
    select.id = id;
    div.appendChild(select);
}
/**
 * Process an order.
 * @param hrpDiv The HinderedRotorPotential div.
 * @param margin The margin for components.
 */ function $9eedba3564ea6a49$var$processUseSineTerms(mIDM, hrpDiv, hrp, margin) {
    let id = mIDM.addID(hrpDiv.id, (0, $597d59a3d37b5b3f$export$9b8e857b9a081d2).s_useSineTerms);
    let buttonTextContentSelected = (0, $597d59a3d37b5b3f$export$9b8e857b9a081d2).s_useSineTerms + (0, $dc4240e6100248ae$export$f0fb6e9d3fd6cf72);
    let buttonTextContentDeselected = (0, $597d59a3d37b5b3f$export$9b8e857b9a081d2).s_useSineTerms + (0, $dc4240e6100248ae$export$b758aa9bd161846e);
    let button = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(buttonTextContentDeselected, undefined, margin);
    hrpDiv.appendChild(button);
    button.classList.add((0, $dc4240e6100248ae$export$50cc31b59b02e033));
    button.classList.add((0, $dc4240e6100248ae$export$d52efe23389358db));
    if (hrp.getUseSineTerms() == true) {
        button.textContent = buttonTextContentSelected;
        button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
    } else {
        button.textContent = buttonTextContentDeselected;
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
    }
    // Add event listener for the button.
    button.addEventListener('click', (event)=>{
        if (hrp.getUseSineTerms() == false) {
            hrp.setUseSineTerms(true);
            button.textContent = buttonTextContentSelected;
        } else {
            hrp.setUseSineTerms(false);
            button.textContent = buttonTextContentDeselected;
        }
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
        button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
    });
}
function $9eedba3564ea6a49$export$ce852d72abd87240(xml, mIDM, molecules) {
    // Create div to contain the molecules list.
    let mlDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(undefined, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    // Get the XML "moleculeList" element.
    let xml_ml = (0, $057fa7562ec736a9$export$b7531b8ff18dc588)(xml, (0, $ccef02370f58a770$export$19d70f3647dee606).tagName);
    // Check the XML "moleculeList" element has one or more "molecule" elements and no other elements.
    let mlTagNames = new Set();
    xml_ml.childNodes.forEach(function(node) {
        mlTagNames.add(node.nodeName);
    });
    if (mlTagNames.size != 1) {
        if (!(mlTagNames.size == 2 && mlTagNames.has("#text"))) {
            console.error("moleculeListTagNames:");
            mlTagNames.forEach((x)=>console.error(x));
            console.warn("Additional tag names in moleculeList:");
        }
    }
    if (!mlTagNames.has((0, $597d59a3d37b5b3f$export$3da9759ad07746a3).tagName)) {
        console.warn("Expecting tags with \"" + (0, $597d59a3d37b5b3f$export$3da9759ad07746a3).tagName + "\" tagName but there are none! Please add molecules to the moleculeList.");
        // Add add molecule button.
        let amb = mlDiv.appendChild($9eedba3564ea6a49$export$12aafb9570dfb660(mlDiv, mIDM, molecules));
        // Add add from library button.
        mlDiv.appendChild($9eedba3564ea6a49$export$1f1b9bc888fe9f4c(mlDiv, amb, mIDM, molecules));
        return mlDiv;
    }
    // Process the XML "molecule" elements.
    let xml_ms = xml_ml.getElementsByTagName((0, $597d59a3d37b5b3f$export$3da9759ad07746a3).tagName);
    let xml_msl = xml_ms.length;
    console.log("Number of molecules=" + xml_msl);
    //xml_molecules.forEach(function (xml_molecule) { // Cannot iterate over HTMLCollectionOf<Element> like this.
    for(let i = 0; i < xml_msl; i++){
        // Create a new Molecule.
        let mDivID = mIDM.addID((0, $597d59a3d37b5b3f$export$3da9759ad07746a3).tagName, i);
        let mDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(mDivID);
        let attributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_ms[i]);
        let m = new (0, $597d59a3d37b5b3f$export$3da9759ad07746a3)(attributes, attributes.get((0, $597d59a3d37b5b3f$export$3da9759ad07746a3).s_id));
        (0, $dc4240e6100248ae$export$ac55d333e780178c)(false, m, molecules);
        // Create collapsible Molecule HTMLDivElement.
        let mcDivID = mIDM.addID(mDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
        let mcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(mcDivID, mlDiv, null, mDiv, m.getLabel(), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        // Create a set of molecule tag names.
        let moleculeTagNames = new Set();
        let cns = xml_ms[i].childNodes;
        //console.log("cns.length=" + cns.length);
        //cns.forEach(function (cn) {
        for(let j = 0; j < cns.length; j++){
            let cn = cns[j];
            // Check for nodeName repeats that are not #text.
            if (!moleculeTagNames.has(cn.nodeName)) moleculeTagNames.add(cn.nodeName);
            else // nodeName = #text are comments or white space/newlines in the XML which are ignored.
            if (cn.nodeName != "#text") console.warn("Another ChildNode with nodeName=" + cn.nodeName);
        //console.log(cn.nodeName);
        }
        // Add edit Name button.
        $9eedba3564ea6a49$var$addEditIDButton(m, molecules, mcDiv.querySelector((0, $341c675b659c6d43$export$25280bc3a7ce098e)), mIDM, mDiv, (0, $dc4240e6100248ae$export$39c84188a71202f7));
        // Description
        mDiv.appendChild($9eedba3564ea6a49$var$processDescription(mIDM.addID(mDivID, (0, $dc4240e6100248ae$export$666359451816b0e7)), mIDM, m.getDescription.bind(m), m.setDescription.bind(m), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7)));
        // Init metadataList.
        //console.log("Init metadataList.");
        let xml_mls = xml_ms[i].getElementsByTagName((0, $cb35636d41d8f309$export$3e18a603070a78a).tagName);
        if (xml_mls.length > 0) {
            if (xml_mls.length > 1) console.warn("Expecting 1 or 0 " + (0, $cb35636d41d8f309$export$3e18a603070a78a).tagName + " but finding " + xml_mls.length + ". Loading the first of these...");
            // Create collapsible MetadataList HTMLDivElement.
            let mdlDivID = mIDM.addID(mDivID, (0, $cb35636d41d8f309$export$3e18a603070a78a).tagName);
            let mdlDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(mdlDivID);
            let mdlcDivID = mIDM.addID(mdlDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
            let mdlcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(mdlcDivID, mDiv, null, mdlDiv, (0, $cb35636d41d8f309$export$3e18a603070a78a).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            let xml_ml = xml_mls[0];
            let xml_ms = xml_ml.getElementsByTagName((0, $cb35636d41d8f309$export$e7adebdc1ebd2fed).tagName);
            let ml = new (0, $cb35636d41d8f309$export$3e18a603070a78a)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_mls[0]));
            m.setMetadataList(ml);
            for(let j = 0; j < xml_ms.length; j++){
                // Create a new Metadata.
                let md = new (0, $cb35636d41d8f309$export$e7adebdc1ebd2fed)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_ms[j]));
                mdlDiv.appendChild($9eedba3564ea6a49$var$addMetadata(m, md, ml, mIDM.addID(mdlDivID, j), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7)));
            }
            moleculeTagNames.delete((0, $cb35636d41d8f309$export$3e18a603070a78a).tagName);
        }
        // Init atoms.
        let xml_aas = xml_ms[i].getElementsByTagName((0, $597d59a3d37b5b3f$export$9cea715eceba39a0).tagName);
        // Create collapsible AtomArray HTMLDivElement.
        let aaDivID = mIDM.addID(mDivID, (0, $597d59a3d37b5b3f$export$9cea715eceba39a0).tagName);
        let aaDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(aaDivID);
        let aacDivID = mIDM.addID(aaDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
        let aacDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(aacDivID, mDiv, null, aaDiv, (0, $597d59a3d37b5b3f$export$9cea715eceba39a0).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        // There should be at least one atom!
        // Atoms may be in AtomArrays or not.
        // If any AtomArray elements have attributes, there will be a console warning.
        // There will be a single AtomArray containing any Atoms.
        let aa = new (0, $597d59a3d37b5b3f$export$9cea715eceba39a0)(new Map());
        m.setAtoms(aa);
        for(let j = 0; j < xml_aas.length; j++){
            let aaa = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_aas[j]);
            if (aaa.size > 0) console.warn("AtomArray attributes lost/ignored: " + (0, $93b71ab6968650c1$export$dc22ec7f8e0b9ac)(aaa));
        }
        let xml_as = xml_ms[i].getElementsByTagName((0, $597d59a3d37b5b3f$export$80986e6afdd7e0cb).tagName);
        for(let j = 0; j < xml_as.length; j++)aaDiv.appendChild($9eedba3564ea6a49$var$addAtom(true, mIDM, m, aaDivID, aa, new (0, $597d59a3d37b5b3f$export$80986e6afdd7e0cb)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_as[j]), m), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7)));
        aaDiv.appendChild($9eedba3564ea6a49$var$getAddAtomButton(mIDM, m, aaDiv, (0, $597d59a3d37b5b3f$export$80986e6afdd7e0cb).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7)));
        moleculeTagNames.delete((0, $597d59a3d37b5b3f$export$80986e6afdd7e0cb).tagName);
        // Init bonds.
        let xml_bas = xml_ms[i].getElementsByTagName((0, $597d59a3d37b5b3f$export$746fba2e30d93fe6).tagName);
        // Create collapsible BondArray HTMLDivElement.
        let baDivID = mIDM.addID(mDivID, (0, $597d59a3d37b5b3f$export$746fba2e30d93fe6).tagName);
        let baDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(baDivID);
        let bacDivID = mIDM.addID(baDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
        let bacDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(bacDivID, mDiv, null, baDiv, (0, $597d59a3d37b5b3f$export$746fba2e30d93fe6).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        // Bonds may be in BondArrays or not.
        // If any BondArray elements have attributes, there will be a console warning.
        // There will be a single BondArray containing any Bonds.
        let ba = new (0, $597d59a3d37b5b3f$export$746fba2e30d93fe6)(new Map());
        m.setBonds(ba);
        for(let j = 0; j < xml_bas.length; j++){
            let baa = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_bas[j]);
            if (baa.size > 0) console.warn("BondArray attributes lost/ignored: " + (0, $93b71ab6968650c1$export$dc22ec7f8e0b9ac)(baa));
        }
        let xml_bs = xml_ms[i].getElementsByTagName((0, $597d59a3d37b5b3f$export$153327fc99ac0c53).tagName);
        for(let j = 0; j < xml_bs.length; j++){
            // Load those bonds that have an id attribute first.
            let b_attributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_bs[j]);
            if (b_attributes.has((0, $597d59a3d37b5b3f$export$153327fc99ac0c53).s_id)) baDiv.appendChild($9eedba3564ea6a49$var$addBond(true, mIDM, m, baDivID, m.getAtoms().atoms, ba, new (0, $597d59a3d37b5b3f$export$153327fc99ac0c53)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_bs[j]), m), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7)));
        }
        // Load those bonds that do not have an id attribute.
        for(let j = 0; j < xml_bs.length; j++){
            let b_attributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_bs[j]);
            if (!b_attributes.has((0, $597d59a3d37b5b3f$export$153327fc99ac0c53).s_id)) baDiv.appendChild($9eedba3564ea6a49$var$addBond(true, mIDM, m, baDivID, m.getAtoms().atoms, ba, new (0, $597d59a3d37b5b3f$export$153327fc99ac0c53)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_bs[j]), m), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7)));
        }
        baDiv.appendChild($9eedba3564ea6a49$var$getAddBondButton(mIDM, m, baDiv, (0, $597d59a3d37b5b3f$export$153327fc99ac0c53).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7)));
        moleculeTagNames.delete((0, $597d59a3d37b5b3f$export$153327fc99ac0c53).tagName);
        // Add a viewer for the molecule.
        // Create collapsible viewer HTMLDivElement.
        let viewerDivID = mIDM.addID(mDivID, (0, $dc4240e6100248ae$export$a59b122474df8e10));
        let viewerDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(viewerDivID);
        let viewercDivID = mIDM.addID(viewerDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
        let viewercDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(viewercDivID, mDiv, null, viewerDiv, (0, $dc4240e6100248ae$export$a59b122474df8e10), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        $9eedba3564ea6a49$export$7aad7e61c4f49964(mIDM, m, viewerDiv, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        // Init properties.
        let xml_pls = xml_ms[i].getElementsByTagName((0, $597d59a3d37b5b3f$export$4e0d1ad7ad6a0802).tagName);
        // Create a new collapsible div for the PropertyList.
        let plDivID = mIDM.addID(mDivID, (0, $597d59a3d37b5b3f$export$4e0d1ad7ad6a0802).tagName);
        let plDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(plDivID);
        let plcDivID = mIDM.addID(plDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
        let plcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(plcDivID, mDiv, null, plDiv, (0, $597d59a3d37b5b3f$export$4e0d1ad7ad6a0802).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        // Properties may be in a PropertyList or not.
        if (xml_pls.length > 1) console.warn("Expecting 1 or 0 " + (0, $597d59a3d37b5b3f$export$4e0d1ad7ad6a0802).tagName + " but finding " + xml_pls.length + ". Loading the first of these...");
        let dictRefs = new Set();
        let dictRefMap = new Map();
        let pl;
        let xml_ps;
        if (xml_pls.length > 0) {
            pl = new (0, $597d59a3d37b5b3f$export$4e0d1ad7ad6a0802)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_pls[0]));
            xml_ps = xml_pls[0].getElementsByTagName((0, $597d59a3d37b5b3f$export$41b04b3a73e7216d).tagName);
            // Init dictRefs
            for(let j = 0; j < xml_ps.length; j++){
                let p = new (0, $597d59a3d37b5b3f$export$41b04b3a73e7216d)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_ps[j]));
                dictRefs.add(p.dictRef);
                dictRefMap.set(p.dictRef, j);
            }
        } else pl = new (0, $597d59a3d37b5b3f$export$4e0d1ad7ad6a0802)(new Map());
        m.setPropertyList(pl);
        moleculeTagNames.delete((0, $597d59a3d37b5b3f$export$4e0d1ad7ad6a0802).tagName);
        let pID;
        let deselect = false;
        // "me:ZPE", scalar, Mesmer.energyUnits.
        if (!dictRefs.has((0, $597d59a3d37b5b3f$export$95174cf0748f45cd).dictRef)) $9eedba3564ea6a49$var$addPropertyScalar(deselect, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$95174cf0748f45cd).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).energyUnits);
        else {
            pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$95174cf0748f45cd).dictRef);
            let j = dictRefMap.get((0, $597d59a3d37b5b3f$export$95174cf0748f45cd).dictRef);
            let p = $9eedba3564ea6a49$export$60ca070fb6dca2f6(pl, xml_ps[j], plDiv, m, mIDM, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        // Get button from div and click
        //let button: HTMLButtonElement = plDiv.querySelector(s_button) as HTMLButtonElement;
        //button.click();
        /*
            let p: Property = pl.getProperty(ZPE.dictRef) as Property;
            let ps: PropertyScalarNumber = p.getProperty() as PropertyScalarNumber;
            let div: HTMLDivElement = processNumber(pID, mIDM, p.dictRef, ps.getValue.bind(ps),
                (value: Big) => setPropertyScalarNumber(p.dictRef, pl, ps, value),
                () => pl.removeProperty(p.dictRef), boundary1, level1);
            addAnyUnits(Mesmer.energyUnits, ps.attributes, div, div.querySelector(s_input) as HTMLElement,
                getID(pID, PropertyScalarNumber.s_units), p.dictRef, boundary1, boundary1);
            plDiv.appendChild(div);
            */ }
        // "me:Hf0", scalar, Mesmer.energyUnits.
        if (!dictRefs.has((0, $597d59a3d37b5b3f$export$90bccbae54bb6d4f).dictRef)) {
            let div = $9eedba3564ea6a49$var$addPropertyScalar(true, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$90bccbae54bb6d4f).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).energyUnits);
        // Click the button.
        //let b: HTMLButtonElement = div.querySelector(s_button)!;
        //b!.click();
        //pl.removeProperty(SpinMultiplicity.dictRef);
        } else {
            pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$90bccbae54bb6d4f).dictRef);
            let j = dictRefMap.get((0, $597d59a3d37b5b3f$export$90bccbae54bb6d4f).dictRef);
            let p = $9eedba3564ea6a49$export$60ca070fb6dca2f6(pl, xml_ps[j], plDiv, m, mIDM, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        /*
            let p: Property = pl.getProperty(Hf0.dictRef) as Property;
            let ps: PropertyScalarNumber = p.getProperty() as PropertyScalarNumber;
            let div: HTMLDivElement = processNumber(pID, mIDM, p.dictRef, ps.getValue.bind(ps),
                (value: Big) => setPropertyScalarNumber(p.dictRef, pl, ps, value),
                () => pl.removeProperty(p.dictRef), boundary1, level1);
            addAnyUnits(Mesmer.energyUnits, ps.attributes, div, div.querySelector(s_input) as HTMLElement,
                getID(pID, PropertyScalarNumber.s_units), p.dictRef, boundary1, boundary1);
            plDiv.appendChild(div);
            */ }
        // "me:HfAT0", scalar, Mesmer.energyUnits.
        if (!dictRefs.has((0, $597d59a3d37b5b3f$export$a4fe62a56eafa45d).dictRef)) $9eedba3564ea6a49$var$addPropertyScalar(deselect, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$a4fe62a56eafa45d).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).energyUnits);
        else {
            pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$a4fe62a56eafa45d).dictRef);
            let j = dictRefMap.get((0, $597d59a3d37b5b3f$export$a4fe62a56eafa45d).dictRef);
            let p = $9eedba3564ea6a49$export$60ca070fb6dca2f6(pl, xml_ps[j], plDiv, m, mIDM, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        /*
            let ps: PropertyScalarNumber = p.getProperty() as PropertyScalarNumber;
            let div: HTMLDivElement = processNumber(pID, mIDM, p.dictRef, ps.getValue.bind(ps),
                (value: Big) => setPropertyScalarNumber(p.dictRef, pl, ps, value),
                () => pl.removeProperty(p.dictRef), boundary1, level1);
            addAnyUnits(Mesmer.energyUnits, ps.attributes, div, div.querySelector(s_input) as HTMLElement,
                getID(pID, PropertyScalarNumber.s_units), p.dictRef, boundary1, boundary1);
            plDiv.appendChild(div);
            */ }
        // "me:Hf298", scalar, Mesmer.energyUnits.
        if (!dictRefs.has((0, $597d59a3d37b5b3f$export$e7df60530792b964).dictRef)) $9eedba3564ea6a49$var$addPropertyScalar(deselect, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$e7df60530792b964).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).energyUnits);
        else {
            pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$e7df60530792b964).dictRef);
            let j = dictRefMap.get((0, $597d59a3d37b5b3f$export$e7df60530792b964).dictRef);
            let p = $9eedba3564ea6a49$export$60ca070fb6dca2f6(pl, xml_ps[j], plDiv, m, mIDM, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        /*
            let ps: PropertyScalarNumber = p.getProperty() as PropertyScalarNumber;
            let div: HTMLDivElement = processNumber(pID, mIDM, p.dictRef, ps.getValue.bind(ps),
                (value: Big) => setPropertyScalarNumber(p.dictRef, pl, ps, value),
                () => pl.removeProperty(p.dictRef), boundary1, level1);
            addAnyUnits(Mesmer.energyUnits, ps.attributes, div, div.querySelector(s_input) as HTMLElement,
                getID(pID, PropertyScalarNumber.s_units), p.dictRef, boundary1, boundary1);
            plDiv.appendChild(div);
            */ }
        // "me:rotConsts", array, Mesmer.frequencyUnits.
        if (!dictRefs.has((0, $597d59a3d37b5b3f$export$984abe26ded13ee0).dictRef)) $9eedba3564ea6a49$var$addPropertyArray(deselect, false, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$984abe26ded13ee0).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).frequencyUnits);
        else {
            pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$984abe26ded13ee0).dictRef);
            let j = dictRefMap.get((0, $597d59a3d37b5b3f$export$984abe26ded13ee0).dictRef);
            let p = $9eedba3564ea6a49$export$60ca070fb6dca2f6(pl, xml_ps[j], plDiv, m, mIDM, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        /*
            let pa: PropertyArray = p.getProperty() as PropertyArray;
            let div: HTMLDivElement = processNumberArrayOrMatrix(plDiv.id, mIDM, p.dictRef, pa, pa.getValues.bind(pa),
                (values: Big[]) => setPropertyArrayOrMatrix(p.dictRef, pl, pa, values),
                () => pl.removeProperty(p.dictRef), boundary1, level1);
            addAnyUnits(Mesmer.frequencyUnits, pa.attributes, div, div.querySelector(s_input) as HTMLElement,
                getID(pID, PropertyScalarNumber.s_units), p.dictRef, boundary1, boundary1);
            plDiv.appendChild(div);
            */ }
        // "me:symmetryNumber", scalar, No units.
        if (!dictRefs.has((0, $597d59a3d37b5b3f$export$d1d1720eff14586a).dictRef)) $9eedba3564ea6a49$var$addPropertyScalar(deselect, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$d1d1720eff14586a).dictRef, undefined);
        else {
            pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$d1d1720eff14586a).dictRef);
            let j = dictRefMap.get((0, $597d59a3d37b5b3f$export$d1d1720eff14586a).dictRef);
            let p = $9eedba3564ea6a49$export$60ca070fb6dca2f6(pl, xml_ps[j], plDiv, m, mIDM, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        /*
            let ps: PropertyScalarNumber = p.getProperty() as PropertyScalarNumber;
            let div: HTMLDivElement = processNumber(pID, mIDM, p.dictRef, ps.getValue.bind(ps),
                (value: Big) => setPropertyScalarNumber(p.dictRef, pl, ps, value),
                () => pl.removeProperty(p.dictRef), boundary1, level1);
            plDiv.appendChild(div);
            */ }
        // "me:TSOpticalSymmetryNumber", scalar, No units.
        if (!dictRefs.has((0, $597d59a3d37b5b3f$export$886461cafebcdaed).dictRef)) $9eedba3564ea6a49$var$addPropertyScalar(deselect, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$886461cafebcdaed).dictRef, undefined);
        else {
            pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$886461cafebcdaed).dictRef);
            let j = dictRefMap.get((0, $597d59a3d37b5b3f$export$886461cafebcdaed).dictRef);
            let p = $9eedba3564ea6a49$export$60ca070fb6dca2f6(pl, xml_ps[j], plDiv, m, mIDM, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        /*
            let ps: PropertyScalarNumber = p.getProperty() as PropertyScalarNumber;
            let div: HTMLDivElement = processNumber(pID, mIDM, p.dictRef, ps.getValue.bind(ps),
                (value: Big) => setPropertyScalarNumber(p.dictRef, pl, ps, value),
                () => pl.removeProperty(p.dictRef), boundary1, level1);
            plDiv.appendChild(div);
            */ }
        // "me:frequenciesScaleFactor", scalar, No units.
        if (!dictRefs.has((0, $597d59a3d37b5b3f$export$1288989e9be37590).dictRef)) $9eedba3564ea6a49$var$addPropertyScalar(deselect, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$1288989e9be37590).dictRef, undefined);
        else {
            pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$1288989e9be37590).dictRef);
            let j = dictRefMap.get((0, $597d59a3d37b5b3f$export$1288989e9be37590).dictRef);
            let p = $9eedba3564ea6a49$export$60ca070fb6dca2f6(pl, xml_ps[j], plDiv, m, mIDM, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        /*
            let ps: PropertyScalarNumber = p.getProperty() as PropertyScalarNumber;
            let div: HTMLDivElement = processNumber(pID, mIDM, p.dictRef, ps.getValue.bind(ps),
                (value: Big) => setPropertyScalarNumber(p.dictRef, pl, ps, value),
                () => pl.removeProperty(p.dictRef), boundary1, level1);
            plDiv.appendChild(div);
            */ }
        // "me:vibFreqs", array, cm-1.
        if (!dictRefs.has((0, $597d59a3d37b5b3f$export$2762c8fbc03043ca).dictRef)) $9eedba3564ea6a49$var$addPropertyArray(deselect, false, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$2762c8fbc03043ca).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).frequencyUnits);
        else {
            pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$2762c8fbc03043ca).dictRef);
            let j = dictRefMap.get((0, $597d59a3d37b5b3f$export$2762c8fbc03043ca).dictRef);
            let p = $9eedba3564ea6a49$export$60ca070fb6dca2f6(pl, xml_ps[j], plDiv, m, mIDM, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        /*
            let pa: PropertyArray = p.getProperty() as PropertyArray;
            let div: HTMLDivElement = processNumberArrayOrMatrix(plDiv.id, mIDM, p.dictRef, pa, pa.getValues.bind(pa),
                (values: Big[]) => setPropertyArrayOrMatrix(p.dictRef, pl, pa, values),
                () => pl.removeProperty(p.dictRef), boundary1, level1);
            addAnyUnits(Mesmer.frequencyUnits, pa.attributes, div, div.querySelector(s_input) as HTMLElement,
                getID(pID, PropertyScalarNumber.s_units), p.dictRef, boundary1, boundary1);
            plDiv.appendChild(div);
            */ }
        // "me:MW", scalar, amu.
        if (!dictRefs.has((0, $597d59a3d37b5b3f$export$a3772f6eb527275b).dictRef)) $9eedba3564ea6a49$var$addPropertyScalar(deselect, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$a3772f6eb527275b).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).massUnits);
        else {
            pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$a3772f6eb527275b).dictRef);
            let j = dictRefMap.get((0, $597d59a3d37b5b3f$export$a3772f6eb527275b).dictRef);
            let p = $9eedba3564ea6a49$export$60ca070fb6dca2f6(pl, xml_ps[j], plDiv, m, mIDM, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        /*
            let ps: PropertyScalarNumber = p.getProperty() as PropertyScalarNumber;
            let div: HTMLDivElement = processNumber(pID, mIDM, p.dictRef, ps.getValue.bind(ps),
                (value: Big) => setPropertyScalarNumber(p.dictRef, pl, ps, value),
                () => pl.removeProperty(p.dictRef), boundary1, level1);
            addAnyUnits(Mesmer.massUnits, ps.attributes, div, div.querySelector(s_input) as HTMLElement,
                getID(pID, PropertyScalarNumber.s_units), p.dictRef, boundary1, boundary1);
            plDiv.appendChild(div);
            */ }
        // "me:spinMultiplicity", scalar, No units.
        if (!dictRefs.has((0, $597d59a3d37b5b3f$export$415ad1120b60f9f3).dictRef)) {
            let div = $9eedba3564ea6a49$var$addPropertyScalar(deselect, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$415ad1120b60f9f3).dictRef, undefined);
            // Click the button.
            let b = div.querySelector((0, $341c675b659c6d43$export$25280bc3a7ce098e));
            b.click();
            pl.removeProperty((0, $597d59a3d37b5b3f$export$415ad1120b60f9f3).dictRef);
        } else {
            pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$415ad1120b60f9f3).dictRef);
            let j = dictRefMap.get((0, $597d59a3d37b5b3f$export$415ad1120b60f9f3).dictRef);
            let p = $9eedba3564ea6a49$export$60ca070fb6dca2f6(pl, xml_ps[j], plDiv, m, mIDM, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        /*
            let ps: PropertyScalarNumber = p.getProperty() as PropertyScalarNumber;
            let div: HTMLDivElement = processNumber(pID, mIDM, p.dictRef, ps.getValue.bind(ps),
                (value: Big) => setPropertyScalarNumber(p.dictRef, pl, ps, value),
                () => pl.removeProperty(p.dictRef), boundary1, level1);
            plDiv.appendChild(div);
            */ }
        // "me:epsilon", scalar, K (fixed).
        if (!dictRefs.has((0, $597d59a3d37b5b3f$export$cb998ac70542b2c3).dictRef)) $9eedba3564ea6a49$var$addPropertyScalar(deselect, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$cb998ac70542b2c3).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).temperatureUnits);
        else {
            pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$cb998ac70542b2c3).dictRef);
            let j = dictRefMap.get((0, $597d59a3d37b5b3f$export$cb998ac70542b2c3).dictRef);
            let p = $9eedba3564ea6a49$export$60ca070fb6dca2f6(pl, xml_ps[j], plDiv, m, mIDM, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        /*
            let ps: PropertyScalarNumber = p.getProperty() as PropertyScalarNumber;
            let div: HTMLDivElement = processNumber(pID, mIDM, p.dictRef, ps.getValue.bind(ps),
                (value: Big) => setPropertyScalarNumber(p.dictRef, pl, ps, value),
                () => pl.removeProperty(p.dictRef), boundary1, level1);
            plDiv.appendChild(div);
            */ }
        // "me:sigma", scalar, Å (fixed).
        if (!dictRefs.has((0, $597d59a3d37b5b3f$export$79e850ed2864d13d).dictRef)) $9eedba3564ea6a49$var$addPropertyScalar(deselect, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$79e850ed2864d13d).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).lengthUnits);
        else {
            pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$79e850ed2864d13d).dictRef);
            let j = dictRefMap.get((0, $597d59a3d37b5b3f$export$79e850ed2864d13d).dictRef);
            let p = $9eedba3564ea6a49$export$60ca070fb6dca2f6(pl, xml_ps[j], plDiv, m, mIDM, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        /*
            let ps: PropertyScalarNumber = p.getProperty() as PropertyScalarNumber;
            let div: HTMLDivElement = processNumber(pID, mIDM, p.dictRef, ps.getValue.bind(ps),
                (value: Big) => setPropertyScalarNumber(p.dictRef, pl, ps, value),
                () => pl.removeProperty(p.dictRef), boundary1, level1);
            plDiv.appendChild(div);
            */ }
        // "me:hessian", matrix, kJ/mol/Å2 or kcal/mol/Å2 or Hartree/Å2.
        if (!dictRefs.has((0, $597d59a3d37b5b3f$export$789e4dcdcb815c05).dictRef)) $9eedba3564ea6a49$var$addPropertyMatrix(deselect, false, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$789e4dcdcb815c05).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).hessianUnits);
        else {
            pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$789e4dcdcb815c05).dictRef);
            let j = dictRefMap.get((0, $597d59a3d37b5b3f$export$789e4dcdcb815c05).dictRef);
            let p = $9eedba3564ea6a49$export$60ca070fb6dca2f6(pl, xml_ps[j], plDiv, m, mIDM, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        /*
            let pm: PropertyMatrix = p.getProperty() as PropertyMatrix;
            let div: HTMLDivElement = processNumberArrayOrMatrix(plDiv.id, mIDM, p.dictRef, pm, pm.getValues.bind(pm),
                (values: Big[]) => setPropertyArrayOrMatrix(p.dictRef, pl, pm, values),
                () => pl.removeProperty(p.dictRef), boundary1, level1);
            addAnyUnits(Mesmer.hessianUnits, pm.attributes, div, div.querySelector(s_input) as HTMLElement,
                getID(pID, PropertyScalarNumber.s_units), p.dictRef, boundary1, boundary1);
            plDiv.appendChild(div);
            */ }
        // "me:EinsteinAij", array, s-1 (fixed).
        if (!dictRefs.has((0, $597d59a3d37b5b3f$export$f3e9ef5020c299b5).dictRef)) $9eedba3564ea6a49$var$addPropertyArray(deselect, false, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$f3e9ef5020c299b5).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).EinsteinAUnits);
        else {
            pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$f3e9ef5020c299b5).dictRef);
            let j = dictRefMap.get((0, $597d59a3d37b5b3f$export$f3e9ef5020c299b5).dictRef);
            let p = $9eedba3564ea6a49$export$60ca070fb6dca2f6(pl, xml_ps[j], plDiv, m, mIDM, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        /*
            let pa: PropertyArray = p.getProperty() as PropertyArray;
            let div: HTMLDivElement = processNumberArrayOrMatrix(plDiv.id, mIDM, p.dictRef, pa, pa.getValues.bind(pa),
                (values: Big[]) => setPropertyArrayOrMatrix(p.dictRef, pl, pa, values),
                () => pl.removeProperty(p.dictRef), boundary1, level1);
            addAnyUnits(Mesmer.EinsteinAUnits, pa.attributes, div, div.querySelector(s_input) as HTMLElement,
                getID(pID, PropertyScalarNumber.s_units), p.dictRef, boundary1, boundary1);
            plDiv.appendChild(div);
            */ }
        // "me:EinsteinBij", array, m3/J/s2 (fixed).
        if (!dictRefs.has((0, $597d59a3d37b5b3f$export$25f02bc420569a7e).dictRef)) $9eedba3564ea6a49$var$addPropertyArray(deselect, false, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$25f02bc420569a7e).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).EinsteinBUnits);
        else {
            pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$25f02bc420569a7e).dictRef);
            let j = dictRefMap.get((0, $597d59a3d37b5b3f$export$25f02bc420569a7e).dictRef);
            let p = $9eedba3564ea6a49$export$60ca070fb6dca2f6(pl, xml_ps[j], plDiv, m, mIDM, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        /*
            let pa: PropertyArray = p.getProperty() as PropertyArray;
            let div: HTMLDivElement = processNumberArrayOrMatrix(plDiv.id, mIDM, p.dictRef, pa, pa.getValues.bind(pa),
                (values: Big[]) => setPropertyArrayOrMatrix(p.dictRef, pl, pa, values),
                () => pl.removeProperty(p.dictRef), boundary1, level1);
            addAnyUnits(Mesmer.EinsteinBUnits, pa.attributes, div, div.querySelector(s_input) as HTMLElement,
                getID(pID, PropertyScalarNumber.s_units), p.dictRef, boundary1, boundary1);
            plDiv.appendChild(div);
            */ }
        // "me:electronicExcitation", scalar, cm-1.
        if (!dictRefs.has((0, $597d59a3d37b5b3f$export$2e66a7dc5ebae8a1).dictRef)) $9eedba3564ea6a49$var$addPropertyScalar(deselect, m, mIDM, plDiv, pl, (0, $597d59a3d37b5b3f$export$2e66a7dc5ebae8a1).dictRef, (0, $ccef02370f58a770$export$692079bb871c6039).frequencyUnits);
        else {
            pID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, (0, $597d59a3d37b5b3f$export$2e66a7dc5ebae8a1).dictRef);
            let j = dictRefMap.get((0, $597d59a3d37b5b3f$export$2e66a7dc5ebae8a1).dictRef);
            let p = $9eedba3564ea6a49$export$60ca070fb6dca2f6(pl, xml_ps[j], plDiv, m, mIDM, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        /*
            let ps: PropertyScalarNumber = p.getProperty() as PropertyScalarNumber;
            let div: HTMLDivElement = processNumber(pID, mIDM, p.dictRef, ps.getValue.bind(ps),
                (value: Big) => setPropertyScalarNumber(p.dictRef, pl, ps, value),
                () => pl.removeProperty(p.dictRef), boundary1, level1);
            addAnyUnits(Mesmer.frequencyUnits, ps.attributes, div, div.querySelector(s_input) as HTMLElement,
                getID(pID, PropertyScalarNumber.s_units), p.dictRef, boundary1, boundary1);
            plDiv.appendChild(div);
            */ }
        moleculeTagNames.delete((0, $597d59a3d37b5b3f$export$4e0d1ad7ad6a0802).tagName);
        moleculeTagNames.delete((0, $597d59a3d37b5b3f$export$41b04b3a73e7216d).tagName);
        // Organise EnergyTransferModel.
        let xml_etms = xml_ms[i].getElementsByTagName((0, $597d59a3d37b5b3f$export$499950da20810ac9).tagName);
        if (xml_etms.length > 0) {
            if (xml_etms.length > 1) throw new Error("Expecting 1 or 0 " + (0, $597d59a3d37b5b3f$export$499950da20810ac9).tagName + " but finding " + xml_etms.length + "!");
            let etm = new (0, $597d59a3d37b5b3f$export$499950da20810ac9)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_etms[0]));
            $9eedba3564ea6a49$var$processEnergyTransferModel(mIDM, etm, m, xml_etms[0], mDiv);
            moleculeTagNames.delete((0, $597d59a3d37b5b3f$export$499950da20810ac9).tagName);
        }
        // Organise DOSCMethod.
        let xml_dms = xml_ms[i].getElementsByTagName((0, $597d59a3d37b5b3f$export$bbdce6c921702068).tagName);
        if (xml_dms.length > 0) {
            if (xml_dms.length > 1) throw new Error("Expecting 1 or 0 " + (0, $597d59a3d37b5b3f$export$bbdce6c921702068).tagName + " but finding " + xml_dms.length + "!");
            let doscm = new (0, $597d59a3d37b5b3f$export$bbdce6c921702068)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_dms[0]));
            mDiv.appendChild((0, $341c675b659c6d43$export$4c3eba01cd3c5ba4)((0, $597d59a3d37b5b3f$export$bbdce6c921702068).tagName, (0, $597d59a3d37b5b3f$export$bbdce6c921702068).xsi_typeOptions, (0, $597d59a3d37b5b3f$export$bbdce6c921702068).tagName, doscm.getXsiType(), mIDM.addID(mDivID, (0, $597d59a3d37b5b3f$export$bbdce6c921702068).tagName), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7)));
            moleculeTagNames.delete((0, $597d59a3d37b5b3f$export$bbdce6c921702068).tagName);
        }
        // Organise DistributionCalcMethod. (Output only)
        let xml_dcms = xml_ms[i].getElementsByTagName((0, $597d59a3d37b5b3f$export$3f9657e7f71262a).tagName);
        if (xml_dcms.length > 0) {
            if (xml_dcms.length > 1) throw new Error("Expecting 1 or 0 " + (0, $597d59a3d37b5b3f$export$3f9657e7f71262a).tagName + " but finding " + xml_dcms.length + "!");
            let dcmAttributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_dcms[0]);
            let dcm = new (0, $597d59a3d37b5b3f$export$3f9657e7f71262a)(dcmAttributes);
            m.setDistributionCalcMethod(dcm);
            let dcmDivID = mIDM.addID(mDivID, (0, $597d59a3d37b5b3f$export$3f9657e7f71262a).tagName);
            let dcmDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(dcmDivID);
            mDiv.appendChild(dcmDiv);
            // Create label.
            dcmDiv.appendChild((0, $341c675b659c6d43$export$f2839682b8c07f35)((0, $597d59a3d37b5b3f$export$3f9657e7f71262a).tagName + " " + (0, $93b71ab6968650c1$export$dc22ec7f8e0b9ac)(dcmAttributes), (0, $dc4240e6100248ae$export$39c84188a71202f7)));
            moleculeTagNames.delete((0, $597d59a3d37b5b3f$export$3f9657e7f71262a).tagName);
        }
        // Organise DensityOfStatesList. (Output only)
        let xml_dosl = xml_ms[i].getElementsByTagName((0, $597d59a3d37b5b3f$export$dcce836c71a83df).tagName);
        if (xml_dosl.length > 0) {
            if (xml_dosl.length > 1) throw new Error("Expecting 1 or 0 " + (0, $597d59a3d37b5b3f$export$dcce836c71a83df).tagName + " but finding " + xml_dosl.length + "!");
            let dosl = new (0, $597d59a3d37b5b3f$export$dcce836c71a83df)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_dosl[0]));
            m.setDensityOfStatesList(dosl);
            // Create collapsible div.
            let doslDivID = mIDM.addID(mDivID, (0, $597d59a3d37b5b3f$export$dcce836c71a83df).tagName);
            let doslDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(doslDivID);
            let doslcDivID = mIDM.addID(doslDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
            let doslcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(doslcDivID, mDiv, null, doslDiv, (0, $597d59a3d37b5b3f$export$dcce836c71a83df).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            let xml_dos = xml_dosl[0].getElementsByTagName((0, $597d59a3d37b5b3f$export$126b026a4280c589).tagName);
            // Organise Description.
            let xml_ds = xml_dosl[0].getElementsByTagName((0, $ccef02370f58a770$export$393edc798c47379d).tagName);
            if (xml_ds.length > 0) {
                if (xml_ds.length > 1) throw new Error("Expecting 1 or 0 " + (0, $ccef02370f58a770$export$393edc798c47379d).tagName + " but finding " + xml_ds.length + "!");
                let ds = new (0, $ccef02370f58a770$export$393edc798c47379d)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_ds[0]), (0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_ds[0])));
                dosl.setDescription(ds);
            }
            // Organise DensityOfStates.
            //console.log("xml_dos.length=" + xml_dos.length);
            if (xml_dos.length == 0) throw new Error("Expecting 1 or more " + (0, $597d59a3d37b5b3f$export$126b026a4280c589).tagName + " but finding 0!");
            else {
                let t = (0, $341c675b659c6d43$export$33bbb3ec7652e187)(mIDM.addID(doslDivID, (0, $dc4240e6100248ae$export$7a850709da5c4f5b)), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                (0, $341c675b659c6d43$export$6c1065e21382520d)(t, (0, $597d59a3d37b5b3f$export$126b026a4280c589).header);
                // Append the table to the div.
                doslDiv.appendChild(t);
                for(let j = 0; j < xml_dos.length; j++){
                    //console.log("j=" + j);
                    let dos = new (0, $597d59a3d37b5b3f$export$126b026a4280c589)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_dos[j]));
                    dosl.addDensityOfStates(dos);
                    let dosDivID = mIDM.addID(doslDivID, j);
                    let dosDiv = (0, $341c675b659c6d43$export$78253536c0178a32)(dosDivID, (0, $dc4240e6100248ae$export$39c84188a71202f7));
                    doslDiv.appendChild(dosDiv);
                    // T.
                    let xml_t = xml_dos[j].getElementsByTagName((0, $ccef02370f58a770$export$971d5caa766a69d7).tagName);
                    if (xml_t.length != 1) throw new Error("Expecting 1 " + (0, $ccef02370f58a770$export$971d5caa766a69d7).tagName + " but finding " + xml_t.length + "!");
                    else {
                        let t = new (0, $ccef02370f58a770$export$971d5caa766a69d7)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_t[0]), new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))((0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_t[0]))));
                        dos.setT(t);
                    //dosDiv.appendChild(createLabel(t.value.toString(), boundary1));
                    }
                    // qtot.
                    let xml_qtot = xml_dos[j].getElementsByTagName((0, $597d59a3d37b5b3f$export$656e8af5996be26).tagName);
                    if (xml_qtot.length != 1) throw new Error("Expecting 1 " + (0, $597d59a3d37b5b3f$export$656e8af5996be26).tagName + " but finding " + xml_qtot.length + "!");
                    else {
                        let qtot = new (0, $597d59a3d37b5b3f$export$656e8af5996be26)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_qtot[0]), new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))((0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_qtot[0]))));
                        dos.setQtot(qtot);
                    //dosDiv.appendChild(createLabel(Qtot.tagName + " " + qtot.value.toString(), boundary1));
                    }
                    // sumc.
                    let xml_sumc = xml_dos[j].getElementsByTagName((0, $597d59a3d37b5b3f$export$c8de58561fc3a710).tagName);
                    if (xml_sumc.length != 1) throw new Error("Expecting 1 " + (0, $597d59a3d37b5b3f$export$c8de58561fc3a710).tagName + " but finding " + xml_sumc.length + "!");
                    else {
                        let sumc = new (0, $597d59a3d37b5b3f$export$c8de58561fc3a710)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_sumc[0]), new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))((0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_sumc[0]))));
                        dos.setSumc(sumc);
                    //dosDiv.appendChild(createLabel(sumc.value.toString(), boundary1));
                    }
                    // sumg.
                    let xml_sumg = xml_dos[j].getElementsByTagName((0, $597d59a3d37b5b3f$export$159051b21d796f59).tagName);
                    if (xml_sumg.length != 1) throw new Error("Expecting 1 " + (0, $597d59a3d37b5b3f$export$159051b21d796f59).tagName + " but finding " + xml_sumg.length + "!");
                    else {
                        let sumg = new (0, $597d59a3d37b5b3f$export$159051b21d796f59)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_sumg[0]), new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))((0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_sumg[0]))));
                        dos.setSumg(sumg);
                    //dosDiv.appendChild(createLabel(sumg.value.toString(), boundary1));
                    }
                    (0, $341c675b659c6d43$export$67d0e2fae00985e1)(t, dos.toStringArray());
                //console.log("dos: " + dos.toString());
                }
                (0, $dc4240e6100248ae$export$dd526fb3a2a9c049)(dosl.toCSV, doslDiv, t, m.getID() + "_" + (0, $597d59a3d37b5b3f$export$dcce836c71a83df).tagName, (0, $dc4240e6100248ae$export$39c84188a71202f7));
            }
            moleculeTagNames.delete((0, $597d59a3d37b5b3f$export$dcce836c71a83df).tagName);
        }
        // Organise ThermoTable. (Output only)
        let tttn = (0, $597d59a3d37b5b3f$export$96f29f03cf201f97).tagName;
        let xml_tts = xml_ms[i].getElementsByTagName(tttn);
        if (xml_tts.length > 0) {
            if (xml_tts.length > 1) throw new Error("Expecting 1 or 0 " + tttn + " but finding " + xml_tts.length + "!");
            let tt = new (0, $597d59a3d37b5b3f$export$96f29f03cf201f97)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_tts[0]));
            // Create collapsible div.
            let ttDivId = mIDM.addID(mDivID, (0, $597d59a3d37b5b3f$export$96f29f03cf201f97).tagName);
            let ttDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(ttDivId);
            let ttcDivId = mIDM.addID(ttDivId, (0, $dc4240e6100248ae$export$7295f538b9762c5));
            let ttcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(ttcDivId, mDiv, null, ttDiv, tttn, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            let tvs;
            let tvtn = (0, $597d59a3d37b5b3f$export$3ee0c201412b230).tagName;
            let xml_tvs = xml_tts[0].getElementsByTagName(tvtn);
            if (xml_tvs.length == 0) throw new Error("Expecting 1 or more " + tvtn + " but finding 0!");
            else {
                tvs = [];
                let t = (0, $341c675b659c6d43$export$33bbb3ec7652e187)(mIDM.addID(ttDivId, (0, $dc4240e6100248ae$export$7a850709da5c4f5b)), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                (0, $341c675b659c6d43$export$6c1065e21382520d)(t, tt.getHeader());
                for(let j = 0; j < xml_tvs.length; j++){
                    let tv = new (0, $597d59a3d37b5b3f$export$3ee0c201412b230)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_tvs[j]));
                    tvs.push(tv);
                    (0, $341c675b659c6d43$export$67d0e2fae00985e1)(t, tv.toStringArray());
                }
                // Append the table to the div.
                ttDiv.appendChild(t);
                tt.init(tvs);
                (0, $dc4240e6100248ae$export$dd526fb3a2a9c049)(tt.toCSV.bind(tt), ttDiv, t, mIDM.addID(m.getID(), (0, $597d59a3d37b5b3f$export$96f29f03cf201f97).tagName), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            }
            m.setThermoTable(tt);
            moleculeTagNames.delete(tvtn);
            moleculeTagNames.delete(tttn);
        }
        // Organise ExtraDOSCMethod.
        let xml_edms = xml_ms[i].getElementsByTagName((0, $597d59a3d37b5b3f$export$ae98b7db6376163d).tagName);
        if (xml_edms.length > 0) for(let j = 0; j < xml_edms.length; j++){
            let edm = new (0, $597d59a3d37b5b3f$export$ae98b7db6376163d)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_edms[j]));
            // Create collapsible ExtraDOSCMethod HTMLDivElement.
            let edmDivID = mIDM.addID(mDivID, (0, $597d59a3d37b5b3f$export$ae98b7db6376163d).tagName, j);
            let edmDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(edmDivID);
            let edmcDivID = mIDM.addID(edmDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
            let edmcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(edmcDivID, mDiv, null, edmDiv, (0, $597d59a3d37b5b3f$export$ae98b7db6376163d).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            // Read bondRef.
            let xml_brs = xml_edms[j].getElementsByTagName((0, $597d59a3d37b5b3f$export$aef8e5ad5552fd72).tagName);
            if (xml_brs.length > 0) {
                if (xml_brs.length != 1) throw new Error("Expecting only 1 bondRef, but there are " + xml_brs.length);
                let bids = m.getBonds().getBondIds();
                let br = new (0, $597d59a3d37b5b3f$export$aef8e5ad5552fd72)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_brs[0]), (0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_brs[0])));
                let lws = (0, $341c675b659c6d43$export$4c3eba01cd3c5ba4)((0, $597d59a3d37b5b3f$export$aef8e5ad5552fd72).tagName, bids, (0, $597d59a3d37b5b3f$export$aef8e5ad5552fd72).tagName, br.value, mIDM.addID(edmDivID, (0, $597d59a3d37b5b3f$export$aef8e5ad5552fd72).tagName), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                let select = lws.getElementsByTagName("select")[0];
                select.classList.add((0, $597d59a3d37b5b3f$export$153327fc99ac0c53).tagName);
                edmDiv.appendChild(lws);
            }
            // Read hinderedRotorPotential.
            let xml_hrps = xml_edms[j].getElementsByTagName((0, $597d59a3d37b5b3f$export$9b8e857b9a081d2).tagName);
            if (xml_hrps.length > 0) {
                if (xml_hrps.length != 1) throw new Error("Expecting only 1 HinderedRotorPotential, but there are " + xml_hrps.length);
                let hrpAttributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_hrps[0]);
                let hrp = new (0, $597d59a3d37b5b3f$export$9b8e857b9a081d2)(hrpAttributes);
                // Create collapsible HinderedRotorPotential HTMLDivElement.
                let hrpDivID = mIDM.addID(edmDivID, (0, $597d59a3d37b5b3f$export$9b8e857b9a081d2).tagName);
                let hrpDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(hrpDivID);
                let hrpcDivID = mIDM.addID(hrpDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
                let hrpcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(hrpcDivID, edmDiv, null, hrpDiv, (0, $597d59a3d37b5b3f$export$9b8e857b9a081d2).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                // Format.
                let lws = (0, $341c675b659c6d43$export$4c3eba01cd3c5ba4)((0, $597d59a3d37b5b3f$export$9b8e857b9a081d2).s_format, (0, $597d59a3d37b5b3f$export$9b8e857b9a081d2).formats, (0, $597d59a3d37b5b3f$export$9b8e857b9a081d2).tagName, hrp.getFormat(), mIDM.addID(hrpDivID, (0, $597d59a3d37b5b3f$export$9b8e857b9a081d2).s_format), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                hrpDiv.appendChild(lws);
                // Units.
                (0, $dc4240e6100248ae$export$2b2254f82abcc900)((0, $ccef02370f58a770$export$692079bb871c6039).energyUnits, hrpAttributes, hrpDiv, lws, mIDM.addID(hrpDivID, (0, $597d59a3d37b5b3f$export$9b8e857b9a081d2).s_units), (0, $597d59a3d37b5b3f$export$9b8e857b9a081d2).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                // ExpansionSize.
                let es = hrp.getExpansionSize() ?? (0, $dc4240e6100248ae$export$2f2abd8810196a7);
                hrpDiv.appendChild((0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("text", mIDM.addID(hrpDivID, (0, $597d59a3d37b5b3f$export$9b8e857b9a081d2).s_expansionSize), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7), (event)=>{
                    let target = event.target;
                    // Check the input is a number.
                    try {
                        console.log("Setting " + (0, $597d59a3d37b5b3f$export$9b8e857b9a081d2).s_expansionSize + " to " + target.value);
                        hrp.setExpansionSize(new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(target.value));
                    } catch (e) {
                        alert("Invalid value, resetting...");
                        target.value = hrp.getExpansionSize() ?? (0, $dc4240e6100248ae$export$2f2abd8810196a7);
                    }
                    (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
                }, es, (0, $597d59a3d37b5b3f$export$9b8e857b9a081d2).s_expansionSize));
                // Add useSineTerms.
                $9eedba3564ea6a49$var$processUseSineTerms(mIDM, hrpDiv, hrp, (0, $dc4240e6100248ae$export$39c84188a71202f7));
                // Load PotentialPoints.
                // Create collapsible HinderedRotorPotential PotentialPoint HTMLDivElement.
                let ppsDivID = mIDM.addID(hrpDivID, (0, $597d59a3d37b5b3f$export$86ca5149fcde8feb).tagName);
                let ppsDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(ppsDivID);
                let ppscDivID = mIDM.addID(ppsDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
                let ppscDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(ppscDivID, mDiv, null, ppsDiv, "PotentialPoints", (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                hrpDiv.appendChild(ppscDiv);
                let pps = [];
                let xml_pps = xml_hrps[0].getElementsByTagName((0, $597d59a3d37b5b3f$export$86ca5149fcde8feb).tagName);
                for(let k = 0; k < xml_pps.length; k++){
                    let pp = new (0, $597d59a3d37b5b3f$export$86ca5149fcde8feb)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_pps[k]));
                    pps.push(pp);
                    let ppDivID = mIDM.addID(ppsDivID, k);
                    let ppDiv = (0, $341c675b659c6d43$export$78253536c0178a32)(ppDivID, (0, $dc4240e6100248ae$export$39c84188a71202f7));
                    ppsDiv.appendChild(ppDiv);
                    let l = (0, $341c675b659c6d43$export$f2839682b8c07f35)((0, $597d59a3d37b5b3f$export$86ca5149fcde8feb).tagName + " " + k, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
                    ppDiv.appendChild(l);
                    // Process angle
                    let a = pp.getAngle() ?? (0, $dc4240e6100248ae$export$2f2abd8810196a7);
                    let anglelwi = (0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("text", mIDM.addID(ppDivID, (0, $597d59a3d37b5b3f$export$86ca5149fcde8feb).s_angle), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (event)=>{
                        let target = event.target;
                        // Check the input is a number.
                        if ((0, $93b71ab6968650c1$export$e90fb89750dba83f)(target.value)) {
                            let value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(target.value);
                            pp.setAngle(value);
                        } else {
                            // Reset the input to the current value.
                            alert("Angle input is not a number, resetting...");
                            target.value = pp.getAngle() ?? (0, $dc4240e6100248ae$export$2f2abd8810196a7);
                        }
                        (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
                    }, a, (0, $597d59a3d37b5b3f$export$86ca5149fcde8feb).s_angle);
                    ppDiv.appendChild(anglelwi);
                    // Create a new div element for the potential.
                    let potentialLabel = (0, $341c675b659c6d43$export$f2839682b8c07f35)((0, $597d59a3d37b5b3f$export$86ca5149fcde8feb).s_potential, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
                    ppDiv.appendChild(potentialLabel);
                    let potentialInputElementId = mIDM.addID(ppDivID, (0, $597d59a3d37b5b3f$export$86ca5149fcde8feb).s_potential);
                    let potentialInputElement = (0, $341c675b659c6d43$export$d80fffb1deb3b97e)("text", potentialInputElementId, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
                    ppDiv.appendChild(potentialInputElement);
                    let p = pp.getPotential() ?? (0, $dc4240e6100248ae$export$2f2abd8810196a7);
                    potentialInputElement.addEventListener('change', (event)=>{
                        let target = event.target;
                        // Check the input is a number.
                        if ((0, $93b71ab6968650c1$export$e90fb89750dba83f)(target.value)) {
                            let value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(target.value);
                            pp.setPotential(value);
                            console.log("Set " + (0, $597d59a3d37b5b3f$export$86ca5149fcde8feb).tagName + " to " + value.toExponential());
                        } else {
                            // Reset the input to the current value.
                            alert("Potential input is not a number, resetting...");
                            potentialInputElement.value = pp.getPotential() ?? (0, $dc4240e6100248ae$export$2f2abd8810196a7);
                        }
                        (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(potentialInputElement);
                    });
                    potentialInputElement.value = p;
                    (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(potentialInputElement);
                }
                //ppsDiv.appendChild(ppDiv);
                hrp.setPotentialPoints(pps);
                edm.setHinderedRotorPotential(hrp);
            }
            // Read periodicities.
            let xml_periodicities = xml_edms[j].getElementsByTagName((0, $597d59a3d37b5b3f$export$9513c16afdf7d852).tagName);
            if (xml_periodicities.length > 0) {
                if (xml_periodicities.length != 1) throw new Error("Expecting only 1 Periodicity, but there are " + xml_periodicities.length);
                let valueString = (0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_periodicities[0]));
                let periodicity = new (0, $597d59a3d37b5b3f$export$9513c16afdf7d852)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_periodicities[0]), new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(valueString));
                edm.setPeriodicity(periodicity);
                let lwi = (0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("text", mIDM.addID(edmDivID, (0, $597d59a3d37b5b3f$export$9513c16afdf7d852).tagName), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7), (event)=>{
                    let target = event.target;
                    valueString = target.value;
                    if ((0, $93b71ab6968650c1$export$e90fb89750dba83f)(valueString)) {
                        let value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(valueString);
                        periodicity.value = value;
                        edm.getPeriodicity().value = value;
                        console.log("Set " + (0, $597d59a3d37b5b3f$export$9513c16afdf7d852).tagName + " to " + value);
                    } else {
                        // Reset the input to the current value.
                        alert("Periodicity input is not a number, resetting...");
                        target.value = periodicity.value.toExponential();
                    }
                }, valueString, (0, $597d59a3d37b5b3f$export$9513c16afdf7d852).tagName);
                edmDiv.appendChild(lwi);
            }
            m.setExtraDOSCMethod(j, edm);
            moleculeTagNames.delete((0, $597d59a3d37b5b3f$export$ae98b7db6376163d).tagName);
        }
        // Organise ReservoirSize.
        moleculeTagNames.delete((0, $597d59a3d37b5b3f$export$97850fe2f2906f00).tagName);
        let xml_ReservoirSize = xml_ms[i].getElementsByTagName((0, $597d59a3d37b5b3f$export$97850fe2f2906f00).tagName);
        if (xml_ReservoirSize.length > 0) {
            if (xml_ReservoirSize.length != 1) throw new Error("Expecting only 1 reservoirSize, but there are " + xml_ReservoirSize.length);
            let valueString = (0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_ReservoirSize[0]));
            let value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(valueString);
            let reservoirSizeAttributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_ReservoirSize[0]);
            let reservoirSize = new (0, $597d59a3d37b5b3f$export$97850fe2f2906f00)(reservoirSizeAttributes, value);
            m.setReservoirSize(reservoirSize);
            let inputDiv = (0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("number", m.getID() + "_" + (0, $597d59a3d37b5b3f$export$97850fe2f2906f00).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7), (event)=>{
                let target = event.target;
                reservoirSize.value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(target.value);
                (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
            }, valueString, (0, $597d59a3d37b5b3f$export$97850fe2f2906f00).tagName);
            mDiv.appendChild(inputDiv);
        }
        // Organise States.
        let xml_states = xml_ms[i].getElementsByTagName((0, $597d59a3d37b5b3f$export$47283907dceba392).tagName);
        let ssDivID = mIDM.addID(mDivID, (0, $597d59a3d37b5b3f$export$7254cc27399e90bd).tagName);
        let ssDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(ssDivID);
        let sscDivID = mIDM.addID(ssDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
        let sscDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(sscDivID, mDiv, null, ssDiv, (0, $597d59a3d37b5b3f$export$47283907dceba392).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        if (xml_states.length > 0) {
            if (xml_states.length > 1) throw new Error("Expecting 1 or 0 " + (0, $597d59a3d37b5b3f$export$47283907dceba392).tagName + " but finding " + xml_states.length + "!");
            let ss = new (0, $597d59a3d37b5b3f$export$47283907dceba392)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_states[0]));
            //let state: State[] = [];
            let xml_ss = xml_states[0].getElementsByTagName((0, $597d59a3d37b5b3f$export$7254cc27399e90bd).tagName);
            for(let j = 0; j < xml_ss.length; j++){
                let s = new (0, $597d59a3d37b5b3f$export$7254cc27399e90bd)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_ss[j]), j);
                //state.push(s);
                ss.addState(s);
            //let sDivID = mIDM.addID(ssDivID, State.tagName, j);
            //let sDiv: HTMLDivElement = createDiv(sDivID, level1);
            //ssDiv.appendChild(sDiv);
            }
            m.setStates(ss);
            moleculeTagNames.delete((0, $597d59a3d37b5b3f$export$7254cc27399e90bd).tagName);
        }
        // Check for unexpected tags.
        moleculeTagNames.delete("#text");
        if (moleculeTagNames.size > 0) {
            console.warn("There are additional unexpected moleculeTagNames:");
            moleculeTagNames.forEach((x)=>console.warn(x));
        //throw new Error("Unexpected tags in molecule.");
        }
        // Add a remove molecule button.
        (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(mDiv, (0, $dc4240e6100248ae$export$39c84188a71202f7), ()=>{
            $9eedba3564ea6a49$var$removeMolecule(mlDiv, mcDiv, mIDM, molecules, mDivID, m);
        });
    }
    // Create an add molecule button.
    let mb = $9eedba3564ea6a49$export$12aafb9570dfb660(mlDiv, mIDM, molecules);
    // Create add from library button.
    let lb = $9eedba3564ea6a49$export$1f1b9bc888fe9f4c(mlDiv, mb, mIDM, molecules);
    return mlDiv;
}
/**
 * Remove a molecule.
 * @param mlDiv The MoleculeList div.
 * @param mcDiv The MoleculeContainer div.
 * @param mIDM The molecule IDManager.
 * @param molecules The molecules.
 * @param mDivID The molecule div ID.
 * @param m The molecule.
 */ function $9eedba3564ea6a49$var$removeMolecule(mlDiv, mcDiv, mIDM, molecules, mDivID, m) {
    mlDiv.removeChild(mcDiv);
    //mlDiv.removeChild(mDiv);
    mIDM.removeIDs(mDivID);
    mIDM.removeIDs((0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(mDivID, (0, $dc4240e6100248ae$export$666359451816b0e7)));
    mIDM.removeIDs((0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(mDivID, (0, $597d59a3d37b5b3f$export$9cea715eceba39a0).tagName));
    mIDM.removeIDs((0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(mDivID, (0, $597d59a3d37b5b3f$export$746fba2e30d93fe6).tagName));
    mIDM.removeIDs((0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(mDivID, (0, $dc4240e6100248ae$export$a59b122474df8e10)));
    mIDM.removeIDs((0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(mDivID, (0, $597d59a3d37b5b3f$export$4e0d1ad7ad6a0802).tagName));
    molecules.delete(m.getID());
}
function $9eedba3564ea6a49$export$60ca070fb6dca2f6(pl, xml, plDiv, molecule, mIDM, boundary, level) {
    let p = new (0, $597d59a3d37b5b3f$export$41b04b3a73e7216d)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml));
    //console.log("p.dictRef " + p.dictRef);
    if (p.dictRef == (0, $597d59a3d37b5b3f$export$95174cf0748f45cd).dictRef) // "me:ZPE", scalar, Mesmer.energyUnits.
    $9eedba3564ea6a49$export$183579040c2dd680(pl, p, (0, $ccef02370f58a770$export$692079bb871c6039).energyUnits, molecule, mIDM, xml, plDiv, boundary, level);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$90bccbae54bb6d4f).dictRef) // "me:Hf0", scalar, Mesmer.energyUnits.
    $9eedba3564ea6a49$export$183579040c2dd680(pl, p, (0, $ccef02370f58a770$export$692079bb871c6039).energyUnits, molecule, mIDM, xml, plDiv, boundary, level);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$a4fe62a56eafa45d).dictRef) // "me:HfAT0", scalar, Mesmer.energyUnits.
    $9eedba3564ea6a49$export$183579040c2dd680(pl, p, (0, $ccef02370f58a770$export$692079bb871c6039).energyUnits, molecule, mIDM, xml, plDiv, boundary, level);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$e7df60530792b964).dictRef) // "me:Hf298", scalar, Mesmer.energyUnits.
    $9eedba3564ea6a49$export$183579040c2dd680(pl, p, (0, $ccef02370f58a770$export$692079bb871c6039).energyUnits, molecule, mIDM, xml, plDiv, boundary, level);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$984abe26ded13ee0).dictRef) // "me:rotConsts", array, Mesmer.frequencyUnits.
    $9eedba3564ea6a49$export$183579040c2dd680(pl, p, (0, $ccef02370f58a770$export$692079bb871c6039).frequencyUnits, molecule, mIDM, xml, plDiv, boundary, level);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$d1d1720eff14586a).dictRef) // "me:symmetryNumber", scalar, No units.
    $9eedba3564ea6a49$export$183579040c2dd680(pl, p, undefined, molecule, mIDM, xml, plDiv, boundary, level);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$886461cafebcdaed).dictRef) // "me:TSOpticalSymmetryNumber", scalar, No units.
    $9eedba3564ea6a49$export$183579040c2dd680(pl, p, undefined, molecule, mIDM, xml, plDiv, boundary, level);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$1288989e9be37590).dictRef) // "me:frequenciesScaleFactor", scalar, No units.
    $9eedba3564ea6a49$export$183579040c2dd680(pl, p, undefined, molecule, mIDM, xml, plDiv, boundary, level);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$2762c8fbc03043ca).dictRef) // "me:vibFreqs", array, cm-1.
    $9eedba3564ea6a49$export$183579040c2dd680(pl, p, (0, $ccef02370f58a770$export$692079bb871c6039).frequencyUnits, molecule, mIDM, xml, plDiv, boundary, level);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$a3772f6eb527275b).dictRef) // "me:MW", scalar, amu.
    $9eedba3564ea6a49$export$183579040c2dd680(pl, p, undefined, molecule, mIDM, xml, plDiv, boundary, level);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$415ad1120b60f9f3).dictRef) // "me:spinMultiplicity", scalar, No units.
    $9eedba3564ea6a49$export$183579040c2dd680(pl, p, undefined, molecule, mIDM, xml, plDiv, boundary, level);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$cb998ac70542b2c3).dictRef) // "me:epsilon", scalar, K (fixed).
    $9eedba3564ea6a49$export$183579040c2dd680(pl, p, undefined, molecule, mIDM, xml, plDiv, boundary, level);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$79e850ed2864d13d).dictRef) // "me:sigma", scalar, Å (fixed).
    $9eedba3564ea6a49$export$183579040c2dd680(pl, p, undefined, molecule, mIDM, xml, plDiv, boundary, level);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$789e4dcdcb815c05).dictRef) // "me:hessian", matrix, kJ/mol/Å2 or kcal/mol/Å2 or Hartree/Å2.
    $9eedba3564ea6a49$export$183579040c2dd680(pl, p, undefined, molecule, mIDM, xml, plDiv, boundary, level);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$f3e9ef5020c299b5).dictRef) // "me:EinsteinAij", array, s-1 (fixed).
    $9eedba3564ea6a49$export$183579040c2dd680(pl, p, undefined, molecule, mIDM, xml, plDiv, boundary, level);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$25f02bc420569a7e).dictRef) // "me:EinsteinBij", array, m3/J/s2 (fixed).
    $9eedba3564ea6a49$export$183579040c2dd680(pl, p, undefined, molecule, mIDM, xml, plDiv, boundary, level);
    else $9eedba3564ea6a49$export$cbd171726dbc631c(pl, p, molecule, xml, plDiv, boundary, level);
    pl.setProperty(p);
    return p;
}
function $9eedba3564ea6a49$export$183579040c2dd680(pl, p, units, molecule, mIDM, element, plDiv, boundary, level) {
    let pID = mIDM.addID((0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, p.dictRef));
    let div;
    // PropertyScalar.
    let scalarNodes = element.getElementsByTagName((0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).tagName);
    if (scalarNodes.length > 0) {
        if (scalarNodes.length != 1) throw new Error("Expecting 1 " + (0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).tagName + " but finding " + scalarNodes.length + "!");
        let inputString = (0, $057fa7562ec736a9$export$433c819efd6b1ea5)(scalarNodes[0]);
        let value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(inputString);
        let psAttributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(scalarNodes[0]);
        // Add PropertyScalarNumber.
        let ps = new (0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3)(psAttributes, value);
        p.setProperty(ps);
        ps.setValue = (function(value) {
            ps.value = value;
            if (p.dictRef == (0, $597d59a3d37b5b3f$export$95174cf0748f45cd).dictRef || p.dictRef == (0, $597d59a3d37b5b3f$export$90bccbae54bb6d4f).dictRef || p.dictRef == (0, $597d59a3d37b5b3f$export$a4fe62a56eafa45d).dictRef || p.dictRef == (0, $597d59a3d37b5b3f$export$e7df60530792b964).dictRef) // Update the molecule energy diagram.
            (0, $dc4240e6100248ae$export$e7cd7bead34ef747)();
        }).bind(ps);
        div = (0, $dc4240e6100248ae$export$17d48ee8ddbf2d44)(pID, mIDM, p.dictRef, ps.getValue.bind(ps), (value)=>$9eedba3564ea6a49$export$c1dce3e534360efd(p.dictRef, pl, ps, value), ()=>pl.removeProperty(p.dictRef), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        (0, $dc4240e6100248ae$export$2b2254f82abcc900)(units, psAttributes, div, div.querySelector((0, $dc4240e6100248ae$export$58785e0018b77d4a)), mIDM.addID(pID, (0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).s_units), p.dictRef, boundary, boundary);
        plDiv.appendChild(div);
    // click
    //let button: HTMLButtonElement = div.querySelector('button') as HTMLButtonElement;
    //button.click();
    } else {
        // PropertyArray.
        let arrayNodes = element.getElementsByTagName((0, $597d59a3d37b5b3f$export$9f93a3fdf2490572).tagName);
        if (arrayNodes.length > 0) {
            if (arrayNodes.length != 1) throw new Error("Expecting 1 " + (0, $597d59a3d37b5b3f$export$9f93a3fdf2490572).tagName + " but finding " + arrayNodes.length + "!");
            let inputString = (0, $057fa7562ec736a9$export$433c819efd6b1ea5)(arrayNodes[0]);
            if (inputString == "") {
                console.warn("inputString is empty setting to 0!");
                inputString = "0";
            }
            let values = (0, $93b71ab6968650c1$export$8cfbaad830aa9e0a)(inputString.split(/\s+/));
            let paAttributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(arrayNodes[0]);
            let pa = new (0, $597d59a3d37b5b3f$export$9f93a3fdf2490572)(paAttributes, values);
            p.setProperty(pa);
            div = $9eedba3564ea6a49$export$e5600fc4ea245d6d(plDiv, mIDM, p.dictRef, pa, pa.getValues.bind(pa), pa.setValues, ()=>pl.removeProperty(p.dictRef), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            (0, $dc4240e6100248ae$export$2b2254f82abcc900)(units, paAttributes, div, div.querySelector((0, $dc4240e6100248ae$export$de72b11c4a138de9)), mIDM.addID(pID, (0, $597d59a3d37b5b3f$export$9f93a3fdf2490572).s_units), p.dictRef, boundary, boundary);
            plDiv.appendChild(div);
        } else {
            // PropertyMatrix.
            let matrixNodes = element.getElementsByTagName((0, $597d59a3d37b5b3f$export$a5a2be813176eb0e).tagName);
            if (matrixNodes.length > 0) {
                if (matrixNodes.length != 1) throw new Error("Expecting 1 " + (0, $597d59a3d37b5b3f$export$a5a2be813176eb0e).tagName + " but finding " + matrixNodes.length + "!");
                //addPropertyMatrix(false, molecule, mIDM, plDiv, pl, p.dictRef, units);
                let inputString = (0, $057fa7562ec736a9$export$433c819efd6b1ea5)(matrixNodes[0]);
                let values = (0, $93b71ab6968650c1$export$8cfbaad830aa9e0a)(inputString.split(/\s+/));
                let pmAttributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(matrixNodes[0]);
                let pm = new (0, $597d59a3d37b5b3f$export$a5a2be813176eb0e)(pmAttributes, values);
                p.setProperty(pm);
                let label = p.dictRef;
                // Create a new div element for the input.
                let inputDiv = (0, $341c675b659c6d43$export$60fee6710ef6fb16)(pID, boundary, level, (event)=>{
                    let target = event.target;
                    $9eedba3564ea6a49$export$819b5ff7dff3652c(false, p.dictRef, pm, target);
                }, inputString, label);
                let ta = inputDiv.querySelector('textarea');
                ta.value = inputString;
                (0, $341c675b659c6d43$export$c5eaaac137ef25d0)(ta);
                ta.addEventListener('change', (event)=>{
                    let target = event.target;
                    inputString = target.value;
                    pm = p.getProperty();
                    values = (0, $93b71ab6968650c1$export$8cfbaad830aa9e0a)(inputString.split(/\s+/));
                    pm.values = values;
                    console.log("Set " + p.dictRef + " of " + molecule.getLabel() + " to " + inputString);
                    //resizeInputElement(inputElement);
                    (0, $341c675b659c6d43$export$c5eaaac137ef25d0)(ta);
                });
                (0, $dc4240e6100248ae$export$2b2254f82abcc900)(units, pmAttributes, inputDiv, ta, mIDM.addID(pID, (0, $597d59a3d37b5b3f$export$9f93a3fdf2490572).s_units), p.dictRef, boundary, boundary);
                plDiv.appendChild(inputDiv);
            } else throw new Error("Expecting " + (0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).tagName + ", " + (0, $597d59a3d37b5b3f$export$9f93a3fdf2490572).tagName + " or " + (0, $597d59a3d37b5b3f$export$a5a2be813176eb0e).tagName + " but finding none!");
        }
    }
}
function $9eedba3564ea6a49$export$cbd171726dbc631c(pl, p, molecule, element, plDiv, boundary, level) {
    // This is for storing the IDs of the components so that if property is removed and readded, the IDs are available and there is no confuion...
    let pIDs = new Set();
    // PropertyScalarString.
    let scalarNodes = element.getElementsByTagName((0, $597d59a3d37b5b3f$export$eb6936faa5f138bb).tagName);
    if (scalarNodes.length > 0) {
        if (scalarNodes.length != 1) throw new Error("Expecting 1 " + (0, $597d59a3d37b5b3f$export$eb6936faa5f138bb).tagName + " but finding " + scalarNodes.length + "!");
        let inputString = (0, $057fa7562ec736a9$export$433c819efd6b1ea5)(scalarNodes[0]);
        let psAttributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(scalarNodes[0]);
        // Add PropertyScalarNumber.
        let ps = new (0, $597d59a3d37b5b3f$export$eb6936faa5f138bb)(psAttributes, inputString);
        p.setProperty(ps);
        ps.setValue = (function(value) {
            ps.value = value;
            //console.log("Set " + p.dictRef + " of " + molecule.getLabel() + " to " + value);
            if (p.dictRef == (0, $597d59a3d37b5b3f$export$95174cf0748f45cd).dictRef || p.dictRef == (0, $597d59a3d37b5b3f$export$90bccbae54bb6d4f).dictRef || p.dictRef == (0, $597d59a3d37b5b3f$export$a4fe62a56eafa45d).dictRef || p.dictRef == (0, $597d59a3d37b5b3f$export$e7df60530792b964).dictRef) // Update the molecule energy diagram.
            (0, $dc4240e6100248ae$export$e7cd7bead34ef747)();
        }).bind(ps);
        let div = (0, $dc4240e6100248ae$export$edf19e7acee859e6)((0, $dc4240e6100248ae$export$bea69a603fae01a6)(plDiv.id, p.dictRef), pIDs, p.dictRef, ps.getValue.bind(ps), ps.setValue, ()=>pl.removeProperty(p.dictRef), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        plDiv.appendChild(div);
    } else console.log("Expecting " + (0, $597d59a3d37b5b3f$export$eb6936faa5f138bb).tagName + " but finding none!");
}
/**
 * For processing a molecule energy transfer model.
 * @param etm The energy transfer model.
 * @param molecule The molecule.
 * @param element The element.
 * @param moleculeDiv The molecule div.
 */ function $9eedba3564ea6a49$var$processEnergyTransferModel(mIDM, etm, molecule, element, moleculeDiv) {
    let xml_deltaEDowns = element.getElementsByTagName((0, $597d59a3d37b5b3f$export$16fc56ab40b12b45).tagName);
    if (xml_deltaEDowns.length > 0) {
        // Create a new collapsible div for the energyTransferModel.
        let etmdivID = mIDM.addID(moleculeDiv.id, (0, $597d59a3d37b5b3f$export$499950da20810ac9).tagName);
        let etmDiv = document.createElement("div");
        let etmcDivID = mIDM.addID(etmdivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
        let etmcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(etmcDivID, moleculeDiv, null, etmDiv, (0, $597d59a3d37b5b3f$export$499950da20810ac9).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        let deltaEDowns = [];
        for(let k = 0; k < xml_deltaEDowns.length; k++){
            let inputString = (0, $057fa7562ec736a9$export$433c819efd6b1ea5)(xml_deltaEDowns[k]);
            let value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(inputString);
            let deltaEDownAttributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_deltaEDowns[k]);
            let deltaEDown = new (0, $597d59a3d37b5b3f$export$16fc56ab40b12b45)(deltaEDownAttributes, value);
            deltaEDowns.push(deltaEDown);
            let label = (0, $597d59a3d37b5b3f$export$16fc56ab40b12b45).tagName;
            // Create a new div element for the input.
            let id = mIDM.addID(etmdivID, (0, $597d59a3d37b5b3f$export$16fc56ab40b12b45).tagName, k);
            let inputDiv = (0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("number", id, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7), (event)=>{
                let target = event.target;
                (0, $dc4240e6100248ae$export$b1e4cbf5b56e0e21)(deltaEDown, target);
                inputString = target.value;
                deltaEDowns[k].setValue(new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(inputString));
                console.log("Set " + id + " to " + inputString);
                (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
            }, inputString, label);
            etmDiv.appendChild(inputDiv);
            let unitsLabel = document.createElement('label');
            unitsLabel.textContent = "units cm-1";
            inputDiv.appendChild(unitsLabel);
        }
        etm.setDeltaEDowns(deltaEDowns);
        molecule.setEnergyTransferModel(etm);
    }
}
function $9eedba3564ea6a49$export$7aad7e61c4f49964(mIDM, molecule, moleculeDiv, boundary, level) {
    // Add a 3Dmol.js viewer.
    // Create a new div for the viewer.
    let viewerContainerDivID = mIDM.addID(moleculeDiv.id, (0, $dc4240e6100248ae$export$a59b122474df8e10), (0, $dc4240e6100248ae$export$7295f538b9762c5));
    let viewerContainerDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(viewerContainerDivID, level);
    moleculeDiv.appendChild(viewerContainerDiv);
    let viewerDivID = mIDM.addID(moleculeDiv.id, (0, $dc4240e6100248ae$export$a59b122474df8e10));
    let showAtomLabels = false;
    let showBondLabels = false;
    // Create the GLViewer viewer.
    function createViewer(position, rotation, zoomLevel, showAtomLabels, showBondLabels) {
        let viewerDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(viewerDivID, boundary);
        viewerDiv.className = "mol-container";
        viewerContainerDiv.appendChild(viewerDiv);
        let config = {
            backgroundColor: 'grey'
        };
        let viewer = $3Dmol.createViewer(viewerDiv, config);
        // Set the viewer style to stick and ball.
        viewer.setStyle({
            stick: {}
        });
        // Create a 3Dmol viewer control to turn labels on and off.
        molecule.getAtoms().atoms.forEach(function(atom) {
            let et = atom.getElementType();
            let color;
            if (et == undefined) color = 'Purple';
            else color = (0, $ccef02370f58a770$export$692079bb871c6039).atomColors.get(et) || 'Purple';
            //let am: number = Mesmer.atomMasses.get(atom.getElementType()) || 1;
            let radius;
            if (et == undefined) radius = 100;
            else radius = (0, $ccef02370f58a770$export$692079bb871c6039).atomRadii.get(atom.getElementType()) || 100;
            let ax = atom.getX3()?.toNumber() || 0;
            let ay = atom.getY3()?.toNumber() || 0;
            let az = atom.getZ3()?.toNumber() || 0;
            //viewer.addSphere({ center: { x: ax, y: ay, z: az }, radius: 0.3 * am / 10.0, color: color });
            viewer.addSphere({
                center: {
                    x: ax,
                    y: ay,
                    z: az
                },
                radius: radius / 110.0,
                color: color
            });
            //viewer.addSphere({ center: { x: ax, y: ay, z: az }, radius: (radius * (am ** (1 / 3.0))) / 275.0, color: color });
            if (showAtomLabels) viewer.addLabel(atom.getID(), {
                position: {
                    x: ax,
                    y: ay,
                    z: az
                }
            });
        });
        //console.log("molecule.getBonds().bonds.size " + molecule.getBonds().bonds.size);
        molecule.getBonds().bonds.forEach(function(bond) {
            //console.log("bond.atomRefs2 " + bond.getAtomRefs2());
            let ids = bond.getAtomRefs2().split(" ");
            let aa = molecule.getAtoms();
            let a0 = aa.getAtom(ids[0]);
            let a1 = aa.getAtom(ids[1]);
            let order = bond.getOrder() || 1;
            let color = (0, $ccef02370f58a770$export$692079bb871c6039).bondColors.get(order) || 'Purple';
            // a0.
            let a0x = a0.getX3()?.toNumber() || 0;
            let a0y = a0.getY3()?.toNumber() || 0;
            let a0z = a0.getZ3()?.toNumber() || 0;
            // a1.
            let a1x = a1.getX3()?.toNumber() || 0;
            let a1y = a1.getY3()?.toNumber() || 0;
            let a1z = a1.getZ3()?.toNumber() || 0;
            viewer.addCylinder({
                start: {
                    x: a0x,
                    y: a0y,
                    z: a0z
                },
                end: {
                    x: a1x,
                    y: a1y,
                    z: a1z
                },
                radius: 0.06 * order,
                color: color
            });
            if (showBondLabels) viewer.addLabel(bond.getID(), {
                position: {
                    x: (a0x + a1x) / 2,
                    y: (a0y + a1y) / 2,
                    z: (a0z + a1z) / 2
                }
            });
        });
        if (position != undefined) {
            console.log("position", position);
            viewer.position = position;
        } else console.log("position", viewer.position);
        if (rotation != undefined) {
            console.log("rotation", rotation);
            viewer.rotation = rotation;
        } else console.log("rotation", viewer.rotation);
        if (zoomLevel != undefined) {
            console.log("zoom", zoomLevel);
            viewer.zoomLevel = zoomLevel;
        } else console.log("zoom", viewer.zoomLevel);
        viewer.zoomTo();
        viewer.render();
        //viewer.zoom(0.8, 2000);
        return viewer;
    }
    // Add a redraw button.
    let redrawButton = (0, $341c675b659c6d43$export$9b6d6ca62970729f)("Draw/Redraw", undefined);
    let viewer;
    redrawButton.addEventListener('click', ()=>{
        (0, $dc4240e6100248ae$export$cd7f480d6b8286c3)(viewerDivID);
        if (viewer == undefined) viewer = createViewer(undefined, undefined, undefined, showAtomLabels, showBondLabels);
        else viewer = createViewer(viewer.position, viewer.rotation, viewer.zoom, showAtomLabels, showBondLabels);
    });
    viewerContainerDiv.appendChild(redrawButton);
    // Helper function to create a label button for hiding or showing labels on the viewer.
    function createLabelButton(label, id, showState, updateState) {
        let button = (0, $341c675b659c6d43$export$9b6d6ca62970729f)((showState ? "Hide " : "Show ") + label, id, boundary);
        button.addEventListener('click', ()=>{
            if (showState) {
                button.textContent = "Show " + label;
                showState = false;
            } else {
                button.textContent = "Hide " + label;
                showState = true;
            }
            let position = viewer.position;
            let rotation = viewer.rotation;
            let zoomLevel = viewer.zoomLevel;
            updateState(showState);
            (0, $dc4240e6100248ae$export$cd7f480d6b8286c3)(viewerDivID);
            viewer = createViewer(position, rotation, zoomLevel, showAtomLabels, showBondLabels);
        });
        return button;
    }
    // Atom Labels.
    let s_Atom_Labels = "Atom Labels";
    let atomLabelbutton = createLabelButton(s_Atom_Labels, mIDM.addID(viewerDivID, s_Atom_Labels), showAtomLabels, (newState)=>showAtomLabels = newState);
    viewerContainerDiv.appendChild(atomLabelbutton);
    // Bond Labels.
    let s_Bond_Labels = "Bond Labels";
    let bondLabelbutton = createLabelButton(s_Bond_Labels, mIDM.addID(viewerDivID, s_Bond_Labels), showBondLabels, (newState)=>showBondLabels = newState);
    viewerContainerDiv.appendChild(bondLabelbutton);
    // Add a save button to save the viewer as an image.
    let saveButton = (0, $341c675b659c6d43$export$9b6d6ca62970729f)("Save as PNG", mIDM.addID(viewerDivID, (0, $dc4240e6100248ae$export$c1dfed4ad865f0b6)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    saveButton.addEventListener('click', ()=>{
        //viewer.pngURI({ backgroundColor: 'white', download: true });
        let canvas = viewer.pngURI();
        let a = document.createElement('a');
        a.href = canvas;
        let title = (0, $dc4240e6100248ae$export$3bb92be1f57fd129).getTitle()?.value;
        a.download = title.replace(/[^a-z0-9]/gi, '_') + 'mol.png';
        document.body.appendChild(a); // Append the anchor to the body.
        a.click(); // Programmatically click the anchor to trigger the download.
        document.body.removeChild(a); // Remove the anchor from the body after triggering the download.
        console.log('Save Image');
    });
    viewerContainerDiv.appendChild(saveButton);
}
function $9eedba3564ea6a49$export$3c6ba217df5e6b83(dictRef, ps, id, boundary, level) {
    let pDiv = (0, $341c675b659c6d43$export$78253536c0178a32)(id, level);
    pDiv.appendChild((0, $341c675b659c6d43$export$f2839682b8c07f35)(dictRef, boundary));
    // value.
    let value = ps.getValue();
    //let value: string = ps.value;
    let valueInputId = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(id, (0, $dc4240e6100248ae$export$58785e0018b77d4a));
    let valueInput = (0, $341c675b659c6d43$export$d80fffb1deb3b97e)("text", valueInputId, boundary);
    pDiv.appendChild(valueInput);
    valueInput.addEventListener('change', (event)=>{
        let target = event.target;
        ps.setValue(new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(target.value));
        //ps.value = target.value;
        (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
    });
    valueInput.value = value.toString();
    (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(valueInput);
    return pDiv;
}
function $9eedba3564ea6a49$export$8f5eeb1aadb49400(attributes, mIDM, value, units, pl, p, plDiv, boundary) {
    let ps = p.getProperty();
    ps.setValue = (function(value) {
        ps.value = value;
        if (p.dictRef == (0, $597d59a3d37b5b3f$export$95174cf0748f45cd).dictRef || p.dictRef == (0, $597d59a3d37b5b3f$export$90bccbae54bb6d4f).dictRef || p.dictRef == (0, $597d59a3d37b5b3f$export$a4fe62a56eafa45d).dictRef || p.dictRef == (0, $597d59a3d37b5b3f$export$e7df60530792b964).dictRef) // Update the molecule energy diagram.
        (0, $dc4240e6100248ae$export$e7cd7bead34ef747)();
    }).bind(ps);
    ps.value = value;
    if (p.dictRef == (0, $597d59a3d37b5b3f$export$95174cf0748f45cd).dictRef || p.dictRef == (0, $597d59a3d37b5b3f$export$90bccbae54bb6d4f).dictRef || p.dictRef == (0, $597d59a3d37b5b3f$export$a4fe62a56eafa45d).dictRef || p.dictRef == (0, $597d59a3d37b5b3f$export$e7df60530792b964).dictRef) // Update the molecule energy diagram.
    (0, $dc4240e6100248ae$export$e7cd7bead34ef747)();
    let id = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(plDiv.id, p.dictRef);
    console.log("div ID " + id);
    let div = (0, $dc4240e6100248ae$export$17d48ee8ddbf2d44)(id, mIDM, p.dictRef, ps.getValue.bind(ps), (value)=>$9eedba3564ea6a49$export$c1dce3e534360efd(p.dictRef, pl, ps, value), ()=>pl.removeProperty(p.dictRef), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
    console.log("unitsID " + (0, $dc4240e6100248ae$export$bea69a603fae01a6)(id, (0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).s_units));
    (0, $dc4240e6100248ae$export$2b2254f82abcc900)(units, attributes, div, div.querySelector((0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(id, (0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).s_units), p.dictRef, boundary, boundary);
    plDiv.appendChild(div);
}
function $9eedba3564ea6a49$export$e5600fc4ea245d6d(plDiv, mIDM, name, pa, getter, setter, remover, marginComponent, margin) {
    let divID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(plDiv.id, name);
    let div = (0, $341c675b659c6d43$export$78253536c0178a32)(divID, margin);
    let buttonTextContentSelected = name + (0, $dc4240e6100248ae$export$f0fb6e9d3fd6cf72);
    let buttonTextContentDeselected = name + (0, $dc4240e6100248ae$export$b758aa9bd161846e);
    //let id: string = mIDM.addID(plDiv.id, name);
    //let idb = mIDM.addID(divID, s_button);
    let idb = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(divID, (0, $341c675b659c6d43$export$25280bc3a7ce098e));
    let button = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(buttonTextContentDeselected, idb, marginComponent);
    div.appendChild(button);
    button.classList.add((0, $dc4240e6100248ae$export$50cc31b59b02e033));
    button.classList.add((0, $dc4240e6100248ae$export$d52efe23389358db));
    //let inputId: string = mIDM.addID(divID, s_input)
    let inputId = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(divID, (0, $dc4240e6100248ae$export$58785e0018b77d4a));
    let values = getter();
    if (values == undefined) {
        button.textContent = buttonTextContentDeselected;
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
    } else {
        $9eedba3564ea6a49$var$addNumberArray(div, inputId, name, values, pa, getter, setter, marginComponent);
        //plDiv.appendChild(div);
        button.textContent = buttonTextContentSelected;
        button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
    }
    // Add event listener for the button.
    button.addEventListener('click', (event)=>{
        if (document.getElementById(inputId) == null) {
            $9eedba3564ea6a49$var$addNumberArray(div, inputId, name, values, pa, getter, setter, marginComponent);
            //plDiv.appendChild(div);
            button.textContent = buttonTextContentSelected;
        } else {
            // Remove existing.
            document.getElementById(inputId)?.remove();
            remover();
            console.log("Removed " + inputId);
            button.textContent = buttonTextContentDeselected;
        }
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
        button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
    });
    return div;
}
/**
 * @param div The div to add the input to.
 * @param id The id.
 * @param name The name of the input.
 * @param values The numerical values.
 * @param paom The PropertyArray or PropertyMatrix.
 * @param getter The getter function.
 * @param setter The setter function.
 * @param boundary The boundary for the text area.
 */ function $9eedba3564ea6a49$var$addNumberArray(div, id, name, values, paom, getter, setter, boundary) {
    let valueString;
    if (values == undefined) valueString = "";
    else valueString = (0, $93b71ab6968650c1$export$dba422ef505af222)(values);
    let ta = (0, $341c675b659c6d43$export$5b32cb28d9a29894)(id, boundary);
    ta.addEventListener('change', (event)=>{
        let target = event.target;
        let values = $9eedba3564ea6a49$export$819b5ff7dff3652c(true, name, paom, ta);
        try {
            setter(values);
            console.log(name + " changed from " + valueString + " to " + target.value);
        } catch (e) {
            alert("Input invalid, resetting...");
            target.value = getter().toString();
        }
        (0, $341c675b659c6d43$export$c5eaaac137ef25d0)(target);
    });
    ta.value = valueString;
    (0, $341c675b659c6d43$export$c5eaaac137ef25d0)(ta);
    div.appendChild(ta);
}
/**
 * @param inputString The input string.
 * @param defaultValues The default values.
 * @returns The input string converted to a numerical Big[] or the defaultValues.
 */ function $9eedba3564ea6a49$var$toBigArray(inputString, defaultValues) {
    let inputStrings = inputString.split(/\s+/);
    let values = [];
    let success = true;
    inputStrings.forEach(function(value) {
        if (!(0, $93b71ab6968650c1$export$e90fb89750dba83f)(value)) success = false;
        else values.push(new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(value));
    });
    if (!success) {
        alert("An input is not a number, resetting...");
        return defaultValues;
    }
    return values;
}
function $9eedba3564ea6a49$export$819b5ff7dff3652c(setSize, dictRef, node, ta) {
    let inputString = ta.value.trim();
    let originalValues = (0, $93b71ab6968650c1$export$4323cc4280d5be7)(node.values, " ");
    //if (node.getValues().length == 0) {
    //let values: Big[] = [];
    //setValues(dictRef, values);
    //node.setValues(values);
    //}
    if (inputString == "") {
        alert("Empty input resetting...");
        ta.value = originalValues;
        return node.values;
    }
    let values = $9eedba3564ea6a49$var$toBigArray(inputString, node.values);
    //console.log("propertyArray=" + propertyArray);
    if (values.length == node.values.length) {
        node.setValues(values);
        console.log("Changed " + node.tagName + " from: \"" + originalValues + "\" to: \"" + (0, $93b71ab6968650c1$export$4323cc4280d5be7)(node.values, " ") + "\"");
    //console.log("molecule=" + molecule);
    } else if (setSize) {
        //let values: Big[] = [];
        //setValues(dictRef, values);
        node.setValues(values);
        console.log("Changed " + node.tagName + " from: \"" + originalValues + "\" to: \"" + (0, $93b71ab6968650c1$export$4323cc4280d5be7)(node.values, " ") + "\"");
    } else {
        alert("Expecting " + node.values.length + " values for, but finding " + values.length + " resetting...");
        ta.value = originalValues;
    }
    return node.values;
}


class $cb5398d795eb2774$export$7587e661a05e5158 {
    /**
     * @param defaults The defaults.
     */ constructor(){}
    /**
     * Read molecules from file.
     * @returns A promise that resolves to a map of molecules.
     */ readFile() {
        return new Promise((resolve, reject)=>{
            let input = document.createElement('input');
            input.type = 'file';
            let self = this;
            input.onchange = function() {
                if (input.files) {
                    let file = input.files[0];
                    let inputFilename = file.name;
                    let reader = new FileReader();
                    let chunkSize = 1048576; // 1MB
                    let start = 0;
                    let contents = '';
                    reader.onload = function(e) {
                        if (e.target == null) {
                            reject(new Error('Event target is null'));
                            return;
                        }
                        contents += e.target.result;
                        if (file != null) {
                            if (start < file.size) {
                                // Read the next chunk
                                let blob = file.slice(start, start + chunkSize);
                                reader.readAsText(blob);
                                start += chunkSize;
                            } else {
                                // All chunks have been read
                                contents = contents.trim();
                                let parser = new DOMParser();
                                let xml = parser.parseFromString(contents, "text/xml");
                                resolve(self.parse(xml));
                            }
                        }
                    };
                    // Read the first chunk
                    let blob = file.slice(start, start + chunkSize);
                    reader.readAsText(blob);
                    start += chunkSize;
                }
            };
            input.click();
        });
    }
    /**
     * Parse the XML.
     */ parse(xml) {
        /**
         * The molecules.
         */ let molecules = new Map();
        // Get the XML "moleculeList" element.
        let xml_ml = (0, $057fa7562ec736a9$export$b7531b8ff18dc588)(xml, (0, $ccef02370f58a770$export$19d70f3647dee606).tagName);
        // Check the XML "moleculeList" element has one or more "molecule" elements and no other elements.
        let mlTagNames = new Set();
        xml_ml.childNodes.forEach(function(node) {
            mlTagNames.add(node.nodeName);
        });
        /*
        if (mlTagNames.size != 1) {
            if (!(mlTagNames.size >= 2 && mlTagNames.has("#text")) ||
                !(mlTagNames.size == 3 && mlTagNames.has('#comment'))) {
                console.error("moleculeListTagNames:");
                mlTagNames.forEach(x => console.error(x));
                //throw new Error("Additional tag names in moleculeList:");
            }
        }
        if (!mlTagNames.has(Molecule.tagName)) {
            throw new Error("Expecting tags with \"" + Molecule.tagName + "\" tagName but there are none!");
        }
        */ // Process the XML "molecule" elements.
        let xml_ms = xml_ml.getElementsByTagName((0, $597d59a3d37b5b3f$export$3da9759ad07746a3).tagName);
        let xml_msl = xml_ms.length;
        console.log("Number of molecules=" + xml_msl);
        let naliases = 0;
        //xml_molecules.forEach(function (xml_molecule) { // Cannot iterate over HTMLCollectionOf<Element> like this.
        for(let i = 0; i < xml_msl; i++){
            // console.log("i=" + i);
            // Create a new Molecule.
            let attributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_ms[i]);
            let mid = attributes.get((0, $597d59a3d37b5b3f$export$3da9759ad07746a3).s_id);
            //console.log("mID=" + mID);
            if (mid == undefined) throw new Error((0, $597d59a3d37b5b3f$export$3da9759ad07746a3).s_id + ' is undefined');
            let cns = xml_ms[i].childNodes;
            //console.log("cns.length=" + cns.length);
            // Check if there are any child elements. If not, then this molecule is an alias.
            if (cns.length == 0) {
                naliases++;
                //console.log("This molecule is an alias.");
                let ref = attributes.get("ref");
                if (ref == undefined) throw new Error("ref is undefined");
                continue;
            }
            let id;
            while(true){
                id = (0, $9eedba3564ea6a49$export$194bfe7da61d65)(false, mid, undefined, molecules);
                if (id != undefined) break;
            }
            let m = new (0, $597d59a3d37b5b3f$export$3da9759ad07746a3)(attributes, id);
            molecules.set(id, m);
            // Create a set of molecule tag names.
            let moleculeTagNames = new Set();
            //cns.forEach(function (cn) {
            for(let j = 0; j < cns.length; j++){
                let cn = cns[j];
                // Check for nodeName repeats that are not #text.
                if (!moleculeTagNames.has(cn.nodeName)) moleculeTagNames.add(cn.nodeName);
                else // nodeName = #text are comments or white space/newlines in the XML which are ignored.
                if (cn.nodeName != "#text") console.warn("Another ChildNode with nodeName=" + cn.nodeName);
            //console.log(cn.nodeName);
            }
            // Init metadataList.
            //console.log("Init metadataList.");
            let xml_mls = xml_ms[i].getElementsByTagName((0, $cb35636d41d8f309$export$3e18a603070a78a).tagName);
            if (xml_mls.length > 0) {
                if (xml_mls.length > 1) throw new Error("Expecting 1 or 0 " + (0, $cb35636d41d8f309$export$3e18a603070a78a).tagName + " but finding " + xml_mls.length + "!");
                let ml = new (0, $cb35636d41d8f309$export$3e18a603070a78a)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_mls[0]));
                m.setMetadataList(ml);
                let xml_ms = xml_mls[0].getElementsByTagName((0, $cb35636d41d8f309$export$e7adebdc1ebd2fed).tagName);
                for(let j = 0; j < xml_ms.length; j++){
                    // Create a new Metadata.
                    let md = new (0, $cb35636d41d8f309$export$e7adebdc1ebd2fed)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_ms[j]));
                    ml.addMetadata(md);
                }
                moleculeTagNames.delete((0, $cb35636d41d8f309$export$3e18a603070a78a).tagName);
            }
            // Init atoms.
            //console.log("Init atoms.");
            // There can be an individual atom not in an atom array, or an atom array.
            let xml_aas = xml_ms[i].getElementsByTagName((0, $597d59a3d37b5b3f$export$9cea715eceba39a0).tagName);
            if (xml_aas.length > 1) throw new Error("Expecting 1 or 0 " + (0, $597d59a3d37b5b3f$export$9cea715eceba39a0).tagName + " but finding " + xml_aas.length + "!");
            if (xml_aas.length == 1) {
                let xml_aa = xml_aas[0];
                let xml_as = xml_aa.getElementsByTagName((0, $597d59a3d37b5b3f$export$80986e6afdd7e0cb).tagName);
                if (xml_as.length == 0) throw new Error("Expecting 1 or more atoms in " + (0, $597d59a3d37b5b3f$export$9cea715eceba39a0).tagName + ", but finding 0!");
                let aa = new (0, $597d59a3d37b5b3f$export$9cea715eceba39a0)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_aa));
                m.setAtoms(aa);
                for(let j = 0; j < xml_as.length; j++)aa.addAtom(new (0, $597d59a3d37b5b3f$export$80986e6afdd7e0cb)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_as[j]), m));
                moleculeTagNames.delete((0, $597d59a3d37b5b3f$export$9cea715eceba39a0).tagName);
            } else {
                let xml_as = xml_ms[i].getElementsByTagName((0, $597d59a3d37b5b3f$export$80986e6afdd7e0cb).tagName);
                if (xml_as.length == 1) {
                    let aa = new (0, $597d59a3d37b5b3f$export$9cea715eceba39a0)(new Map());
                    aa.addAtom(new (0, $597d59a3d37b5b3f$export$80986e6afdd7e0cb)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_as[0]), m));
                    m.setAtoms(aa);
                } else if (xml_as.length > 1) throw new Error("Expecting 1 " + (0, $597d59a3d37b5b3f$export$80986e6afdd7e0cb).tagName + " but finding " + xml_as.length + ". Should these be in an " + (0, $597d59a3d37b5b3f$export$9cea715eceba39a0).tagName + "?");
            }
            //console.log("atomsNode=" + atomsNode);
            moleculeTagNames.delete((0, $597d59a3d37b5b3f$export$80986e6afdd7e0cb).tagName);
            // Init bonds.
            // There can be an individual bond not in a bond array, or a bond array.
            // There may be only 1 bond in a BondArray.
            let xml_bas = xml_ms[i].getElementsByTagName((0, $597d59a3d37b5b3f$export$746fba2e30d93fe6).tagName);
            if (xml_bas.length > 0) {
                if (xml_bas.length > 1) throw new Error("Expecting 1 or 0 " + (0, $597d59a3d37b5b3f$export$746fba2e30d93fe6).tagName + " but finding " + xml_bas.length + "!");
                let xml_bs = xml_bas[0].getElementsByTagName((0, $597d59a3d37b5b3f$export$153327fc99ac0c53).tagName);
                let ba = new (0, $597d59a3d37b5b3f$export$746fba2e30d93fe6)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_bas[0]));
                for(let j = 0; j < xml_bs.length; j++)ba.addBond(new (0, $597d59a3d37b5b3f$export$153327fc99ac0c53)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_bs[j]), m));
                m.setBonds(ba);
                moleculeTagNames.delete((0, $597d59a3d37b5b3f$export$746fba2e30d93fe6).tagName);
            } else {
                let xml_bonds = xml_ms[i].getElementsByTagName((0, $597d59a3d37b5b3f$export$153327fc99ac0c53).tagName);
                if (xml_bonds.length > 0) {
                    if (xml_bonds.length > 1) throw new Error("Expecting 1 " + (0, $597d59a3d37b5b3f$export$153327fc99ac0c53).tagName + " but finding " + xml_bonds.length + ". Should these be in a " + (0, $597d59a3d37b5b3f$export$746fba2e30d93fe6).tagName + "?");
                    let ba = new (0, $597d59a3d37b5b3f$export$746fba2e30d93fe6)(new Map());
                    ba.addBond(new (0, $597d59a3d37b5b3f$export$153327fc99ac0c53)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_bonds[0]), m));
                    m.setBonds(ba);
                }
            }
            moleculeTagNames.delete((0, $597d59a3d37b5b3f$export$153327fc99ac0c53).tagName);
            // Organise PropertyList or individual Property.
            // (There can be an individual property not in a propertyList?)
            // If there is a PropertyList, then create a property list.
            let xml_pls = xml_ms[i].getElementsByTagName((0, $597d59a3d37b5b3f$export$4e0d1ad7ad6a0802).tagName);
            if (xml_pls.length > 1) throw new Error("Expecting 1 or 0 " + (0, $597d59a3d37b5b3f$export$4e0d1ad7ad6a0802).tagName + " but finding " + xml_pls.length + "!");
            if (xml_pls.length == 1) {
                // Create a new PropertyList.
                let pl = new (0, $597d59a3d37b5b3f$export$4e0d1ad7ad6a0802)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_pls[0]));
                m.setPropertyList(pl);
                let xml_ps = xml_pls[0].getElementsByTagName((0, $597d59a3d37b5b3f$export$41b04b3a73e7216d).tagName);
                for(let j = 0; j < xml_ps.length; j++)// Create a new Property.
                pl.setProperty($cb5398d795eb2774$var$createProperty(xml_ps[j]));
                moleculeTagNames.delete((0, $597d59a3d37b5b3f$export$4e0d1ad7ad6a0802).tagName);
            } else {
                // There is a Property on its own. For simplicity, this will be stored in a PropertyList.
                // Create a new PropertyList.
                let pl = new (0, $597d59a3d37b5b3f$export$4e0d1ad7ad6a0802)(new Map());
                m.setPropertyList(pl);
                let xml_ps = xml_ms[i].getElementsByTagName((0, $597d59a3d37b5b3f$export$41b04b3a73e7216d).tagName);
                if (xml_ps.length != 1) throw new Error("Expecting 1 " + (0, $597d59a3d37b5b3f$export$41b04b3a73e7216d).tagName + " but finding " + xml_ps.length + ". Should these be in a " + (0, $597d59a3d37b5b3f$export$4e0d1ad7ad6a0802).tagName + "?");
                // Create a new Property.
                pl.setProperty($cb5398d795eb2774$var$createProperty(xml_ps[0]));
                moleculeTagNames.delete((0, $597d59a3d37b5b3f$export$41b04b3a73e7216d).tagName);
            }
            // Organise EnergyTransferModel.
            let xml_etms = xml_ms[i].getElementsByTagName((0, $597d59a3d37b5b3f$export$499950da20810ac9).tagName);
            if (xml_etms.length > 0) {
                if (xml_etms.length > 1) throw new Error("Expecting 1 or 0 " + (0, $597d59a3d37b5b3f$export$499950da20810ac9).tagName + " but finding " + xml_etms.length + "!");
                let etm = new (0, $597d59a3d37b5b3f$export$499950da20810ac9)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_etms[0]));
                m.setEnergyTransferModel(etm);
                moleculeTagNames.delete((0, $597d59a3d37b5b3f$export$499950da20810ac9).tagName);
            }
            // Organise DOSCMethod.
            let xml_dms = xml_ms[i].getElementsByTagName((0, $597d59a3d37b5b3f$export$bbdce6c921702068).tagName);
            if (xml_dms.length > 0) {
                if (xml_dms.length > 1) throw new Error("Expecting 1 or 0 " + (0, $597d59a3d37b5b3f$export$bbdce6c921702068).tagName + " but finding " + xml_dms.length + "!");
                let doscm = new (0, $597d59a3d37b5b3f$export$bbdce6c921702068)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_dms[0]));
                m.setDOSCMethod(doscm);
                moleculeTagNames.delete((0, $597d59a3d37b5b3f$export$bbdce6c921702068).tagName);
            }
            // Organise DistributionCalcMethod. (Output only)
            let xml_dcms = xml_ms[i].getElementsByTagName((0, $597d59a3d37b5b3f$export$3f9657e7f71262a).tagName);
            if (xml_dcms.length > 0) {
                if (xml_dcms.length > 1) throw new Error("Expecting 1 or 0 " + (0, $597d59a3d37b5b3f$export$3f9657e7f71262a).tagName + " but finding " + xml_dcms.length + "!");
                let dcmAttributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_dcms[0]);
                let dcm = new (0, $597d59a3d37b5b3f$export$3f9657e7f71262a)(dcmAttributes);
                m.setDistributionCalcMethod(dcm);
                moleculeTagNames.delete((0, $597d59a3d37b5b3f$export$3f9657e7f71262a).tagName);
            }
            // Organise DensityOfStatesList. (Output only)
            let xml_dosl = xml_ms[i].getElementsByTagName((0, $597d59a3d37b5b3f$export$dcce836c71a83df).tagName);
            if (xml_dosl.length > 0) {
                if (xml_dosl.length > 1) throw new Error("Expecting 1 or 0 " + (0, $597d59a3d37b5b3f$export$dcce836c71a83df).tagName + " but finding " + xml_dosl.length + "!");
                let dosl = new (0, $597d59a3d37b5b3f$export$dcce836c71a83df)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_dosl[0]));
                m.setDensityOfStatesList(dosl);
                let xml_dos = xml_dosl[0].getElementsByTagName((0, $597d59a3d37b5b3f$export$126b026a4280c589).tagName);
                // Organise Description.
                let xml_ds = xml_dosl[0].getElementsByTagName((0, $ccef02370f58a770$export$393edc798c47379d).tagName);
                if (xml_ds.length > 0) {
                    if (xml_ds.length > 1) throw new Error("Expecting 1 or 0 " + (0, $ccef02370f58a770$export$393edc798c47379d).tagName + " but finding " + xml_ds.length + "!");
                    let ds = new (0, $ccef02370f58a770$export$393edc798c47379d)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_ds[0]), (0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_ds[0])));
                    dosl.setDescription(ds);
                }
                // Organise DensityOfStates.
                //console.log("xml_dos.length=" + xml_dos.length);
                if (xml_dos.length == 0) throw new Error("Expecting 1 or more " + (0, $597d59a3d37b5b3f$export$126b026a4280c589).tagName + " but finding 0!");
                else for(let j = 0; j < xml_dos.length; j++){
                    //console.log("j=" + j);
                    let dos = new (0, $597d59a3d37b5b3f$export$126b026a4280c589)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_dos[j]));
                    dosl.addDensityOfStates(dos);
                    // T.
                    let xml_t = xml_dos[j].getElementsByTagName((0, $ccef02370f58a770$export$971d5caa766a69d7).tagName);
                    if (xml_t.length != 1) throw new Error("Expecting 1 " + (0, $ccef02370f58a770$export$971d5caa766a69d7).tagName + " but finding " + xml_t.length + "!");
                    else {
                        let t = new (0, $ccef02370f58a770$export$971d5caa766a69d7)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_t[0]), new (0, $ad9e9f310a798519$exports.Big)((0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_t[0]))));
                        dos.setT(t);
                    //dosDiv.appendChild(createLabel(t.value.toString(), boundary1));
                    }
                    // qtot.
                    let xml_qtot = xml_dos[j].getElementsByTagName((0, $597d59a3d37b5b3f$export$656e8af5996be26).tagName);
                    if (xml_qtot.length != 1) throw new Error("Expecting 1 " + (0, $597d59a3d37b5b3f$export$656e8af5996be26).tagName + " but finding " + xml_qtot.length + "!");
                    else {
                        let qtot = new (0, $597d59a3d37b5b3f$export$656e8af5996be26)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_qtot[0]), new (0, $ad9e9f310a798519$exports.Big)((0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_qtot[0]))));
                        dos.setQtot(qtot);
                    //dosDiv.appendChild(createLabel(Qtot.tagName + " " + qtot.value.toString(), boundary1));
                    }
                    // sumc.
                    let xml_sumc = xml_dos[j].getElementsByTagName((0, $597d59a3d37b5b3f$export$c8de58561fc3a710).tagName);
                    if (xml_sumc.length != 1) throw new Error("Expecting 1 " + (0, $597d59a3d37b5b3f$export$c8de58561fc3a710).tagName + " but finding " + xml_sumc.length + "!");
                    else {
                        let sumc = new (0, $597d59a3d37b5b3f$export$c8de58561fc3a710)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_sumc[0]), new (0, $ad9e9f310a798519$exports.Big)((0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_sumc[0]))));
                        dos.setSumc(sumc);
                    //dosDiv.appendChild(createLabel(sumc.value.toString(), boundary1));
                    }
                    // sumg.
                    let xml_sumg = xml_dos[j].getElementsByTagName((0, $597d59a3d37b5b3f$export$159051b21d796f59).tagName);
                    if (xml_sumg.length != 1) throw new Error("Expecting 1 " + (0, $597d59a3d37b5b3f$export$159051b21d796f59).tagName + " but finding " + xml_sumg.length + "!");
                    else {
                        let sumg = new (0, $597d59a3d37b5b3f$export$159051b21d796f59)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_sumg[0]), new (0, $ad9e9f310a798519$exports.Big)((0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_sumg[0]))));
                        dos.setSumg(sumg);
                    //dosDiv.appendChild(createLabel(sumg.value.toString(), boundary1));
                    }
                }
                moleculeTagNames.delete((0, $597d59a3d37b5b3f$export$dcce836c71a83df).tagName);
            }
            // Organise States.
            let xml_states = xml_ms[i].getElementsByTagName((0, $597d59a3d37b5b3f$export$47283907dceba392).tagName);
            if (xml_states.length > 0) {
                if (xml_states.length > 1) throw new Error("Expecting 1 or 0 " + (0, $597d59a3d37b5b3f$export$47283907dceba392).tagName + " but finding " + xml_states.length + "!");
                let ss = new (0, $597d59a3d37b5b3f$export$47283907dceba392)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_states[0]));
                //let state: State[] = [];
                let xml_ss = xml_states[0].getElementsByTagName((0, $597d59a3d37b5b3f$export$7254cc27399e90bd).tagName);
                for(let j = 0; j < xml_ss.length; j++){
                    let s = new (0, $597d59a3d37b5b3f$export$7254cc27399e90bd)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_ss[j]), j);
                    //state.push(s);
                    ss.addState(s);
                //let sDivID = mIDM.addID(ssDivID, State.tagName, j);
                //let sDiv: HTMLDivElement = createDiv(sDivID, level1);
                //ssDiv.appendChild(sDiv);
                }
                m.setStates(ss);
                moleculeTagNames.delete((0, $597d59a3d37b5b3f$export$47283907dceba392).tagName);
            }
            // Check for unexpected tags.
            moleculeTagNames.delete("#text");
            if (moleculeTagNames.size > 0) {
                console.warn("There are additional unexpected moleculeTagNames:");
                moleculeTagNames.forEach((x)=>console.warn(x));
            //throw new Error("Unexpected tags in molecule.");
            }
        }
        console.log("Number of molecules=" + molecules.size);
        console.log("Number of alias molecules=" + naliases.toString());
        return molecules;
    }
}
/**
 * Create a property.
 * @param xml The XML element.
 * @returns The property.
 */ function $cb5398d795eb2774$var$createProperty(xml) {
    let p = new (0, $597d59a3d37b5b3f$export$41b04b3a73e7216d)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml));
    //console.log("p.dictRef " + p.dictRef);
    if (p.dictRef == (0, $597d59a3d37b5b3f$export$95174cf0748f45cd).dictRef) // "me:ZPE", scalar, Mesmer.energyUnits.
    $cb5398d795eb2774$var$processProperty(p, xml);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$90bccbae54bb6d4f).dictRef) // "me:Hf0", scalar, Mesmer.energyUnits.
    $cb5398d795eb2774$var$processProperty(p, xml);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$a4fe62a56eafa45d).dictRef) // "me:HfAT0", scalar, Mesmer.energyUnits.
    $cb5398d795eb2774$var$processProperty(p, xml);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$e7df60530792b964).dictRef) // "me:Hf298", scalar, Mesmer.energyUnits.
    $cb5398d795eb2774$var$processProperty(p, xml);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$984abe26ded13ee0).dictRef) // "me:rotConsts", array, Mesmer.frequencyUnits.
    $cb5398d795eb2774$var$processProperty(p, xml);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$d1d1720eff14586a).dictRef) // "me:symmetryNumber", scalar, No units.
    $cb5398d795eb2774$var$processProperty(p, xml);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$886461cafebcdaed).dictRef) // "me:TSOpticalSymmetryNumber", scalar, No units.
    $cb5398d795eb2774$var$processProperty(p, xml);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$1288989e9be37590).dictRef) // "me:frequenciesScaleFactor", scalar, No units.
    $cb5398d795eb2774$var$processProperty(p, xml);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$2762c8fbc03043ca).dictRef) // "me:vibFreqs", array, cm-1.
    $cb5398d795eb2774$var$processProperty(p, xml);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$a3772f6eb527275b).dictRef) // "me:MW", scalar, amu.
    $cb5398d795eb2774$var$processProperty(p, xml);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$415ad1120b60f9f3).dictRef) // "me:spinMultiplicity", scalar, No units.
    $cb5398d795eb2774$var$processProperty(p, xml);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$cb998ac70542b2c3).dictRef) // "me:epsilon", scalar, K (fixed).
    $cb5398d795eb2774$var$processProperty(p, xml);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$79e850ed2864d13d).dictRef) // "me:sigma", scalar, Å (fixed).
    $cb5398d795eb2774$var$processProperty(p, xml);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$789e4dcdcb815c05).dictRef) // "me:hessian", matrix, kJ/mol/Å2 or kcal/mol/Å2 or Hartree/Å2.
    $cb5398d795eb2774$var$processProperty(p, xml);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$f3e9ef5020c299b5).dictRef) // "me:EinsteinAij", array, s-1 (fixed).
    $cb5398d795eb2774$var$processProperty(p, xml);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$25f02bc420569a7e).dictRef) // "me:EinsteinBij", array, m3/J/s2 (fixed).
    $cb5398d795eb2774$var$processProperty(p, xml);
    else if (p.dictRef == (0, $597d59a3d37b5b3f$export$2e66a7dc5ebae8a1).dictRef) // "me:electronicExcitation", scalar, cm-1.
    $cb5398d795eb2774$var$processProperty(p, xml);
    else $cb5398d795eb2774$export$cbd171726dbc631c(p, xml);
    return p;
}
/**
 * Process a property.
 * @param p The property.
 * @param element The element.
 */ function $cb5398d795eb2774$var$processProperty(p, element) {
    // PropertyScalar.
    let scalarNodes = element.getElementsByTagName((0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).tagName);
    if (scalarNodes.length > 0) {
        if (scalarNodes.length != 1) throw new Error("Expecting 1 " + (0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).tagName + " but finding " + scalarNodes.length + "!");
        let inputString = (0, $057fa7562ec736a9$export$433c819efd6b1ea5)(scalarNodes[0]);
        let value = new (0, $ad9e9f310a798519$exports.Big)(inputString);
        let psAttributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(scalarNodes[0]);
        // Add PropertyScalarNumber.
        let ps = new (0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3)(psAttributes, value);
        p.setProperty(ps);
    } else {
        // PropertyArray.
        let arrayNodes = element.getElementsByTagName((0, $597d59a3d37b5b3f$export$9f93a3fdf2490572).tagName);
        if (arrayNodes.length > 0) {
            if (arrayNodes.length != 1) throw new Error("Expecting 1 " + (0, $597d59a3d37b5b3f$export$9f93a3fdf2490572).tagName + " but finding " + arrayNodes.length + "!");
            let inputString = (0, $057fa7562ec736a9$export$433c819efd6b1ea5)(arrayNodes[0]);
            if (inputString != "") {
                let values = (0, $93b71ab6968650c1$export$8cfbaad830aa9e0a)(inputString.split(/\s+/));
                let paAttributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(arrayNodes[0]);
                let pa = new (0, $597d59a3d37b5b3f$export$9f93a3fdf2490572)(paAttributes, values);
                p.setProperty(pa);
            }
        } else {
            // PropertyMatrix.
            let matrixNodes = element.getElementsByTagName((0, $597d59a3d37b5b3f$export$a5a2be813176eb0e).tagName);
            if (matrixNodes.length > 0) {
                if (matrixNodes.length != 1) throw new Error("Expecting 1 " + (0, $597d59a3d37b5b3f$export$a5a2be813176eb0e).tagName + " but finding " + matrixNodes.length + "!");
                let inputString = (0, $057fa7562ec736a9$export$433c819efd6b1ea5)(matrixNodes[0]);
                let values = (0, $93b71ab6968650c1$export$8cfbaad830aa9e0a)(inputString.split(/\s+/));
                let pmAttributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(matrixNodes[0]);
                let pm = new (0, $597d59a3d37b5b3f$export$a5a2be813176eb0e)(pmAttributes, values);
                p.setProperty(pm);
            } else throw new Error("Expecting " + (0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).tagName + ", " + (0, $597d59a3d37b5b3f$export$9f93a3fdf2490572).tagName + " or " + (0, $597d59a3d37b5b3f$export$a5a2be813176eb0e).tagName + " but finding none!");
        }
    }
}
function $cb5398d795eb2774$export$cbd171726dbc631c(p, element) {
    // PropertyScalarString.
    let scalarNodes = element.getElementsByTagName((0, $597d59a3d37b5b3f$export$eb6936faa5f138bb).tagName);
    if (scalarNodes.length > 0) {
        if (scalarNodes.length != 1) throw new Error("Expecting 1 " + (0, $597d59a3d37b5b3f$export$eb6936faa5f138bb).tagName + " but finding " + scalarNodes.length + "!");
        let inputString = (0, $057fa7562ec736a9$export$433c819efd6b1ea5)(scalarNodes[0]);
        let psAttributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(scalarNodes[0]);
        // Add PropertyScalarNumber.
        let ps = new (0, $597d59a3d37b5b3f$export$eb6936faa5f138bb)(psAttributes, inputString);
        p.setProperty(ps);
    } else console.log("Expecting " + (0, $597d59a3d37b5b3f$export$eb6936faa5f138bb).tagName + " but finding none!");
}


let $5a83eb614eac3a1c$var$mk_url = "https://github.com/MESMER-kinetics";
/**
 * MXG.
 */ let $5a83eb614eac3a1c$var$mxg_url = $5a83eb614eac3a1c$var$mk_url + "/mxg";
let $5a83eb614eac3a1c$var$mxg_a = document.createElement('a');
$5a83eb614eac3a1c$var$mxg_a.href = $5a83eb614eac3a1c$var$mxg_url;
$5a83eb614eac3a1c$var$mxg_a.textContent = $5a83eb614eac3a1c$var$mxg_url;
/**
 * Example data.
 */ let $5a83eb614eac3a1c$var$mxgDataExamples_url = $5a83eb614eac3a1c$var$mxg_url + "/tree/main/data/examples";
let $5a83eb614eac3a1c$var$mxgDataExamples_a = document.createElement('a');
$5a83eb614eac3a1c$var$mxgDataExamples_a.href = $5a83eb614eac3a1c$var$mxgDataExamples_url;
$5a83eb614eac3a1c$var$mxgDataExamples_a.textContent = $5a83eb614eac3a1c$var$mxgDataExamples_url;
/**
 * MESMER.
 */ let $5a83eb614eac3a1c$var$mesmer_url = $5a83eb614eac3a1c$var$mk_url + "/MESMER-code";
let $5a83eb614eac3a1c$var$mesmer_a = document.createElement('a');
$5a83eb614eac3a1c$var$mesmer_a.href = $5a83eb614eac3a1c$var$mesmer_url;
$5a83eb614eac3a1c$var$mesmer_a.textContent = $5a83eb614eac3a1c$var$mesmer_url;
/**
 * EPSRC.
 */ let $5a83eb614eac3a1c$var$epsrc_url = "https://epsrc.ukri.org/";
let $5a83eb614eac3a1c$var$epsrc_a = document.createElement('a');
$5a83eb614eac3a1c$var$epsrc_a.href = $5a83eb614eac3a1c$var$epsrc_url;
$5a83eb614eac3a1c$var$epsrc_a.textContent = "The UK Engineering and Physical Sciences Research Council (EPSRC)";
/**
 * University of Leeds
 */ let $5a83eb614eac3a1c$var$uol_url = "https://www.leeds.ac.uk/";
let $5a83eb614eac3a1c$var$uol_a = document.createElement('a');
$5a83eb614eac3a1c$var$uol_a.href = $5a83eb614eac3a1c$var$uol_url;
$5a83eb614eac3a1c$var$uol_a.textContent = "The University of Leeds";
/**
 * 3DMol.
 */ let $5a83eb614eac3a1c$var$t3Dmol_url = "https://github.com/3dmol/3Dmol.js";
let $5a83eb614eac3a1c$var$t3Dmol_a = document.createElement('a');
$5a83eb614eac3a1c$var$t3Dmol_a.href = $5a83eb614eac3a1c$var$t3Dmol_url;
$5a83eb614eac3a1c$var$t3Dmol_a.textContent = $5a83eb614eac3a1c$var$t3Dmol_url;
let $5a83eb614eac3a1c$var$t3Dmol_citation_url = "http://doi.org/10.1093/bioinformatics/btu829";
let $5a83eb614eac3a1c$var$t3Dmol_citation_a = document.createElement('a');
$5a83eb614eac3a1c$var$t3Dmol_citation_a.href = $5a83eb614eac3a1c$var$t3Dmol_citation_url;
$5a83eb614eac3a1c$var$t3Dmol_citation_a.textContent = "doi:10.1093/bioinformatics/btu829";
/**
 * Big.js.
 */ let $5a83eb614eac3a1c$var$bigjs_url = "https://mikemcl.github.io/big.js/";
let $5a83eb614eac3a1c$var$bigjs_a = document.createElement('a');
$5a83eb614eac3a1c$var$bigjs_a.href = $5a83eb614eac3a1c$var$bigjs_url;
$5a83eb614eac3a1c$var$bigjs_a.textContent = $5a83eb614eac3a1c$var$bigjs_url;
/**
 * Get a div with details about MXG.
 */ function $5a83eb614eac3a1c$var$about(w) {
    if (w == null) return;
    w.document.title = "About MXG";
    // Welcome Text.
    let wDiv = document.createElement('div');
    w.document.body.appendChild(wDiv);
    // p1.
    let p1 = w.document.createElement('p');
    wDiv.appendChild(p1);
    p1.appendChild(w.document.createTextNode('MXG is a free and open source program to assist in creating, editing and \
        visualising MESMER XML data. MXG is released via the MESMER-kinetics GitHub repository: '));
    p1.appendChild($5a83eb614eac3a1c$var$mxg_a);
    p1.appendChild(w.document.createTextNode('. Details of MESMER - the Master Equation Solver for Multi Energy-well Reactions \
        can be found at: '));
    p1.appendChild($5a83eb614eac3a1c$var$mesmer_a);
    p1.appendChild(w.document.createTextNode('.'));
    // p2.
    let p2 = document.createElement('p');
    wDiv.appendChild(p2);
    p2.appendChild(w.document.createTextNode('MXG development has been led by a team based at '));
    p2.appendChild($5a83eb614eac3a1c$var$uol_a);
    p2.appendChild(w.document.createTextNode(' and funded by '));
    p2.appendChild($5a83eb614eac3a1c$var$epsrc_a);
    p2.appendChild(w.document.createTextNode('. Please contribute to MXG development by reporting issues on GitHub.'));
    // p3.
    let p3 = w.document.createElement('p');
    wDiv.appendChild(p3);
    p3.appendChild(w.document.createTextNode('MXG should work with the latest Firefox, Chrome, Edge or Safari Web browsers. \
        It can be used offline after installation as a Progressive Web App (PWA). The process of installing a PWA varies by \
        Web browser and device. For guidance please see the MXG development repository README.'));
    // p4.
    let p4 = w.document.createElement('p');
    wDiv.appendChild(p4);
    p4.appendChild(w.document.createTextNode('The Menu contains 7 buttons: \
        The About button displays the about text in a new Window. \
        The Load MESMER File button is for loading a MESMER XML data file. \
        The Load Into Library button is for adding molecule data to a molecule library. \
        The Clear Library button clears the molecule library. \
        The Load Defaults button is for loading default values from a file. \
        The Save button is for saving a new MESMER XML data file. \
        The Restart button reinitialises the interface.'));
    /* 
        The file will contain no comments, and numbers are output in a particular format (decimals - where numbers with more \
        than 8 digits are output in scientific notation). The file should reflect what is specified via the interface.'));
        Between the Load and Save buttons are buttons to increase or decrease the fontsize and to change between a light \
        and dark theme. In fontsize buttons either increase or decrease the fontsize of text elements including those in \
        the reaction diagram and species plots.'));*/ // p5.
    let p5 = document.createElement('p');
    wDiv.appendChild(p5);
    p5.appendChild(w.document.createTextNode('A MESMER XML input data file normally has a "me:mesmer" element containing: \
        "me:title", "moleculeList", "reactionList", "me:conditions", "me:modelParameters", and "me:control" elements. \
        A MESMER XML output data usually also has "me:metadataList" and "me:analysis" elements in the "me:mesmer" \
        element, and additional output located in the "moleculeList" and "reactionList" elements. \
        The main interface below the Menu presents what is in a loaded MESMER file, or what will be in saved to a MESMER file. \
        It also presents visualisations of the data which can be output in PNG or CSV formats. \
        The "me:title" value is presented in an input after a label. The input allows for the default value, \
        "Example_title" to be changed. Other details are presented via buttons with descriptive names and a triangular \
        symbol: \
        A triangle orientated with a point down: ' + (0, $341c675b659c6d43$export$38aa1ab9c2935930) + ' can be actioned to reveal details. \
        A triangle orientated with a point up: ' + (0, $341c675b659c6d43$export$e5e81646ee331a9e) + ' can be actioned to hide those details.'));
    // p6.
    let p6 = w.document.createElement('p');
    wDiv.appendChild(p6);
    p6.textContent = 'The Reaction Diagram button shows/hides a reaction well diagram which is redrawn if molecule "me:ZPE" \
        property values are changed. The diagram can be opened in a new Window and saved as an image in PNG format file.';
    // p7.
    let p7 = w.document.createElement('p');
    wDiv.appendChild(p7);
    p7.textContent = 'MXG uses 3DMol.js under a BSD-3-Clause licence to visualise molecules with coordinates. For details \
        of 3DMol.js please see the GitHub repository: ';
    p7.appendChild($5a83eb614eac3a1c$var$t3Dmol_a);
    p7.appendChild(w.document.createTextNode('. If you use the 3DMol.js visualisations, please cite: Nicholas Rego and \
        David Koes 3Dmol.js: molecular visualization with WebGL Bioinformatics (2015) 31 (8): 1322-1324 '));
    p7.appendChild($5a83eb614eac3a1c$var$t3Dmol_citation_a);
    p7.appendChild(w.document.createTextNode('.'));
    // p8.
    let p8 = w.document.createElement('p');
    wDiv.appendChild(p8);
    p8.textContent = 'MXG uses Big.js under an MIT licence to handle numbers. For details of Big.js please see the GitHub \
        repository: ';
    p8.appendChild($5a83eb614eac3a1c$var$bigjs_a);
    p8.appendChild(w.document.createTextNode('.'));
}
function $5a83eb614eac3a1c$export$c9a19c59161f09a0() {
    // Create Menu.
    let menuDiv = document.getElementById((0, $dc4240e6100248ae$export$32f4a893b4a151db));
    menuDiv.style.display = 'flex';
    menuDiv.style.justifyContent = 'center';
    menuDiv.style.margin = '5px';
    menuDiv.style.padding = '5px';
    menuDiv.style.border = '1px solid black';
    menuDiv.style.backgroundColor = 'lightgrey';
    // Add About MXG button.
    let s_About = 'About';
    let ab = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(s_About, (0, $dc4240e6100248ae$export$39722580448f5a99)(s_About), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    menuDiv.appendChild(ab);
    ab.addEventListener('click', async (event)=>{
        let aw = window.open("", "", "width=600,height=400");
        $5a83eb614eac3a1c$var$about(aw);
    });
    // Add Load MESMER File button.
    let s_Load_MESMER_File = 'Load MESMER File';
    let lb = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(s_Load_MESMER_File, (0, $dc4240e6100248ae$export$39722580448f5a99)(s_Load_MESMER_File), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    lb.addEventListener('click', (event)=>{
        // Alert the user that any changes will be lost unless saved, giving the option to save.
        if (confirm('Any unsaved changes will be lost. Select OK to continue loading or Cancel to cancel.')) (0, $dc4240e6100248ae$export$11e63f7b0f3d9900)();
        else return;
    });
    menuDiv.appendChild(lb);
    // Add Load Into Library button.
    let s_Load_Into_Library = 'Load Into Library';
    let llmb = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(s_Load_Into_Library, (0, $dc4240e6100248ae$export$39722580448f5a99)(s_Load_Into_Library), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    menuDiv.appendChild(llmb);
    let lms = new (0, $cb5398d795eb2774$export$7587e661a05e5158)();
    llmb.addEventListener('click', async (event)=>{
        let ms = await lms.readFile();
        // Add the molecules to the libmols map.
        if ((0, $dc4240e6100248ae$export$7c97c73a2c729cf9) == undefined) (0, $dc4240e6100248ae$export$4802e08cda112391)(new Map());
        ms.forEach((v, k)=>{
            (0, $dc4240e6100248ae$export$ac55d333e780178c)(false, v, (0, $dc4240e6100248ae$export$7c97c73a2c729cf9));
        });
    });
    // Add Clear Library button.
    let s_Clear_Library = 'Clear Library';
    let clmb = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(s_Clear_Library, (0, $dc4240e6100248ae$export$39722580448f5a99)(s_Clear_Library), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    menuDiv.appendChild(clmb);
    clmb.addEventListener('click', async (event)=>{
        (0, $dc4240e6100248ae$export$4802e08cda112391)(new Map());
    });
    // Add Load Defaults button.
    let s_Load_Defaults = 'Load Defaults';
    let ldb = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(s_Load_Defaults, (0, $dc4240e6100248ae$export$39722580448f5a99)(s_Load_Defaults), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    ldb.addEventListener('click', (event)=>{
        (0, $dc4240e6100248ae$export$ebe90cb607ad99e).readFile();
    });
    menuDiv.appendChild(ldb);
    // Add Save File button.
    let s_Save = 'Save';
    let saveButton = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(s_Save, (0, $dc4240e6100248ae$export$39722580448f5a99)(s_Save), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    saveButton.addEventListener('click', (0, $dc4240e6100248ae$export$cffb3d6135ce44ec));
    menuDiv.appendChild(saveButton);
    // Add Restart button.
    let s_Restart = 'Restart';
    let sab = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(s_Restart, (0, $dc4240e6100248ae$export$39722580448f5a99)(s_Restart), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    menuDiv.appendChild(sab);
    sab.addEventListener('click', (event)=>{
        // Alert the user that any changes will be lost unless saved, giving the option to save.
        if (confirm('Any unsaved changes will be lost. Select OK to continue loading or Cancel to cancel.')) (0, $dc4240e6100248ae$export$2f77af1e417942e1)();
        else return;
    });
    /* Add style/theme option buttons.
    // Add Increase Fontsize button.
    let s_Increase_Fontsize: string = 'Increase Fontsize';
    let increaseFontSizeButton = createButton(s_Increase_Fontsize, addID(s_Increase_Fontsize), boundary1);
    increaseFontSizeButton.addEventListener('click', () => {
        let fontSize = parseInt(getComputedStyle(document.body).fontSize);
        document.body.style.fontSize = (fontSize + 1) + 'px';
        if (rdWindow != null) {
            //let fontSize = parseInt(getComputedStyle(popWindow.document.body).fontSize);
            rdWindow.document.body.style.fontSize = (fontSize + 1) + 'px';
        }
        redrawReactionsDiagram();
        redrawScatterPlots();
    });
    menuDiv.appendChild(increaseFontSizeButton);
    // Add Decrease Fontsize button.
    let s_Decrease_Fontsize: string = 'Decrease Fontsize';
    let decreaseFontSizeButton = createButton(s_Decrease_Fontsize, addID(s_Decrease_Fontsize), boundary1);
    decreaseFontSizeButton.addEventListener('click', () => {
        let fontSize = parseInt(getComputedStyle(document.body).fontSize);
        document.body.style.fontSize = (fontSize - 1) + 'px';
        if (rdWindow != null) {
            //let fontSize = parseInt(getComputedStyle(popWindow.document.body).fontSize);
            rdWindow.document.body.style.fontSize = (fontSize - 1) + 'px';
        }
        redrawReactionsDiagram();
        redrawScatterPlots();
    });
    menuDiv.appendChild(decreaseFontSizeButton);
    // Add Light/Dark Mode button.
    let s_Light_Dark_Mode = 'Light/Dark Mode';
    let lightDarkModeButton = createButton(s_Light_Dark_Mode, addID(s_Light_Dark_Mode), boundary1);
    lightDarkModeButton.addEventListener('click', () => {
        dark = !dark;
        //localStorage.setItem('darkMode', dark ? 'true' : 'false');
        if (dark) {
            document.body.className = 'dark-mode';
        } else {
            document.body.className = 'light-mode';
        }
        redrawReactionsDiagram();
    });
    menuDiv.appendChild(lightDarkModeButton);
    */ return menuDiv;
}














const $0ff23b3a70668dbf$var$s_graph = "graph";
// Scatterplot font.
let $0ff23b3a70668dbf$var$sp_font = "2em SensSerif";
//For storing any scatter plots.
let $0ff23b3a70668dbf$var$scatterPlots;
$0ff23b3a70668dbf$var$scatterPlots = [];
function $0ff23b3a70668dbf$export$56a93e1041dcdd6d(xml) {
    console.log((0, $012df152aa25e440$export$c4c153dc94cc96b4).tagName);
    let aDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)((0, $012df152aa25e440$export$c4c153dc94cc96b4).tagName, 0);
    let aDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(aDivID, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    let xml_as = xml.getElementsByTagName((0, $012df152aa25e440$export$c4c153dc94cc96b4).tagName);
    if (xml_as.length > 0) {
        if (xml_as.length > 1) throw new Error("More than one Analysis element.");
        let a = new (0, $012df152aa25e440$export$c4c153dc94cc96b4)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_as[0]));
        (0, $dc4240e6100248ae$export$3bb92be1f57fd129).setAnalysis(a);
        // "me:description".
        let xml_d = xml_as[0].getElementsByTagName((0, $ccef02370f58a770$export$393edc798c47379d).tagName);
        if (xml_d.length > 0) {
            if (xml_d.length == 1) {
                let s = (0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_d[0])?.nodeValue ?? "";
                let d = new (0, $ccef02370f58a770$export$393edc798c47379d)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_d[0]), s);
                let dDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)((0, $dc4240e6100248ae$export$bea69a603fae01a6)(aDivID, (0, $ccef02370f58a770$export$393edc798c47379d).tagName), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                aDiv.appendChild(dDiv);
                dDiv.appendChild((0, $341c675b659c6d43$export$f2839682b8c07f35)(d.tagName + " " + s, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b)));
                a.setDescription(d);
            } else throw new Error("More than one Description element.");
        }
        // "me:eigenvalueList".
        $0ff23b3a70668dbf$var$EigenvalueAnalysis(xml_as, aDivID, aDiv, a);
        // "me:populationList".
        $0ff23b3a70668dbf$var$PopulationEvolution(xml_as, aDivID, aDiv, a);
        // "me:avEnergyList".
        $0ff23b3a70668dbf$var$AverageEnergyEvolution(xml_as, aDivID, aDiv, "me:avEnergyList");
        // me:rateList.
        let xml_rl = xml_as[0].getElementsByTagName((0, $012df152aa25e440$export$9cdf0fcb7c05190f).tagName);
        // Create a new collapsible div for the RateLists.
        let rlDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(aDivID, (0, $012df152aa25e440$export$9cdf0fcb7c05190f).tagName);
        let rlDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(rlDivID, (0, $dc4240e6100248ae$export$39c84188a71202f7));
        let rlcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(rlDivID, aDiv, null, rlDiv, (0, $012df152aa25e440$export$9cdf0fcb7c05190f).tagName + "s", (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        if (xml_rl.length > 0) for(let i = 0; i < xml_rl.length; i++){
            let rle_attributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_rl[i]);
            let rle_attributesKeys = Array.from(rle_attributes.keys());
            let rle_values = [];
            for(let j = 0; j < rle_attributesKeys.length; j++)rle_values.push(rle_attributes.get(rle_attributesKeys[j]));
            let rl = new (0, $012df152aa25e440$export$9cdf0fcb7c05190f)(rle_attributes);
            let t = rle_attributes.get("T");
            rl.setTemperature(new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(t));
            let conc = rle_attributes.get("conc");
            rl.setConcentration(new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(conc));
            let bathGas = rle_attributes.get("bathGas");
            rl.setBathGas(bathGas);
            let units = rle_attributes.get("units");
            rl.setUnits(units);
            a.addRateList(rl);
            //let labelText: string = rl.tagName + " " + i.toString() + " " + mapToString(rle_attributes);
            let labelText = rl.tagName + " " + i.toString() + " T(" + t + "(K)) conc(" + rle_attributes.get("conc") + "(molec/cm3)) bathGas(" + bathGas + ")";
            // Create a new collapsible div for the RateList.
            let rleDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(rlDivID, i.toString());
            let rleDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(rleDivID);
            rlDiv.appendChild(rleDiv);
            let rlecDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(rleDivID, rlDiv, null, rleDiv, labelText, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$b1ddbf2a116c10ee));
            let keys;
            let values;
            // "me:firstOrderLoss".
            // Create a new collapsible div for the FirstOrderLosses.
            let folDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(rleDivID, (0, $012df152aa25e440$export$2450ca15ad4d2ed0).tagName);
            let folDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(folDivID);
            rleDiv.appendChild(folDiv);
            let folcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(folDivID, rleDiv, null, folDiv, (0, $012df152aa25e440$export$2450ca15ad4d2ed0).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            let xml_fol = xml_rl[i].getElementsByTagName((0, $012df152aa25e440$export$2450ca15ad4d2ed0).tagName);
            let folTable = (0, $341c675b659c6d43$export$33bbb3ec7652e187)(folDivID, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
            let folTableDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)((0, $dc4240e6100248ae$export$bea69a603fae01a6)(folDivID, (0, $dc4240e6100248ae$export$7a850709da5c4f5b)), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            folTableDiv.appendChild(folTable);
            folDiv.appendChild(folTableDiv);
            for(let j = 0; j < xml_fol.length; j++){
                let fol_attributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_fol[j]);
                if (j == 0) {
                    // header
                    keys = Array.from(fol_attributes.keys());
                    /*
                        let keys2 = Array.from(fol_attributes.keys());
                        // In keys2, replace "ref" to be "reactant/product".
                        keys2 = keys2.map((key) => {
                            if (key == "ref") {
                                return "reactant/product";
                            } else {
                                return key;
                            }
                        });
                        keys2.push("kloss/" + units);
                        addTableHeaderRow(folTable, keys2);
                        */ keys.push("kloss/" + units);
                    (0, $341c675b659c6d43$export$6c1065e21382520d)(folTable, keys);
                }
                values = Array.from(fol_attributes.values());
                // Check lengths.
                //if (keys!.length != values!.length) {
                if (keys.length - 1 != values.length) console.error("FirstOrderLoss values0!.length != values!.length");
                let s = ((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_fol[j])?.nodeValue ?? "").trim();
                let fol = new (0, $012df152aa25e440$export$2450ca15ad4d2ed0)(fol_attributes, new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(s));
                rl.addFirstOrderLoss(fol);
                for(let k = 0; k < keys.length; k++)// Check reference.
                if (keys[k] == values[k]) values.push(fol_attributes.get(values[k]));
                else console.log("FirstOrderLoss values0![k] != values![k]");
                values.push(s);
                (0, $341c675b659c6d43$export$67d0e2fae00985e1)(folTable, values);
            }
            // Insert a save as csv button.
            (0, $dc4240e6100248ae$export$dd526fb3a2a9c049)(()=>(0, $dc4240e6100248ae$export$1209ee63cd9aa290)(folTable), folDiv, folTableDiv, "First Order Losses", (0, $dc4240e6100248ae$export$39c84188a71202f7));
            // "me:firstOrderRate".
            // Create a new collapsible div for the FirstOrderRates.
            let forDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(rleDivID, (0, $012df152aa25e440$export$984142e8329468e6).tagName);
            let forDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(forDivID);
            rleDiv.appendChild(forDiv);
            let forcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(forDivID, rleDiv, null, forDiv, (0, $012df152aa25e440$export$984142e8329468e6).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            let xml_for = xml_rl[i].getElementsByTagName((0, $012df152aa25e440$export$984142e8329468e6).tagName);
            let forTable = (0, $341c675b659c6d43$export$33bbb3ec7652e187)(forDivID, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
            let forTableDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)((0, $dc4240e6100248ae$export$bea69a603fae01a6)(forDivID, (0, $dc4240e6100248ae$export$7a850709da5c4f5b)), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            forTableDiv.appendChild(forTable);
            forDiv.appendChild(forTableDiv);
            for(let j = 0; j < xml_for.length; j++){
                let for_attributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_for[j]);
                //let fromRef: string = for_attributes.get("fromRef") as string;
                //let toRef: string = for_attributes.get("toRef") as string;
                if (j == 0) {
                    // header
                    keys = Array.from(for_attributes.keys());
                    let keys2 = Array.from(for_attributes.keys());
                    // In keys2, replace "fromRef" to be "reactant" and "toRef" to be "product".
                    keys2 = keys2.map((key)=>{
                        if (key == "fromRef") return "reactant";
                        else if (key == "toRef") return "product";
                        else return key;
                    });
                    keys2.push("k/" + units);
                    (0, $341c675b659c6d43$export$6c1065e21382520d)(forTable, keys2);
                }
                values = Array.from(for_attributes.values());
                // Check lengths.
                if (keys.length != values.length) console.error("FirstOrderLoss values0!.length != values!.length");
                let s = ((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_for[j])?.nodeValue ?? "").trim();
                let forate = new (0, $012df152aa25e440$export$984142e8329468e6)(for_attributes, new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(s));
                rl.addFirstOrderRate(forate);
                for(let k = 0; k < keys.length; k++)// Check reference.
                if (keys[k] == values[k]) values.push(for_attributes.get(values[k]));
                else console.log("FirstOrderRate values0![k] != values![k]");
                values.push(s);
                (0, $341c675b659c6d43$export$67d0e2fae00985e1)(forTable, values);
            }
            // Insert a save as csv button.
            (0, $dc4240e6100248ae$export$dd526fb3a2a9c049)(()=>(0, $dc4240e6100248ae$export$1209ee63cd9aa290)(forTable), forDiv, forTableDiv, "First Order Rates", (0, $dc4240e6100248ae$export$39c84188a71202f7));
            // "me:secondOrderRate".
            // Create a new collapsible div for the SecondOrderRates.
            let sorDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(rleDivID, (0, $012df152aa25e440$export$f449a9e759d0ecf8).tagName);
            let sorDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(sorDivID);
            rleDiv.appendChild(sorDiv);
            let sorcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(sorDivID, rleDiv, null, sorDiv, (0, $012df152aa25e440$export$f449a9e759d0ecf8).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            let xml_sor = xml_rl[i].getElementsByTagName((0, $012df152aa25e440$export$f449a9e759d0ecf8).tagName);
            let sorTable = (0, $341c675b659c6d43$export$33bbb3ec7652e187)(sorDivID, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
            let sorTableDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)((0, $dc4240e6100248ae$export$bea69a603fae01a6)(sorDivID, (0, $dc4240e6100248ae$export$7a850709da5c4f5b)), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            sorTableDiv.appendChild(sorTable);
            sorDiv.appendChild(sorTableDiv);
            for(let j = 0; j < xml_sor.length; j++){
                let sor_attributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_sor[j]);
                //let fromRef: string = sor_attributes.get("fromRef") as string;
                //let toRef: string = sor_attributes.get("toRef") as string;
                if (j == 0) {
                    // header
                    keys = Array.from(sor_attributes.keys());
                    let keys2 = Array.from(sor_attributes.keys());
                    // In keys2, replace "fromRef" to be "reactant" and "toRef" to be "product".
                    keys2 = keys2.map((key)=>{
                        if (key == "fromRef") return "reactant";
                        else if (key == "toRef") return "product";
                        else return key;
                    });
                    keys2.push("k/cm3molecule-1" + units);
                    (0, $341c675b659c6d43$export$6c1065e21382520d)(sorTable, keys2);
                }
                values = Array.from(sor_attributes.values());
                // Check lengths.
                if (keys.length != values.length) console.error("SecondOrderRate values0!.length != values!.length");
                let s = ((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_sor[j])?.nodeValue ?? "").trim();
                let sorate = new (0, $012df152aa25e440$export$f449a9e759d0ecf8)(sor_attributes, new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(s));
                rl.addSecondOrderRate(sorate);
                for(let k = 0; k < keys.length; k++)// Check reference.
                if (keys[k] == values[k]) values.push(sor_attributes.get(values[k]));
                else console.log("SecondOrderRate values0![k] != values![k]");
                values.push(s);
                (0, $341c675b659c6d43$export$67d0e2fae00985e1)(sorTable, values);
            }
            // Insert a save as csv button.
            (0, $dc4240e6100248ae$export$dd526fb3a2a9c049)(()=>(0, $dc4240e6100248ae$export$1209ee63cd9aa290)(sorTable), sorDiv, sorTableDiv, "Second Order Rates", (0, $dc4240e6100248ae$export$39c84188a71202f7));
        }
    }
    return aDiv;
}
// "me:eigenvalueList".
function $0ff23b3a70668dbf$var$EigenvalueAnalysis(xml_as, aDivID, aDiv, a) {
    // Create a new collapsible div for the EigenvalueLists.
    let elDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(aDivID, (0, $012df152aa25e440$export$f681829d43cbf50e).tagName);
    let elDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(elDivID, (0, $dc4240e6100248ae$export$39c84188a71202f7));
    let elcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(elDivID, aDiv, null, elDiv, (0, $012df152aa25e440$export$f681829d43cbf50e).tagName + "s", (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
    let xml_el = xml_as[0].getElementsByTagName((0, $012df152aa25e440$export$f681829d43cbf50e).tagName);
    if (xml_el.length > 0) for(let i = 0; i < xml_el.length; i++){
        let el_attributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_el[i]);
        let el = new (0, $012df152aa25e440$export$f681829d43cbf50e)(el_attributes);
        let labelText = el.tagName + " " + i.toString() + " " + (0, $93b71ab6968650c1$export$dc22ec7f8e0b9ac)(el_attributes);
        // Create a new collapsible div for the EigenvalueList.
        let eDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(elDiv.id, i.toString());
        let eDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(elDivID, (0, $dc4240e6100248ae$export$39c84188a71202f7));
        let ecDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(eDivID, elDiv, null, eDiv, labelText, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$b1ddbf2a116c10ee));
        //eDiv.appendChild(createLabel(labelText, boundary1));
        a.addEigenvalueList(el);
        // "me:eigenvalue".
        let evs = [];
        let xml_ei = xml_el[i].getElementsByTagName((0, $012df152aa25e440$export$877cee35188549c7).tagName);
        if (xml_ei.length > 0) for(let j = 0; j < xml_ei.length; j++){
            let ev = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_ei[j])?.nodeValue);
            evs.push(ev);
            el.addEigenvalue(new (0, $012df152aa25e440$export$877cee35188549c7)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_ei[j]), ev));
        }
        eDiv.appendChild((0, $341c675b659c6d43$export$f2839682b8c07f35)((0, $93b71ab6968650c1$export$4323cc4280d5be7)(evs, ", "), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b)));
    }
}
// "me:populationList".
function $0ff23b3a70668dbf$var$PopulationEvolution(xml_as, aDivID, aDiv, a) {
    // Create a new collapsible div for the PopulationLists.
    let plDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(aDivID, (0, $012df152aa25e440$export$8f9a53be9a409418).tagName);
    let plDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(plDivID, (0, $dc4240e6100248ae$export$39c84188a71202f7));
    let plcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(plDivID, aDiv, null, plDiv, (0, $012df152aa25e440$export$8f9a53be9a409418).tagName + "s", (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
    let xml_pl = xml_as[0].getElementsByTagName((0, $012df152aa25e440$export$8f9a53be9a409418).tagName);
    if (xml_pl.length > 0) // Create a new collapsible div for the PopulationList.
    for(let i = 0; i < xml_pl.length; i++){
        let pl_attributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_pl[i]);
        let pl = new (0, $012df152aa25e440$export$8f9a53be9a409418)(pl_attributes);
        let labelText = pl.tagName + " " + i.toString() + " " + (0, $93b71ab6968650c1$export$dc22ec7f8e0b9ac)(pl_attributes);
        let plDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(aDiv.id, (0, $012df152aa25e440$export$8f9a53be9a409418).tagName, i.toString());
        // Create a new collapsible div for the EigenvalueList.
        let pDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(plDivID, i.toString());
        let pDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(plDivID, (0, $dc4240e6100248ae$export$39c84188a71202f7));
        let pcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(pDivID, plDiv, null, pDiv, labelText, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$b1ddbf2a116c10ee));
        a.addPopulationList(pl);
        // "me:population".
        //let lt_ref_pop : Map<Big, Map<string, Big>> = new Map(); 
        // // Change to calculate the log of the time when creating the plots.
        let t_ref_pop = new Map();
        let refs = [];
        refs.push("time");
        let xml_pn = xml_pl[i].getElementsByTagName((0, $012df152aa25e440$export$9764fff2991ff94a).tagName);
        if (xml_pn.length > 0) for(let j = 0; j < xml_pn.length; j++){
            let pn_attributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_pn[j]);
            let population = new (0, $012df152aa25e440$export$9764fff2991ff94a)(pn_attributes, []);
            pl.addPopulation(population);
            let t = pn_attributes.get("time") != undefined ? new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(pn_attributes.get("time")) : (0, $dc4240e6100248ae$export$a94c859b6fc3ec52);
            //let lt: Big = pn_attributes.get("logTime") != undefined ? new Big(pn_attributes.get("logTime") as string) : big0; 
            let ref_pop = new Map();
            //lt_ref_pop.set(lt, ref_pop);
            t_ref_pop.set(t, ref_pop);
            let xml_pop = xml_pn[j].getElementsByTagName((0, $012df152aa25e440$export$910c21a5819ebc2e).tagName);
            if (xml_pop.length > 0) for(let k = 0; k < xml_pop.length; k++){
                let pop_attributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_pop[k]);
                let ref = pop_attributes.get("ref");
                if (j == 0) refs.push(ref);
                let p = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_pop[k])?.nodeValue);
                let pop = new (0, $012df152aa25e440$export$910c21a5819ebc2e)(pop_attributes, p);
                population.addPop(pop);
                ref_pop.set(ref, p);
            }
        }
        // Create graph.
        let graphdetails = new (0, $dc4240e6100248ae$export$855b799c430f2201)();
        graphdetails.yAxisLabel = "fractional population";
        $0ff23b3a70668dbf$var$createGraph(pDiv, pDivID, t_ref_pop, labelText, graphdetails);
        // Create Table.
        let tableDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)((0, $dc4240e6100248ae$export$bea69a603fae01a6)(pDivID, (0, $dc4240e6100248ae$export$7a850709da5c4f5b)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
        pDiv.appendChild(tableDiv);
        let tab = (0, $341c675b659c6d43$export$33bbb3ec7652e187)((0, $dc4240e6100248ae$export$bea69a603fae01a6)(plDivID, (0, $dc4240e6100248ae$export$7a850709da5c4f5b)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
        (0, $341c675b659c6d43$export$6c1065e21382520d)(tab, refs);
        t_ref_pop.forEach((ref_pop, t)=>{
            let row = [];
            row.push(t.toString());
            ref_pop.forEach((p, ref)=>{
                row.push(p.toString());
            });
            (0, $341c675b659c6d43$export$67d0e2fae00985e1)(tab, row);
        });
        tableDiv.appendChild(tab);
        // Insert a save as csv button.
        (0, $dc4240e6100248ae$export$dd526fb3a2a9c049)(()=>(0, $dc4240e6100248ae$export$1209ee63cd9aa290)(tab), pDiv, tableDiv, labelText, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    }
}
// "me:avEnergyList".
function $0ff23b3a70668dbf$var$AverageEnergyEvolution(xml_as, aDivID, aDiv, tagName) {
    // Create a new collapsible div for the PopulationLists.
    let plDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(aDivID, tagName);
    let plDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(plDivID, (0, $dc4240e6100248ae$export$39c84188a71202f7));
    let plcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(plDivID, aDiv, null, plDiv, tagName + "s", (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
    let xml_pl = xml_as[0].getElementsByTagName(tagName);
    let units = "";
    if (xml_pl.length > 0) // Create a new collapsible div for the PopulationList.
    for(let i = 0; i < xml_pl.length; i++){
        let pl_attributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_pl[i]);
        units = pl_attributes.get("energyUnits");
        let pl = new (0, $012df152aa25e440$export$8f9a53be9a409418)(pl_attributes);
        let labelText = tagName + " " + i.toString() + " " + (0, $93b71ab6968650c1$export$dc22ec7f8e0b9ac)(pl_attributes);
        let plDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(aDiv.id, tagName, i.toString());
        let pDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(plDivID, i.toString());
        let pDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(plDivID, (0, $dc4240e6100248ae$export$39c84188a71202f7));
        let pcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(pDivID, plDiv, null, pDiv, labelText, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$b1ddbf2a116c10ee));
        // "me:avEnergy".
        // Change to calculate the log of the time when creating the plots.
        let t_ref_pop = new Map();
        let xml_pn = xml_pl[i].getElementsByTagName("me:avEnergy");
        if (xml_pn.length > 0) {
            // SHR May 2025: The following temporary Map is based on type string because Map.has(key) fails for type Big.
            let tmp_pop = new Map();
            for(let j = 0; j < xml_pn.length; j++){
                let pn_attributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_pn[j]);
                let species = pn_attributes.get("ref");
                let xml_pop = xml_pn[j].getElementsByTagName("me:Av");
                if (xml_pop.length > 0) for(let k = 0; k < xml_pop.length; k++){
                    let pop_attributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_pop[k]);
                    let time = pop_attributes.get("time");
                    let t = pop_attributes.get("time") != undefined ? new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(pop_attributes.get("time")) : (0, $dc4240e6100248ae$export$a94c859b6fc3ec52);
                    let energy = xml_pop[k].textContent;
                    if (tmp_pop.has(time)) tmp_pop.get(time)?.set(species, (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(energy));
                    else {
                        let ref_pop = new Map();
                        ref_pop.set(species, (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(energy));
                        tmp_pop.set(time, ref_pop);
                    }
                }
            }
            if (tmp_pop.size > 0) for (let key of tmp_pop.keys())t_ref_pop.set((0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(key), tmp_pop.get(key));
        }
        // Create graph.
        let graphdetails = new (0, $dc4240e6100248ae$export$855b799c430f2201)();
        graphdetails.yAxisLabel = "Average Energy";
        graphdetails.units = units;
        $0ff23b3a70668dbf$var$createGraph(pDiv, pDivID, t_ref_pop, labelText, graphdetails);
    }
}
// Create graph.
function $0ff23b3a70668dbf$var$createGraph(pDiv, pDivID, t_ref_pop, labelText, graphdetails) {
    let graphDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)((0, $dc4240e6100248ae$export$bea69a603fae01a6)(pDivID, $0ff23b3a70668dbf$var$s_graph), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    pDiv.appendChild(graphDiv);
    let canvas = document.createElement('canvas');
    graphDiv.appendChild(canvas);
    // Create a scatter plot.
    let scatterPlot = new (0, $dc4240e6100248ae$export$eec270bd176da5f5)(canvas, t_ref_pop, $0ff23b3a70668dbf$var$sp_font, graphdetails);
    // Add the scatter plot to the collection.
    $0ff23b3a70668dbf$var$scatterPlots.push(scatterPlot);
    //scatterPlot.draw();
    // Add a save to PNG button.
    (0, $dc4240e6100248ae$export$f0119d1c38383eb8)(canvas, pDiv, graphDiv, labelText);
}





class $5d3e67bd01cf7225$export$79d0bd4671c1fc67 {
    /**
     * Construct a new M_Defaults object.
     */ constructor(){
        /**
     * TagName.
     */ this.tagName = 'defaults';
        this.values = new Map();
        this.attributess = new Map();
    }
    /**
     * Read the defaults.xml file.
     */ readFile() {
        // Create a file input element to prompt the user to select the default.xml file.
        let input = document.createElement('input');
        input.type = 'file';
        let self = this;
        input.onchange = function() {
            if (input.files) {
                for(let i = 0; i < input.files.length; i++)console.log("inputElement.files[" + i + "]=" + input.files[i]);
                let file = input.files[0];
                //console.log("file=" + file);
                console.log(file.name);
                let inputFilename = file.name;
                let reader = new FileReader();
                let chunkSize = 1048576; // 1MB
                let start = 0;
                let contents = '';
                reader.onload = function(e) {
                    if (e.target == null) throw new Error('Event target is null');
                    contents += e.target.result;
                    if (file != null) {
                        if (start < file.size) {
                            // Read the next chunk
                            let blob = file.slice(start, start + chunkSize);
                            reader.readAsText(blob);
                            start += chunkSize;
                        } else {
                            // All chunks have been read
                            contents = contents.trim();
                            //console.log('contents ' + contents);
                            let parser = new DOMParser();
                            let xml = parser.parseFromString(contents, "text/xml");
                            self.parse(xml);
                        }
                    }
                };
                // Read the first chunk
                let blob = file.slice(start, start + chunkSize);
                reader.readAsText(blob);
                start += chunkSize;
            }
        };
        input.click();
    }
    /**
     * Parses the xml loading data into attributess and values.
     * @param xml The XML document.
     */ parse(xml) {
        // Process the XML.
        let xml_defaults = (0, $057fa7562ec736a9$export$b7531b8ff18dc588)(xml, this.tagName);
        let attributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_defaults);
        console.log("Default attributes: " + (0, $93b71ab6968650c1$export$dc22ec7f8e0b9ac)(attributes));
        let children = xml_defaults.children;
        console.log("children.length=" + children.length);
        for(let i = 0; i < children.length; i++){
            let child = children[i];
            let tagName = child.tagName;
            console.log("tagName=" + tagName);
            let attributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(child);
            this.attributess.set(tagName, attributes);
            console.log("Attributes: " + (0, $93b71ab6968650c1$export$dc22ec7f8e0b9ac)(attributes));
            if (tagName == 'property') {
                let dictRef = child.getAttribute('dictRef');
                try {
                    let xml_scalar = (0, $057fa7562ec736a9$export$b7531b8ff18dc588)(child, 'scalar');
                    let v = xml_scalar.innerHTML;
                    if (v != null) {
                        console.log("v=" + v);
                        this.values.set(dictRef, v);
                    } else console.log("v is null");
                } catch (e) {
                    console.log("Error: " + e);
                }
            } else {
                //let v: string | null = child.nodeValue;
                //let v: string | null = child.nodeName;
                let v = child.innerHTML;
                if (v != null) {
                    console.log("v=" + v);
                    this.values.set(tagName, v);
                } else console.log("v is null");
            }
        }
        // Some tests.
        console.log("values: " + (0, $93b71ab6968650c1$export$dc22ec7f8e0b9ac)(this.values));
        this.attributess.forEach((value, key)=>{
            console.log("key=" + key + " value=" + (0, $93b71ab6968650c1$export$dc22ec7f8e0b9ac)(value));
        });
    }
}













class $13401187c7985864$export$e8a062bb2fc9e2ba extends (0, $057fa7562ec736a9$export$ca4ceee82ec565dc) {
    static{
        /**
     * The tag name.
     */ this.tagName = "molecule";
    }
    static{
        /**
     * The ref string.
     */ this.s_ref = "ref";
    }
    static{
        /**
     * The role string.
     */ this.s_role = "role";
    }
    /**
     * @param attributes The attributes.
     * @param tagName The tag name.
     * @param molecule The molecule (an abbreviated molecule).
     */ constructor(attributes){
        super(attributes, $13401187c7985864$export$e8a062bb2fc9e2ba.tagName);
        this.ref = attributes.get($13401187c7985864$export$e8a062bb2fc9e2ba.s_ref);
        this.role = attributes.get($13401187c7985864$export$e8a062bb2fc9e2ba.s_role);
    }
    /**
     * @returns The ref attribute.
     */ getRef() {
        return this.ref;
    }
    /**
     * @param ref The ref attribute.
     */ setRef(ref) {
        this.ref = ref;
        this.attributes.set("ref", ref);
    }
    /**
     * @returns The role attribute.
     */ getRole() {
        return this.role;
    }
    /**
     * @param role The role of the molecule in the reaction.
     */ setRole(role) {
        this.role = role;
        this.attributes.set("role", role);
    }
}
class $13401187c7985864$export$dcfd4302d04b7fb6 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "reactant";
    }
    static{
        /**
     * The role options.
     */ this.s_deficientReactant = "deficientReactant";
    }
    static{
        this.s_excessReactant = "excessReactant";
    }
    static{
        this.s_modelled = "modelled";
    }
    static{
        this.roleOptions = [
            $13401187c7985864$export$dcfd4302d04b7fb6.s_deficientReactant,
            $13401187c7985864$export$dcfd4302d04b7fb6.s_excessReactant,
            $13401187c7985864$export$dcfd4302d04b7fb6.s_modelled
        ];
    }
    /**
     * @param attributes The attributes.
     * @param molecule The reaction molecule.
     */ constructor(attributes, molecule){
        super(attributes, $13401187c7985864$export$dcfd4302d04b7fb6.tagName);
        this.addNode(molecule);
    }
    /**
     * @returns The molecule.
     */ getMolecule() {
        return this.nodes.get(0);
    }
}
class $13401187c7985864$export$264ad599d7cef668 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "product";
    }
    static{
        /**
     * The role options.
     */ this.roleOptions = [
            "modelled",
            "sink"
        ];
    }
    /**
     * @param attributes The attributes.
     * @param molecule The reaction molecule.
     */ constructor(attributes, molecule){
        super(attributes, $13401187c7985864$export$264ad599d7cef668.tagName);
        this.addNode(molecule);
    }
    /**
     * @returns The molecule.
     */ getMolecule() {
        return this.nodes.get(0);
    }
}
class $13401187c7985864$export$145c1ed87b1a2216 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:transitionState";
    }
    static{
        /**
     * The role.
     */ this.role = "transitionState";
    }
    /**
     * @param attributes The attributes.
     * @param molecule The reaction molecule.
     */ constructor(attributes, molecule){
        super(attributes, $13401187c7985864$export$145c1ed87b1a2216.tagName);
        this.addNode(molecule);
    }
    /**
     * @returns The molecule.
     */ getMolecule() {
        return this.nodes.get(0);
    }
}
class $13401187c7985864$export$38ce90ac8b004d85 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:preExponential";
    }
    /**
     * @param attributes The attributes. 
     * @param value The value of the factor.
     */ constructor(attributes, value){
        super(attributes, $13401187c7985864$export$38ce90ac8b004d85.tagName, value);
    }
}
class $13401187c7985864$export$1bdc69d2439d749d extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:activationEnergy";
    }
    /**
     * @param attributes The attributes. 
     * @param value The value of the factor.
     */ constructor(attributes, value){
        super(attributes, $13401187c7985864$export$1bdc69d2439d749d.tagName, value);
    }
}
class $13401187c7985864$export$8d95dd32819bc86c extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:TInfinity";
    }
    /**
     * @param attributes The attributes. 
     * @param value The value of the factor.
     */ constructor(attributes, value){
        super(attributes, $13401187c7985864$export$8d95dd32819bc86c.tagName, value);
    }
}
class $13401187c7985864$export$d08982dd841d496f extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:nInfinity";
    }
    /**
     * @param attributes The attributes. 
     * @param value The value of the factor.
     */ constructor(attributes, value){
        super(attributes, $13401187c7985864$export$d08982dd841d496f.tagName, value);
    }
}
class $13401187c7985864$export$6fa70ee10f356b6 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:MCRCMethod";
    }
    /**
     * @param {Map<string, string>} attributes The attributes.
     */ constructor(attributes){
        super(attributes, $13401187c7985864$export$6fa70ee10f356b6.tagName);
    }
}
class $13401187c7985864$export$191e95ebb11cc88 extends $13401187c7985864$export$6fa70ee10f356b6 {
    static{
        /**
     * The xsiType.
     */ this.xsiType = "me:MesmerILT";
    }
    static{
        /**
     * The tag name.
     */ this.xsiType2 = "MesmerILT";
    }
    /**
     * Should any parameters be specified as being optional?
     * @param attributes The attributes.
     * @param preExponential The pre-exponential factor (optional).
     * @param activationEnergy The activation energy (optional).
     * @param tInfinity The TInfinity (optional).
     * @param nInfinity The nInfinity (optional).
     */ constructor(attributes, preExponential, activationEnergy, tInfinity, nInfinity){
        super(attributes);
        this.index = new Map();
        if (preExponential != undefined) {
            this.index.set($13401187c7985864$export$38ce90ac8b004d85.tagName, this.index.size);
            this.addNode(preExponential);
        }
        if (activationEnergy != undefined) {
            this.index.set($13401187c7985864$export$1bdc69d2439d749d.tagName, this.index.size);
            this.addNode(activationEnergy);
        }
        if (tInfinity != undefined) {
            this.index.set($13401187c7985864$export$8d95dd32819bc86c.tagName, this.index.size);
            this.addNode(tInfinity);
        }
        if (nInfinity != undefined) {
            this.index.set($13401187c7985864$export$d08982dd841d496f.tagName, this.index.size);
            this.addNode(nInfinity);
        }
    }
    /**
     * @returns The pre-exponential factor or undefined if it does not exist.
     */ getPreExponential() {
        let i = this.index.get($13401187c7985864$export$38ce90ac8b004d85.tagName);
        if (i == undefined) return undefined;
        return this.nodes.get(i);
    }
    /**
     * @param preExponential The pre-exponential factor.
     */ setPreExponential(preExponential) {
        let i = this.index.get($13401187c7985864$export$38ce90ac8b004d85.tagName);
        if (i == undefined) {
            this.index.set($13401187c7985864$export$38ce90ac8b004d85.tagName, this.nodes.size);
            this.addNode(preExponential);
        } else this.nodes.set(i, preExponential);
    }
    /**
     * @returns The activation energy or undefined if it does not exist.
     */ getActivationEnergy() {
        let i = this.index.get($13401187c7985864$export$1bdc69d2439d749d.tagName);
        if (i == undefined) return undefined;
        return this.nodes.get(i);
    }
    /**
     * @param activationEnergy The activation energy.
     */ setActivationEnergy(activationEnergy) {
        let i = this.index.get($13401187c7985864$export$1bdc69d2439d749d.tagName);
        if (i == undefined) {
            this.index.set($13401187c7985864$export$1bdc69d2439d749d.tagName, this.nodes.size);
            this.addNode(activationEnergy);
        } else this.nodes.set(i, activationEnergy);
    }
    /**
     * @returns The TInfinity or undefined if it does not exist.
     */ getTInfinity() {
        let i = this.index.get($13401187c7985864$export$8d95dd32819bc86c.tagName);
        if (i == undefined) return undefined;
        return this.nodes.get(i);
    }
    /**
     * @param tInfinity The TInfinity.
     */ setTInfinity(tInfinity) {
        let i = this.index.get($13401187c7985864$export$8d95dd32819bc86c.tagName);
        if (i == undefined) {
            this.index.set($13401187c7985864$export$8d95dd32819bc86c.tagName, this.nodes.size);
            this.addNode(tInfinity);
        } else this.nodes.set(i, tInfinity);
    }
    /**
     * @returns The NInfinity or undefined if it does not exist.
     */ getNInfinity() {
        let i = this.index.get($13401187c7985864$export$d08982dd841d496f.tagName);
        if (i == undefined) return undefined;
        return this.nodes.get(i);
    }
    /**
     * @param nInfinity The NInfinity.
     */ setNInfinity(nInfinity) {
        let i = this.index.get($13401187c7985864$export$d08982dd841d496f.tagName);
        if (i == undefined) {
            this.index.set($13401187c7985864$export$d08982dd841d496f.tagName, this.nodes.size);
            this.addNode(nInfinity);
        } else this.nodes.set(i, nInfinity);
    }
}
class $13401187c7985864$export$c3cf6f96dac11421 extends (0, $057fa7562ec736a9$export$ca4ceee82ec565dc) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:tunneling";
    }
    static{
        /**
     * The options.
     */ this.options = [
            "Eckart",
            "WKB"
        ];
    }
    static{
        /**
     * The key to the name attribute value.
     */ this.s_name = "name";
    }
    /**
     * @param {Map<string, string>} attributes The attributes.
     */ constructor(attributes){
        super(attributes, $13401187c7985864$export$c3cf6f96dac11421.tagName);
    }
    /**
     * @returns The name of the tunneling method.
     */ getName() {
        return this.attributes.get($13401187c7985864$export$c3cf6f96dac11421.s_name);
    }
    /**
     * @param The name of the tunneling method.
     */ setName(name) {
        this.attributes.set($13401187c7985864$export$c3cf6f96dac11421.s_name, name);
    }
}
class $13401187c7985864$export$284227145ed02b04 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:excessReactantConc";
    }
    /**
     * @param attributes The attributes. 
     * @param value The value of the factor.
     */ constructor(attributes, value){
        super(attributes, $13401187c7985864$export$284227145ed02b04.tagName, value);
    }
}
class $13401187c7985864$export$38dfac6a73b2b45e extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:val";
    }
    /**
     * @param attributes The attributes. 
     * @param value The value of the factor.
     */ constructor(attributes, value){
        super(attributes, $13401187c7985864$export$38dfac6a73b2b45e.tagName, value);
    }
}
class $13401187c7985864$export$a292f79afb9ad235 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:rev";
    }
    /**
     * @param attributes The attributes. 
     * @param value The value of the factor.
     */ constructor(attributes, value){
        super(attributes, $13401187c7985864$export$a292f79afb9ad235.tagName, value);
    }
}
class $13401187c7985864$export$835b53a514d067b0 extends (0, $057fa7562ec736a9$export$82583fad49645fc9) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:Keq";
    }
    /**
     * @param attributes The attributes. 
     * @param value The value of the factor.
     */ constructor(attributes, value){
        super(attributes, $13401187c7985864$export$835b53a514d067b0.tagName, value);
    }
}
class $13401187c7985864$export$5eb02c9a0d4a6c5 extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:kinf";
    }
    /**
     * @param attributes The attributes.
     * @param t The t.
     * @param val The val.
     * @param rev The rev.
     * @param Keq The Keq.
     */ constructor(attributes, t, val, rev, keq){
        super(attributes, $13401187c7985864$export$5eb02c9a0d4a6c5.tagName);
        this.index = new Map();
        if (t != undefined) {
            this.index.set((0, $ccef02370f58a770$export$971d5caa766a69d7).tagName, this.nodes.size);
            this.addNode(t);
        }
        if (val != undefined) {
            this.index.set($13401187c7985864$export$38dfac6a73b2b45e.tagName, this.nodes.size);
            this.addNode(val);
        }
        if (rev != undefined) {
            this.index.set($13401187c7985864$export$a292f79afb9ad235.tagName, this.nodes.size);
            this.addNode(rev);
        }
        if (keq != undefined) {
            this.index.set($13401187c7985864$export$835b53a514d067b0.tagName, this.nodes.size);
            this.addNode(keq);
        }
    }
    /**
     * @returns The T node or undefined if it does not exist.
     */ getT() {
        let i = this.index.get((0, $ccef02370f58a770$export$971d5caa766a69d7).tagName);
        if (i == undefined) return undefined;
        return this.nodes.get(i);
    }
    /**
     * @param t The T node.
     */ setT(t) {
        let i = this.index.get((0, $ccef02370f58a770$export$971d5caa766a69d7).tagName);
        if (i == undefined) {
            this.index.set((0, $ccef02370f58a770$export$971d5caa766a69d7).tagName, this.nodes.size);
            this.addNode(t);
        } else this.nodes.set(i, t);
    }
    /**
     * @returns The Val node or undefined if it does not exist.
     */ getVal() {
        let i = this.index.get($13401187c7985864$export$38dfac6a73b2b45e.tagName);
        if (i == undefined) return undefined;
        return this.nodes.get(i);
    }
    /**
     * @param val The Val node.
     */ setVal(val) {
        let i = this.index.get($13401187c7985864$export$38dfac6a73b2b45e.tagName);
        if (i == undefined) {
            this.index.set($13401187c7985864$export$38dfac6a73b2b45e.tagName, this.nodes.size);
            this.addNode(val);
        } else this.nodes.set(i, val);
    }
    /**
     * @returns The Rev node or undefined if it does not exist.
     */ getRev() {
        let i = this.index.get($13401187c7985864$export$a292f79afb9ad235.tagName);
        if (i == undefined) return undefined;
        return this.nodes.get(i);
    }
    /**
     * @param rev The Rev node.
     */ setRev(rev) {
        let i = this.index.get($13401187c7985864$export$a292f79afb9ad235.tagName);
        if (i == undefined) {
            this.index.set($13401187c7985864$export$a292f79afb9ad235.tagName, this.nodes.size);
            this.addNode(rev);
        } else this.nodes.set(i, rev);
    }
    /**
     * @returns The Keq node or undefined if it does not exist.
     */ getKeq() {
        let i = this.index.get($13401187c7985864$export$835b53a514d067b0.tagName);
        if (i == undefined) return undefined;
        return this.nodes.get(i);
    }
    /**
     * @param keq The Keq node.
     */ setKeq(keq) {
        let i = this.index.get($13401187c7985864$export$835b53a514d067b0.tagName);
        if (i == undefined) {
            this.index.set($13401187c7985864$export$835b53a514d067b0.tagName, this.nodes.size);
            this.addNode(keq);
        } else this.nodes.set(i, keq);
    }
    /**
    * The header.
    */ getHeader() {
        let header = [];
        header.push("T (" + this.getT()?.attributes.get("units") + ")");
        header.push("kf (" + this.getVal()?.attributes.get("units") + ")");
        header.push("krev (" + this.getRev()?.attributes.get("units") + ")");
        header.push("Keq (" + this.getKeq()?.attributes.get("units") + ")");
        return header;
    }
    /**
     * @returns The Kinf as a string[].
     */ toStringArray() {
        let t = this.getT();
        let val = this.getVal();
        let rev = this.getRev();
        let keq = this.getKeq();
        return [
            t.value.toString(),
            val.value.toString(),
            rev != undefined ? rev.value.toString() : "undef",
            keq != undefined ? keq.value.toString() : "undef"
        ];
    }
    /**
     * @returns The Kinf as a CSV string.
     */ toCSV() {
        return this.toStringArray().join(",");
    }
}
class $13401187c7985864$export$3f85289af9546f7e extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "me:canonicalRateList";
    }
    /**
     * @param attributes The attributes.
     * @param canonicalRate The canonical rate.
     */ constructor(attributes, description, kinfs){
        super(attributes, $13401187c7985864$export$3f85289af9546f7e.tagName);
        this.index = new Map();
        this.kinfIndex = new Map();
        if (description != undefined) {
            this.index.set((0, $ccef02370f58a770$export$393edc798c47379d).tagName, this.nodes.size);
            this.addNode(description);
        }
        if (kinfs != undefined) kinfs.forEach((kinf)=>{
            this.kinfIndex.set(this.nodes.size, this.nodes.size);
            this.addNode(kinf);
        });
    }
    /**
     * @returns The Description node or undefined if it does not exist.
     */ getDescription() {
        let i = this.index.get((0, $ccef02370f58a770$export$393edc798c47379d).tagName);
        if (i == undefined) return undefined;
        return this.nodes.get(i);
    }
    /**
     * @param description The Description node.
     */ setDescription(description) {
        let i = this.index.get((0, $ccef02370f58a770$export$393edc798c47379d).tagName);
        if (i == undefined) {
            this.index.set((0, $ccef02370f58a770$export$393edc798c47379d).tagName, this.nodes.size);
            this.addNode(description);
        } else this.nodes.set(i, description);
    }
    /**
     * @returns The Kinf nodes.
     */ getKinfs() {
        return Array.from(this.kinfIndex.values()).map((index)=>this.nodes.get(index));
    }
    /**
     * @param kinf The Kinf node.
     */ addKinf(kinf) {
        this.kinfIndex.set(this.kinfIndex.size, this.nodes.size);
        this.addNode(kinf);
    }
    /**
     * @returns The CanonicalRateList as a CSV string.
     */ toCSV() {
        let csv = "";
        let first = true;
        this.getKinfs().forEach((k)=>{
            if (first) {
                first = false;
                csv += k.getHeader().join(",") + "\n";
            }
            csv += k.toCSV() + "\n";
        });
        return csv;
    }
}
class $13401187c7985864$export$d2ae4167a30cf6bb extends (0, $057fa7562ec736a9$export$bd431b64ad3b0433) {
    static{
        /**
     * The tag name.
     */ this.tagName = "reaction";
    }
    static{
        /**
     * The key to the id attribute value.
     */ this.s_id = "id";
    }
    /**
     * @param attributes The attributes.
     * @param id The id of the reaction.
     * @param reactants The reactants in the reaction.
     * @param products The products of the reaction.
     * @param tunneling The tunneling (optional).
     * @param transitionStates The transition states (optional).
     * @param mCRCMethod The MCRCMethod (optional).
     * @param excessReactantConc The excess reactant concentration (optional).
     * @param canonicalRateList The canonical rate list (optional).
     */ constructor(attributes, reactants, products, tunneling, transitionStates, mCRCMethod, excessReactantConc, canonicalRateList){
        super(attributes, $13401187c7985864$export$d2ae4167a30cf6bb.tagName);
        this.index = new Map();
        this.reactantsIndex = new Map();
        this.productsIndex = new Map();
        this.transitionStatesIndex = new Map();
        let id = attributes.get($13401187c7985864$export$d2ae4167a30cf6bb.s_id);
        if (id == undefined) throw new Error($13401187c7985864$export$d2ae4167a30cf6bb.s_id + ' is undefined!');
        this.id = id;
        if (reactants != undefined) {
            reactants.forEach((r, key)=>{
                this.reactantsIndex.set(r.getMolecule().getRef(), this.nodes.size);
                this.addNode(r);
            });
            this.index.set($13401187c7985864$export$dcfd4302d04b7fb6.tagName, this.reactantsIndex);
        }
        if (products != undefined) {
            products.forEach((p, key)=>{
                this.productsIndex.set(p.getMolecule().getRef(), this.nodes.size);
                this.addNode(p);
            });
            this.index.set($13401187c7985864$export$264ad599d7cef668.tagName, this.productsIndex);
        }
        if (tunneling != undefined) {
            this.index.set($13401187c7985864$export$c3cf6f96dac11421.tagName, this.nodes.size);
            this.addNode(tunneling);
        }
        if (transitionStates != undefined) {
            transitionStates.forEach((t, key)=>{
                this.transitionStatesIndex.set(t.getMolecule().getRef(), this.nodes.size);
                this.addNode(t);
            });
            this.index.set($13401187c7985864$export$145c1ed87b1a2216.tagName, this.transitionStatesIndex);
        }
        if (mCRCMethod != undefined) {
            this.index.set($13401187c7985864$export$6fa70ee10f356b6.tagName, this.nodes.size);
            this.addNode(mCRCMethod);
        }
        if (excessReactantConc != undefined) {
            this.index.set($13401187c7985864$export$284227145ed02b04.tagName, this.nodes.size);
            this.addNode(excessReactantConc);
        }
        if (canonicalRateList != undefined) {
            this.index.set($13401187c7985864$export$3f85289af9546f7e.tagName, this.nodes.size);
            this.addNode(canonicalRateList);
        }
    }
    /**
     * Add a node to the index.
     */ addToIndex(tagName, node) {
        let v = this.index.get(tagName);
        if (v == undefined) this.index.set(tagName, this.nodes.size);
        else if (v instanceof Map) v.set(node.tagName, this.nodes.size);
        else {
            let map = new Map();
            map.set(this.nodes.get(v).getRef(), v);
            map.set(node.tagName, this.nodes.size);
            this.index.set(tagName, map);
        }
    }
    /**
     * @returns The reactants.
     */ getReactants() {
        let i = this.index.get($13401187c7985864$export$dcfd4302d04b7fb6.tagName);
        if (i == undefined) return new Map();
        let reactants = new Map();
        if (i instanceof Map) i.forEach((index, ref)=>{
            reactants.set(ref, this.nodes.get(index));
        });
        else {
            let r = this.nodes.get(i);
            reactants.set(r.getMolecule().getRef(), r);
        }
        return reactants;
    }
    /**
     * Set the reactants.
     */ setReactants(reactants) {
        reactants.forEach((reactant, key)=>{
            this.reactantsIndex.set(reactant.getMolecule().getRef(), this.nodes.size);
            this.addNode(reactant);
        });
        this.index.set($13401187c7985864$export$dcfd4302d04b7fb6.tagName, this.reactantsIndex);
    }
    /**
     * @returns A particular Reactant.
     * @param ref The ref of the reactant to return.
     * @returns The reactant at the given index.
     */ getReactant(ref) {
        let index = this.reactantsIndex.get(ref);
        if (index == undefined) throw new Error(`Reactant with ref ${ref} not found`);
        return this.nodes.get(index);
    }
    /**
     * @param reactant The reactant to add.
     */ addReactant(reactant) {
        this.reactantsIndex.set(reactant.getMolecule().getRef(), this.nodes.size);
        this.addNode(reactant);
    }
    /**
     * @param ref The ref of the reactant to remove.
     */ removeReactant(ref) {
        let index = this.reactantsIndex.get(ref);
        if (index == undefined) throw new Error(`Reactant with ref ${ref} not found`);
        else {
            this.nodes.delete(index);
            this.reactantsIndex.delete(ref);
        }
    }
    /**
     * @returns The products.
     */ getProducts() {
        /*
        let i: Map<string, number> | number | undefined = this.index.get(Product.tagName);
        if (i == undefined) {
            return [];
        }
        if (i instanceof Map) {
            return Array.from(i.values()).map(index => this.nodes.get(index) as Product);
        } else {
            return [this.nodes.get(i) as Product];
        }*/ let i = this.index.get($13401187c7985864$export$264ad599d7cef668.tagName);
        if (i == undefined) return new Map();
        let products = new Map();
        if (i instanceof Map) i.forEach((index, ref)=>{
            products.set(ref, this.nodes.get(index));
        });
        else {
            let r = this.nodes.get(i);
            products.set(r.getMolecule().getRef(), r);
        }
        return products;
    }
    /**
     * Set the products.
     */ setProducts(products) {
        products.forEach((product, key)=>{
            this.productsIndex.set(product.getMolecule().getRef(), this.nodes.size);
            this.addNode(product);
        });
        this.index.set($13401187c7985864$export$264ad599d7cef668.tagName, this.productsIndex);
    }
    /**
     * @returns A particular Product.
     * @param ref The ref of the product to return.
     * @returns The product at the given index.
     */ getProduct(ref) {
        let index = this.productsIndex.get(ref);
        if (index == undefined) throw new Error(`Product with ref ${ref} not found`);
        return this.nodes.get(index);
    }
    /**
     * @param product The product to add.
     */ addProduct(product) {
        this.productsIndex.set(product.getMolecule().getRef(), this.nodes.size);
        this.addNode(product);
    }
    /**
     * @param ref The ref of the product to remove.
     */ removeProduct(ref) {
        let index = this.productsIndex.get(ref);
        if (index == undefined) throw new Error(`Product with ref ${ref} not found`);
        else {
            this.nodes.delete(index);
            this.productsIndex.delete(ref);
        }
    }
    /**
     * @returns The tunneling node or undefined if it does not exist.
     */ getTunneling() {
        let i = this.index.get($13401187c7985864$export$c3cf6f96dac11421.tagName);
        if (i == undefined) return undefined;
        return this.nodes.get(i);
    }
    /**
     * Set the tunneling node or create it if it is undefined.
     */ setTunneling(tunneling) {
        let i = this.index.get($13401187c7985864$export$c3cf6f96dac11421.tagName);
        if (i == undefined) {
            this.index.set($13401187c7985864$export$c3cf6f96dac11421.tagName, this.nodes.size);
            this.addNode(tunneling);
        } else {
            if (i instanceof Map) throw new Error("Tunneling is a map and it is assumed there would be only 1!");
            else this.nodes.set(i, tunneling);
        }
    }
    /**
     * @returns The transition states.
     */ getTransitionStates() {
        let i = this.index.get($13401187c7985864$export$145c1ed87b1a2216.tagName);
        if (i == undefined) return new Map();
        let transitionStates = new Map();
        if (i instanceof Map) i.forEach((index, ref)=>{
            transitionStates.set(ref, this.nodes.get(index));
        });
        else {
            let r = this.nodes.get(i);
            transitionStates.set(r.getMolecule().getRef(), r);
        }
        return transitionStates;
    }
    /**
     * Set the transition states.
     */ setTransitionStates(transitionStates) {
        transitionStates.forEach((transitionState, key)=>{
            this.transitionStatesIndex.set(transitionState.getMolecule().getRef(), this.nodes.size);
            this.addNode(transitionState);
        });
        this.index.set($13401187c7985864$export$145c1ed87b1a2216.tagName, this.transitionStatesIndex);
    }
    /**
     * @returns A particular TransitionState.
     * @param ref The ref of the transition state to return.
     * @returns The transition state at the given index.
     */ getTransitionState(ref) {
        let index = this.transitionStatesIndex.get(ref);
        if (index == undefined) throw new Error(`Transition state with ref ${ref} not found`);
        return this.nodes.get(index);
    }
    /**
     * @param transitionState The transition state to add.
     */ addTransitionState(transitionState) {
        this.transitionStatesIndex.set(transitionState.getMolecule().getRef(), this.nodes.size);
        this.addNode(transitionState);
    }
    /**
     * @param ref The ref of the transition state to remove.
     */ removeTransitionState(ref) {
        let index = this.transitionStatesIndex.get(ref);
        if (index == undefined) throw new Error(`Transition State with ref ${ref} not found`);
        else {
            this.nodes.delete(index);
            this.transitionStatesIndex.delete(ref);
        }
    }
    /**
     * @returns The MCRCMethod node or undefined if it does not exist.
     */ getMCRCMethod() {
        let i = this.index.get($13401187c7985864$export$6fa70ee10f356b6.tagName);
        if (i == undefined) return undefined;
        return this.nodes.get(i);
    }
    /**
     * Set the MCRCMethod node or create it if it is undefined.
     */ setMCRCMethod(mCRCMethod) {
        let i = this.index.get($13401187c7985864$export$6fa70ee10f356b6.tagName);
        if (i == undefined) {
            this.index.set($13401187c7985864$export$6fa70ee10f356b6.tagName, this.nodes.size);
            this.addNode(mCRCMethod);
        } else {
            if (i instanceof Map) throw new Error("MCRCMethod is a map and it is assumed there would be only 1!");
            else this.nodes.set(i, mCRCMethod);
        }
    }
    /**
     * @returns The excess reactant concentration or undefined if it does not exist.
     */ getExcessReactantConc() {
        let i = this.index.get($13401187c7985864$export$284227145ed02b04.tagName);
        if (i == undefined) return undefined;
        return this.nodes.get(i);
    }
    /**
     * Set the excess reactant concentration or create it if it is undefined.
     */ setExcessReactantConc(excessReactantConc) {
        let i = this.index.get($13401187c7985864$export$284227145ed02b04.tagName);
        if (i == undefined) {
            this.index.set($13401187c7985864$export$284227145ed02b04.tagName, this.nodes.size);
            this.addNode(excessReactantConc);
        } else {
            if (i instanceof Map) throw new Error("ExcessReactantConc is a map and it is assumed there would be only 1!");
            else this.nodes.set(i, excessReactantConc);
        }
    }
    /**
     * @returns The canonical rate list or undefined if it does not exist.
     */ getCanonicalRateList() {
        let i = this.index.get($13401187c7985864$export$3f85289af9546f7e.tagName);
        if (i == undefined) return undefined;
        return this.nodes.get(i);
    }
    /**
     * Set the canonical rate list or create it if it is undefined.
     */ setCanonicalRateList(canonicalRateList) {
        let i = this.index.get($13401187c7985864$export$3f85289af9546f7e.tagName);
        if (i == undefined) {
            this.index.set($13401187c7985864$export$3f85289af9546f7e.tagName, this.nodes.size);
            this.addNode(canonicalRateList);
        } else {
            if (i instanceof Map) throw new Error("CanonicalRateList is a map and it is assumed there would be only 1!");
            else this.nodes.set(i, canonicalRateList);
        }
    }
    /**
     * Get the label of the reactants.
     * @returns The label of the reactants.
     */ getReactantsLabel() {
        return Array.from(this.getReactants().values()).map((reactant)=>reactant.getMolecule().getRef()).join(' + ');
    }
    /**
     * Returns the label for the products.
     * @returns The label for the products.
     */ getProductsLabel() {
        //return this.getProducts().map(product => product.getMolecule().getRef()).join(' + ');
        return Array.from(this.getProducts().values()).map((product)=>product.getMolecule().getRef()).join(' + ');
    }
    /**
     * Get the label of the reaction.
     * @returns The label of the reaction.
     */ getLabel() {
        let label = this.id + ' (' + this.getReactantsLabel() + ' -> ' + this.getProductsLabel() + ')';
        return label;
    }
    /**
     * Returns the total energy of all reactants or products.
     * @param retrieveMolecule A function to retrieve a molecule.
     * @param molecules The molecules.
     * @param items Either the reactants or products.
     * @returns The total energy of all reactants or products.
     */ getTotalEnergy(retrieveMolecule, molecules, items) {
        return Array.from(items.values()).map((item)=>{
            let ref = item.getMolecule().getRef();
            let molecule = retrieveMolecule(ref, molecules);
            if (molecule == undefined) {
                console.log("Molecule with ref " + ref + " not found!");
                alert("Molecule with ref " + ref + " not found. Please add it to the list of molecules. \
                 In the meantime it will be treated as having an energy of 0.");
                return 0, $dc4240e6100248ae$export$a94c859b6fc3ec52;
            }
            return molecule.getEnergy();
        }).reduce((a, b)=>a.add(b), new (0, $ad9e9f310a798519$exports.Big)(0));
    }
    /**
     * Returns the total energy of all reactants.
     * @param retrieveMolecule A function to retrieve a molecule.
     * @param molecules The molecules.
     * @returns The total energy of all reactants.
     */ getReactantsEnergy(retrieveMolecule, molecules) {
        return this.getTotalEnergy(retrieveMolecule, molecules, this.getReactants());
    }
    /**
     * Returns the total energy of all products.
     * @param retrieveMolecule A function to retrieve a molecule.
     * @param molecules The molecules.
     * @returns The total energy of all products.
     */ getProductsEnergy(retrieveMolecule, molecules) {
        return this.getTotalEnergy(retrieveMolecule, molecules, this.getProducts());
    }
    /**
     * Checks all energy units are the same and returns the energy units.
     * @param retrieveMolecule A function to retrieve a molecule.
     * @param molecules The molecules.
     * @param items Either the reactants or products.
     * @returns The energy units.
     */ getEnergyUnits(retrieveMolecule, molecules, items) {
        let unitsSet = new Set();
        Array.from(items.values()).map((item)=>{
            let ref = item.getMolecule().getRef();
            let molecule = retrieveMolecule(ref, molecules);
            if (molecule == undefined) {
                console.log("molecule with ref " + ref + " not found");
                alert("Molecule with ref " + ref + " not found. Please add it to the list of molecules. \
                     In the meantime it will be treated as having an energy of 0.");
                return "";
            } else {
                let pZPE = molecule.getProperty("me:ZPE");
                let units = pZPE?.attributes.get((0, $597d59a3d37b5b3f$export$742f9ce317ef8ba3).s_units);
                unitsSet.add(units ? units : "");
            }
        });
        if (unitsSet.size > 1) {
            console.log("Warning: Not all molecules have the same units");
            return "";
        } else return Array.from(unitsSet)[0]; // Return the only unit in the set
    }
    /**
     * @param tagName The tag name.
     * @param dictRef The dictRef.
     * @returns The node with the tag name and dictRef or undefined if it does not exist.
     */ get(tagName, dictRef) {
        if (this.index.has(tagName)) {
            let i = this.index.get(tagName);
            if (i != undefined) {
                if (i instanceof Map) {
                    let nodeIndex = i.get(dictRef);
                    if (nodeIndex != undefined) return this.nodes.get(nodeIndex);
                } else return this.nodes.get(i);
            }
        }
    }
}





function $7991f82905a8f5df$export$b12ef0e3d99deb64(rIDM, rlDiv, reactions, molecules) {
    let rb = (0, $341c675b659c6d43$export$9b6d6ca62970729f)((0, $dc4240e6100248ae$export$1bb8965d05fbf467), (0, $dc4240e6100248ae$export$bea69a603fae01a6)((0, $13401187c7985864$export$d2ae4167a30cf6bb).tagName, "add", (0, $341c675b659c6d43$export$25280bc3a7ce098e)), (0, $dc4240e6100248ae$export$39c84188a71202f7));
    rlDiv.appendChild(rb);
    rb.addEventListener('click', ()=>{
        let reactionAttributes = new Map();
        // Get Reaction ID.
        let rl = (0, $dc4240e6100248ae$export$3bb92be1f57fd129).getReactionList();
        let i = rl.getNextReactionID();
        console.log("Next Reaction ID=" + i);
        reactionAttributes.set((0, $13401187c7985864$export$d2ae4167a30cf6bb).s_id, "R" + i);
        let r = new (0, $13401187c7985864$export$d2ae4167a30cf6bb)(reactionAttributes);
        reactions.set(r.id, r);
        // Add to mesmer.
        rl.addReaction(r);
        let rDivID = rIDM.addID((0, $13401187c7985864$export$d2ae4167a30cf6bb).tagName, r.id);
        let rDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(rDivID);
        rlDiv.appendChild(rDiv);
        // Create collapsible content.
        let rcDivID = rIDM.addID(rDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
        let rcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(rcDivID, rlDiv, rb, rDiv, r.getLabel(), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        let rcb = rcDiv.querySelector('button');
        // Create collapsible content for reactants.
        let rsDivID = rIDM.addID(rDivID, (0, $13401187c7985864$export$dcfd4302d04b7fb6).tagName);
        let rsDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(rsDivID);
        let rscDivID = rIDM.addID(rsDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
        let rscDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(rscDivID, rDiv, null, rsDiv, (0, $dc4240e6100248ae$export$ae4e72e6b8ac1d64), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        let reactants = new Map();
        r.setReactants(reactants);
        $7991f82905a8f5df$var$addAddReactantButton(r, rcb, rIDM, rDivID, rsDiv, molecules, reactants);
        // Create collapsible content for products.
        let psDivID = rIDM.addID(rDivID, (0, $13401187c7985864$export$264ad599d7cef668).tagName);
        let psDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(psDivID);
        let pscDivID = rIDM.addID(psDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
        let pscDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(pscDivID, rDiv, null, psDiv, (0, $dc4240e6100248ae$export$2a0edc6caa2454db), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        let products = new Map();
        r.setProducts(products);
        $7991f82905a8f5df$var$addAddProductButton(r, rcb, rIDM, rDivID, psDiv, molecules, products);
        // Create collapsible content for transition states.
        let tsDivID = rIDM.addID(rDivID, (0, $13401187c7985864$export$145c1ed87b1a2216).tagName);
        let tsDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(tsDivID);
        let tscDivID = rIDM.addID(tsDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
        let tscDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(tscDivID, rDiv, null, tsDiv, (0, $dc4240e6100248ae$export$f6270d42dca30dc6), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        let transitionStates = new Map();
        r.setTransitionStates(transitionStates);
        $7991f82905a8f5df$var$addAddTransitionStateButton(rIDM, rDivID, tsDiv, molecules, transitionStates);
        // Create collapsible content for MCRCMethod.
        let mmDivId = rIDM.addID(rDivID, (0, $13401187c7985864$export$6fa70ee10f356b6).tagName);
        let mmDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(mmDivId);
        let mmcDivId = rIDM.addID(mmDivId, (0, $dc4240e6100248ae$export$7295f538b9762c5));
        let mmcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(mmcDivId, rDiv, null, mmDiv, (0, $13401187c7985864$export$6fa70ee10f356b6).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        //rDiv.appendChild(mmcDiv);
        let mmAttributes = new Map();
        mmAttributes.set("xsi:type", (0, $13401187c7985864$export$191e95ebb11cc88).xsiType);
        let mm = new (0, $13401187c7985864$export$191e95ebb11cc88)(mmAttributes);
        r.setMCRCMethod(mm);
        let inputString;
        let value;
        {
            // Get value from defaults.
            if ((0, $dc4240e6100248ae$export$ebe90cb607ad99e) != undefined) {
                inputString = (0, $dc4240e6100248ae$export$ebe90cb607ad99e).values.get((0, $13401187c7985864$export$38ce90ac8b004d85).tagName) ?? "";
                if (inputString == "") inputString = "6.00e-12";
            } else inputString = "6.00e-12";
            value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(inputString);
            let peAttributes = new Map();
            let pe = new (0, $13401187c7985864$export$38ce90ac8b004d85)(peAttributes, value);
            mm.setPreExponential(pe);
            let lwi = (0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("number", (0, $dc4240e6100248ae$export$bea69a603fae01a6)(mmDivId, (0, $13401187c7985864$export$38ce90ac8b004d85).tagName, (0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7), (event)=>{
                let target = event.target;
                (0, $dc4240e6100248ae$export$b1e4cbf5b56e0e21)(pe, target);
            }, inputString, (0, $13401187c7985864$export$38ce90ac8b004d85).tagName);
            mmDiv.appendChild(lwi);
            let input = lwi.querySelector('input');
            input.value = inputString;
            (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(input);
            input.addEventListener('change', (event)=>{
                let target = event.target;
                inputString = target.value;
                pe.value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(inputString);
                console.log((0, $13401187c7985864$export$38ce90ac8b004d85).tagName + " changed to " + inputString);
                (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(input);
            });
            (0, $dc4240e6100248ae$export$2b2254f82abcc900)(undefined, peAttributes, lwi, null, (0, $dc4240e6100248ae$export$bea69a603fae01a6)(mmDivId, (0, $13401187c7985864$export$38ce90ac8b004d85).tagName), (0, $13401187c7985864$export$38ce90ac8b004d85).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
            mmDiv.appendChild(lwi);
        }
        {
            // Get value from defaults.
            if ((0, $dc4240e6100248ae$export$ebe90cb607ad99e) != undefined) {
                inputString = (0, $dc4240e6100248ae$export$ebe90cb607ad99e).values.get((0, $13401187c7985864$export$1bdc69d2439d749d).tagName) ?? "";
                if (inputString == "") inputString = "0.0";
            } else inputString = "0.0";
            value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(inputString);
            let aeAttributes = new Map();
            let ae = new (0, $13401187c7985864$export$1bdc69d2439d749d)(aeAttributes, value);
            mm.setActivationEnergy(ae);
            // Create a new div element for the input.
            let lwi = (0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("number", (0, $dc4240e6100248ae$export$bea69a603fae01a6)(mmDivId, (0, $13401187c7985864$export$1bdc69d2439d749d).tagName, (0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7), (event)=>{
                let target = event.target;
                (0, $dc4240e6100248ae$export$b1e4cbf5b56e0e21)(ae, target);
            }, inputString, (0, $13401187c7985864$export$1bdc69d2439d749d).tagName);
            let input = lwi.querySelector('input');
            input.value = inputString;
            (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(input);
            input.addEventListener('change', (event)=>{
                let target = event.target;
                inputString = target.value;
                ae.value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(inputString);
                console.log((0, $13401187c7985864$export$1bdc69d2439d749d).tagName + " changed to " + inputString);
                (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(input);
            });
            (0, $dc4240e6100248ae$export$2b2254f82abcc900)(undefined, aeAttributes, lwi, null, (0, $dc4240e6100248ae$export$bea69a603fae01a6)(mmDivId, (0, $13401187c7985864$export$1bdc69d2439d749d).tagName), (0, $13401187c7985864$export$1bdc69d2439d749d).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
            mmDiv.appendChild(lwi);
        }
        {
            // Get value from defaults.
            if ((0, $dc4240e6100248ae$export$ebe90cb607ad99e) != undefined) {
                inputString = (0, $dc4240e6100248ae$export$ebe90cb607ad99e).values.get((0, $13401187c7985864$export$8d95dd32819bc86c).tagName) ?? "";
                if (inputString == "") inputString = "298";
            } else inputString = "298";
            value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(inputString);
            let tiAttributes = new Map();
            let ti = new (0, $13401187c7985864$export$8d95dd32819bc86c)(tiAttributes, value);
            mm.setTInfinity(ti);
            // Create a new div element for the input.
            let lwi = (0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("number", (0, $dc4240e6100248ae$export$bea69a603fae01a6)(mmDivId, (0, $13401187c7985864$export$8d95dd32819bc86c).tagName, (0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7), (event)=>{
                let target = event.target;
                (0, $dc4240e6100248ae$export$b1e4cbf5b56e0e21)(ti, target);
            }, inputString, (0, $13401187c7985864$export$8d95dd32819bc86c).tagName);
            let input = lwi.querySelector('input');
            input.value = inputString;
            (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(input);
            input.addEventListener('change', (event)=>{
                let target = event.target;
                inputString = target.value;
                ti.value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(inputString);
                console.log((0, $13401187c7985864$export$8d95dd32819bc86c).tagName + " changed to " + inputString);
                (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(input);
            });
            (0, $dc4240e6100248ae$export$2b2254f82abcc900)(undefined, tiAttributes, lwi, null, (0, $dc4240e6100248ae$export$bea69a603fae01a6)(mmDivId, (0, $13401187c7985864$export$8d95dd32819bc86c).tagName), (0, $13401187c7985864$export$8d95dd32819bc86c).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
            mmDiv.appendChild(lwi);
        }
        {
            // Get value from defaults.
            if ((0, $dc4240e6100248ae$export$ebe90cb607ad99e) != undefined) {
                inputString = (0, $dc4240e6100248ae$export$ebe90cb607ad99e).values.get((0, $13401187c7985864$export$d08982dd841d496f).tagName) ?? "";
                if (inputString == "") inputString = "0.08";
            } else inputString = "0.08";
            value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(inputString);
            let niAttributes = new Map();
            let ni = new (0, $13401187c7985864$export$d08982dd841d496f)(niAttributes, value);
            mm.setNInfinity(ni);
            // Create a new div element for the input.
            let lwi = (0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("number", (0, $dc4240e6100248ae$export$bea69a603fae01a6)(mmDivId, (0, $13401187c7985864$export$d08982dd841d496f).tagName, (0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7), (event)=>{
                let target = event.target;
                (0, $dc4240e6100248ae$export$b1e4cbf5b56e0e21)(ni, target);
            }, inputString, (0, $13401187c7985864$export$d08982dd841d496f).tagName);
            mmDiv.appendChild(lwi);
            let input = lwi.querySelector('input');
            input.value = inputString;
            (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(input);
            input.addEventListener('change', (event)=>{
                let target = event.target;
                inputString = target.value;
                ni.value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(inputString);
                console.log((0, $13401187c7985864$export$d08982dd841d496f).tagName + " set to " + inputString);
                (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(input);
            });
            (0, $dc4240e6100248ae$export$2b2254f82abcc900)(undefined, niAttributes, lwi, null, (0, $dc4240e6100248ae$export$bea69a603fae01a6)(mmDivId, (0, $13401187c7985864$export$d08982dd841d496f).tagName), (0, $13401187c7985864$export$d08982dd841d496f).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
            mmDiv.appendChild(lwi);
        }
        // ExcessReactantConc.
        let ercDivId = rIDM.addID(rDivID, (0, $13401187c7985864$export$284227145ed02b04).tagName);
        let ercDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(ercDivId);
        // Get default value.
        if ((0, $dc4240e6100248ae$export$ebe90cb607ad99e) != undefined) {
            inputString = (0, $dc4240e6100248ae$export$ebe90cb607ad99e).values.get((0, $13401187c7985864$export$284227145ed02b04).tagName) ?? "";
            if (inputString == "") inputString = "2.25e+16";
        } else inputString = "2.25e+16";
        value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(inputString);
        let erc = new (0, $13401187c7985864$export$284227145ed02b04)(new Map(), value);
        r.setExcessReactantConc(erc);
        // Create a new div element for the input.
        let lwi = (0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("number", (0, $dc4240e6100248ae$export$bea69a603fae01a6)(ercDivId, (0, $13401187c7985864$export$284227145ed02b04).tagName, (0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7), (event)=>{
            let target = event.target;
            (0, $dc4240e6100248ae$export$b1e4cbf5b56e0e21)(erc, target);
        }, inputString, (0, $13401187c7985864$export$284227145ed02b04).tagName);
        let input = lwi.querySelector('input');
        input.value = inputString;
        (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(input);
        input.addEventListener('change', (event)=>{
            let target = event.target;
            let inputString = target.value;
            erc.value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(inputString);
            console.log((0, $13401187c7985864$export$284227145ed02b04).tagName + " changed to " + inputString);
            (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(input);
        });
        (0, $dc4240e6100248ae$export$2b2254f82abcc900)(undefined, new Map(), lwi, null, (0, $dc4240e6100248ae$export$bea69a603fae01a6)(ercDivId, (0, $13401187c7985864$export$284227145ed02b04).tagName), (0, $13401187c7985864$export$284227145ed02b04).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
        ercDiv.appendChild(lwi);
        rDiv.appendChild(ercDiv);
        // Add a remove reaction button.
        (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(rDiv, (0, $dc4240e6100248ae$export$39c84188a71202f7), ()=>{
            $7991f82905a8f5df$var$removeReaction(rlDiv, rcDiv, rIDM, rDivID, reactions, r);
        });
    });
    return rb;
}
/**
 * For adding an add reactant button.
 * @param r The reaction.
 * @param rIDM The IDManager for the reaction list.
 * @param rDivID The reaction div ID.
 * @param rsDiv The reactants div.
 * @param molecules The molecules map.
 * @param reactants The reactants map.
 */ function $7991f82905a8f5df$var$addAddReactantButton(r, rcb, rIDM, rDivID, rsDiv, molecules, reactants) {
    // Add an add button to add a reactant.
    let addReactantButton = (0, $341c675b659c6d43$export$9b6d6ca62970729f)((0, $dc4240e6100248ae$export$1bb8965d05fbf467), rIDM.addID(rDivID, (0, $13401187c7985864$export$dcfd4302d04b7fb6).tagName, (0, $341c675b659c6d43$export$25280bc3a7ce098e)), (0, $dc4240e6100248ae$export$39c84188a71202f7));
    rsDiv.appendChild(addReactantButton);
    addReactantButton.addEventListener('click', ()=>{
        if (molecules.size === 0) {
            // Instruct user to add a molecule.
            alert("Please add a molecule to the moleculeList first.");
            return;
        }
        //let reactantDivID: string = rIDM.addID(rDivID, Reactant.tagName, mid);
        //let reactantDiv: HTMLDivElement = createDiv(reactantDivID);
        let reactantDiv = (0, $341c675b659c6d43$export$78253536c0178a32)(undefined);
        rsDiv.insertBefore(reactantDiv, addReactantButton);
        // Create a selector to select a molecule as a reactant.
        let selectReactant = (0, $341c675b659c6d43$export$b89bf4b169286865)((0, $dc4240e6100248ae$export$5ac38056c0103baa)(molecules), (0, $341c675b659c6d43$export$8797b0c8298d191), "", (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(rDivID, (0, $13401187c7985864$export$dcfd4302d04b7fb6).tagName, (0, $341c675b659c6d43$export$8797b0c8298d191)), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        // Have the select element update options if new molecules are added.
        selectReactant.classList.add((0, $5b710835528e7170$export$b33a132661f4be58).tagName);
        reactantDiv.appendChild(selectReactant);
        // Add an event listener to the select element.
        selectReactant.addEventListener('click', (event)=>{
            if (selectReactant.options.length === 1) {
                // If there is only one option then select it.
                alert("As there is only one molecule it will be selected.");
                selectReactant.selectedIndex = 0;
                selectReactant.dispatchEvent(new Event('change'));
            }
        });
        selectReactant.addEventListener('change', (event)=>{
            let target = event.target;
            let molecule = molecules.get(target.value);
            let rmAttributes = new Map();
            let mid = molecule.getID();
            if (reactants.has(mid)) {
                alert("Molecule already selected as a reactant. Please select a different molecule \
                (you may want to add more molecules to the moleculeList).");
                // Remove the select element.
                reactantDiv.removeChild(selectReactant);
                return;
            }
            reactantDiv.id = rIDM.addID(rDivID, (0, $13401187c7985864$export$dcfd4302d04b7fb6).tagName, mid);
            rmAttributes.set((0, $13401187c7985864$export$e8a062bb2fc9e2ba).s_ref, mid);
            let rm = new (0, $13401187c7985864$export$e8a062bb2fc9e2ba)(rmAttributes);
            let reactant = new (0, $13401187c7985864$export$dcfd4302d04b7fb6)(new Map(), rm);
            reactants.set(mid, reactant);
            r.addReactant(reactant);
            // Update the collapsible button label with the molecule name.
            rcb.textContent = r.getLabel();
            console.log("ReactionLabel=" + r.getLabel());
            // Create a new div for the role selector.
            let lws = (0, $341c675b659c6d43$export$4c3eba01cd3c5ba4)(rm.getRef() + " role", (0, $13401187c7985864$export$dcfd4302d04b7fb6).roleOptions, "Role", rm.getRole(), (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(rDivID, (0, $341c675b659c6d43$export$8797b0c8298d191)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            let select = lws.querySelector('select');
            select?.addEventListener('change', (event)=>{
                let target = event.target;
                rm.setRole(target.value);
                console.log("Set Role to " + target.value);
                (0, $341c675b659c6d43$export$fdd146df37959fe8)(target);
            });
            reactantDiv.appendChild(lws);
            // Remove the select element.
            reactantDiv.removeChild(selectReactant);
            // Add a remove button to remove the reactant.
            let rrb = (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(reactantDiv, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), ()=>{
                rsDiv.removeChild(reactantDiv);
                reactants.delete(mid);
                r.removeReactant(mid);
                // Redraw the reaction diagram.
                (0, $dc4240e6100248ae$export$e7cd7bead34ef747)();
            });
            // Redraw the reaction diagram.
            (0, $dc4240e6100248ae$export$e7cd7bead34ef747)();
        });
        if (selectReactant.options.length === 1) {
            // If there is only one option then select it.
            selectReactant.selectedIndex = 0;
            selectReactant.dispatchEvent(new Event('change'));
        }
    });
}
/**
 * For adding an add product button.
 * @param rcb The reaction button.
 * @param rIDM The IDManager for the reaction list.
 * @param rDivID The reaction div ID.
 * @param psDiv The products div.
 * @param molecules The molecules map.
 * @param products The products map.
 */ function $7991f82905a8f5df$var$addAddProductButton(r, rcb, rIDM, rDivID, psDiv, molecules, products) {
    // Add an add button to add a product.
    let addProductButton = (0, $341c675b659c6d43$export$9b6d6ca62970729f)((0, $dc4240e6100248ae$export$1bb8965d05fbf467), rIDM.addID(rDivID, (0, $13401187c7985864$export$264ad599d7cef668).tagName, (0, $341c675b659c6d43$export$25280bc3a7ce098e)), (0, $dc4240e6100248ae$export$39c84188a71202f7));
    psDiv.appendChild(addProductButton);
    addProductButton.addEventListener('click', ()=>{
        if (molecules.size === 0) {
            // Instruct user to add a molecule.
            alert("Please add a molecule to the moleculeList first.");
            return;
        }
        //let productDivID: string = rIDM.addID(rDivID, Product.tagName, mid);
        //let productDiv: HTMLDivElement = createDiv(productDivID);
        let productDiv = (0, $341c675b659c6d43$export$78253536c0178a32)(undefined);
        psDiv.insertBefore(productDiv, addProductButton);
        // Create a selector to select a molecule as a product.
        let selectProduct = (0, $341c675b659c6d43$export$b89bf4b169286865)((0, $dc4240e6100248ae$export$5ac38056c0103baa)(molecules), (0, $341c675b659c6d43$export$8797b0c8298d191), "", (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(rDivID, (0, $13401187c7985864$export$264ad599d7cef668).tagName, (0, $341c675b659c6d43$export$8797b0c8298d191)), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        // Have the select element update options if new molecules are added.
        selectProduct.classList.add((0, $5b710835528e7170$export$b33a132661f4be58).tagName);
        productDiv.appendChild(selectProduct);
        // Add an event listener to the select element.
        selectProduct.addEventListener('click', (event)=>{
            if (selectProduct.options.length === 1) {
                // If there is only one option then select it.
                alert("As there is only one molecule it will be selected.");
                selectProduct.selectedIndex = 0;
                selectProduct.dispatchEvent(new Event('change'));
            }
        });
        selectProduct.addEventListener('change', (event)=>{
            let target = event.target;
            let molecule = molecules.get(target.value);
            let rmAttributes = new Map();
            let mid = molecule.getID();
            if (products.has(mid)) {
                alert("Molecule already selected as a product. Please select a different molecule (you may want to add more molecules to the moleculeList).");
                // Remove the select element.
                productDiv.removeChild(selectProduct);
                //r.removeProduct(target.value);
                return;
            }
            productDiv.id = rIDM.addID(rDivID, (0, $13401187c7985864$export$264ad599d7cef668).tagName, mid);
            rmAttributes.set((0, $13401187c7985864$export$e8a062bb2fc9e2ba).s_ref, mid);
            let rm = new (0, $13401187c7985864$export$e8a062bb2fc9e2ba)(rmAttributes);
            let product = new (0, $13401187c7985864$export$264ad599d7cef668)(new Map(), rm);
            products.set(mid, product);
            r.addProduct(product);
            // Update the collapsible button label with the molecule name.
            rcb.textContent = r.getLabel();
            console.log("ReactionLabel=" + r.getLabel());
            // Create a new div for the role selector.
            let lws = (0, $341c675b659c6d43$export$4c3eba01cd3c5ba4)(rm.getRef() + " role", (0, $13401187c7985864$export$264ad599d7cef668).roleOptions, "Role", rm.getRole(), (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(rDivID, (0, $341c675b659c6d43$export$8797b0c8298d191)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            let select = lws.querySelector('select');
            select?.addEventListener('change', (event)=>{
                let target = event.target;
                rm.setRole(target.value);
                console.log("Set Role to " + target.value);
                (0, $341c675b659c6d43$export$fdd146df37959fe8)(target);
            });
            productDiv.appendChild(lws);
            // Remove the select element.
            productDiv.removeChild(selectProduct);
            // Add a remove button to remove the product.
            let prb = (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(productDiv, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), ()=>{
                psDiv.removeChild(productDiv);
                products.delete(mid);
                r.removeProduct(mid);
                // Redraw the reaction diagram.
                (0, $dc4240e6100248ae$export$e7cd7bead34ef747)();
            });
            // Redraw the reaction diagram.
            (0, $dc4240e6100248ae$export$e7cd7bead34ef747)();
        });
        if (selectProduct.options.length === 1) {
            // If there is only one option then select it.
            selectProduct.selectedIndex = 0;
            selectProduct.dispatchEvent(new Event('change'));
        }
    });
}
/**
 * For adding an add transition state button.
 * @param rIDM The IDManager for the reaction list.
 * @param rDivID The reaction div ID.
 * @param tsDiv The transition state div.
 * @param molecules The molecules map.
 * @param transitionStates The transition states map.
 */ function $7991f82905a8f5df$var$addAddTransitionStateButton(rIDM, rDivID, tsDiv, molecules, transitionStates) {
    // Add an add button to add a transition state.
    let addTSButton = (0, $341c675b659c6d43$export$9b6d6ca62970729f)((0, $dc4240e6100248ae$export$1bb8965d05fbf467), rIDM.addID(rDivID, (0, $13401187c7985864$export$145c1ed87b1a2216).tagName, (0, $341c675b659c6d43$export$25280bc3a7ce098e)), (0, $dc4240e6100248ae$export$39c84188a71202f7));
    tsDiv.appendChild(addTSButton);
    addTSButton.addEventListener('click', ()=>{
        if (molecules.size === 0) {
            // Instruct user to add a molecule.
            alert("Please add a molecule to the moleculeList first.");
            return;
        }
        let ts2Div = (0, $341c675b659c6d43$export$78253536c0178a32)(undefined);
        tsDiv.insertBefore(ts2Div, addTSButton);
        // Create a selector to select a molecule as a reactant.
        let selectTS = (0, $341c675b659c6d43$export$b89bf4b169286865)((0, $dc4240e6100248ae$export$5ac38056c0103baa)(molecules), (0, $341c675b659c6d43$export$8797b0c8298d191), "", (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(rDivID, (0, $13401187c7985864$export$145c1ed87b1a2216).tagName, (0, $341c675b659c6d43$export$8797b0c8298d191)), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        // Have the select element update options if new molecules are added.
        selectTS.classList.add((0, $5b710835528e7170$export$b33a132661f4be58).tagName);
        ts2Div.appendChild(selectTS);
        // Add an event listener to the select element.
        selectTS.addEventListener('click', (event)=>{
            if (selectTS.options.length === 1) {
                // If there is only one option then select it.
                alert("As there is only one molecule it will be selected.");
                selectTS.selectedIndex = 0;
                selectTS.dispatchEvent(new Event('change'));
            }
        });
        selectTS.addEventListener('change', (event)=>{
            let target = event.target;
            let molecule = molecules.get(target.value);
            let rmAttributes = new Map();
            let mid = molecule.getID();
            if (transitionStates.has(mid)) {
                alert("Molecule already selected as a transitionState. Please select a different molecule (you may want to add more molecules to the moleculeList).");
                // Remove the select element.
                tsDiv.removeChild(selectTS);
                return;
            }
            ts2Div.id = rIDM.addID(rDivID, (0, $13401187c7985864$export$145c1ed87b1a2216).tagName, mid);
            rmAttributes.set((0, $13401187c7985864$export$e8a062bb2fc9e2ba).s_ref, mid);
            let rm = new (0, $13401187c7985864$export$e8a062bb2fc9e2ba)(rmAttributes);
            let reactant = new (0, $13401187c7985864$export$145c1ed87b1a2216)(new Map(), rm);
            transitionStates.set(mid, reactant);
            // Create a label for the Transition State role.
            let label = (0, $341c675b659c6d43$export$f2839682b8c07f35)(rm.getRef() + " role " + (0, $13401187c7985864$export$145c1ed87b1a2216).role, (0, $dc4240e6100248ae$export$39c84188a71202f7));
            ts2Div.appendChild(label);
            // Remove the select element.
            ts2Div.removeChild(selectTS);
            // Add a remove button to remove the transition state.
            let rrb = (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(ts2Div, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), ()=>{
                ts2Div.removeChild(tsDiv);
                transitionStates.delete(mid);
            });
        });
        if (selectTS.options.length === 1) {
            // If there is only one option then select it.
            selectTS.selectedIndex = 0;
            selectTS.dispatchEvent(new Event('change'));
        }
    });
}
/**
 * Remove a reaction.
 * @param rlDiv The reaction list div.
 * @param rcDiv The reaction collapsible div.
 * @param rIDM The reaction list IDManager.
 * @param rDivID The reaction div ID.
 * @param reactions The reactions map.
 * @param r The reaction to remove.
 */ function $7991f82905a8f5df$var$removeReaction(rlDiv, rcDiv, rIDM, rDivID, reactions, r) {
    rlDiv.removeChild(rcDiv);
    rIDM.removeIDs(rDivID);
    rIDM.removeIDs((0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(rDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5)));
    rIDM.removeIDs((0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(rDivID, (0, $13401187c7985864$export$dcfd4302d04b7fb6).tagName));
    reactions.delete(r.id);
    (0, $dc4240e6100248ae$export$3bb92be1f57fd129).getReactionList().removeReaction(r.id);
}
function $7991f82905a8f5df$export$ef4959ac45646090(xml, rIDM, rsDivID, reactions, molecules) {
    let bid = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(rsDivID, (0, $341c675b659c6d43$export$25280bc3a7ce098e));
    let rcb = document.querySelector(bid);
    // Create div to contain the reaction list.
    let rlDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(undefined, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    // Get the XML "reactionList" element.
    let xml_reactionList = (0, $057fa7562ec736a9$export$b7531b8ff18dc588)(xml, (0, $ccef02370f58a770$export$44466a39ca846289).tagName);
    // Check the XML "reactionList" element has one or more "reaction" elements and no other elements.
    let reactionListTagNames = new Set();
    xml_reactionList.childNodes.forEach(function(node) {
        reactionListTagNames.add(node.nodeName);
    });
    if (reactionListTagNames.size > 0) {
        if (reactionListTagNames.size != 1) {
            if (!(reactionListTagNames.size == 2 && reactionListTagNames.has("#text") || reactionListTagNames.size == 3 && reactionListTagNames.has("#text") && reactionListTagNames.has("#comment"))) {
                console.error("reactionListTagNames:");
                reactionListTagNames.forEach((x)=>console.error(x));
                throw new Error("Additional tag names in reactionList:");
            }
        }
        if (!reactionListTagNames.has((0, $13401187c7985864$export$d2ae4167a30cf6bb).tagName)) throw new Error("Expecting tags with \"" + (0, $13401187c7985864$export$d2ae4167a30cf6bb).tagName + "\" tagName but there are none!");
        // Process the XML "reaction" elements.
        let xml_reactions = xml_reactionList.getElementsByTagName((0, $13401187c7985864$export$d2ae4167a30cf6bb).tagName);
        let xml_reactions_length = xml_reactions.length;
        console.log("Number of reactions=" + xml_reactions_length);
        //xml_reactions.forEach(function (xml_reaction) { // Cannot iterate over HTMLCollectionOf<Element> like this.
        for(let i = 0; i < xml_reactions.length; i++){
            // Set attributes.
            let reactionAttributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_reactions[i]);
            // Create reaction.
            let reaction = new (0, $13401187c7985864$export$d2ae4167a30cf6bb)(reactionAttributes);
            reactions.set(reaction.id, reaction);
            let reactionTagNames = new Set();
            let cns = xml_reactions[i].childNodes;
            // Create a new div for the reaction.
            let reactionDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)((0, $13401187c7985864$export$d2ae4167a30cf6bb).tagName, i);
            let reactionDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(reactionDivID);
            //console.log("cns.length=" + cns.length);
            //cns.forEach(function (cn) {
            for(let j = 0; j < cns.length; j++){
                let cn = cns[j];
                // Check for nodeName repeats that are not #text.
                if (!reactionTagNames.has(cn.nodeName)) reactionTagNames.add(cn.nodeName);
                else // nodeName = #text are comments or white space/newlines in the XML which are ignored.
                if (cn.nodeName != "#text") console.warn("Another ChildNode with nodeName=" + cn.nodeName);
            //console.log(cn.nodeName);
            }
            // Reactions typically have one or more reactant and product. They may also have one or more "me:transitionState" and other things...
            // Load reactants.
            let xml_reactants = xml_reactions[i].getElementsByTagName((0, $13401187c7985864$export$dcfd4302d04b7fb6).tagName);
            reactionTagNames.delete((0, $13401187c7985864$export$dcfd4302d04b7fb6).tagName);
            //console.log("xml_reactants.length=" + xml_reactants.length);
            // Create a new collapsible div for the reactants.
            let rsDivID = rIDM.addID(reactionDivID, (0, $13401187c7985864$export$dcfd4302d04b7fb6).tagName);
            let rsDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(rsDivID);
            let rscDivID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(rsDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
            let rscDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(rscDivID, reactionDiv, null, rsDiv, (0, $dc4240e6100248ae$export$ae4e72e6b8ac1d64), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            let reactants = new Map();
            if (xml_reactants.length > 0) {
                for(let j = 0; j < xml_reactants.length; j++){
                    let reactantDivID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(rsDivID, (0, $13401187c7985864$export$dcfd4302d04b7fb6).tagName, j);
                    let reactantDiv = (0, $341c675b659c6d43$export$78253536c0178a32)(reactantDivID);
                    rsDiv.appendChild(reactantDiv);
                    let xml_molecule = (0, $057fa7562ec736a9$export$91e73a91db22e6a2)(xml_reactants[j], (0, $597d59a3d37b5b3f$export$3da9759ad07746a3).tagName);
                    let rmAttributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_molecule);
                    let molecule = new (0, $13401187c7985864$export$e8a062bb2fc9e2ba)(rmAttributes);
                    let reactant = new (0, $13401187c7985864$export$dcfd4302d04b7fb6)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_reactants[j]), molecule);
                    reactants.set(molecule.getRef(), reactant);
                    // Create a new div for the role.
                    let lws = (0, $341c675b659c6d43$export$4c3eba01cd3c5ba4)(molecule.getRef() + " role", (0, $13401187c7985864$export$dcfd4302d04b7fb6).roleOptions, "Role", molecule.getRole(), rIDM.addID(reactantDivID, (0, $341c675b659c6d43$export$8797b0c8298d191)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                    lws.querySelector('select')?.addEventListener('change', (event)=>{
                        let target = event.target;
                        molecule.setRole(target.value);
                        console.log("Set Role to " + target.value);
                        (0, $341c675b659c6d43$export$fdd146df37959fe8)(target);
                    });
                    reactantDiv.appendChild(lws);
                    // Add a remove button to remove the reactant.
                    let rrb = (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(reactantDiv, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), ()=>{
                        rsDiv.removeChild(reactantDiv);
                        rIDM.removeIDs(reactantDivID);
                        reactants.delete(molecule.getRef());
                    });
                }
                reaction.setReactants(reactants);
            }
            $7991f82905a8f5df$var$addAddReactantButton(reaction, rcb, rIDM, reactionDivID, rsDiv, molecules, reactants);
            // Load products.
            let xml_products = xml_reactions[i].getElementsByTagName((0, $13401187c7985864$export$264ad599d7cef668).tagName);
            reactionTagNames.delete((0, $13401187c7985864$export$264ad599d7cef668).tagName);
            //console.log("xml_products.length=" + xml_products.length);
            // Create collapsible div for the products.
            let psDivID = rIDM.addID(reactionDivID, (0, $13401187c7985864$export$264ad599d7cef668).tagName);
            let psDiv = (0, $341c675b659c6d43$export$78253536c0178a32)(psDivID);
            let pscDivID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(psDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
            let pscDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(pscDivID, reactionDiv, null, psDiv, (0, $dc4240e6100248ae$export$2a0edc6caa2454db), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            //let products: Product[] = [];
            let products = new Map();
            if (xml_products.length > 0) {
                for(let j = 0; j < xml_products.length; j++){
                    let xml_molecule = (0, $057fa7562ec736a9$export$91e73a91db22e6a2)(xml_products[j], (0, $597d59a3d37b5b3f$export$3da9759ad07746a3).tagName);
                    let molecule = new (0, $13401187c7985864$export$e8a062bb2fc9e2ba)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_molecule));
                    let product = new (0, $13401187c7985864$export$264ad599d7cef668)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_products[j]), molecule);
                    //products.push(product);
                    products.set(molecule.getRef(), product);
                    let lws = (0, $341c675b659c6d43$export$4c3eba01cd3c5ba4)(molecule.getRef() + " role", (0, $13401187c7985864$export$264ad599d7cef668).roleOptions, molecule.getRole(), molecule.getRef(), rIDM.addID(psDivID, j, "Role"), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                    let select = lws.querySelector('select');
                    select.value = molecule.getRole();
                    select.addEventListener('change', (event)=>{
                        let target = event.target;
                        molecule.setRole(target.value);
                        console.log("Set Role to " + target.value);
                        (0, $341c675b659c6d43$export$fdd146df37959fe8)(target);
                    });
                    (0, $341c675b659c6d43$export$fdd146df37959fe8)(select);
                    psDiv.appendChild(lws);
                    // Add a remove button to remove the product.
                    let prb = (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(psDiv, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), ()=>{
                        psDiv.removeChild(lws);
                        rIDM.removeIDs(psDivID);
                        products.delete(molecule.getRef());
                    });
                }
                reaction.setProducts(products);
            }
            $7991f82905a8f5df$var$addAddProductButton(reaction, rcb, rIDM, reactionDivID, psDiv, molecules, products);
            // Create a new collapsible div for the reaction.
            let reactioncDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(reactionDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
            let reactioncDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(reactioncDivID, rlDiv, null, reactionDiv, reaction.getLabel(), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            // Load tunneling.
            let xml_tunneling = xml_reactions[i].getElementsByTagName((0, $13401187c7985864$export$c3cf6f96dac11421).tagName);
            if (xml_tunneling.length > 0) {
                if (xml_tunneling.length > 1) throw new Error("Expecting 1 " + (0, $13401187c7985864$export$c3cf6f96dac11421).tagName + " but finding " + xml_tunneling.length + "!");
                let tunneling = new (0, $13401187c7985864$export$c3cf6f96dac11421)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_tunneling[0]));
                reaction.setTunneling(tunneling);
                let lws = (0, $341c675b659c6d43$export$4c3eba01cd3c5ba4)((0, $13401187c7985864$export$c3cf6f96dac11421).tagName, (0, $13401187c7985864$export$c3cf6f96dac11421).options, (0, $dc4240e6100248ae$export$4402a75a856d5151), tunneling.getName(), (0, $dc4240e6100248ae$export$bea69a603fae01a6)(reactionDivID, (0, $13401187c7985864$export$c3cf6f96dac11421).tagName), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                lws.querySelector('select')?.addEventListener('change', (event)=>{
                    let target = event.target;
                    tunneling.setName(target.value);
                    console.log("Set Tunneling to " + target.value);
                    (0, $341c675b659c6d43$export$fdd146df37959fe8)(target);
                });
                reactionDiv.appendChild(lws);
            }
            // Load transition states.
            let xml_transitionStates = xml_reactions[i].getElementsByTagName((0, $13401187c7985864$export$145c1ed87b1a2216).tagName);
            //console.log("xml_transitionStates.length=" + xml_transitionStates.length);
            // Create collapsible div.
            let tsDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(reactionDivID, (0, $13401187c7985864$export$145c1ed87b1a2216).tagName);
            let tsDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(tsDivID);
            let tscDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(tsDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
            let tscDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(tscDivID, reactionDiv, null, tsDiv, (0, $dc4240e6100248ae$export$f6270d42dca30dc6), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            let transitionStates = new Map();
            if (xml_transitionStates.length > 0) {
                for(let j = 0; j < xml_transitionStates.length; j++){
                    let xml_molecule = (0, $057fa7562ec736a9$export$91e73a91db22e6a2)(xml_transitionStates[j], (0, $597d59a3d37b5b3f$export$3da9759ad07746a3).tagName);
                    let molecule = new (0, $13401187c7985864$export$e8a062bb2fc9e2ba)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_molecule));
                    let transitionState = new (0, $13401187c7985864$export$145c1ed87b1a2216)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_transitionStates[j]), molecule);
                    transitionStates.set(molecule.getRef(), transitionState);
                    // Create a label for the Transition State role.
                    let label = (0, $341c675b659c6d43$export$f2839682b8c07f35)(molecule.getRef() + " role " + (0, $13401187c7985864$export$145c1ed87b1a2216).role, (0, $dc4240e6100248ae$export$39c84188a71202f7));
                    tsDiv.appendChild(label);
                }
                reaction.setTransitionStates(transitionStates);
            }
            $7991f82905a8f5df$var$addAddTransitionStateButton(rIDM, reactionDivID, tsDiv, molecules, transitionStates);
            // Load MCRCMethod.
            //console.log("Load MCRCMethod...");
            let xml_MCRCMethod = xml_reactions[i].getElementsByTagName((0, $13401187c7985864$export$6fa70ee10f356b6).tagName);
            //console.log("xml_MCRCMethod=" + xml_MCRCMethod);
            //console.log("xml_MCRCMethod.length=" + xml_MCRCMethod.length);
            if (xml_MCRCMethod.length > 0) {
                if (xml_MCRCMethod.length > 1) throw new Error("Expecting 1 " + (0, $13401187c7985864$export$6fa70ee10f356b6).tagName + " but finding " + xml_MCRCMethod.length + "!");
                else {
                    let mm;
                    let mmAttributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_MCRCMethod[0]);
                    let type = mmAttributes.get("xsi:type");
                    if (type == undefined) // If there is no xsi:type search for a name.
                    type = mmAttributes.get("name");
                    let mmDivId = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(reactionDivID, (0, $13401187c7985864$export$6fa70ee10f356b6).tagName);
                    let mmDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(mmDivId);
                    if (type == (0, $13401187c7985864$export$191e95ebb11cc88).xsiType || type == (0, $13401187c7985864$export$191e95ebb11cc88).xsiType2) {
                        // Create a collapsible div.
                        let mmcDivId = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(mmDivId, (0, $dc4240e6100248ae$export$7295f538b9762c5));
                        let mmcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(mmcDivId, reactionDiv, null, mmDiv, (0, $13401187c7985864$export$6fa70ee10f356b6).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                        reactionDiv.appendChild(mmcDiv);
                        //console.log(MCRCMethod.tagName + " name=" + name);
                        mm = new (0, $13401187c7985864$export$191e95ebb11cc88)(mmAttributes);
                        //console.log(MCRCMethod.tagName + "xsi:type=" + type);
                        let xml_pe = xml_MCRCMethod[0].getElementsByTagName((0, $13401187c7985864$export$38ce90ac8b004d85).tagName);
                        if (xml_pe != null) {
                            if (xml_pe[0] != null) {
                                let inputString = (0, $057fa7562ec736a9$export$433c819efd6b1ea5)(xml_pe[0]);
                                let value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(inputString);
                                let peAttributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_pe[0]);
                                let pe = new (0, $13401187c7985864$export$38ce90ac8b004d85)(peAttributes, value);
                                mm.setPreExponential(pe);
                                // Create a new div element for the input.
                                let lwi = (0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("number", (0, $dc4240e6100248ae$export$bea69a603fae01a6)(mmDivId, (0, $13401187c7985864$export$38ce90ac8b004d85).tagName, (0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7), (event)=>{
                                    let target = event.target;
                                    (0, $dc4240e6100248ae$export$b1e4cbf5b56e0e21)(pe, target);
                                }, inputString, (0, $13401187c7985864$export$38ce90ac8b004d85).tagName);
                                mmDiv.appendChild(lwi);
                                let input = lwi.querySelector('input');
                                input.value = inputString;
                                (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(input);
                                input.addEventListener('change', (event)=>{
                                    let target = event.target;
                                    inputString = target.value;
                                    pe.value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(inputString);
                                    console.log((0, $13401187c7985864$export$38ce90ac8b004d85).tagName + " changed to " + inputString);
                                    (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(input);
                                });
                                (0, $dc4240e6100248ae$export$2b2254f82abcc900)(undefined, peAttributes, lwi, null, (0, $dc4240e6100248ae$export$bea69a603fae01a6)(mmDivId, (0, $13401187c7985864$export$38ce90ac8b004d85).tagName), (0, $13401187c7985864$export$38ce90ac8b004d85).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
                                mmDiv.appendChild(lwi);
                            }
                        }
                        //console.log("preExponential " + preExponential);
                        let xml_ae = xml_MCRCMethod[0].getElementsByTagName((0, $13401187c7985864$export$1bdc69d2439d749d).tagName);
                        if (xml_ae != null) {
                            if (xml_ae[0] != null) {
                                let inputString = (0, $057fa7562ec736a9$export$433c819efd6b1ea5)(xml_ae[0]);
                                let value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(inputString);
                                let aeAttributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_ae[0]);
                                let ae = new (0, $13401187c7985864$export$1bdc69d2439d749d)(aeAttributes, value);
                                mm.setActivationEnergy(ae);
                                // Create a new div element for the input.
                                let lwi = (0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("number", (0, $dc4240e6100248ae$export$bea69a603fae01a6)(mmDivId, (0, $13401187c7985864$export$1bdc69d2439d749d).tagName, (0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7), (event)=>{
                                    let target = event.target;
                                    (0, $dc4240e6100248ae$export$b1e4cbf5b56e0e21)(ae, target);
                                }, inputString, (0, $13401187c7985864$export$1bdc69d2439d749d).tagName);
                                let input = lwi.querySelector('input');
                                input.value = inputString;
                                (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(input);
                                input.addEventListener('change', (event)=>{
                                    let target = event.target;
                                    inputString = target.value;
                                    ae.value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(inputString);
                                    console.log((0, $13401187c7985864$export$1bdc69d2439d749d).tagName + " changed to " + inputString);
                                    (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(input);
                                });
                                (0, $dc4240e6100248ae$export$2b2254f82abcc900)(undefined, aeAttributes, lwi, null, (0, $dc4240e6100248ae$export$bea69a603fae01a6)(mmDivId, (0, $13401187c7985864$export$1bdc69d2439d749d).tagName), (0, $13401187c7985864$export$1bdc69d2439d749d).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
                                mmDiv.appendChild(lwi);
                            }
                        }
                        //console.log("activationEnergy " + activationEnergy);
                        let xml_ti = xml_MCRCMethod[0].getElementsByTagName((0, $13401187c7985864$export$8d95dd32819bc86c).tagName);
                        if (xml_ti != null) {
                            if (xml_ti[0] != null) {
                                let inputString = (0, $057fa7562ec736a9$export$433c819efd6b1ea5)(xml_ti[0]);
                                let value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(inputString);
                                let tiAttributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_ti[0]);
                                let ti = new (0, $13401187c7985864$export$8d95dd32819bc86c)(tiAttributes, value);
                                mm.setTInfinity(ti);
                                // Create a new div element for the input.
                                let lwi = (0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("number", (0, $dc4240e6100248ae$export$bea69a603fae01a6)(mmDivId, (0, $13401187c7985864$export$8d95dd32819bc86c).tagName, (0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7), (event)=>{
                                    let target = event.target;
                                    (0, $dc4240e6100248ae$export$b1e4cbf5b56e0e21)(ti, target);
                                }, inputString, (0, $13401187c7985864$export$8d95dd32819bc86c).tagName);
                                let input = lwi.querySelector('input');
                                input.value = inputString;
                                (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(input);
                                input.addEventListener('change', (event)=>{
                                    let target = event.target;
                                    inputString = target.value;
                                    ti.value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(inputString);
                                    console.log((0, $13401187c7985864$export$8d95dd32819bc86c).tagName + " changed to " + inputString);
                                    (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(input);
                                });
                                (0, $dc4240e6100248ae$export$2b2254f82abcc900)(undefined, tiAttributes, lwi, null, (0, $dc4240e6100248ae$export$bea69a603fae01a6)(mmDivId, (0, $13401187c7985864$export$8d95dd32819bc86c).tagName), (0, $13401187c7985864$export$8d95dd32819bc86c).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
                                mmDiv.appendChild(lwi);
                            }
                        }
                        //console.log("tInfinity " + tInfinity);
                        let xml_ni = xml_MCRCMethod[0].getElementsByTagName((0, $13401187c7985864$export$d08982dd841d496f).tagName);
                        if (xml_ni != null) {
                            if (xml_ni[0] != null) {
                                let inputString = (0, $057fa7562ec736a9$export$433c819efd6b1ea5)(xml_ni[0]);
                                let value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(inputString);
                                let niAttributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_ni[0]);
                                let ni = new (0, $13401187c7985864$export$d08982dd841d496f)(niAttributes, value);
                                mm.setNInfinity(ni);
                                // Create a new div element for the input.
                                let lwi = (0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("number", (0, $dc4240e6100248ae$export$bea69a603fae01a6)(mmDivId, (0, $13401187c7985864$export$d08982dd841d496f).tagName, (0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7), (event)=>{
                                    let target = event.target;
                                    (0, $dc4240e6100248ae$export$b1e4cbf5b56e0e21)(ni, target);
                                }, inputString, (0, $13401187c7985864$export$d08982dd841d496f).tagName);
                                mmDiv.appendChild(lwi);
                                let inputElement = lwi.querySelector('input');
                                inputElement.value = inputString;
                                (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(inputElement);
                                inputElement.addEventListener('change', (event)=>{
                                    let target = event.target;
                                    inputString = target.value;
                                    ni.value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(inputString);
                                    console.log((0, $13401187c7985864$export$d08982dd841d496f).tagName + " set to " + inputString);
                                    (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(inputElement);
                                });
                                (0, $dc4240e6100248ae$export$2b2254f82abcc900)(undefined, niAttributes, lwi, null, (0, $dc4240e6100248ae$export$bea69a603fae01a6)(mmDivId, (0, $13401187c7985864$export$d08982dd841d496f).tagName), (0, $13401187c7985864$export$d08982dd841d496f).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
                                mmDiv.appendChild(lwi);
                            }
                        }
                    } else {
                        mm = new (0, $13401187c7985864$export$6fa70ee10f356b6)(mmAttributes);
                        let mCRCMethodLabel = document.createElement('label');
                        mCRCMethodLabel.textContent = (0, $13401187c7985864$export$6fa70ee10f356b6).tagName + ": " + type;
                        Object.assign(mCRCMethodLabel.style, (0, $dc4240e6100248ae$export$39c84188a71202f7));
                        mmDiv.appendChild(mCRCMethodLabel);
                        reactionDiv.appendChild(mmDiv);
                    }
                    reaction.setMCRCMethod(mm);
                }
            }
            // me:excessReactantConc
            let xml_erc = xml_reactions[i].getElementsByTagName((0, $13401187c7985864$export$284227145ed02b04).tagName);
            //console.log("n_me:excessReactantConc=" + xml_erc.length);
            if (xml_erc.length > 0) {
                if (xml_erc.length > 1) throw new Error("Expecting 1 " + (0, $13401187c7985864$export$284227145ed02b04).tagName + " but finding " + xml_erc.length + "!");
                let value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))((0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_erc[0])));
                let erc = new (0, $13401187c7985864$export$284227145ed02b04)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_erc[0]), value);
                reaction.setExcessReactantConc(erc);
                let id = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(reactionDivID, (0, $13401187c7985864$export$284227145ed02b04).tagName);
                let lwi = (0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("number", id, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7), (event)=>{
                    let target = event.target;
                    (0, $dc4240e6100248ae$export$b1e4cbf5b56e0e21)(erc, target);
                }, value.toExponential(), (0, $13401187c7985864$export$284227145ed02b04).tagName);
                reactionDiv.appendChild(lwi);
            }
            // me:canonicalRateList
            let xml_crl = xml_reactions[i].getElementsByTagName((0, $13401187c7985864$export$3f85289af9546f7e).tagName);
            //console.log("n_me:canonicalRateList=" + xml_crl.length);
            if (xml_crl.length > 0) {
                if (xml_crl.length > 1) throw new Error("Expecting 1 " + (0, $13401187c7985864$export$3f85289af9546f7e).tagName + " but finding " + xml_crl.length + "!");
                let clr_attributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_crl[0]);
                let crl = new (0, $13401187c7985864$export$3f85289af9546f7e)(clr_attributes);
                reaction.setCanonicalRateList(crl);
                // Create a new collapsible div for the canonicalRateList.
                let crlDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(reactionDivID, (0, $13401187c7985864$export$3f85289af9546f7e).tagName);
                let crlDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(crlDivID);
                let crlcDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(crlDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
                let crlcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(crlcDivID, reactionDiv, null, crlDiv, (0, $13401187c7985864$export$3f85289af9546f7e).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                reactionDiv.appendChild(crlcDiv);
                //let id = addID(reaction.id, CanonicalRateList.tagName);
                // me:description.
                let xml_d = xml_crl[0].getElementsByTagName((0, $ccef02370f58a770$export$393edc798c47379d).tagName);
                //console.log("xml_d.length=" + xml_d.length);
                if (xml_d.length > 0) {
                    if (xml_d.length > 1) throw new Error("Expecting 1 " + (0, $ccef02370f58a770$export$393edc798c47379d).tagName + " but finding " + xml_d.length + "!");
                    let description = (0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_d[0]));
                    //console.log("description=" + description);
                    crl.setDescription(new (0, $ccef02370f58a770$export$393edc798c47379d)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_d[0]), description));
                    let l = (0, $341c675b659c6d43$export$f2839682b8c07f35)(description + " (" + (0, $93b71ab6968650c1$export$dc22ec7f8e0b9ac)(clr_attributes) + ")", (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
                    let ldiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(undefined, (0, $dc4240e6100248ae$export$39c84188a71202f7));
                    ldiv.appendChild(l);
                    crlDiv.appendChild(ldiv);
                }
                // me:kinf.
                let xml_k = xml_crl[0].getElementsByTagName((0, $13401187c7985864$export$5eb02c9a0d4a6c5).tagName);
                //console.log("xml_k.length=" + xml_k.length);
                if (xml_k.length > 0) {
                    // Create a table for the kinf.
                    let t = (0, $341c675b659c6d43$export$33bbb3ec7652e187)((0, $dc4240e6100248ae$export$bea69a603fae01a6)(crlDivID, (0, $13401187c7985864$export$5eb02c9a0d4a6c5).tagName, (0, $dc4240e6100248ae$export$7a850709da5c4f5b)), (0, $dc4240e6100248ae$export$39c84188a71202f7));
                    crlDiv.appendChild(t);
                    for(let j = 0; j < xml_k.length; j++){
                        let k = new (0, $13401187c7985864$export$5eb02c9a0d4a6c5)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_k[j]));
                        crl.addKinf(k);
                        // T.
                        let xml_T = xml_k[j].getElementsByTagName((0, $ccef02370f58a770$export$971d5caa766a69d7).tagName);
                        //console.log("xml_T.length=" + xml_T.length);
                        if (xml_T.length > 0) {
                            if (xml_T.length > 1) throw new Error("Expecting 1 " + (0, $ccef02370f58a770$export$971d5caa766a69d7).tagName + " but finding " + xml_T.length + "!");
                            let value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))((0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_T[0])));
                            k.setT(new (0, $ccef02370f58a770$export$971d5caa766a69d7)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_T[0]), value));
                        }
                        // Val.
                        let xml_Val = xml_k[j].getElementsByTagName((0, $13401187c7985864$export$38dfac6a73b2b45e).tagName);
                        //console.log("xml_Val.length=" + xml_Val.length);
                        if (xml_Val.length > 0) {
                            if (xml_Val.length > 1) throw new Error("Expecting 1 " + (0, $13401187c7985864$export$38dfac6a73b2b45e).tagName + " but finding " + xml_Val.length + "!");
                            let value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))((0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_Val[0])));
                            k.setVal(new (0, $13401187c7985864$export$38dfac6a73b2b45e)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_Val[0]), value));
                        }
                        // Rev.
                        let xml_Rev = xml_k[j].getElementsByTagName((0, $13401187c7985864$export$a292f79afb9ad235).tagName);
                        //console.log("xml_Rev.length=" + xml_Rev.length);
                        if (xml_Rev.length > 0) {
                            if (xml_Rev.length > 1) throw new Error("Expecting 1 " + (0, $13401187c7985864$export$a292f79afb9ad235).tagName + " but finding " + xml_Rev.length + "!");
                            let value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))((0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_Rev[0])));
                            k.setRev(new (0, $13401187c7985864$export$a292f79afb9ad235)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_Rev[0]), value));
                        }
                        // Keq.
                        let xml_Keq = xml_k[j].getElementsByTagName((0, $13401187c7985864$export$835b53a514d067b0).tagName);
                        //console.log("xml_Keq.length=" + xml_Keq.length);
                        if (xml_Keq.length > 0) {
                            if (xml_Keq.length > 1) throw new Error("Expecting 1 " + (0, $13401187c7985864$export$835b53a514d067b0).tagName + " but finding " + xml_Keq.length + "!");
                            let value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))((0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_Keq[0])));
                            k.setKeq(new (0, $13401187c7985864$export$835b53a514d067b0)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_Keq[0]), value));
                        }
                        if (j == 0) // It maybe that only the first kinf contains unit details!
                        (0, $341c675b659c6d43$export$6c1065e21382520d)(t, k.getHeader());
                        (0, $341c675b659c6d43$export$67d0e2fae00985e1)(t, k.toStringArray());
                    }
                    (0, $dc4240e6100248ae$export$dd526fb3a2a9c049)(crl.toCSV.bind(crl), crlDiv, t, reaction.id + "_" + (0, $13401187c7985864$export$3f85289af9546f7e).tagName, (0, $dc4240e6100248ae$export$39c84188a71202f7));
                }
            }
            // Add a remove reaction button.
            (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(reactionDiv, (0, $dc4240e6100248ae$export$39c84188a71202f7), ()=>{
                $7991f82905a8f5df$var$removeReaction(rlDiv, reactioncDiv, rIDM, reactionDivID, reactions, reaction);
            });
        }
    } else console.warn("No reaction elements found! Please add a reaction in reactionList.");
    // Add a button to add a reaction.
    //getAddReactionButton(rIDM, rlDiv, reactions, molecules);
    return rlDiv;
}









function $d0fe07d64e0283ae$export$120facc5efd57974(xml, conditionsIDs, molecules) {
    console.log((0, $5b710835528e7170$export$363c7374d425f4ad).tagName);
    // Create a div for the conditionss.
    let conditionssDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(undefined, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    // Get the XML "me:conditions" element.
    let xml_conditionss = xml.getElementsByTagName((0, $5b710835528e7170$export$363c7374d425f4ad).tagName);
    for(let i = 0; i < xml_conditionss.length; i++){
        let xml_conditions = xml_conditionss[i];
        // Create a collapsible div for each conditions.
        let cDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)((0, $5b710835528e7170$export$363c7374d425f4ad).tagName, i.toString());
        let cDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(cDivID, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
        let ccDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(cDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
        let ccDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(ccDivID, conditionssDiv, null, cDiv, (0, $5b710835528e7170$export$363c7374d425f4ad).tagName + " " + i.toString(), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        let conditions = $d0fe07d64e0283ae$var$addConditions((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_conditions), i);
        $d0fe07d64e0283ae$var$handleBathGases(conditions, cDiv, xml_conditions, conditionsIDs, molecules);
        $d0fe07d64e0283ae$var$handlePTs(conditions, cDiv, xml_conditions, conditionsIDs, molecules);
        // Add a remove conditions button.
        let removeButton = (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(cDiv, (0, $dc4240e6100248ae$export$39c84188a71202f7), (0, $dc4240e6100248ae$export$3bb92be1f57fd129).removeConditions.bind((0, $dc4240e6100248ae$export$3bb92be1f57fd129)), i);
        removeButton.addEventListener('click', (event)=>{
            // Remove the conditions.
            (0, $dc4240e6100248ae$export$cd7f480d6b8286c3)(ccDivID);
            conditionsIDs.removeIDs(cDivID);
        });
    }
    // Create an add button to add a conditions.
    $d0fe07d64e0283ae$export$c1600199abe19050(conditionssDiv, conditionsIDs, molecules);
    return conditionssDiv;
}
/**
 * @param conditions The conditions.
 * @param cDiv The conditions div.
 * @param conditionsIndex The conditions index.
 * @param xml_conditions The XML conditions.
 */ function $d0fe07d64e0283ae$var$handleBathGases(conditions, cDiv, xml_conditions, conditionsIDs, molecules) {
    // Bath Gases
    // Create a collapsible div.
    let bsDivID = conditionsIDs.addID(cDiv.id, (0, $5b710835528e7170$export$b33a132661f4be58).tagName);
    let bsDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(bsDivID);
    let bscDivID = conditionsIDs.addID(cDiv.id, (0, $5b710835528e7170$export$b33a132661f4be58).tagName, (0, $dc4240e6100248ae$export$7295f538b9762c5));
    let bscDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(bscDivID, cDiv, null, bsDiv, (0, $5b710835528e7170$export$b33a132661f4be58).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
    // Add add button.
    let addBathGasButton = (0, $341c675b659c6d43$export$9b6d6ca62970729f)((0, $dc4240e6100248ae$export$1bb8965d05fbf467), conditionsIDs.addID(cDiv.id, (0, $5b710835528e7170$export$b33a132661f4be58).tagName, (0, $341c675b659c6d43$export$25280bc3a7ce098e)), (0, $dc4240e6100248ae$export$39c84188a71202f7));
    bsDiv.appendChild(addBathGasButton);
    addBathGasButton.addEventListener('click', ()=>{
        let bathGas = new (0, $5b710835528e7170$export$b33a132661f4be58)(new Map(), (0, $dc4240e6100248ae$export$d8b8827abc8ab7e7));
        let bathGasIndex = conditions.addBathGas(bathGas);
        let div = (0, $341c675b659c6d43$export$78253536c0178a32)(undefined, (0, $dc4240e6100248ae$export$39c84188a71202f7));
        let id = conditionsIDs.addID(cDiv.id, (0, $5b710835528e7170$export$b33a132661f4be58).tagName, bathGasIndex.toString());
        let select = $d0fe07d64e0283ae$var$createSelectElementBathGas(Array.from((0, $dc4240e6100248ae$export$5ac38056c0103baa)(molecules)), bathGas, true, id);
        select.classList.add((0, $5b710835528e7170$export$b33a132661f4be58).tagName);
        div.appendChild(select);
        (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(div, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (bathGas)=>{
            bsDiv.removeChild(div);
            conditionsIDs.removeIDs(id), conditions.removeBathGas(bathGas);
        });
        bsDiv.insertBefore(div, addBathGasButton);
    });
    // Process any "bathGas" elements that are immediate children of xml_conditions.
    if (xml_conditions != null) {
        let xml_bathGases = Array.from(xml_conditions.children).filter((child)=>child.tagName === (0, $5b710835528e7170$export$b33a132661f4be58).tagName);
        if (xml_bathGases.length > 0) for(let i = 0; i < xml_bathGases.length; i++){
            let attributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_bathGases[i]);
            let moleculeID = (0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_bathGases[i]));
            let bathGas = new (0, $5b710835528e7170$export$b33a132661f4be58)(attributes, moleculeID);
            //console.log("bathGas " + bathGas.toString());
            let bathGasIndex = conditions.addBathGas(bathGas);
            let id = conditionsIDs.addID(cDiv.id, (0, $5b710835528e7170$export$b33a132661f4be58).tagName, bathGasIndex.toString());
            let div = (0, $341c675b659c6d43$export$78253536c0178a32)(id, (0, $dc4240e6100248ae$export$39c84188a71202f7));
            div.appendChild($d0fe07d64e0283ae$var$createSelectElementBathGas(Array.from((0, $dc4240e6100248ae$export$5ac38056c0103baa)(molecules)), bathGas, false, id));
            (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(div, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (bathGas)=>{
                bsDiv.removeChild(div);
                conditionsIDs.removeIDs(id);
                conditions.removeBathGas(bathGas);
            });
            bsDiv.insertBefore(div, addBathGasButton);
        }
        else {
            let div = (0, $341c675b659c6d43$export$78253536c0178a32)(undefined, (0, $dc4240e6100248ae$export$39c84188a71202f7));
            let id = conditionsIDs.addID(cDiv.id, (0, $5b710835528e7170$export$b33a132661f4be58).tagName, 0);
            div.appendChild($d0fe07d64e0283ae$var$createSelectElementBathGas(Array.from((0, $dc4240e6100248ae$export$5ac38056c0103baa)(molecules)), undefined, false, id));
            (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(div, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (bathGas)=>{
                bsDiv.removeChild(div);
                conditionsIDs.removeIDs(id);
                conditions.removeBathGas(bathGas);
            });
            bsDiv.insertBefore(div, addBathGasButton);
        }
    }
}
/**
 * 
 * @param conditions 
 * @param cDiv
 * @param xml_conditions 
 * @param level 
 * @param nextLevel 
 */ function $d0fe07d64e0283ae$var$handlePTs(conditions, cDiv, xml_conditions, conditionsIDs, molecules) {
    // PTs
    let moleculeKeys = (0, $dc4240e6100248ae$export$5ac38056c0103baa)(molecules);
    // Create collapsible div.
    let pTsDivId = conditionsIDs.addID(cDiv.id, (0, $5b710835528e7170$export$3be0efe793283834).tagName);
    let pTsDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(pTsDivId);
    let pTscDivId = conditionsIDs.addID(cDiv.id, pTsDivId, (0, $dc4240e6100248ae$export$7295f538b9762c5));
    let pTscDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(pTscDivId, cDiv, null, pTsDiv, (0, $5b710835528e7170$export$3be0efe793283834).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
    let pTs = new (0, $5b710835528e7170$export$3be0efe793283834)(new Map());
    if (xml_conditions) {
        let xml_PTss = xml_conditions.getElementsByTagName((0, $5b710835528e7170$export$3be0efe793283834).tagName);
        if (xml_PTss.length > 0) {
            if (xml_PTss.length > 1) throw new Error("Expecting 1 " + (0, $5b710835528e7170$export$3be0efe793283834).tagName + " but finding " + xml_PTss.length + "!");
            let attributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_PTss[0]);
            let xml_PTpairs = xml_PTss[0].getElementsByTagName((0, $5b710835528e7170$export$3fe97ecb6b172244).tagName);
            if (xml_PTpairs.length == 0) console.warn("Expecting 1 or more " + (0, $5b710835528e7170$export$3fe97ecb6b172244).tagName + " but finding 0! Please add some PTpairs in " + (0, $5b710835528e7170$export$363c7374d425f4ad).tagName + " " + conditions.id + ".");
            else {
                pTs = new (0, $5b710835528e7170$export$3be0efe793283834)(attributes);
                for(let i = 0; i < xml_PTpairs.length; i++){
                    let pTpairAttributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_PTpairs[i]);
                    //console.log("pTpairAttributes=" + mapToString(pTpairAttributes));
                    let pTpair = new (0, $5b710835528e7170$export$3fe97ecb6b172244)(pTpairAttributes);
                    pTs.add(pTpair);
                    // BathGas.
                    let xml_bathGass = xml_PTpairs[i].getElementsByTagName((0, $5b710835528e7170$export$b33a132661f4be58).tagName);
                    if (xml_bathGass.length > 0) {
                        if (xml_bathGass.length > 1) console.warn("xml_bathGass.length=" + xml_bathGass.length);
                        pTpair.setBathGas(new (0, $5b710835528e7170$export$b33a132661f4be58)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_bathGass[0]), (0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_bathGass[0]))));
                    }
                    // ExperimentRate.
                    let xml_ers = xml_PTpairs[i].getElementsByTagName((0, $5b710835528e7170$export$cdeafdd1d936ed5b).tagName);
                    if (xml_ers.length > 0) {
                        if (xml_ers.length > 1) console.warn("xml_experimentRates.length=" + xml_ers.length);
                        pTpair.setExperimentalRate(new (0, $5b710835528e7170$export$cdeafdd1d936ed5b)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_ers[0]), new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))((0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_ers[0])).trim())));
                    }
                    // ExperimentalYield.
                    let xml_eys = xml_PTpairs[i].getElementsByTagName((0, $5b710835528e7170$export$c291f4faacd745a6).tagName);
                    if (xml_eys.length > 0) {
                        if (xml_eys.length > 1) console.warn("xml_experimentalYields.length=" + xml_eys.length);
                        pTpair.setExperimentalYield(new (0, $5b710835528e7170$export$c291f4faacd745a6)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_eys[0]), new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))((0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_eys[0])).trim())));
                    }
                    // ExperimentalEigenvalue.
                    let xml_ees = xml_PTpairs[i].getElementsByTagName((0, $5b710835528e7170$export$ed9dfbc127680fd1).tagName);
                    if (xml_ees.length > 0) {
                        if (xml_ees.length > 1) console.warn("xml_experimentalEigenvalues.length=" + xml_ees.length);
                        pTpair.setExperimentalEigenvalue(new (0, $5b710835528e7170$export$ed9dfbc127680fd1)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_ees[0]), new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))((0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_ees[0])).trim())));
                    }
                    // Create pTpairDiv.
                    pTsDiv.appendChild($d0fe07d64e0283ae$var$createPTpairDiv(pTs, pTsDiv, pTpair, cDiv.id, i, moleculeKeys, (0, $dc4240e6100248ae$export$39c84188a71202f7)));
                }
            }
        }
    }
    conditions.setPTs(pTs);
    // Create a buttons div for the add, add from spreadsheet and remove all buttons.
    let pTsButtonsDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(undefined, (0, $dc4240e6100248ae$export$39c84188a71202f7));
    pTsDiv.appendChild(pTsButtonsDiv);
    // Create an add button to add a new PTpair.
    let addButton = (0, $341c675b659c6d43$export$9b6d6ca62970729f)((0, $dc4240e6100248ae$export$1bb8965d05fbf467), undefined, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    pTsButtonsDiv.appendChild(addButton);
    // Add event listener to the addButton.
    addButton.addEventListener('click', ()=>{
        // Create a new PTpair.
        let pTpairAttributes = new Map();
        pTpairAttributes.set("units", "Torr");
        let pTpair = new (0, $5b710835528e7170$export$3fe97ecb6b172244)(pTpairAttributes);
        let pTpairIndex = pTs.add(pTpair);
        console.log("Added new pTpair pTpairIndex=" + pTpairIndex);
        // Create a new div for the PTpair.
        pTsDiv.insertBefore($d0fe07d64e0283ae$var$createPTpairDiv(pTs, pTsDiv, pTpair, cDiv.id, pTpairIndex, moleculeKeys, (0, $dc4240e6100248ae$export$39c84188a71202f7)), pTsButtonsDiv);
    });
    // Create an add from spreadsheet button to add multiple PTPairs.
    let addMultipleButton = (0, $341c675b659c6d43$export$9b6d6ca62970729f)((0, $dc4240e6100248ae$export$3e0cc820631ca658), undefined, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    pTsButtonsDiv.appendChild(addMultipleButton);
    // Add event listener to the addMultipleButton.
    addMultipleButton.addEventListener('click', ()=>{
        // Add a new text input for the user to paste the PTPairs.
        let div = (0, $341c675b659c6d43$export$78253536c0178a32)(undefined, (0, $dc4240e6100248ae$export$39c84188a71202f7));
        let addFromSpreadsheetId = (0, $dc4240e6100248ae$export$bea69a603fae01a6)((0, $5b710835528e7170$export$3be0efe793283834).tagName, "addFromSpreadsheet");
        let input = (0, $341c675b659c6d43$export$d80fffb1deb3b97e)("text", addFromSpreadsheetId, (0, $dc4240e6100248ae$export$39c84188a71202f7));
        div.appendChild(input);
        pTsDiv.insertBefore(div, pTsButtonsDiv);
        // Add an event listener to the inputElement.
        input.addEventListener('change', ()=>{
            console.log("inputElement.value=" + input.value);
            console.log("inputElement.value.length=" + input.value.length);
            if (input.value.length > 0) {
                let pTpairsArray = input.value.split(" ");
                // Is there a header?
                let index = new Map();
                pTpairsArray[0].split("\t").forEach((value, i)=>{
                    index.set(value, i);
                });
                console.log("pTpairsArray.length=" + pTpairsArray.length);
                for(let i = 1; i < pTpairsArray.length; i++){
                    let pTpairArray = pTpairsArray[i].split("\t");
                    let pIndex = index.get("P");
                    let p = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(pTpairArray[pIndex]);
                    let unitsIndex = index.get("units");
                    let pTpairAttributes = new Map();
                    if (index.has("units")) {
                        let units = pTpairArray[unitsIndex];
                        pTpairAttributes.set("units", units);
                    }
                    let pTpair = new (0, $5b710835528e7170$export$3fe97ecb6b172244)(pTpairAttributes);
                    pTs.add(pTpair);
                    let tIndex = index.get("T");
                    let t = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(pTpairArray[tIndex]);
                    pTpair.setP(p);
                    pTpair.setT(t);
                    if (index.has((0, $5b710835528e7170$export$3fe97ecb6b172244).s_excessReactantConc)) {
                        let excessReactantConIndex = index.get((0, $5b710835528e7170$export$3fe97ecb6b172244).s_excessReactantConc);
                        let excessReactantConc = pTpairArray[excessReactantConIndex];
                        pTpairAttributes.set((0, $5b710835528e7170$export$3fe97ecb6b172244).s_excessReactantConc, excessReactantConc);
                    }
                    if (index.has((0, $5b710835528e7170$export$3fe97ecb6b172244).s_percentExcessReactantConc)) {
                        let percentExcessReactantConIndex = index.get((0, $5b710835528e7170$export$3fe97ecb6b172244).s_percentExcessReactantConc);
                        let percentExcessReactantConc = pTpairArray[percentExcessReactantConIndex];
                        pTpairAttributes.set((0, $5b710835528e7170$export$3fe97ecb6b172244).s_percentExcessReactantConc, percentExcessReactantConc);
                    }
                    if (index.has((0, $5b710835528e7170$export$3fe97ecb6b172244).s_precision)) {
                        console.log("index.has(PTpair.s_precision)");
                        let precisionIndex = index.get((0, $5b710835528e7170$export$3fe97ecb6b172244).s_precision);
                        let precision = pTpairArray[precisionIndex];
                        pTpairAttributes.set((0, $5b710835528e7170$export$3fe97ecb6b172244).s_precision, precision);
                    //console.log("precision=" + precision);
                    }
                    if (index.has((0, $5b710835528e7170$export$b33a132661f4be58).tagName)) {
                        let bathGasIndex = index.get((0, $5b710835528e7170$export$b33a132661f4be58).tagName);
                        let bathGas = pTpairArray[bathGasIndex];
                        pTpair.setBathGas(new (0, $5b710835528e7170$export$b33a132661f4be58)(new Map(), bathGas));
                    }
                    if (index.has((0, $5b710835528e7170$export$cdeafdd1d936ed5b).tagName)) {
                        let eri = index.get((0, $5b710835528e7170$export$cdeafdd1d936ed5b).tagName);
                        let er = pTpairArray[eri];
                        if (er.length > 0) {
                            pTpairAttributes.set((0, $5b710835528e7170$export$cdeafdd1d936ed5b).tagName, er);
                            pTpair.setExperimentalRate(new (0, $5b710835528e7170$export$cdeafdd1d936ed5b)(new Map(), new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(er)));
                            // Set the attributes of the experimentalRate.
                            // ref1.
                            let err1i = index.get((0, $5b710835528e7170$export$cdeafdd1d936ed5b).tagName + "_" + (0, $5b710835528e7170$export$cdeafdd1d936ed5b).s_ref1);
                            let err1 = pTpairArray[err1i];
                            pTpair.getExperimentalRate()?.setRef1(err1);
                            // ref2.
                            let err2i = index.get((0, $5b710835528e7170$export$cdeafdd1d936ed5b).tagName + "_" + (0, $5b710835528e7170$export$cdeafdd1d936ed5b).s_ref2);
                            let err2 = pTpairArray[err2i];
                            pTpair.getExperimentalRate()?.setRef2(err2);
                            // refReaction.
                            let errri = index.get((0, $5b710835528e7170$export$cdeafdd1d936ed5b).tagName + "_" + (0, $5b710835528e7170$export$cdeafdd1d936ed5b).s_refReaction);
                            let errr = pTpairArray[errri];
                            pTpair.getExperimentalRate()?.setRefReaction(errr);
                            // error.
                            let erei = index.get((0, $5b710835528e7170$export$cdeafdd1d936ed5b).tagName + "_" + (0, $5b710835528e7170$export$cdeafdd1d936ed5b).s_error);
                            let ere = pTpairArray[erei];
                            pTpair.getExperimentalRate()?.setError(new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(ere));
                        }
                    }
                    if (index.has((0, $5b710835528e7170$export$c291f4faacd745a6).tagName)) {
                        let eyi = index.get((0, $5b710835528e7170$export$c291f4faacd745a6).tagName);
                        let ey = pTpairArray[eyi];
                        if (ey.length > 0) {
                            pTpair.setExperimentalYield(new (0, $5b710835528e7170$export$c291f4faacd745a6)(new Map(), new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(ey)));
                            // Set the attributes of the experimentalYield.
                            // ref.
                            let eyri = index.get((0, $5b710835528e7170$export$c291f4faacd745a6).tagName + "_" + (0, $5b710835528e7170$export$c291f4faacd745a6).s_ref);
                            let eyr = pTpairArray[eyri];
                            pTpair.getExperimentalYield()?.setRef(eyr);
                            // yieldTime.
                            let eyyti = index.get((0, $5b710835528e7170$export$c291f4faacd745a6).tagName + "_" + (0, $5b710835528e7170$export$c291f4faacd745a6).s_yieldTime);
                            let eyyt = pTpairArray[eyyti];
                            pTpair.getExperimentalYield()?.setYieldTime(new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(eyyt));
                            // error.
                            let eyei = index.get((0, $5b710835528e7170$export$c291f4faacd745a6).tagName + "_" + (0, $5b710835528e7170$export$c291f4faacd745a6).s_error);
                            let eye = pTpairArray[eyei];
                            pTpair.getExperimentalYield()?.setError(new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(eye));
                        }
                    }
                    if (index.has((0, $5b710835528e7170$export$ed9dfbc127680fd1).tagName)) {
                        let eei = index.get((0, $5b710835528e7170$export$ed9dfbc127680fd1).tagName);
                        let ee = pTpairArray[eei];
                        if (ee.length > 0) {
                            pTpair.setExperimentalEigenvalue(new (0, $5b710835528e7170$export$ed9dfbc127680fd1)(new Map(), new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(ee)));
                            // Set the attributes of the experimentalEigenvalue.
                            // EigenvalueID.
                            let eeeidi = index.get((0, $5b710835528e7170$export$ed9dfbc127680fd1).tagName + "_" + (0, $5b710835528e7170$export$ed9dfbc127680fd1).s_EigenvalueID);
                            let eeeid = pTpairArray[eeeidi];
                            pTpair.getExperimentalEigenvalue()?.setEigenvalueID(eeeid);
                            // error.
                            let eeei = index.get((0, $5b710835528e7170$export$ed9dfbc127680fd1).tagName + "_" + (0, $5b710835528e7170$export$ed9dfbc127680fd1).s_error);
                            let eee = pTpairArray[eeei];
                            pTpair.getExperimentalEigenvalue()?.setError(new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(eee));
                        }
                    }
                    //console.log("pTpair=" + pTpair);
                    let pTpairIndex = pTs.ptps.length - 1;
                    // Create a new div for the PTpair.
                    pTsDiv.insertBefore($d0fe07d64e0283ae$var$createPTpairDiv(pTs, pTsDiv, pTpair, cDiv.id, pTpairIndex, moleculeKeys, (0, $dc4240e6100248ae$export$39c84188a71202f7)), pTsButtonsDiv);
                }
                pTsDiv.removeChild(div);
            }
        });
    });
    // Add a remove all button.
    let removeAllButton = (0, $341c675b659c6d43$export$9b6d6ca62970729f)("Remove All", undefined, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    pTsButtonsDiv.appendChild(removeAllButton);
    removeAllButton.addEventListener('click', ()=>{
        pTs.clear();
        // Remove all elements before the pTsButtonsDiv.
        let child = pTsDiv.firstChild;
        while(child != null && child != pTsButtonsDiv){
            let nextSibling = child.nextSibling;
            pTsDiv.removeChild(child);
            child = nextSibling;
        }
    });
}
function $d0fe07d64e0283ae$export$c1600199abe19050(conditionssDiv, conditionsDivIDs, molecules) {
    let button = (0, $341c675b659c6d43$export$9b6d6ca62970729f)((0, $dc4240e6100248ae$export$1bb8965d05fbf467), undefined, (0, $dc4240e6100248ae$export$39c84188a71202f7));
    conditionssDiv.appendChild(button);
    button.addEventListener('click', (event)=>{
        let i = (0, $dc4240e6100248ae$export$3bb92be1f57fd129).getNextConditionsID();
        console.log("Add Conditions " + i.toString());
        // Create collapsible div.
        let cDivID = conditionsDivIDs.addID((0, $5b710835528e7170$export$363c7374d425f4ad).tagName, i.toString());
        let cDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(cDivID, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
        let ccDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(cDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
        // ElementToInsert before is element after the conditions div with the previous index.
        let elementToInsertBefore;
        if (i > 0) {
            let aboveElement = document.getElementById((0, $93b71ab6968650c1$export$3205c97bcf96f7dc)((0, $5b710835528e7170$export$363c7374d425f4ad).tagName, (i - 1).toString(), (0, $dc4240e6100248ae$export$7295f538b9762c5)));
            let nextElementSibling = aboveElement.nextElementSibling;
            // If nextElementSibling is not a child of conditionssDiv the element.
            if (nextElementSibling != null) {
                if (nextElementSibling.parentElement == conditionssDiv) elementToInsertBefore = nextElementSibling;
                else elementToInsertBefore = button;
            } else elementToInsertBefore = button;
        } else elementToInsertBefore = button;
        let ccDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(ccDivID, conditionssDiv, elementToInsertBefore, cDiv, (0, $5b710835528e7170$export$363c7374d425f4ad).tagName + " " + i.toString(), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        // Add the conditions
        let conditions = $d0fe07d64e0283ae$var$addConditions(new Map(), i);
        $d0fe07d64e0283ae$var$handleBathGases(conditions, cDiv, null, conditionsDivIDs, molecules);
        $d0fe07d64e0283ae$var$handlePTs(conditions, cDiv, null, conditionsDivIDs, molecules);
        // Add a remove conditions button.
        let removeButton = (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(cDiv, (0, $dc4240e6100248ae$export$39c84188a71202f7), (0, $dc4240e6100248ae$export$3bb92be1f57fd129).removeConditions.bind((0, $dc4240e6100248ae$export$3bb92be1f57fd129)), i);
        removeButton.addEventListener('click', (event)=>{
            // Remove the conditions.
            (0, $dc4240e6100248ae$export$cd7f480d6b8286c3)(ccDivID);
            conditionsDivIDs.removeIDs(cDivID);
        });
    });
    return button;
}
/**
 * Add and return a new conditions.
 */ function $d0fe07d64e0283ae$var$addConditions(attributes, i) {
    let conditions = new (0, $5b710835528e7170$export$363c7374d425f4ad)(attributes, i);
    (0, $dc4240e6100248ae$export$3bb92be1f57fd129).addConditions(conditions);
    return conditions;
}
/**
 * @param pTs The PTs.
 * @param pTsDiv The PTs div.
 * @param pTpairDiv The PTpair div.
 * @param pTpair The PTpair.
 * @param pTIndex The index.
 * @param moleculeKeys The molecule keys.
 * @param level The level.
 */ function $d0fe07d64e0283ae$var$createPTpairDiv(pTs, pTsDiv, pTpair, cDivID, pTIndex, moleculeKeys, level) {
    let pTpairDiv = (0, $341c675b659c6d43$export$78253536c0178a32)((0, $dc4240e6100248ae$export$bea69a603fae01a6)(pTsDiv.id, pTIndex), level);
    $d0fe07d64e0283ae$var$addPorT(pTpairDiv, (0, $5b710835528e7170$export$3fe97ecb6b172244).s_P, pTpair.getP.bind(pTpair), pTpair.setP.bind(pTpair)); // The binding is necessary to maintain the correct "this".
    (0, $dc4240e6100248ae$export$2b2254f82abcc900)((0, $ccef02370f58a770$export$692079bb871c6039).pressureUnits, pTpair.attributes, pTpairDiv, null, (0, $5b710835528e7170$export$3fe97ecb6b172244).tagName, (0, $5b710835528e7170$export$3fe97ecb6b172244).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
    $d0fe07d64e0283ae$var$addPorT(pTpairDiv, (0, $5b710835528e7170$export$3fe97ecb6b172244).s_T, pTpair.getT.bind(pTpair), pTpair.setT.bind(pTpair)); // The binding is necessary to maintain the correct "this".
    //let id: string = conditionsIDs.addID(cDivID, pTsDiv.id, pTIndex.toString());
    // ExcessReactantConc.
    //addButtonWithToggle(pTpairDiv, pTpair, PTpair.s_excessReactantConc, addID(id, PTpair.s_excessReactantConc),
    //    [pTpair], createExcessReactantConcInputElement);
    //addExcessReactantConc(pTpairDiv, pTpair, pTIndex);
    $d0fe07d64e0283ae$var$addAttribute(pTpairDiv, pTpair, (0, $5b710835528e7170$export$3fe97ecb6b172244).s_excessReactantConc, $d0fe07d64e0283ae$var$createExcessReactantConcInputElement);
    //addAttribute(    pTpairDiv,     pTpair,    pTIndex,     PTpair.s_excessReactantConc,     createExcessReactantConcInputElement,
    //(pTpair, attribute) => pTpair.attributes.has(attribute),    (pTpair, attribute) => null);
    // PercentExcessReactantConc.
    //addButtonWithToggle(pTpairDiv, pTpair, PTpair.s_percentExcessReactantConc);
    $d0fe07d64e0283ae$var$addPercentExcessReactantConc(pTpairDiv, pTpair);
    // Precision.
    //addButtonWithToggle(pTpairDiv, pTpair, PTpair.s_precision, addID(id, PTpair.s_precision),
    //    [pTpair], createPrecisionSelectElement);
    //addPrecision(pTpairDiv, pTpair, pTIndex);
    $d0fe07d64e0283ae$var$addAttribute(pTpairDiv, pTpair, (0, $5b710835528e7170$export$3fe97ecb6b172244).s_precision, $d0fe07d64e0283ae$var$createPrecisionSelectElement);
    //addAttribute(    pTpairDiv,     pTpair,    pTIndex,     PTpair.s_precision, createPrecisionSelectElement,
    //    (pTpair, attribute) => pTpair.attributes.has(attribute),    (pTpair, attribute) => null);
    // BathGas.
    //addButtonWithToggle(pTpairDiv, pTpair, BathGas.tagName, addID(id, BathGas.tagName),
    //    [pTpair, moleculeKeys, true], createBathGasSelectElement);
    $d0fe07d64e0283ae$var$addBathGas(pTpairDiv, pTpair, moleculeKeys);
    /*
    addAttribute(pTpairDiv, pTpair, pTIndex, BathGas.tagName, createBathGasSelectElement,
        (pTpair, attribute) => pTpair.getBathGas() !== undefined,  (pTpair, attribute) => pTpair.getBathGas(), moleculeKeys
    );
    */ // ExperimentalRate.
    //addButtonWithToggle(pTpairDiv, pTpair, ExperimentalRate.tagName, addID(id, ExperimentalRate.tagName),
    //    [undefined, pTpair, pTIndex], addExperimentalRateDetails);
    //addExperimentalRate(pTpairDiv, pTpair, pTIndex);
    $d0fe07d64e0283ae$var$addExperimentalElement(pTpairDiv, pTpair, pTIndex, (0, $5b710835528e7170$export$cdeafdd1d936ed5b).tagName, (pTpair)=>pTpair.getExperimentalRate(), $d0fe07d64e0283ae$var$createExperimentalRateDetails);
    // ExperimentalYield.
    //addButtonWithToggle(pTpairDiv, pTpair, ExperimentalYield.tagName, addID(id, ExperimentalYield.tagName),
    //    [undefined, pTpair, pTIndex], addExperimentalYieldDetails);
    //addExperimentalYield(pTpairDiv, pTpair, pTIndex);
    $d0fe07d64e0283ae$var$addExperimentalElement(pTpairDiv, pTpair, pTIndex, (0, $5b710835528e7170$export$c291f4faacd745a6).tagName, (pTpair)=>pTpair.getExperimentalYield(), $d0fe07d64e0283ae$var$createExperimentalYieldDetails);
    // ExperimentalEigenvalue.
    //addButtonWithToggle(pTpairDiv, pTpair, ExperimentalEigenvalue.tagName, addID(id, ExperimentalEigenvalue.tagName),
    //   [undefined, pTpair, pTIndex], addExperimentalEigenvalueDetails);
    //addExperimentalEigenvalue(pTpairDiv, pTpair, pTIndex);
    $d0fe07d64e0283ae$var$addExperimentalElement(pTpairDiv, pTpair, pTIndex, (0, $5b710835528e7170$export$ed9dfbc127680fd1).tagName, (pTpair)=>pTpair.getExperimentalEigenvalue(), $d0fe07d64e0283ae$var$createExperimentalEigenvalueDetails);
    // Function to be used to remove a PTpair.
    let removePTpair = (pTpairDiv, i, pTpair)=>{
        pTsDiv.removeChild(pTpairDiv);
        if (i !== undefined) pTs.remove(i);
        pTpair.removeBathGas();
    };
    (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(pTpairDiv, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), removePTpair, pTpairDiv, pTIndex, pTpair);
    return pTpairDiv;
}
/**
 * @param pTpairDiv The pTpair div.
 * @param name The name ("P" or "T").
 * @param getter The getter method.
 * @param setter The setter method.
 */ function $d0fe07d64e0283ae$var$addPorT(pTpairDiv, name, getter, setter) {
    let lwi = (0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("text", (0, $5b710835528e7170$export$3fe97ecb6b172244).tagName + "_" + name, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$b1ddbf2a116c10ee), (event)=>{
        let target = event.target;
        try {
            setter(new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(target.value));
            console.log(`Set ${name} to ${target.value}`);
        } catch (e) {
            alert("Invalid input, resetting...");
            input.value = $d0fe07d64e0283ae$var$getValue(getter);
        }
        (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
    }, $d0fe07d64e0283ae$var$getValue(getter), name);
    let input = lwi.querySelector('input');
    input.value = $d0fe07d64e0283ae$var$getValue(getter);
    (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(input);
    pTpairDiv.appendChild(lwi);
}
function $d0fe07d64e0283ae$var$getValue(getter) {
    let value = getter();
    if (value !== undefined) return value.toString();
    else return "";
}
/**
 * @param pTpairDiv The PTpair div.
 * @param pTpair The PTpair.
 */ function $d0fe07d64e0283ae$var$addPercentExcessReactantConc(pTpairDiv, pTpair) {
    let id = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(pTpairDiv.id, (0, $5b710835528e7170$export$3fe97ecb6b172244).s_percentExcessReactantConc);
    let div = (0, $341c675b659c6d43$export$331ff980f0d45cff)(id, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    pTpairDiv.appendChild(div);
    let attribute = (0, $5b710835528e7170$export$3fe97ecb6b172244).s_percentExcessReactantConc;
    let buttonTextContentSelected = attribute + (0, $dc4240e6100248ae$export$f0fb6e9d3fd6cf72);
    let buttonTextContentDeselected = attribute + (0, $dc4240e6100248ae$export$b758aa9bd161846e);
    let button = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(buttonTextContentDeselected, (0, $dc4240e6100248ae$export$bea69a603fae01a6)(id, (0, $341c675b659c6d43$export$25280bc3a7ce098e)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    div.appendChild(button);
    button.classList.add((0, $dc4240e6100248ae$export$50cc31b59b02e033));
    button.classList.add((0, $dc4240e6100248ae$export$d52efe23389358db));
    if (pTpair.attributes.get(attribute)?.toLowerCase() == "true") {
        button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
        button.textContent = buttonTextContentSelected;
    } else {
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
        button.textContent = buttonTextContentDeselected;
    }
    // Add event listener for the button.
    button.addEventListener('click', (event)=>{
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
        button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
        if (button.textContent === buttonTextContentDeselected) {
            button.textContent = buttonTextContentSelected;
            pTpair.attributes.set(attribute, "true");
        } else {
            button.textContent = buttonTextContentDeselected;
            pTpair.attributes.delete(attribute);
        }
    });
}
/**
 * @param pTpairDiv The PTpair div.
 * @param pTpair The PTpair.
 * @param conditionsIndex The conditions index.
 * @param pTIndex The pTindex.
 * @param attribute The attribute.
 * @param createInputElement The function to create the input element.
 */ function $d0fe07d64e0283ae$var$addAttribute(pTpairDiv, pTpair, attribute, createInputElement) {
    let id = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(pTpairDiv.id, attribute);
    let div = (0, $341c675b659c6d43$export$331ff980f0d45cff)(id, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    pTpairDiv.appendChild(div);
    let buttonTextContentSelected = attribute + (0, $dc4240e6100248ae$export$f0fb6e9d3fd6cf72);
    let buttonTextContentDeselected = attribute + (0, $dc4240e6100248ae$export$b758aa9bd161846e);
    let button = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(buttonTextContentDeselected, (0, $dc4240e6100248ae$export$bea69a603fae01a6)(id, (0, $341c675b659c6d43$export$25280bc3a7ce098e)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    div.appendChild(button);
    button.classList.add((0, $dc4240e6100248ae$export$50cc31b59b02e033));
    button.classList.add((0, $dc4240e6100248ae$export$d52efe23389358db));
    let iid = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(id, (0, $dc4240e6100248ae$export$58785e0018b77d4a));
    if (pTpair.attributes.has(attribute)) {
        button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
        button.textContent = buttonTextContentSelected;
        let input = createInputElement(iid, pTpair);
        div.insertBefore(input, button.nextSibling);
    } else {
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
        button.textContent = buttonTextContentDeselected;
    }
    // Add event listener for the button.
    button.addEventListener('click', (event)=>{
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
        button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
        if (button.textContent === buttonTextContentDeselected) {
            button.textContent = buttonTextContentSelected;
            let input = createInputElement(iid, pTpair);
            div.insertBefore(input, button.nextSibling);
        } else {
            button.textContent = buttonTextContentDeselected;
            // Remove the input element.
            (0, $dc4240e6100248ae$export$cd7f480d6b8286c3)(iid);
        }
    });
}
/**
 * @param pTpairDiv The PTpair div.
 * @param pTpair The PTpair.
 * @param i The index.
 * @param moleculeKeys The molecule keys.
 */ function $d0fe07d64e0283ae$var$addBathGas(pTpairDiv, pTpair, moleculeKeys) {
    let id = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(pTpairDiv.id, (0, $5b710835528e7170$export$b33a132661f4be58).tagName);
    let div = (0, $341c675b659c6d43$export$331ff980f0d45cff)(id, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    pTpairDiv.appendChild(div);
    let tagName = (0, $5b710835528e7170$export$b33a132661f4be58).tagName;
    let buttonTextContentSelected = tagName + (0, $dc4240e6100248ae$export$f0fb6e9d3fd6cf72);
    let buttonTextContentDeselected = tagName + (0, $dc4240e6100248ae$export$b758aa9bd161846e);
    let button = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(buttonTextContentDeselected, (0, $dc4240e6100248ae$export$bea69a603fae01a6)(id, (0, $341c675b659c6d43$export$25280bc3a7ce098e)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    div.appendChild(button);
    button.classList.add((0, $dc4240e6100248ae$export$50cc31b59b02e033));
    button.classList.add((0, $dc4240e6100248ae$export$d52efe23389358db));
    let iid = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(id, (0, $dc4240e6100248ae$export$58785e0018b77d4a));
    let bathGas = pTpair.getBathGas();
    if (bathGas == undefined) {
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
        button.textContent = buttonTextContentDeselected;
    } else {
        button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
        button.textContent = buttonTextContentSelected;
        if (moleculeKeys.has(bathGas.value) == false) console.warn("moleculeKeys does not contain " + bathGas.value);
        div.appendChild($d0fe07d64e0283ae$var$createBathGasSelectElement(iid, pTpair, bathGas, false, moleculeKeys));
    }
    // Add event listener for the button.
    button.addEventListener('click', (event)=>{
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
        button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
        if (button.textContent === buttonTextContentDeselected) {
            button.textContent = buttonTextContentSelected;
            div.appendChild($d0fe07d64e0283ae$var$createBathGasSelectElement(iid, pTpair, bathGas, false, moleculeKeys));
        } else {
            button.textContent = buttonTextContentDeselected;
            // Remove the select element.
            (0, $dc4240e6100248ae$export$cd7f480d6b8286c3)(iid);
        }
    });
}
/**
 * 
 * @param pTpairDiv 
 * @param pTpair 
 * @param conditionsIndex 
 * @param pTIndex 
 * @param tagName 
 * @param getAttribute 
 * @param createElement 
 */ function $d0fe07d64e0283ae$var$addExperimentalElement(pTpairDiv, pTpair, pTIndex, tagName, getAttribute, createElement) {
    let id = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(pTpairDiv.id, tagName);
    let div = (0, $341c675b659c6d43$export$331ff980f0d45cff)(id, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    pTpairDiv.appendChild(div);
    let buttonTextContentSelected = tagName + (0, $dc4240e6100248ae$export$f0fb6e9d3fd6cf72);
    let buttonTextContentDeselected = tagName + (0, $dc4240e6100248ae$export$b758aa9bd161846e);
    let button = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(buttonTextContentDeselected, (0, $dc4240e6100248ae$export$bea69a603fae01a6)(id, (0, $341c675b659c6d43$export$25280bc3a7ce098e)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    div.appendChild(button);
    button.classList.add((0, $dc4240e6100248ae$export$50cc31b59b02e033));
    button.classList.add((0, $dc4240e6100248ae$export$d52efe23389358db));
    let iid = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(id, (0, $dc4240e6100248ae$export$58785e0018b77d4a));
    if (getAttribute(pTpair) == undefined) {
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
        button.textContent = buttonTextContentDeselected;
    } else {
        button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
        button.textContent = buttonTextContentSelected;
        div.appendChild(createElement(iid, pTpair, pTIndex));
    }
    // Add event listener for the button.
    button.addEventListener('click', (event)=>{
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
        button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
        if (button.textContent === buttonTextContentDeselected) {
            button.textContent = buttonTextContentSelected;
            div.appendChild(createElement(iid, pTpair, pTIndex));
        } else {
            button.textContent = buttonTextContentDeselected;
            // Remove the element.
            (0, $dc4240e6100248ae$export$cd7f480d6b8286c3)(iid);
        }
    });
}
/**
 * @param id The id.
 * @param pTpair The PTpair.
 * @returns A select element.
 */ function $d0fe07d64e0283ae$var$createPrecisionSelectElement(id, pTpair) {
    let value;
    if (pTpair.attributes.has((0, $5b710835528e7170$export$3fe97ecb6b172244).s_precision)) value = pTpair.attributes.get((0, $5b710835528e7170$export$3fe97ecb6b172244).s_precision);
    else value = (0, $ccef02370f58a770$export$692079bb871c6039).precisionOptions[0];
    let select = (0, $341c675b659c6d43$export$b89bf4b169286865)((0, $ccef02370f58a770$export$692079bb871c6039).precisionOptions, (0, $5b710835528e7170$export$3fe97ecb6b172244).s_precision, value, id, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    select.addEventListener('change', (event)=>{
        let target = event.target;
        pTpair.setPrecision(target.value);
        console.log("Set " + (0, $5b710835528e7170$export$3fe97ecb6b172244).s_precision + " to " + target.value);
        (0, $341c675b659c6d43$export$fdd146df37959fe8)(target);
    });
    (0, $341c675b659c6d43$export$fdd146df37959fe8)(select);
    return select;
}
/**
 * @param id The id for the HTMLInputElement created.
 * @param pTpair The PTpair.
 * @returns An HTMLInputElement.
 */ function $d0fe07d64e0283ae$var$createExcessReactantConcInputElement(id, pTpair) {
    let input = (0, $341c675b659c6d43$export$d80fffb1deb3b97e)("number", id, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    let value;
    if (pTpair.attributes.has((0, $5b710835528e7170$export$3fe97ecb6b172244).s_excessReactantConc)) value = pTpair.attributes.get((0, $5b710835528e7170$export$3fe97ecb6b172244).s_excessReactantConc);
    else value = NaN.toString();
    console.log((0, $5b710835528e7170$export$3fe97ecb6b172244).s_excessReactantConc + "=" + value);
    input.value = value;
    input.addEventListener('change', (event)=>{
        let target = event.target;
        pTpair.setExcessReactantConc(target.value);
        console.log("Set " + (0, $5b710835528e7170$export$3fe97ecb6b172244).s_excessReactantConc + " to " + target.value);
        (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
    });
    (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(input);
    return input;
}
/**
 * @param pTpair The PTpair.
 * @param id The id.
 * @param bathGas The bath gas.
 * @returns A select element.
 */ function $d0fe07d64e0283ae$var$createBathGasSelectElement(id, pTpair, bathGas, first, moleculeKeys) {
    //console.log("createBathGasSelectElement");
    //console.log("pTpair " + pTpair.toString());
    let select = $d0fe07d64e0283ae$var$createSelectElementBathGas(Array.from(moleculeKeys), bathGas, first, id);
    //select.id = id;
    select.addEventListener('change', (event)=>{
        let target = event.target;
        pTpair.setBathGas(new (0, $5b710835528e7170$export$b33a132661f4be58)(new Map(), target.value));
        console.log("Set bathGas to " + target.value);
        (0, $341c675b659c6d43$export$fdd146df37959fe8)(target);
    });
    (0, $341c675b659c6d43$export$fdd146df37959fe8)(select);
    return select;
}
/**
 * @param options The options.
 * @param bathGas The bath gas.
 * @param first True if this is the first selection, flase otherwise?
 * @param id The id used to generate other ids.
 */ function $d0fe07d64e0283ae$var$createSelectElementBathGas(options, bathGas, first, id) {
    let value;
    if (first) options.push((0, $dc4240e6100248ae$export$d8b8827abc8ab7e7));
    else {
        // remove selectAnotherOption if it is present.
        let index = options.indexOf((0, $dc4240e6100248ae$export$d8b8827abc8ab7e7));
        if (index > -1) options.splice(index, 1);
    }
    if (bathGas == undefined) {
        bathGas = new (0, $5b710835528e7170$export$b33a132661f4be58)(new Map(), (0, $dc4240e6100248ae$export$d8b8827abc8ab7e7));
        value = (0, $dc4240e6100248ae$export$d8b8827abc8ab7e7);
    } else value = bathGas.value;
    let select = (0, $341c675b659c6d43$export$b89bf4b169286865)(options, (0, $5b710835528e7170$export$b33a132661f4be58).tagName, value, (0, $dc4240e6100248ae$export$bea69a603fae01a6)(id, (0, $341c675b659c6d43$export$8797b0c8298d191)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    select.classList.add((0, $5b710835528e7170$export$b33a132661f4be58).tagName);
    (0, $dc4240e6100248ae$export$3b08dcba56872ec6)(options, select);
    // Add event listener to selectElement.
    select.addEventListener('change', (event)=>{
        let target = event.target;
        bathGas.value = target.value;
        console.log("Added " + target.value + " as " + (0, $5b710835528e7170$export$b33a132661f4be58).tagName);
        (0, $341c675b659c6d43$export$fdd146df37959fe8)(target);
    });
    select.value = value;
    (0, $341c675b659c6d43$export$fdd146df37959fe8)(select);
    return select;
}
/**
 * Create a div for the experimental rate details.
 * @param id The id.
 * @param pTpair The PTpair.
 * @returns A div.
 */ function $d0fe07d64e0283ae$var$createExperimentalRateDetails(id, pTpair) {
    return $d0fe07d64e0283ae$var$addExperimentalDetails(pTpair, id, (pTpair)=>pTpair.getExperimentalRate(), (pTpair, value)=>pTpair.setExperimentalRate(value), (0, $5b710835528e7170$export$cdeafdd1d936ed5b), [
        {
            tagName: (0, $5b710835528e7170$export$cdeafdd1d936ed5b).tagName,
            type: "number",
            eventHandler: (event, target)=>(0, $dc4240e6100248ae$export$b1e4cbf5b56e0e21)(pTpair.getExperimentalRate(), target),
            valueGetter: ()=>pTpair.getExperimentalRate().value.toString()
        },
        {
            tagName: (0, $5b710835528e7170$export$cdeafdd1d936ed5b).tagName + "_" + (0, $5b710835528e7170$export$cdeafdd1d936ed5b).s_ref1,
            type: "text",
            eventHandler: (event, target)=>pTpair.getExperimentalRate()?.setRef1(target.value),
            valueGetter: ()=>pTpair.getExperimentalRate().getRef1()
        },
        {
            tagName: (0, $5b710835528e7170$export$cdeafdd1d936ed5b).tagName + "_" + (0, $5b710835528e7170$export$cdeafdd1d936ed5b).s_ref2,
            type: "text",
            eventHandler: (event, target)=>pTpair.getExperimentalRate()?.setRef2(target.value),
            valueGetter: ()=>pTpair.getExperimentalRate().getRef2()
        },
        {
            tagName: (0, $5b710835528e7170$export$cdeafdd1d936ed5b).tagName + "_" + (0, $5b710835528e7170$export$cdeafdd1d936ed5b).s_refReaction,
            type: "text",
            eventHandler: (event, target)=>pTpair.getExperimentalRate()?.setRefReaction(target.value),
            valueGetter: ()=>pTpair.getExperimentalRate().getRefReaction()
        },
        {
            tagName: (0, $5b710835528e7170$export$cdeafdd1d936ed5b).tagName + "_" + (0, $5b710835528e7170$export$cdeafdd1d936ed5b).s_error,
            type: "number",
            eventHandler: (event, target)=>pTpair.getExperimentalRate()?.setError(new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(target.value)),
            valueGetter: ()=>pTpair.getExperimentalRate().getError().toString()
        }
    ]);
}
/**
 * Create a div for the experimental yield details.
 * @param id The id.
 * @param pTpair The PTpair.
 * @returns A div.
 */ function $d0fe07d64e0283ae$var$createExperimentalYieldDetails(id, pTpair) {
    return $d0fe07d64e0283ae$var$addExperimentalDetails(pTpair, id, (pTpair)=>pTpair.getExperimentalYield(), (pTpair, value)=>pTpair.setExperimentalYield(value), (0, $5b710835528e7170$export$c291f4faacd745a6), [
        {
            tagName: (0, $5b710835528e7170$export$c291f4faacd745a6).tagName,
            type: "number",
            eventHandler: (event, target)=>(0, $dc4240e6100248ae$export$b1e4cbf5b56e0e21)(pTpair.getExperimentalYield(), target),
            valueGetter: ()=>pTpair.getExperimentalYield().value.toString()
        },
        {
            tagName: (0, $5b710835528e7170$export$c291f4faacd745a6).tagName + "_" + (0, $5b710835528e7170$export$c291f4faacd745a6).s_ref,
            type: "text",
            eventHandler: (event, target)=>pTpair.getExperimentalYield()?.setRef(target.value),
            valueGetter: ()=>pTpair.getExperimentalYield().getRef()
        },
        {
            tagName: (0, $5b710835528e7170$export$c291f4faacd745a6).tagName + "_" + (0, $5b710835528e7170$export$c291f4faacd745a6).s_yieldTime,
            type: "number",
            eventHandler: (event, target)=>pTpair.getExperimentalYield()?.setYieldTime(new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(target.value)),
            valueGetter: ()=>pTpair.getExperimentalYield().getYieldTime().toString()
        },
        {
            tagName: (0, $5b710835528e7170$export$c291f4faacd745a6).tagName + "_" + (0, $5b710835528e7170$export$c291f4faacd745a6).s_error,
            type: "number",
            eventHandler: (event, target)=>pTpair.getExperimentalYield()?.setError(new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(target.value)),
            valueGetter: ()=>pTpair.getExperimentalYield().getError().toString()
        }
    ]);
}
/**
 * Create a div for the experimental eigenvalue.
 * @param id The id.
 * @param pTpair The PTpair.
 * @returns A div.
 */ function $d0fe07d64e0283ae$var$createExperimentalEigenvalueDetails(id, pTpair) {
    return $d0fe07d64e0283ae$var$addExperimentalDetails(pTpair, id, (pTpair)=>pTpair.getExperimentalEigenvalue(), (pTpair, value)=>pTpair.setExperimentalEigenvalue(value), (0, $5b710835528e7170$export$ed9dfbc127680fd1), [
        {
            tagName: (0, $5b710835528e7170$export$ed9dfbc127680fd1).tagName,
            type: "number",
            eventHandler: (event, target)=>(0, $dc4240e6100248ae$export$b1e4cbf5b56e0e21)(pTpair.getExperimentalEigenvalue(), target),
            valueGetter: ()=>pTpair.getExperimentalEigenvalue().value.toString()
        },
        {
            tagName: (0, $5b710835528e7170$export$ed9dfbc127680fd1).tagName + "_" + (0, $5b710835528e7170$export$ed9dfbc127680fd1).s_EigenvalueID,
            type: "text",
            eventHandler: (event, target)=>pTpair.getExperimentalEigenvalue()?.setEigenvalueID(target.value),
            valueGetter: ()=>pTpair.getExperimentalEigenvalue().getEigenvalueID()
        },
        {
            tagName: (0, $5b710835528e7170$export$ed9dfbc127680fd1).tagName + "_" + (0, $5b710835528e7170$export$ed9dfbc127680fd1).s_error,
            type: "number",
            eventHandler: (event, target)=>pTpair.getExperimentalEigenvalue()?.setError(new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(target.value)),
            valueGetter: ()=>pTpair.getExperimentalEigenvalue().getError().toString()
        }
    ]);
}
/**
 * @param pTpair The PTpair.
 * @param id The id.
 * @param getExperimental The getter.
 * @param setExperimental The setter.
 * @param ExperimentalClass The class.
 * @param details The details.
 * @returns HTMLDivElement.
 */ function $d0fe07d64e0283ae$var$addExperimentalDetails(pTpair, id, getExperimental, setExperimental, ExperimentalClass, details) {
    let div = (0, $341c675b659c6d43$export$331ff980f0d45cff)(undefined, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    div.id = id;
    let experimental = getExperimental(pTpair);
    if (experimental == undefined) {
        experimental = new ExperimentalClass(new Map(), (0, $dc4240e6100248ae$export$a94c859b6fc3ec52));
        setExperimental(pTpair, experimental);
    }
    for (let detail of details){
        let detailId = id + "_" + detail.tagName;
        div.appendChild((0, $341c675b659c6d43$export$4e9ec2b27757d9dd)(detail.type, detailId, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$b1ddbf2a116c10ee), (event)=>{
            let target = event.target;
            detail.eventHandler(event, target);
            console.log("Set " + detail.tagName + " to " + target.value);
            (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
        }, detail.valueGetter(), detail.label || ""));
    }
    return div;
}










function $45391daa0c41efdf$export$7502110c3a5d7b36(xml, mpIDM) {
    console.log((0, $6ab526da66ecf283$export$77f098867dc64198).tagName);
    // Create a div for the modelParameterss.
    let mpsDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(undefined, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    let xml_mps = xml.getElementsByTagName((0, $6ab526da66ecf283$export$77f098867dc64198).tagName);
    for(let i = 0; i < xml_mps.length; i++){
        // Create a collapsible div for the model parameters.
        let mpDivID = mpIDM.addID((0, $6ab526da66ecf283$export$77f098867dc64198).tagName, i.toString());
        let mpDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(mpDivID, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
        let mpcDivID = mpIDM.addID(mpDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
        let mpcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(mpcDivID, mpsDiv, null, mpDiv, (0, $6ab526da66ecf283$export$77f098867dc64198).tagName + " " + i.toString(), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        let mp = $45391daa0c41efdf$var$addModelParameters((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_mps[i]), i);
        $45391daa0c41efdf$var$processGrainSize(mp, xml_mps[i], mpDiv, mpIDM);
        //setGrainSize(mp, xml_mps[i], mpDiv);
        $45391daa0c41efdf$var$processModelParametersN(mp, mpIDM, xml_mps[i], mpDiv, (0, $085f2478c495b249$export$576b56ca6e34780b), mp.setAutomaticallySetMaxEne, mp.removeAutomaticallySetMaxEne.bind(mp));
        $45391daa0c41efdf$var$processModelParametersN(mp, mpIDM, xml_mps[i], mpDiv, (0, $6ab526da66ecf283$export$aa73446724166cdb), mp.setEnergyAboveTheTopHill, mp.removeEnergyAboveTheTopHill.bind(mp));
        $45391daa0c41efdf$var$processModelParametersN(mp, mpIDM, xml_mps[i], mpDiv, (0, $6ab526da66ecf283$export$f9c72965e4ddfc8e), mp.setMaxTemperature, mp.removeMaxTemperature.bind(mp));
        // Add a remove modelParameters button.
        let removeButton = (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(mpDiv, (0, $dc4240e6100248ae$export$39c84188a71202f7), (0, $dc4240e6100248ae$export$3bb92be1f57fd129).removeModelParameters.bind((0, $dc4240e6100248ae$export$3bb92be1f57fd129)), i);
        removeButton.addEventListener('click', (event)=>{
            // Remove the modelParameters.
            (0, $dc4240e6100248ae$export$cd7f480d6b8286c3)(mpcDivID);
            mpIDM.removeIDs(mpDivID);
        });
    }
    // Create an add button to add a modelParameters.
    $45391daa0c41efdf$export$5733f83ee927902f(mpsDiv, mpIDM);
    return mpsDiv;
}
/**
 * Add and return a new modelParameters.
 */ function $45391daa0c41efdf$var$addModelParameters(attributes, i) {
    let mp = new (0, $6ab526da66ecf283$export$77f098867dc64198)(attributes, i);
    (0, $dc4240e6100248ae$export$3bb92be1f57fd129).addModelParameters(mp);
    return mp;
}
/**
 * @param mps The model parameters.
 * @param xml_mps The XML model parameters.
 * @param mpsDiv The model parameters div.
 */ function $45391daa0c41efdf$var$processGrainSize(mps, xml_mps, mpsDiv, modelParametersIDs) {
    let tagName = (0, $6ab526da66ecf283$export$26e33f0df9ce919d).tagName;
    let id = modelParametersIDs.addID(mpsDiv.id, tagName);
    let div = (0, $341c675b659c6d43$export$78253536c0178a32)(id, (0, $dc4240e6100248ae$export$39c84188a71202f7));
    mpsDiv.appendChild(div);
    let buttonTextContentSelected = tagName + (0, $dc4240e6100248ae$export$f0fb6e9d3fd6cf72);
    let buttonTextContentDeselected = tagName + (0, $dc4240e6100248ae$export$b758aa9bd161846e);
    let button = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(tagName, modelParametersIDs.addID(mpsDiv.id, tagName, (0, $341c675b659c6d43$export$25280bc3a7ce098e)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    button.classList.add((0, $dc4240e6100248ae$export$50cc31b59b02e033));
    button.classList.add((0, $dc4240e6100248ae$export$d52efe23389358db));
    div.appendChild(button);
    let idi = modelParametersIDs.addID(mpsDiv.id, tagName, (0, $dc4240e6100248ae$export$58785e0018b77d4a));
    let gs;
    let valueString;
    if (xml_mps != null) {
        let xml = xml_mps.getElementsByTagName(tagName);
        if (xml.length == 1) {
            valueString = (0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml[0]));
            let value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(Number(valueString));
            gs = new (0, $6ab526da66ecf283$export$26e33f0df9ce919d)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml[0]), value);
            button.textContent = buttonTextContentSelected;
            $45391daa0c41efdf$var$createInputModelParameters(mps, div, gs, idi, valueString, mps.setGrainSize, (0, $ccef02370f58a770$export$692079bb871c6039).energyUnits);
            button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
        } else {
            gs = $45391daa0c41efdf$var$getDefaultGrainsize(tagName);
            button.textContent = buttonTextContentDeselected;
            button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
        }
    } else {
        gs = $45391daa0c41efdf$var$getDefaultGrainsize(tagName);
        button.textContent = buttonTextContentDeselected;
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
    }
    // Add event listener for the button.
    button.addEventListener('click', ()=>{
        // Check if the GrainSize already exists
        if (!mps.index.has((0, $6ab526da66ecf283$export$26e33f0df9ce919d).tagName)) {
            $45391daa0c41efdf$var$createInputModelParameters(mps, div, gs, idi, valueString, mps.setGrainSize, (0, $ccef02370f58a770$export$692079bb871c6039).energyUnits);
            button.textContent = buttonTextContentSelected;
        } else {
            mps.removeGrainSize();
            document.getElementById(idi)?.remove();
            document.getElementById((0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(idi, (0, $dc4240e6100248ae$export$5a13f59b7b9618a3)))?.remove();
            button.textContent = buttonTextContentDeselected;
        }
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
        button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
    });
}
/**
 * @param mps The model parameters.
 * @param xml_mps The XML model parameters.
 * @param mpsDiv The model parameters div.
 */ function $45391daa0c41efdf$var$setGrainSize(mps, xml_mps, mpsDiv, modelParametersIDs) {
    let tagName = (0, $6ab526da66ecf283$export$26e33f0df9ce919d).tagName;
    let div = $45391daa0c41efdf$var$addGrainSize(mps, mpsDiv, modelParametersIDs);
    // Save the current display style of the div
    let originalDisplay = div.style.display;
    // Make the div visible
    div.style.display = "block";
    let input = div.querySelector('input');
    // restore the original display style
    div.style.display = originalDisplay;
    //let input: HTMLInputElement = document.getElementById(getID(mpsDiv.id, tagName, s_input)) as HTMLInputElement;
    let xml = xml_mps.getElementsByTagName(tagName);
    if (xml.length > 0) {
        if (xml.length > 1) console.warn("More than one GrainSize found in XML. The first is used!");
        let valueString = (0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml[0]));
        let value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(valueString);
        mps.getGrainSize().value = value;
        if (input !== null) {
            input.value = valueString;
            (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(input);
        } else console.warn("GrainSize input element not found.");
    }
}
/**
 * @param mps The model parameters.
 * @param xml_mps The XML model parameters.
 * @param mpsDiv The model parameters div.
 */ function $45391daa0c41efdf$var$addGrainSize(mps, mpsDiv, modelParametersIDs) {
    let tagName = (0, $6ab526da66ecf283$export$26e33f0df9ce919d).tagName;
    let id = modelParametersIDs.addID(mpsDiv.id, tagName);
    let div = (0, $341c675b659c6d43$export$78253536c0178a32)(id, (0, $dc4240e6100248ae$export$39c84188a71202f7));
    mpsDiv.appendChild(div);
    let buttonTextContentSelected = tagName + (0, $dc4240e6100248ae$export$f0fb6e9d3fd6cf72);
    let buttonTextContentDeselected = tagName + (0, $dc4240e6100248ae$export$b758aa9bd161846e);
    let button = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(tagName, modelParametersIDs.addID(mpsDiv.id, tagName, (0, $341c675b659c6d43$export$25280bc3a7ce098e)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    button.classList.add((0, $dc4240e6100248ae$export$50cc31b59b02e033));
    button.classList.add((0, $dc4240e6100248ae$export$d52efe23389358db));
    div.appendChild(button);
    let idi = modelParametersIDs.addID(mpsDiv.id, tagName, (0, $dc4240e6100248ae$export$58785e0018b77d4a));
    let gs;
    button.textContent = buttonTextContentDeselected;
    button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
    // Add event listener for the button.
    button.addEventListener('click', ()=>{
        // Check if the GrainSize already exists
        if (!mps.index.has((0, $6ab526da66ecf283$export$26e33f0df9ce919d).tagName)) {
            console.log("Adding GrainSize input");
            gs = $45391daa0c41efdf$var$getDefaultGrainsize(tagName);
            mps.setGrainSize(gs);
            $45391daa0c41efdf$var$createInputModelParameters(mps, div, gs, idi, gs.value.toString(), mps.setGrainSize, (0, $ccef02370f58a770$export$692079bb871c6039).energyUnits);
            button.textContent = buttonTextContentSelected;
        } else {
            console.log("Removing GrainSize input");
            mps.removeGrainSize();
            document.getElementById(idi)?.remove();
            document.getElementById((0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(idi, (0, $dc4240e6100248ae$export$5a13f59b7b9618a3)))?.remove();
            button.textContent = buttonTextContentDeselected;
        }
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
        button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
    });
    //button.click();
    return div;
}
function $45391daa0c41efdf$var$getDefaultGrainsize(tagName) {
    let value;
    let attributes;
    if ((0, $dc4240e6100248ae$export$ebe90cb607ad99e) != undefined) {
        let valueString = (0, $dc4240e6100248ae$export$ebe90cb607ad99e).values.get(tagName) ?? "";
        if (valueString == "") value = (0, $dc4240e6100248ae$export$a94c859b6fc3ec52);
        else value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(valueString);
        attributes = (0, $dc4240e6100248ae$export$ebe90cb607ad99e).attributess.get(tagName) ?? new Map();
    } else {
        console.log(tagName + " set using hardcoded default.");
        value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(101);
        attributes = new Map();
        attributes.set((0, $dc4240e6100248ae$export$5a13f59b7b9618a3), "cm-1");
    }
    return new (0, $6ab526da66ecf283$export$26e33f0df9ce919d)(attributes, value);
}
/**
 * Process numerical modelParameters.
 * @param mps The ModelParameters.
 * @param mpsDiv The modelParameters div.
 * @param xml_mps The xml modelParameters.
 */ function $45391daa0c41efdf$var$processModelParametersN(mps, modelParametersIDs, xml_mps, mpsDiv, mpt, setModelParameter, removeModelParameter) {
    let tagName = mpt.tagName;
    let id = modelParametersIDs.addID(mpsDiv.id, tagName);
    let div = (0, $341c675b659c6d43$export$78253536c0178a32)(id, (0, $dc4240e6100248ae$export$39c84188a71202f7));
    mpsDiv.appendChild(div);
    let buttonTextContentSelected = tagName + (0, $dc4240e6100248ae$export$f0fb6e9d3fd6cf72);
    let buttonTextContentDeselected = tagName + (0, $dc4240e6100248ae$export$b758aa9bd161846e);
    let button = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(tagName, modelParametersIDs.addID(mpsDiv.id, tagName, (0, $341c675b659c6d43$export$25280bc3a7ce098e)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    button.classList.add((0, $dc4240e6100248ae$export$50cc31b59b02e033));
    button.classList.add((0, $dc4240e6100248ae$export$d52efe23389358db));
    div.appendChild(button);
    let idi = modelParametersIDs.addID(mpsDiv.id, tagName, (0, $dc4240e6100248ae$export$58785e0018b77d4a));
    let mp;
    let valueString;
    if (xml_mps != null) {
        let xml = xml_mps.getElementsByTagName(tagName);
        if (xml.length == 1) {
            valueString = (0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml[0]));
            let value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(valueString);
            mp = new mpt((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml[0]), value);
            button.textContent = buttonTextContentSelected;
            $45391daa0c41efdf$var$createInputModelParameters(mps, div, mp, idi, valueString, setModelParameter, undefined);
            button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
        } else {
            valueString = "";
            mp = new mpt(new Map(), (0, $dc4240e6100248ae$export$a94c859b6fc3ec52));
            button.textContent = buttonTextContentDeselected;
            button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
        }
    } else {
        valueString = "";
        mp = new mpt(new Map(), (0, $dc4240e6100248ae$export$a94c859b6fc3ec52));
        button.textContent = buttonTextContentDeselected;
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
    }
    // Add event listener for the button.
    button.addEventListener('click', ()=>{
        // Check if the ModelParameter already exists
        if (!mps.index.has(tagName)) {
            $45391daa0c41efdf$var$createInputModelParameters(mps, div, mp, idi, valueString, setModelParameter, undefined);
            button.textContent = buttonTextContentSelected;
        } else {
            //valueString = mp.value.toExponential();
            removeModelParameter();
            (0, $dc4240e6100248ae$export$cd7f480d6b8286c3)(idi);
            modelParametersIDs.removeIDs(idi);
            button.textContent = buttonTextContentDeselected;
        }
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
        button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
    });
}
/**
 * @param mps The model parameters.
 * @param div The div.
 * @param element The element.
 * @param id The id.
 * @param ids The id for the units select.
 * @param valueString The value string.
 * @param setElementMethod The method to set the element.
 * @param units The units.
 */ function $45391daa0c41efdf$var$createInputModelParameters(mps, div, element, id, valueString, setElementMethod, units) {
    setElementMethod.call(mps, element);
    let input = (0, $341c675b659c6d43$export$d80fffb1deb3b97e)("text", id, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    div.appendChild(input);
    input.addEventListener('change', (event)=>{
        let target = event.target;
        (0, $dc4240e6100248ae$export$b1e4cbf5b56e0e21)(element, target);
        (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
    });
    input.value = valueString;
    (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(input);
    (0, $dc4240e6100248ae$export$2b2254f82abcc900)(units, element.attributes, div, input, (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(id, (0, $dc4240e6100248ae$export$5a13f59b7b9618a3)), element.constructor.tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
}
function $45391daa0c41efdf$export$5733f83ee927902f(mpsDiv, mpIDM) {
    let button = (0, $341c675b659c6d43$export$9b6d6ca62970729f)((0, $dc4240e6100248ae$export$1bb8965d05fbf467), undefined, (0, $dc4240e6100248ae$export$39c84188a71202f7));
    let tn = (0, $6ab526da66ecf283$export$77f098867dc64198).tagName;
    mpsDiv.appendChild(button);
    button.addEventListener('click', (event)=>{
        let i = (0, $dc4240e6100248ae$export$3bb92be1f57fd129).getNextModelParametersID();
        console.log("Add " + tn + i.toString());
        // Create collapsible div.
        let mpDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(tn, i.toString());
        let mpDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(mpDivID, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
        let mpcDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(mpDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
        let elementToInsertBefore;
        if (i > 0) {
            let aboveElement = document.getElementById((0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(tn, (i - 1).toString(), (0, $dc4240e6100248ae$export$7295f538b9762c5)));
            let nextElementSibling = aboveElement.nextElementSibling;
            if (nextElementSibling != null) {
                if (nextElementSibling.parentElement == mpsDiv) elementToInsertBefore = nextElementSibling;
                else elementToInsertBefore = button;
            } else elementToInsertBefore = button;
        } else elementToInsertBefore = button;
        let mpcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(mpcDivID, mpsDiv, elementToInsertBefore, mpDiv, tn + " " + i.toString(), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        // Add the modelParameters.
        let mp = $45391daa0c41efdf$var$addModelParameters(new Map(), i);
        $45391daa0c41efdf$var$addGrainSize(mp, mpDiv, mpIDM);
        $45391daa0c41efdf$var$processModelParametersN(mp, mpIDM, null, mpDiv, (0, $085f2478c495b249$export$576b56ca6e34780b), mp.setAutomaticallySetMaxEne, mp.removeAutomaticallySetMaxEne);
        $45391daa0c41efdf$var$processModelParametersN(mp, mpIDM, null, mpDiv, (0, $6ab526da66ecf283$export$aa73446724166cdb), mp.setEnergyAboveTheTopHill, mp.removeEnergyAboveTheTopHill);
        $45391daa0c41efdf$var$processModelParametersN(mp, mpIDM, null, mpDiv, (0, $6ab526da66ecf283$export$f9c72965e4ddfc8e), mp.setMaxTemperature, mp.removeMaxTemperature);
        // Add a remove modelParameters button.
        let removeButton = (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(mpDiv, (0, $dc4240e6100248ae$export$39c84188a71202f7), (0, $dc4240e6100248ae$export$3bb92be1f57fd129).removeModelParameters.bind((0, $dc4240e6100248ae$export$3bb92be1f57fd129)), i);
        removeButton.addEventListener('click', (event)=>{
            // Remove the modelParameters.
            (0, $dc4240e6100248ae$export$cd7f480d6b8286c3)(mpcDivID);
            mpIDM.removeIDs(mpDivID);
        });
    });
    return button;
}









function $e383a1a86a5ebbd4$export$76caf53413cf3464(xml, controlIDM) {
    console.log((0, $085f2478c495b249$export$7a7fa4424cb20976).tagName);
    // Create a div for the controls.
    let controlsDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(undefined, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    // Get the XML "me:control" element.
    let xml_controls = xml.getElementsByTagName((0, $085f2478c495b249$export$7a7fa4424cb20976).tagName);
    for(let i = 0; i < xml_controls.length; i++){
        //console.log("Control " + i);
        let xml_control = xml_controls[i];
        // Create a collapsible divfor the control.
        let cDivID = controlIDM.addID((0, $085f2478c495b249$export$7a7fa4424cb20976).tagName, i.toString());
        let cDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(cDivID, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
        controlsDiv.appendChild(cDiv);
        let ccDivID = controlIDM.addID(cDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
        let ccDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(ccDivID, controlsDiv, null, cDiv, (0, $085f2478c495b249$export$7a7fa4424cb20976).tagName + " " + i.toString(), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        let control = $e383a1a86a5ebbd4$var$addControl((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_control), i);
        // Create a map of the on/off control options. The keys are the tag names and the values are the buttons.
        let onOffControls = new Map();
        $e383a1a86a5ebbd4$var$getControlOptionsSimple(control).forEach((option)=>{
            $e383a1a86a5ebbd4$var$handleControl(control, cDiv, controlIDM, onOffControls, xml_control, null, option.class, option.setMethod, option.removeMethod);
        });
        // Create a div for the on/off controls.
        let onOffControlsDiv = (0, $341c675b659c6d43$export$78253536c0178a32)(undefined, (0, $dc4240e6100248ae$export$39c84188a71202f7));
        let orderedOnOffControls = new Map([
            ...onOffControls.entries()
        ].sort());
        orderedOnOffControls.forEach((button)=>{
            onOffControlsDiv.appendChild(button);
        });
        cDiv.appendChild(onOffControlsDiv);
        // Controls with additional things to set.
        $e383a1a86a5ebbd4$var$handleTestMicroRates(control, cDiv, controlIDM, null, (0, $dc4240e6100248ae$export$39c84188a71202f7));
        $e383a1a86a5ebbd4$var$handleCalcMethod(control, cDiv, controlIDM, xml_control, (0, $dc4240e6100248ae$export$39c84188a71202f7));
        $e383a1a86a5ebbd4$var$getControlItems(control).forEach((item)=>{
            $e383a1a86a5ebbd4$var$handleControl(control, cDiv, controlIDM, onOffControls, xml_control, (0, $dc4240e6100248ae$export$39c84188a71202f7), item.class, item.setMethod, item.removeMethod, true);
        });
        // me:ForceMacroDetailedBalance
        let xml_fdb = xml_control.getElementsByTagName((0, $085f2478c495b249$export$6ffea14bdffd427f).tagName);
        if (xml_fdb.length == 1) {
            let fdb = new (0, $085f2478c495b249$export$6ffea14bdffd427f)();
            control.setForceMacroDetailedBalance(fdb);
            let fdbDiv = (0, $341c675b659c6d43$export$78253536c0178a32)(controlIDM.addID(cDivID, (0, $085f2478c495b249$export$6ffea14bdffd427f).tagName), (0, $dc4240e6100248ae$export$39c84188a71202f7));
            cDiv.appendChild(fdbDiv);
            let fdbl = (0, $341c675b659c6d43$export$f2839682b8c07f35)((0, $085f2478c495b249$export$6ffea14bdffd427f).tagName, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
            fdbDiv.appendChild(fdbl);
        }
        // Add a remove control button.
        let removeButton = (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(cDiv, (0, $dc4240e6100248ae$export$39c84188a71202f7), (0, $dc4240e6100248ae$export$3bb92be1f57fd129).removeControl.bind((0, $dc4240e6100248ae$export$3bb92be1f57fd129)), i);
        removeButton.addEventListener('click', (event)=>{
            // Remove the control.
            (0, $dc4240e6100248ae$export$cd7f480d6b8286c3)(ccDivID);
            controlIDM.removeIDs(cDivID);
            let divCmId = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(cDivID, (0, $085f2478c495b249$export$f0bfd84d03c3a22d).tagName);
            controlIDM.removeIDs(divCmId);
            let divCmDetailsId = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(divCmId, "details");
            controlIDM.removeIDs(divCmDetailsId);
            let divCmDetailsSelectId = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(divCmDetailsId, "select");
            controlIDM.removeIDs(divCmDetailsSelectId);
        });
    }
    // Create an add button to add a control.
    $e383a1a86a5ebbd4$export$2e5ceda339237ce2(controlsDiv, controlIDM);
    return controlsDiv;
}
/**
 * @param control The control.
 * @return An array of the on/off control options.
 */ function $e383a1a86a5ebbd4$var$getControlOptionsSimple(control) {
    return [
        {
            class: (0, $085f2478c495b249$export$7d9247c9879133fb),
            setMethod: control.setCalculateRateCoefficientsOnly,
            removeMethod: control.removeCalculateRateCoefficientsOnly
        },
        {
            class: (0, $085f2478c495b249$export$60b233651e162b60),
            setMethod: control.setPrintCellDOS,
            removeMethod: control.removePrintCellDOS
        },
        {
            class: (0, $085f2478c495b249$export$7e63e5104be309ff),
            setMethod: control.setPrintCellTransitionStateFlux,
            removeMethod: control.removePrintCellTransitionStateFlux
        },
        {
            class: (0, $085f2478c495b249$export$a915db169f144f37),
            setMethod: control.setPrintReactionOperatorColumnSums,
            removeMethod: control.removePrintReactionOperatorColumnSums
        },
        {
            class: (0, $085f2478c495b249$export$e7fff349901f700d),
            setMethod: control.setPrintGrainBoltzmann,
            removeMethod: control.removePrintGrainBoltzmann
        },
        {
            class: (0, $085f2478c495b249$export$d23243bda4dfae2b),
            setMethod: control.setPrintGrainDOS,
            removeMethod: control.removePrintGrainDOS
        },
        {
            class: (0, $085f2478c495b249$export$55888ef4e813a34d),
            setMethod: control.setPrintGrainkbE,
            removeMethod: control.removePrintGrainkbE
        },
        {
            class: (0, $085f2478c495b249$export$f8d814a406a0ff5b),
            setMethod: control.setPrintGrainkfE,
            removeMethod: control.removePrintGrainkfE
        },
        {
            class: (0, $085f2478c495b249$export$3627f2b606ffd3cb),
            setMethod: control.setPrintTSsos,
            removeMethod: control.removePrintTSsos
        },
        {
            class: (0, $085f2478c495b249$export$c5481d114fddc81c),
            setMethod: control.setPrintGrainedSpeciesProfile,
            removeMethod: control.removePrintGrainedSpeciesProfile
        },
        {
            class: (0, $085f2478c495b249$export$ec7c00ae1b17b2ab),
            setMethod: control.setPrintGrainTransitionStateFlux,
            removeMethod: control.removePrintGrainTransitionStateFlux
        },
        {
            class: (0, $085f2478c495b249$export$8420ab6988728a65),
            setMethod: control.setPrintReactionOperatorSize,
            removeMethod: control.removePrintReactionOperatorSize
        },
        {
            class: (0, $085f2478c495b249$export$ed9b9e07e51c2ac1),
            setMethod: control.setPrintSpeciesProfile,
            removeMethod: control.removePrintSpeciesProfile
        },
        {
            class: (0, $085f2478c495b249$export$9f7939759d8efd9f),
            setMethod: control.setPrintPhenomenologicalEvolution,
            removeMethod: control.removePrintPhenomenologicalEvolution
        },
        {
            class: (0, $085f2478c495b249$export$fc99460819e23ac5),
            setMethod: control.setPrintTunnelingCoefficients,
            removeMethod: control.removePrintTunnelingCoefficients
        },
        {
            class: (0, $085f2478c495b249$export$2f2eaac8983031ef),
            setMethod: control.setPrintCrossingCoefficients,
            removeMethod: control.removePrintCrossingCoefficients
        },
        {
            class: (0, $085f2478c495b249$export$a3d7e677521f681f),
            setMethod: control.setTestDOS,
            removeMethod: control.removeTestDOS
        },
        {
            class: (0, $085f2478c495b249$export$980e5abe9a459423),
            setMethod: control.setTestRateConstants,
            removeMethod: control.removeTestRateConstants
        },
        {
            class: (0, $085f2478c495b249$export$5d7dbeba4bf49655),
            setMethod: control.setUseTheSameCellNumberForAllConditions,
            removeMethod: control.removeUseTheSameCellNumberForAllConditions
        },
        //{ class: HideInactive, setMethod: control.setHideInactive, removeMethod: control.removeHideInactive }
        {
            class: (0, $085f2478c495b249$export$6ffea14bdffd427f),
            setMethod: control.setForceMacroDetailedBalance,
            removeMethod: control.removeForceMacroDetailedBalance
        }
    ];
}
/**
 * @param control The control.
 * @return An array of the control items.
 */ function $e383a1a86a5ebbd4$var$getControlItems(control) {
    return [
        {
            class: (0, $085f2478c495b249$export$2453e311f702d9c7),
            setMethod: control.setEigenvalues,
            removeMethod: control.removeEigenvalues
        },
        {
            class: (0, $085f2478c495b249$export$421603058c6718db),
            setMethod: control.setShortestTimeOfInterest,
            removeMethod: control.removeShortestTimeOfInterest
        },
        {
            class: (0, $085f2478c495b249$export$b51d7314540831ed),
            setMethod: control.setMaximumEvolutionTime,
            removeMethod: control.removeMaximumEvolutionTime
        },
        {
            class: (0, $085f2478c495b249$export$576b56ca6e34780b),
            setMethod: control.setAutomaticallySetMaxEne,
            removeMethod: control.removeAutomaticallySetMaxEne
        },
        {
            class: (0, $085f2478c495b249$export$159b5d3263f1049a),
            setMethod: control.setDiagramEnergyOffset,
            removeMethod: control.removeDiagramEnergyOffset
        }
    ];
}
function $e383a1a86a5ebbd4$export$2e5ceda339237ce2(controlsDiv, controlIDM) {
    let button = (0, $341c675b659c6d43$export$9b6d6ca62970729f)((0, $dc4240e6100248ae$export$1bb8965d05fbf467), undefined, (0, $dc4240e6100248ae$export$39c84188a71202f7));
    controlsDiv.appendChild(button);
    button.addEventListener('click', (event)=>{
        let i = (0, $dc4240e6100248ae$export$3bb92be1f57fd129).getNextControlID();
        console.log("Add Control " + i.toString());
        let cDivID = controlIDM.addID((0, $085f2478c495b249$export$7a7fa4424cb20976).tagName, i.toString());
        let cDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(cDivID, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
        // ElementToInsert before is element after the control div with the previous index.
        let elementToInsertBefore;
        if (i > 0) {
            let aboveElement = document.getElementById((0, $93b71ab6968650c1$export$3205c97bcf96f7dc)((0, $085f2478c495b249$export$7a7fa4424cb20976).tagName, (i - 1).toString(), (0, $dc4240e6100248ae$export$7295f538b9762c5)));
            let nextElementSibling = aboveElement.nextElementSibling;
            // If nextElementSibling is not a child of controlsDiv the element.
            if (nextElementSibling != null) {
                if (nextElementSibling.parentElement == controlsDiv) elementToInsertBefore = nextElementSibling;
                else elementToInsertBefore = button;
            } else elementToInsertBefore = button;
        } else elementToInsertBefore = button;
        // Create a collapsible div for each conditions.
        let ccDivID = controlIDM.addID(cDivID, (0, $dc4240e6100248ae$export$7295f538b9762c5));
        let ccDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(ccDivID, controlsDiv, elementToInsertBefore, cDiv, (0, $085f2478c495b249$export$7a7fa4424cb20976).tagName + " " + i.toString(), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$39c84188a71202f7));
        // Add the control
        let control = $e383a1a86a5ebbd4$var$addControl(new Map(), i);
        // Create a map of the on/off control options. The keys are the tag names and the values are the buttons.
        let onOffControls = new Map();
        $e383a1a86a5ebbd4$var$getControlOptionsSimple(control).forEach((option)=>{
            $e383a1a86a5ebbd4$var$handleControl(control, cDiv, controlIDM, onOffControls, null, null, option.class, option.setMethod, option.removeMethod);
        });
        // Create a div for the on/off controls.
        let onOffControlsDiv = (0, $341c675b659c6d43$export$78253536c0178a32)(undefined, (0, $dc4240e6100248ae$export$39c84188a71202f7));
        let orderedOnOffControls = new Map([
            ...onOffControls.entries()
        ].sort());
        orderedOnOffControls.forEach((button)=>{
            onOffControlsDiv.appendChild(button);
        });
        cDiv.appendChild(onOffControlsDiv);
        // Controls with additional things to set.
        $e383a1a86a5ebbd4$var$handleTestMicroRates(control, cDiv, controlIDM, null, (0, $dc4240e6100248ae$export$39c84188a71202f7));
        $e383a1a86a5ebbd4$var$handleCalcMethod(control, cDiv, controlIDM, null, (0, $dc4240e6100248ae$export$39c84188a71202f7));
        $e383a1a86a5ebbd4$var$getControlItems(control).forEach((item)=>{
            $e383a1a86a5ebbd4$var$handleControl(control, cDiv, controlIDM, onOffControls, null, (0, $dc4240e6100248ae$export$39c84188a71202f7), item.class, item.setMethod, item.removeMethod, true);
        });
        // Add a remove control button.
        let removeButton = (0, $dc4240e6100248ae$export$590bdcb7f5f5327a)(cDiv, (0, $dc4240e6100248ae$export$39c84188a71202f7), (0, $dc4240e6100248ae$export$3bb92be1f57fd129).removeControl.bind((0, $dc4240e6100248ae$export$3bb92be1f57fd129)), i);
        removeButton.addEventListener('click', (event)=>{
            // Remove the control.
            (0, $dc4240e6100248ae$export$cd7f480d6b8286c3)(ccDivID);
            controlIDM.removeIDs(cDivID);
            let divCmId = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(cDivID, (0, $085f2478c495b249$export$f0bfd84d03c3a22d).tagName);
            controlIDM.removeIDs(divCmId);
            let divCmDetailsId = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(divCmId, "details");
            controlIDM.removeIDs(divCmDetailsId);
            let divCmDetailsSelectId = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(divCmDetailsId, "select");
            controlIDM.removeIDs(divCmDetailsSelectId);
        });
    });
    return button;
}
/**
 * Add and return a new control.
 */ function $e383a1a86a5ebbd4$var$addControl(attributes, i) {
    let control = new (0, $085f2478c495b249$export$7a7fa4424cb20976)(attributes, i);
    (0, $dc4240e6100248ae$export$3bb92be1f57fd129).addControl(control);
    return control;
}
/**
 * @param control The control.
 * @param div The div.
 * @param obj The object.
 * @param setControlMethod The set control method. 
 * @param id The id for the input.
 * @param valueString The value string.
 */ function $e383a1a86a5ebbd4$var$createInputControlItem(control, div, obj, setControlMethod, id, valueString) {
    setControlMethod.call(control, obj);
    let input = (0, $341c675b659c6d43$export$d80fffb1deb3b97e)("number", id, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    input.addEventListener('change', (event)=>{
        let target = event.target;
        (0, $dc4240e6100248ae$export$b1e4cbf5b56e0e21)(obj, target);
        (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
    });
    input.value = valueString;
    (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(input);
    div.appendChild(input);
}
/**
 * 
 * @param control The control.
 * @param cDiv The control div.
 * @param onOffControls The on/off controls.
 * @param xml_control The xml control.
 * @param ControlClass The control class.
 * @param setControlMethod The set control method.
 * @param removeControlMethod The remove control method.
 */ function $e383a1a86a5ebbd4$var$handleControl(control, cDiv, controlIDs, onOffControls, xml_control, level, ControlClass, setControlMethod, removeControlMethod, handleInput = false) {
    let tagName = ControlClass.tagName;
    let buttonTextContentSelected = tagName + (0, $dc4240e6100248ae$export$f0fb6e9d3fd6cf72);
    let buttonTextContentDeselected = tagName + (0, $dc4240e6100248ae$export$b758aa9bd161846e);
    let button = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(buttonTextContentDeselected, undefined, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    button.classList.add((0, $dc4240e6100248ae$export$50cc31b59b02e033));
    button.classList.add((0, $dc4240e6100248ae$export$d52efe23389358db));
    if (onOffControls) onOffControls.set(tagName, button);
    let controlInstance;
    let div;
    let id;
    if (level) {
        id = controlIDs.addID(cDiv.id, tagName);
        div = (0, $341c675b659c6d43$export$78253536c0178a32)(id, level);
        cDiv.appendChild(div);
        div.appendChild(button);
        id = controlIDs.addID(cDiv.id, id, (0, $dc4240e6100248ae$export$58785e0018b77d4a));
    }
    if (xml_control) {
        let xml = xml_control.getElementsByTagName(tagName);
        if (xml.length == 1) {
            if (handleInput) {
                let valueString = (0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml[0]));
                let value;
                // Deal with the special case of eigenvalues, which can take either numerical or string values.
                value = valueString == "all" ? new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(0) : new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(valueString);
                controlInstance = new ControlClass((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml[0]), value);
                $e383a1a86a5ebbd4$var$createInputControlItem(control, div, controlInstance, setControlMethod, id, valueString);
            } else {
                controlInstance = new ControlClass((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml[0]));
                setControlMethod.call(control, controlInstance);
            }
            button.textContent = buttonTextContentSelected;
            button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
        } else {
            button.textContent = buttonTextContentDeselected;
            button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
        }
    } else {
        controlInstance = new ControlClass(new Map());
        button.textContent = buttonTextContentDeselected;
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
    }
    button.addEventListener('click', (event)=>{
        if (!control.index.has(tagName)) {
            if (handleInput) $e383a1a86a5ebbd4$var$createInputControlItem(control, div, controlInstance, setControlMethod, id, "");
            else setControlMethod.call(control, controlInstance);
            button.textContent = buttonTextContentSelected;
        } else {
            if (handleInput) (0, $dc4240e6100248ae$export$cd7f480d6b8286c3)(id);
            removeControlMethod.call(control);
            button.textContent = buttonTextContentDeselected;
        }
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
        button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
    });
}
/**
 * @param control The control.
 * @param cDiv The control div.
 * @param xml_control The xml control. 
 * @param level The level.
 */ function $e383a1a86a5ebbd4$var$handleCalcMethod(control, cDiv, controlIDM, xml_control, level) {
    //console.log("handleCalcMethod " + (xml_control == null));
    let div = (0, $341c675b659c6d43$export$78253536c0178a32)(undefined, level);
    cDiv.appendChild(div);
    let tagName = (0, $085f2478c495b249$export$f0bfd84d03c3a22d).tagName;
    let buttonTextContentSelected = tagName + (0, $dc4240e6100248ae$export$f0fb6e9d3fd6cf72);
    let buttonTextContentDeselected = tagName + (0, $dc4240e6100248ae$export$b758aa9bd161846e);
    let button = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(buttonTextContentDeselected, undefined, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    div.appendChild(button);
    button.classList.add((0, $dc4240e6100248ae$export$50cc31b59b02e033));
    button.classList.add((0, $dc4240e6100248ae$export$d52efe23389358db));
    // Add the div for the CalcMethod.
    let divCmId = controlIDM.addID(cDiv.id, tagName);
    let divCm = (0, $341c675b659c6d43$export$78253536c0178a32)(divCmId, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    div.appendChild(divCm);
    let options = (0, $085f2478c495b249$export$f0bfd84d03c3a22d).options;
    let divCmDetailsId = controlIDM.addID(divCmId, "details");
    let divCmDetailsSelectId = controlIDM.addID(divCmDetailsId, "select");
    let cm;
    let first = true;
    if (xml_control != null) {
        //let xml: HTMLCollectionOf<Element> = xml_control.getElementsByTagNameNS("http://www.chem.leeds.ac.uk/mesmer", "calcMethod");
        let xml = xml_control.getElementsByTagName(tagName);
        //console.log("xml.length " + xml.length);
        if (xml.length > 0) {
            if (xml.length > 1) throw new Error("More than one CalcMethod element.");
            let attributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml[0]);
            let xsi_type = attributes.get("xsi:type");
            cm = $e383a1a86a5ebbd4$var$getCalcMethod(controlIDM, control, divCm, xml, options, attributes, tagName, xsi_type, divCmDetailsId, divCmDetailsSelectId);
            control.setCalcMethod(cm);
            button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
            button.textContent = buttonTextContentSelected;
        } else {
            button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
            button.textContent = buttonTextContentDeselected;
        }
    } else {
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
        button.textContent = buttonTextContentDeselected;
    }
    // Add event listener for the button.
    button.addEventListener('click', (event)=>{
        // Check if the CalcMethod already exists
        if (!control.index.has(tagName)) {
            if (first) {
                if (options[options.length - 1] != (0, $dc4240e6100248ae$export$d8b8827abc8ab7e7)) options.push((0, $dc4240e6100248ae$export$d8b8827abc8ab7e7));
            }
            // Remove select.
            //remove(divCmId);
            controlIDM.removeIDs(divCmDetailsId);
            controlIDM.removeIDs(divCmDetailsSelectId);
            // Create the select element.
            let select = $e383a1a86a5ebbd4$var$createSelectElementCalcMethod(controlIDM, control, div, options, tagName, (0, $dc4240e6100248ae$export$d8b8827abc8ab7e7), divCmDetailsId, divCmDetailsSelectId);
            divCm.appendChild(select);
            button.textContent = buttonTextContentSelected;
            button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
            button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
        } else if (control.getCalcMethod() != null) {
            control.removeCalcMethod();
            // Remove any existing div.
            //remove(divCmId);
            controlIDM.removeIDs(divCmDetailsId);
            //console.log("remove(divCmDetailsSelectId) " + divCmDetailsSelectId);
            //console.log("button.textContent " + button.textContent);
            controlIDM.removeIDs(divCmDetailsSelectId);
            button.textContent = buttonTextContentDeselected;
            button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
            button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
        }
    });
}
/**
 * Process "me:testMicroRates".
 * @param control The control.
 * @param cDiv The control div.
 * @param xml_control The xml control.
 * @param level The level.
 */ function $e383a1a86a5ebbd4$var$handleTestMicroRates(control, cDiv, controlIDM, xml_control, level) {
    let tagName = (0, $085f2478c495b249$export$1f37c7c73e401f31).tagName;
    let divID = controlIDM.addID(cDiv.id, tagName);
    let div = (0, $341c675b659c6d43$export$78253536c0178a32)(divID, level);
    cDiv.appendChild(div);
    let buttonTextContentSelected = tagName + (0, $dc4240e6100248ae$export$f0fb6e9d3fd6cf72);
    let buttonTextContentDeselected = tagName + (0, $dc4240e6100248ae$export$b758aa9bd161846e);
    let button = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(tagName, controlIDM.addID(cDiv.id, tagName, (0, $341c675b659c6d43$export$25280bc3a7ce098e)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    div.appendChild(button);
    button.classList.add((0, $dc4240e6100248ae$export$50cc31b59b02e033));
    button.classList.add((0, $dc4240e6100248ae$export$d52efe23389358db));
    let idTmax = controlIDM.addID(cDiv.id, tagName, (0, $085f2478c495b249$export$58c8f4b7ec654137).tagName);
    let idTmin = controlIDM.addID(cDiv.id, tagName, (0, $085f2478c495b249$export$7be1a36e1f74dbc7).tagName);
    let idTstep = controlIDM.addID(cDiv.id, tagName, (0, $085f2478c495b249$export$7b8cfe3a6a460886).tagName);
    if (xml_control) {
        let xml = xml_control.getElementsByTagName(tagName);
        if (xml.length == 1) {
            $e383a1a86a5ebbd4$var$createTestMicroRates(control, div, xml, idTmax, idTmin, idTstep);
            button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
            button.textContent = buttonTextContentSelected;
        } else {
            button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
            button.textContent = buttonTextContentDeselected;
        }
    } else {
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
        button.textContent = buttonTextContentDeselected;
    }
    // Add event listener for the button.
    button.addEventListener('click', (event)=>{
        // Check if the TestMicroRates already exists
        if (!control.index.has(tagName)) {
            $e383a1a86a5ebbd4$var$createTestMicroRates(control, div, null, idTmax, idTmin, idTstep);
            button.textContent = buttonTextContentSelected;
        } else {
            control.removeTestMicroRates();
            // Remove any existing Tmax.
            document.getElementById(idTmax)?.remove();
            // Remove any existing Tmin.
            document.getElementById(idTmin)?.remove();
            // Remove any existing Tstep.
            document.getElementById(idTstep)?.remove();
            button.textContent = buttonTextContentDeselected;
        }
        button.classList.toggle((0, $dc4240e6100248ae$export$50cc31b59b02e033));
        button.classList.toggle((0, $dc4240e6100248ae$export$d52efe23389358db));
    });
}
/**
 * @param control The control.
 * @param div The div.
 * @param xml_tmr The xml.
 * @param idTmax The Tmax id.
 * @param idTmin The Tmin id.
 * @param idTstep The Tstep id.
 */ function $e383a1a86a5ebbd4$var$createTestMicroRates(control, div, xml_tmr, idTmax, idTmin, idTstep) {
    let attributes;
    let tmr;
    if (xml_tmr != null && xml_tmr.length > 0) {
        if (xml_tmr.length > 1) throw new Error("More than one TestMicroRates element.");
        attributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_tmr[0]);
        tmr = new (0, $085f2478c495b249$export$1f37c7c73e401f31)(attributes);
    } else {
        attributes = new Map();
        // Set some default values.
        attributes.set((0, $085f2478c495b249$export$1f37c7c73e401f31).s_Tmax, "2000"); // These should load from some kind of default...
        attributes.set((0, $085f2478c495b249$export$1f37c7c73e401f31).s_Tmin, "100");
        attributes.set((0, $085f2478c495b249$export$1f37c7c73e401f31).s_Tstep, "100");
        tmr = new (0, $085f2478c495b249$export$1f37c7c73e401f31)(attributes);
    }
    control.setTestMicroRates(tmr);
    // Tmax.
    let tMax = tmr.getTmax();
    let tMaxlwi = (0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("text", (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(idTmax, "input"), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$b1ddbf2a116c10ee), (event)=>{
        let target = event.target;
        // Check the value is a number.
        try {
            tmr.setTmax(new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(target.value));
            console.log("Set " + (0, $085f2478c495b249$export$1f37c7c73e401f31).s_Tmax + " to " + target.value);
        } catch (e) {
            alert("Invalid input, resetting...");
            target.value = tMax.toString();
        }
        (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
    }, tMax.toString(), (0, $085f2478c495b249$export$1f37c7c73e401f31).s_Tmax);
    tMaxlwi.id = idTmax;
    (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(tMaxlwi.querySelector('input'));
    div.appendChild(tMaxlwi);
    // Tmin.
    let tMin = tmr.getTmin();
    let tMinlwi = (0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("number", (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(idTmin + "input"), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$b1ddbf2a116c10ee), (event)=>{
        let target = event.target;
        // Check the value is a number.
        if ((0, $93b71ab6968650c1$export$e90fb89750dba83f)(target.value)) {
            tmr.setTmin(new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(target.value));
            console.log("Set " + (0, $085f2478c495b249$export$1f37c7c73e401f31).s_Tmin + " to " + target.value);
        } else {
            alert("Value is not numeric, resetting...");
            target.value = tMin.toString();
        }
        (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
    }, tMin.toString(), (0, $085f2478c495b249$export$1f37c7c73e401f31).s_Tmin);
    tMinlwi.id = idTmin;
    (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(tMinlwi.querySelector('input'));
    div.appendChild(tMinlwi);
    // Tstep.
    let tStep = tmr.getTstep();
    let tSteplwi = (0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("text", (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(idTstep + "input"), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$b1ddbf2a116c10ee), (event)=>{
        let target = event.target;
        // Check the value is a number.
        if ((0, $93b71ab6968650c1$export$e90fb89750dba83f)(target.value)) {
            tmr.setTstep(new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(target.value));
            console.log("Set " + (0, $085f2478c495b249$export$1f37c7c73e401f31).s_Tstep + " to " + target.value);
        } else {
            alert("Value is not numeric, resetting...");
            target.value = tStep.toString();
        }
        (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
    }, tStep.toString(), (0, $085f2478c495b249$export$1f37c7c73e401f31).s_Tstep);
    tSteplwi.id = idTstep;
    (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(tSteplwi.querySelector('input'));
    div.appendChild(tSteplwi);
}
/**
 * Get the CalcMethod from the XML.
 * @param control The control.
 * @param divCm The div cm.
 * @param xml The xml.
 * @param options The options.
 * @param attributes The attributes.
 * @param tagName The tag name.
 * @param xsi_type The xsi:type.
 * @param divCmDetailsId The div cm details id.
 * @param divCmDetailsSelectId The div cm details select id.
 * @returns The CalcMethod.
 */ function $e383a1a86a5ebbd4$var$getCalcMethod(controlIDM, control, divCm, xml, options, attributes, tagName, xsi_type, divCmDetailsId, divCmDetailsSelectId) {
    //console.log("getCalcMethod");
    let cm;
    // Create the select element.
    let select = $e383a1a86a5ebbd4$var$createSelectElementCalcMethod(controlIDM, control, divCm, options, tagName, xsi_type, divCmDetailsId, divCmDetailsSelectId);
    // Set the select element to the correct value.
    select.value = xsi_type;
    divCm.appendChild(select);
    // Add the details div.
    let divCmDetails = (0, $341c675b659c6d43$export$78253536c0178a32)(divCmDetailsId, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    divCm.appendChild(divCmDetails);
    if (xsi_type == (0, $085f2478c495b249$export$afd374542f6f3da6).xsi_type || xsi_type == (0, $085f2478c495b249$export$afd374542f6f3da6).xsi_type2) //console.log("CalcMethodSimpleCalc");
    cm = new (0, $085f2478c495b249$export$afd374542f6f3da6)(attributes);
    else if (xsi_type == (0, $085f2478c495b249$export$271191b096a55e63).xsi_type || xsi_type == (0, $085f2478c495b249$export$271191b096a55e63).xsi_type2) cm = new (0, $085f2478c495b249$export$271191b096a55e63)(attributes);
    else if (xsi_type == (0, $085f2478c495b249$export$654b70df01671c79).xsi_type || xsi_type == (0, $085f2478c495b249$export$654b70df01671c79).xsi_type2) {
        let cmf = new (0, $085f2478c495b249$export$654b70df01671c79)(attributes);
        cm = cmf;
        // FittingIterations.
        let fi_xml = xml[0].getElementsByTagName((0, $085f2478c495b249$export$830a50cd13af6e84).tagName);
        if (fi_xml.length > 0) {
            if (fi_xml.length == 1) {
                let value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))((0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(fi_xml[0])));
                let fittingIterations = new (0, $085f2478c495b249$export$830a50cd13af6e84)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(fi_xml[0]), value);
                cmf.setFittingIterations(fittingIterations);
            } else throw new Error("More than one FittingIterations element.");
        }
        $e383a1a86a5ebbd4$var$processCalcMethodFitting(divCmDetails, cmf);
    } else if (xsi_type == (0, $085f2478c495b249$export$7968aa666bcf62fa).xsi_type || xsi_type == (0, $085f2478c495b249$export$7968aa666bcf62fa).xsi_type2) {
        let cmm = new (0, $085f2478c495b249$export$7968aa666bcf62fa)(attributes);
        cm = cmm;
        function processElement(xml, ClassConstructor, setterMethod) {
            let tagName = (0, $085f2478c495b249$export$9f699e98369d9591).tagName;
            let elementXml = xml[0].getElementsByTagName(tagName);
            if (elementXml.length > 0) {
                if (elementXml.length == 1) {
                    let value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))((0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(elementXml[0])));
                    let instance = new ClassConstructor((0, $057fa7562ec736a9$export$fe94072fee8a6976)(elementXml[0]), value);
                    setterMethod(instance);
                } else throw new Error(`More than one ${tagName} element.`);
            }
        }
        processElement(xml, (0, $085f2478c495b249$export$9f699e98369d9591), cmm.setMarquardtIterations.bind(cmm));
        processElement(xml, (0, $085f2478c495b249$export$ca1e6c3ff9fd3627), cmm.setMarquardtTolerance.bind(cmm));
        processElement(xml, (0, $085f2478c495b249$export$d3887b529debf19d), cmm.setMarquardtDerivDelta.bind(cmm));
        $e383a1a86a5ebbd4$var$processCalcMethodMarquardt(divCmDetails, cmm);
    } else if (xsi_type == (0, $085f2478c495b249$export$fe9781900d201bdf).xsi_type || xsi_type == (0, $085f2478c495b249$export$fe9781900d201bdf).xsi_type2) {
        let cmar = new (0, $085f2478c495b249$export$fe9781900d201bdf)(attributes);
        cm = cmar;
        function processElement1(xml, ClassConstructor, setterMethod, isNumber) {
            let tagName = ClassConstructor.tagName;
            let elementXml = xml[0].getElementsByTagName(tagName);
            if (elementXml.length > 0) {
                if (elementXml.length == 1) {
                    let value = (0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(elementXml[0]));
                    if (isNumber) {
                        if (value != undefined) {
                            if (value != "" && value != "NaN") value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(value);
                        }
                    }
                    let instance = new ClassConstructor((0, $057fa7562ec736a9$export$fe94072fee8a6976)(elementXml[0]), value);
                    setterMethod(instance);
                } else throw new Error(`More than one ${tagName} element.`);
            }
        }
        processElement1(xml, (0, $085f2478c495b249$export$93514d28bd18d75a), cmar.setFormat.bind(cmar), false);
        processElement1(xml, (0, $085f2478c495b249$export$be201676156f3e60), cmar.setPrecision.bind(cmar), false);
        processElement1(xml, (0, $085f2478c495b249$export$19d20f3642d82681), cmar.setChebNumTemp.bind(cmar), true);
        processElement1(xml, (0, $085f2478c495b249$export$906be0805438fd80), cmar.setChebNumConc.bind(cmar), true);
        processElement1(xml, (0, $085f2478c495b249$export$6ab4fe1621c91452), cmar.setChebMaxTemp.bind(cmar), true);
        processElement1(xml, (0, $085f2478c495b249$export$e9853d49316ae9ae), cmar.setChebMinTemp.bind(cmar), true);
        processElement1(xml, (0, $085f2478c495b249$export$39eacc768d7e9bb), cmar.setChebMaxConc.bind(cmar), true);
        processElement1(xml, (0, $085f2478c495b249$export$78194e57ce26d99a), cmar.setChebMinConc.bind(cmar), true);
        processElement1(xml, (0, $085f2478c495b249$export$96094ac7e31a750e), cmar.setChebTExSize.bind(cmar), true);
        processElement1(xml, (0, $085f2478c495b249$export$ae695595d3952700), cmar.setChebPExSize.bind(cmar), true);
        $e383a1a86a5ebbd4$var$processCalcMethodAnalyticalRepresentation(divCmDetails, cmar);
    } else if (xsi_type == (0, $085f2478c495b249$export$16ef3f79998b60b4).xsi_type || xsi_type == (0, $085f2478c495b249$export$16ef3f79998b60b4).xsi_type2) {
        let cmtt = new (0, $085f2478c495b249$export$16ef3f79998b60b4)(attributes);
        cm = cmtt;
        function processElement2(xml, ClassConstructor, setterMethod) {
            let tagName = ClassConstructor.tagName;
            let elementXml = xml[0].getElementsByTagName(tagName);
            if (elementXml.length > 0) {
                if (elementXml.length == 1) {
                    let value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))((0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(elementXml[0])));
                    let instance = new ClassConstructor((0, $057fa7562ec736a9$export$fe94072fee8a6976)(elementXml[0]), value);
                    setterMethod(instance);
                } else throw new Error(`More than one ${tagName} element.`);
            }
        }
        processElement2(xml, (0, $085f2478c495b249$export$7be1a36e1f74dbc7), cmtt.setTmin.bind(cmtt));
        processElement2(xml, (0, $085f2478c495b249$export$ac2eb7df727f506d), cmtt.setTmid.bind(cmtt));
        processElement2(xml, (0, $085f2478c495b249$export$58c8f4b7ec654137), cmtt.setTmax.bind(cmtt));
        processElement2(xml, (0, $085f2478c495b249$export$7b8cfe3a6a460886), cmtt.setTstep.bind(cmtt));
        $e383a1a86a5ebbd4$var$processCalcMethodThermodynamicTable(divCmDetails, cmtt);
    } else if (xsi_type == (0, $085f2478c495b249$export$a532500cc43efbef).xsi_type || xsi_type == (0, $085f2478c495b249$export$a532500cc43efbef).xsi_type2) {
        let cmsa = new (0, $085f2478c495b249$export$a532500cc43efbef)(attributes);
        cm = cmsa;
        function processElement3(xml, ClassConstructor, setterMethod) {
            let tagName = ClassConstructor.tagName;
            let elementXml = xml[0].getElementsByTagName(tagName);
            if (elementXml.length > 0) {
                if (elementXml.length == 1) {
                    let value = (0, $057fa7562ec736a9$export$13cb40e9b656ab9e)((0, $057fa7562ec736a9$export$4e07613bf412feb7)(elementXml[0]));
                    if (value != undefined) value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(value);
                    let instance = new ClassConstructor((0, $057fa7562ec736a9$export$fe94072fee8a6976)(elementXml[0]), value);
                    setterMethod(instance);
                } else throw new Error(`More than one ${tagName} element.`);
            }
        }
        processElement3(xml, (0, $085f2478c495b249$export$37d0520a9fac7849), cmsa.setSensitivityAnalysisSamples.bind(cmsa));
        processElement3(xml, (0, $085f2478c495b249$export$9a832710e54827ea), cmsa.setSensitivityAnalysisOrder.bind(cmsa));
        processElement3(xml, (0, $085f2478c495b249$export$b43b57458ce8fb96), cmsa.setSensitivityNumVarRedIters.bind(cmsa));
        processElement3(xml, (0, $085f2478c495b249$export$e98aeac6c6b1df09), cmsa.setSensitivityVarRedMethod.bind(cmsa));
        $e383a1a86a5ebbd4$var$processCalcMethodSensitivityAnalysis(divCmDetails, cmsa);
    } else {
        // If there is a name attribute instead, try this in place of the xsi:type.
        let name = attributes.get("name");
        if (name != undefined && name !== xsi_type) {
            attributes.set("xsi:type", name);
            console.warn(`Using name attribute as xsi:type: ${name}`);
            return $e383a1a86a5ebbd4$var$getCalcMethod(controlIDM, control, divCm, xml, options, attributes, tagName, name, divCmDetailsId, divCmDetailsSelectId);
        } else throw new Error(`Unable to determine calculation method for xsi_type: ${xsi_type}`);
    }
    return cm;
}
/**
 * @param divCmDetails The details div.
 * @param cm The CalcMethodFitting.
 */ function $e383a1a86a5ebbd4$var$processCalcMethodFitting(divCmDetails, cm) {
    // FittingIterations.
    let fi = cm.getFittingIterations() || new (0, $085f2478c495b249$export$830a50cd13af6e84)(new Map(), (0, $dc4240e6100248ae$export$a94c859b6fc3ec52));
    cm.setFittingIterations(fi);
    divCmDetails.appendChild((0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("number", (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(divCmDetails.id, (0, $085f2478c495b249$export$830a50cd13af6e84).tagName, (0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$b1ddbf2a116c10ee), (event)=>{
        let target = event.target;
        // Check the value is a number.
        if ((0, $93b71ab6968650c1$export$e90fb89750dba83f)(target.value)) {
            fi.value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(target.value);
            console.log("Set FittingIterations to " + target.value);
        } else {
            alert("Value is not numeric, resetting...");
            target.value = fi.value.toString();
        }
        (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
    }, fi.value.toString(), (0, $085f2478c495b249$export$830a50cd13af6e84).tagName));
}
/**
 * @param divCmDetails The details div.
 * @param cm The CalcMethodMarquardt.
 */ function $e383a1a86a5ebbd4$var$processCalcMethodMarquardt(divCmDetails, cm) {
    function createLabelWithInputForObject(obj, divCmDetails, boundary, level) {
        let id = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(divCmDetails.id, obj.tagName, (0, $dc4240e6100248ae$export$58785e0018b77d4a));
        let value = obj.value.toString();
        let labelTextContent = obj.tagName;
        let inputHandler = (event)=>{
            let target = event.target;
            // Check the value is a number.
            if ((0, $93b71ab6968650c1$export$e90fb89750dba83f)(target.value)) {
                obj.value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(target.value);
                console.log("Set " + obj.tagName + " to " + target.value);
            } else {
                alert("Value is not numeric, resetting...");
                target.value = obj.value.toString();
            }
            (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
        };
        divCmDetails.appendChild((0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("number", id, boundary, level, inputHandler, value, labelTextContent));
    }
    // MarquardtIterations.
    let mi = cm.getMarquardtIterations() || new (0, $085f2478c495b249$export$9f699e98369d9591)(new Map(), (0, $dc4240e6100248ae$export$a94c859b6fc3ec52));
    cm.setMarquardtIterations(mi);
    createLabelWithInputForObject(mi, divCmDetails, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$b1ddbf2a116c10ee));
    // MarquardtTolerance.
    let mt = cm.getMarquardtTolerance() || new (0, $085f2478c495b249$export$ca1e6c3ff9fd3627)(new Map(), (0, $dc4240e6100248ae$export$a94c859b6fc3ec52));
    cm.setMarquardtTolerance(mt);
    createLabelWithInputForObject(mt, divCmDetails, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$b1ddbf2a116c10ee));
    // MarquardtDerivDelta.
    let mdd = cm.getMarquardtDerivDelta() || new (0, $085f2478c495b249$export$d3887b529debf19d)(new Map(), (0, $dc4240e6100248ae$export$a94c859b6fc3ec52));
    cm.setMarquardtDerivDelta(mdd);
    createLabelWithInputForObject(mdd, divCmDetails, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$b1ddbf2a116c10ee));
}
/**
 * @param divCmDetails The details div.
 * @param cm The CalcMethodAnalyticalRepresentation.
 */ function $e383a1a86a5ebbd4$var$processCalcMethodAnalyticalRepresentation(divCmDetails, cm) {
    // "me:format".
    let format = cm.getFormat() || new (0, $085f2478c495b249$export$93514d28bd18d75a)(new Map(), (0, $085f2478c495b249$export$93514d28bd18d75a).options[0]);
    // value, rateUnits, "me:precision"
    function processSelectElement(ClassConstructor, getter, setter, tagName, options) {
        let element = getter() || new ClassConstructor(new Map(), options[0]);
        setter(element);
        let lwsElement = (0, $341c675b659c6d43$export$4c3eba01cd3c5ba4)(tagName, options, tagName, element.value, divCmDetails.id, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
        lwsElement.querySelector('select')?.addEventListener('change', (event)=>{
            let target = event.target;
            element.value = target.value;
            console.log(`Set ${tagName} to ` + target.value);
            (0, $341c675b659c6d43$export$fdd146df37959fe8)(target);
        });
        divCmDetails.appendChild(lwsElement);
    }
    processSelectElement((0, $085f2478c495b249$export$93514d28bd18d75a), cm.getFormat.bind(cm), cm.setFormat.bind(cm), (0, $085f2478c495b249$export$93514d28bd18d75a).tagName, (0, $085f2478c495b249$export$93514d28bd18d75a).options);
    processSelectElement((0, $085f2478c495b249$export$93514d28bd18d75a), ()=>format.getRateUnits(), format.setRateUnits.bind(format), (0, $085f2478c495b249$export$93514d28bd18d75a).rateUnits, (0, $085f2478c495b249$export$93514d28bd18d75a).rateUnitsOptions);
    processSelectElement((0, $085f2478c495b249$export$be201676156f3e60), cm.getPrecision.bind(cm), cm.setPrecision.bind(cm), (0, $085f2478c495b249$export$be201676156f3e60).tagName, (0, $ccef02370f58a770$export$692079bb871c6039).precisionOptions);
    // "me:chebNumTemp", "me:chebNumConc", "me:chebMaxTemp", "me:chebMaxTemp", "me:chebMinTemp", "me:chebMaxConc", "me:chebMinConc",
    // "me:chebTExSize", "me:chebPExSize".
    function processElement(ClassConstructor, getter, setter, tagName) {
        let element = getter() || new ClassConstructor(new Map(), NaN);
        setter(element);
        divCmDetails.appendChild((0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("text", divCmDetails.id + `_${tagName}_input`, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$b1ddbf2a116c10ee), $e383a1a86a5ebbd4$var$handleEvent(element, tagName), element.value.toString(), tagName));
    }
    processElement((0, $085f2478c495b249$export$19d20f3642d82681), cm.getChebNumTemp.bind(cm), cm.setChebNumTemp.bind(cm), (0, $085f2478c495b249$export$19d20f3642d82681).tagName);
    processElement((0, $085f2478c495b249$export$906be0805438fd80), cm.getChebNumConc.bind(cm), cm.setChebNumConc.bind(cm), (0, $085f2478c495b249$export$906be0805438fd80).tagName);
    processElement((0, $085f2478c495b249$export$6ab4fe1621c91452), cm.getChebMaxTemp.bind(cm), cm.setChebMaxTemp.bind(cm), (0, $085f2478c495b249$export$6ab4fe1621c91452).tagName);
    processElement((0, $085f2478c495b249$export$e9853d49316ae9ae), cm.getChebMinTemp.bind(cm), cm.setChebMinTemp.bind(cm), (0, $085f2478c495b249$export$e9853d49316ae9ae).tagName);
    processElement((0, $085f2478c495b249$export$39eacc768d7e9bb), cm.getChebMaxConc.bind(cm), cm.setChebMaxConc.bind(cm), (0, $085f2478c495b249$export$39eacc768d7e9bb).tagName);
    processElement((0, $085f2478c495b249$export$78194e57ce26d99a), cm.getChebMinConc.bind(cm), cm.setChebMinConc.bind(cm), (0, $085f2478c495b249$export$78194e57ce26d99a).tagName);
    processElement((0, $085f2478c495b249$export$96094ac7e31a750e), cm.getChebTExSize.bind(cm), cm.setChebTExSize.bind(cm), (0, $085f2478c495b249$export$96094ac7e31a750e).tagName);
    processElement((0, $085f2478c495b249$export$ae695595d3952700), cm.getChebPExSize.bind(cm), cm.setChebPExSize.bind(cm), (0, $085f2478c495b249$export$ae695595d3952700).tagName);
}
/**
 * @param divCmDetails The details div.
 * @param cm The CalcMethodThermodynamicTable.
 */ function $e383a1a86a5ebbd4$var$processCalcMethodThermodynamicTable(divCmDetails, cm) {
    // "me:Tmin", "me:Tmid", "me:Tmax, "me:Tstep".
    function processElement(ClassConstructor, getter, setter, tagName) {
        let element = getter() || new ClassConstructor(new Map(), NaN);
        setter(element);
        divCmDetails.appendChild((0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("text", divCmDetails.id + `_${tagName}_input`, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$b1ddbf2a116c10ee), $e383a1a86a5ebbd4$var$handleEvent(element, tagName), element.value.toString(), tagName));
    }
    processElement((0, $085f2478c495b249$export$7be1a36e1f74dbc7), cm.getTmin.bind(cm), cm.setTmin.bind(cm), (0, $085f2478c495b249$export$7be1a36e1f74dbc7).tagName);
    processElement((0, $085f2478c495b249$export$ac2eb7df727f506d), cm.getTmid.bind(cm), cm.setTmid.bind(cm), (0, $085f2478c495b249$export$ac2eb7df727f506d).tagName);
    processElement((0, $085f2478c495b249$export$58c8f4b7ec654137), cm.getTmax.bind(cm), cm.setTmax.bind(cm), (0, $085f2478c495b249$export$58c8f4b7ec654137).tagName);
    processElement((0, $085f2478c495b249$export$7b8cfe3a6a460886), cm.getTstep.bind(cm), cm.setTstep.bind(cm), (0, $085f2478c495b249$export$7b8cfe3a6a460886).tagName);
}
function $e383a1a86a5ebbd4$var$handleEvent(element, tagName) {
    return (event)=>{
        let target = event.target;
        try {
            element.value = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9e9f310a798519$exports)))(target.value);
        } catch (e) {
            alert("Invalid input value " + target.value + " , resetting...");
            target.value = element.value.toString();
        }
        (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
    };
}
/**
 * @param divCmDetails The details div.
 * @param cm The CalcMethodSensitivityAnalysis.
 */ function $e383a1a86a5ebbd4$var$processCalcMethodSensitivityAnalysis(divCmDetails, cm) {
    // "me:sensitivityAnalysisSamples", "me:sensitivityAnalysisOrder", "me:sensitivityNumVarRedIters".
    function processNumberElement(ClassConstructor, getter, setter, tagName) {
        let element = getter() || new ClassConstructor(new Map(), NaN);
        setter(element);
        divCmDetails.appendChild((0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("text", (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(divCmDetails.id, tagName, (0, $dc4240e6100248ae$export$58785e0018b77d4a)), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$b1ddbf2a116c10ee), $e383a1a86a5ebbd4$var$handleEvent(element, tagName), element.value.toString(), tagName));
    }
    processNumberElement((0, $085f2478c495b249$export$37d0520a9fac7849), cm.getSensitivityAnalysisSamples.bind(cm), cm.setSensitivityAnalysisSamples.bind(cm), (0, $085f2478c495b249$export$37d0520a9fac7849).tagName);
    processNumberElement((0, $085f2478c495b249$export$9a832710e54827ea), cm.getSensitivityAnalysisOrder.bind(cm), cm.setSensitivityAnalysisOrder.bind(cm), (0, $085f2478c495b249$export$9a832710e54827ea).tagName);
    processNumberElement((0, $085f2478c495b249$export$b43b57458ce8fb96), cm.getSensitivityNumVarRedIters.bind(cm), cm.setSensitivityNumVarRedIters.bind(cm), (0, $085f2478c495b249$export$b43b57458ce8fb96).tagName);
    // "me:sensitivityVarRedMethod".
    let sensitivityVarRedMethod = cm.getSensitivityVarRedMethod() || new (0, $085f2478c495b249$export$e98aeac6c6b1df09)(new Map(), "");
    cm.setSensitivityVarRedMethod(sensitivityVarRedMethod);
    let tagName = (0, $085f2478c495b249$export$e98aeac6c6b1df09).tagName;
    divCmDetails.appendChild((0, $341c675b659c6d43$export$4c3eba01cd3c5ba4)(tagName, (0, $085f2478c495b249$export$e98aeac6c6b1df09).options, tagName, (0, $085f2478c495b249$export$e98aeac6c6b1df09).options[0], (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(divCmDetails.id, tagName, 'select'), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b)));
    // Add event listener for the select element.
    let select = divCmDetails.querySelector('select');
    select?.addEventListener('change', (event)=>{
        let target = event.target;
        sensitivityVarRedMethod.value = target.value;
        console.log(tagName + " set to " + target.value);
        (0, $341c675b659c6d43$export$fdd146df37959fe8)(target);
    });
}
/**
 * @param control The control.
 * @param div The div. 
 * @param options The options.
 * @param tagName The tag name.
 * @param value The value.
 * @param id The id for the HTMLSelectElement.
 * @returns An HTMLSelectElement.
 */ function $e383a1a86a5ebbd4$var$createSelectElementCalcMethod(controlIDM, control, div, options, tagName, value, divCmDetailsId, divCmDetailsSelectId) {
    let select = (0, $341c675b659c6d43$export$b89bf4b169286865)(options, tagName, value, divCmDetailsSelectId, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
    div.appendChild(select);
    (0, $dc4240e6100248ae$export$3b08dcba56872ec6)(options, select);
    select.addEventListener('change', (event)=>{
        // Remove any existing div.
        let divCmDetails = document.getElementById(divCmDetailsId);
        if (divCmDetails != null) {
            divCmDetails.remove();
            controlIDM.removeIDs(divCmDetailsId);
        }
        divCmDetails = (0, $341c675b659c6d43$export$78253536c0178a32)(divCmDetailsId, (0, $dc4240e6100248ae$export$d6befed1f1d5e56b));
        div.appendChild(divCmDetails);
        let target = event.target;
        let value = target.value;
        let attributes = new Map();
        attributes.set("xsi:type", value);
        if (value == (0, $085f2478c495b249$export$afd374542f6f3da6).xsi_type || value == (0, $085f2478c495b249$export$afd374542f6f3da6).xsi_type2) // "me:simpleCalc", "simpleCalc".
        control.setCalcMethod(new (0, $085f2478c495b249$export$afd374542f6f3da6)(attributes));
        else if (value == (0, $085f2478c495b249$export$271191b096a55e63).xsi_type || value == (0, $085f2478c495b249$export$271191b096a55e63).xsi_type2) // "me:gridSearch", "gridSearch".
        control.setCalcMethod(new (0, $085f2478c495b249$export$271191b096a55e63)(attributes));
        else if (value == (0, $085f2478c495b249$export$654b70df01671c79).xsi_type || value == (0, $085f2478c495b249$export$654b70df01671c79).xsi_type2) {
            let cm = new (0, $085f2478c495b249$export$654b70df01671c79)(attributes);
            control.setCalcMethod(cm);
            $e383a1a86a5ebbd4$var$processCalcMethodFitting(divCmDetails, cm);
        } else if (value == (0, $085f2478c495b249$export$7968aa666bcf62fa).xsi_type || value == (0, $085f2478c495b249$export$7968aa666bcf62fa).xsi_type2) {
            // "me:marquardt", "marquardt".
            let cm = new (0, $085f2478c495b249$export$7968aa666bcf62fa)(attributes);
            control.setCalcMethod(cm);
            $e383a1a86a5ebbd4$var$processCalcMethodMarquardt(divCmDetails, cm);
        } else if (value == (0, $085f2478c495b249$export$fe9781900d201bdf).xsi_type || value == (0, $085f2478c495b249$export$fe9781900d201bdf).xsi_type2) {
            // "me:analyticalRepresentation", "analyticalRepresentation".
            let cm = new (0, $085f2478c495b249$export$fe9781900d201bdf)(attributes);
            control.setCalcMethod(cm);
            $e383a1a86a5ebbd4$var$processCalcMethodAnalyticalRepresentation(divCmDetails, cm);
        } else if (value == (0, $085f2478c495b249$export$16ef3f79998b60b4).xsi_type || value == (0, $085f2478c495b249$export$16ef3f79998b60b4).xsi_type2) {
            // "me:ThermodynamicTable", "ThermodynamicTable".
            let cm = new (0, $085f2478c495b249$export$16ef3f79998b60b4)(attributes);
            control.setCalcMethod(cm);
            $e383a1a86a5ebbd4$var$processCalcMethodThermodynamicTable(divCmDetails, cm);
        } else if (value == (0, $085f2478c495b249$export$a532500cc43efbef).xsi_type || value == (0, $085f2478c495b249$export$a532500cc43efbef).xsi_type2) {
            // "me:sensitivityAnalysis", "sensitivityAnalysis".
            let cm = new (0, $085f2478c495b249$export$a532500cc43efbef)(new Map());
            control.setCalcMethod(cm);
            $e383a1a86a5ebbd4$var$processCalcMethodSensitivityAnalysis(divCmDetails, cm);
        } else throw new Error("Unknown CalcMethod type.");
        (0, $341c675b659c6d43$export$fdd146df37959fe8)(target);
    });
    return select;
}



/**
 * Draw a horizontal line and add labels.
 * @param ctx The context to use.
 * @param strokeStyle The name of a style to use for the line.
 * @param strokewidth The width of the line.
 * @param x0 The start x-coordinate of the line.
 * @param y0 The start y-coordinate of the line. Also used for an energy label.
 * @param x1 The end x-coordinate of the line.
 * @param y1 The end y-coordinate of the line.
 * @param font The font to use.
 * @param th The height of the text in pixels.
 * @param label The label.
 * @param energyString The energy.
 */ function $b7f59824b753c7b9$export$479ac392a7fb4419(ctx, strokeStyle, strokewidth, x0, y0, x1, y1, font, th, label, energyString) {
    let x_centre = x0 + (x1 - x0) / 2;
    $b7f59824b753c7b9$export$bec150f75a9b8f11(ctx, energyString, font, strokeStyle, $b7f59824b753c7b9$var$getTextStartX(ctx, energyString, font, x_centre), y1 + th);
    $b7f59824b753c7b9$export$bec150f75a9b8f11(ctx, label, font, strokeStyle, $b7f59824b753c7b9$var$getTextStartX(ctx, label, font, x_centre), y1 + 3 * th);
    $b7f59824b753c7b9$export$819db45aec5fcbe5(ctx, strokeStyle, strokewidth, x0, y0, x1, y1);
}
/**
 * @param ctx The context to use.
 * @param text The text to get the start x-coordinate of.
 * @paramfont The font to use.  
 * @param x_centre The x-coordinate of the centre of the text.
 * @returns The x-coordinate of the start of the text.
 */ function $b7f59824b753c7b9$var$getTextStartX(ctx, text, font, x_centre) {
    let tw = $b7f59824b753c7b9$export$37827d046293d309(ctx, text, font);
    return x_centre - tw / 2;
}
function $b7f59824b753c7b9$export$819db45aec5fcbe5(ctx, strokeStyle, strokewidth, x1, y1, x2, y2) {
    ctx.beginPath();
    ctx.strokeStyle = strokeStyle;
    ctx.lineWidth = strokewidth;
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.stroke();
}
function $b7f59824b753c7b9$export$bec150f75a9b8f11(ctx, text, font, colour, x, y) {
    // Save the context (to restore after).
    ctx.save();
    // Translate to the point where text is to be added.
    ctx.translate(x, y);
    // Invert Y-axis.
    ctx.scale(1, -1);
    // Set the text font.
    ctx.font = font;
    // Set the text colour.
    ctx.fillStyle = colour;
    // Write the text.
    ctx.fillText(text, 0, 0);
    // Restore the context.
    ctx.restore();
}
function $b7f59824b753c7b9$export$c398604a09be5382(ctx, text, font) {
    ctx.font = font;
    var fontMetric = ctx.measureText(text);
    return fontMetric.actualBoundingBoxAscent + fontMetric.actualBoundingBoxDescent;
}
function $b7f59824b753c7b9$export$37827d046293d309(ctx, text, font) {
    ctx.font = font;
    return ctx.measureText(text).width;
}




function $8fba87eb7959a54b$export$f1b90a337037b551(rdcID, rdcHeight, dark, rd_font, rd_lw, rd_lwc, rdWindow, molecules, reactions, draw) {
    // Destroy any existing rdWindow.
    if (rdWindow != null) {
        rdWindow.close();
        rdWindow = null;
    }
    let rddDiv = document.getElementById((0, $dc4240e6100248ae$export$d475b637ed2435f7));
    let rdDivID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)((0, $dc4240e6100248ae$export$196db41cc586e1c));
    // If rdDiv already exists, remove it.
    (0, $dc4240e6100248ae$export$cd7f480d6b8286c3)(rdDivID);
    // Create collapsible content.
    let rdDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(rdDivID, (0, $dc4240e6100248ae$export$39c84188a71202f7));
    rddDiv.appendChild(rdDiv);
    // Create collapsible content.
    let rdcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(rdDivID, rddDiv, null, rdDiv, (0, $dc4240e6100248ae$export$196db41cc586e1c), (0, $dc4240e6100248ae$export$d6befed1f1d5e56b), (0, $dc4240e6100248ae$export$b1ddbf2a116c10ee));
    // Create a pop diagram button in its own div.
    let bDivId = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(rdDiv.id, (0, $341c675b659c6d43$export$25280bc3a7ce098e) + 's');
    let bDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(bDivId);
    rdDiv.appendChild(bDiv);
    let pbID = (0, $dc4240e6100248ae$export$bea69a603fae01a6)(bDivId, (0, $341c675b659c6d43$export$25280bc3a7ce098e));
    let popOutText = "Pop into a new Window";
    let pb = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(popOutText, pbID);
    bDiv.appendChild(pb);
    let rdCanvas = document.createElement('canvas');
    rdCanvas.id = rdcID;
    rdDiv.appendChild(rdCanvas);
    //rd_canvas.width = rd_canvas_width;
    rdCanvas.height = rdcHeight;
    rdCanvas.style.border = "1px solid black";
    //rdCanvas.style.margin = "1px";
    if (draw) $8fba87eb7959a54b$export$9a6a0a663dda2923(rdCanvas, rdcHeight, dark, rd_font, rd_lw, rd_lwc, molecules, reactions);
    // Add action listener to the pop diagram button.
    pb.addEventListener('click', ()=>{
        //if (rdWindow == null || rdWindow.closed) {
        if (rdWindow == null) {
            let popWindowRDCanvas = document.createElement('canvas');
            popWindowRDCanvas.id = rdcID;
            rdWindow = window.open("", (0, $dc4240e6100248ae$export$196db41cc586e1c), "width=" + rdCanvas.width + ", height=" + rdCanvas.height);
            rdWindow.document.body.appendChild(popWindowRDCanvas);
            if (draw) $8fba87eb7959a54b$export$9a6a0a663dda2923(popWindowRDCanvas, rdcHeight, dark, rd_font, rd_lw, rd_lwc, molecules, reactions);
            (0, $dc4240e6100248ae$export$cd7f480d6b8286c3)(rdcID);
            pb.textContent = "Pop into this Window";
        } else {
            rdCanvas = document.createElement('canvas');
            rdCanvas.id = rdcID;
            rdDiv.appendChild(rdCanvas);
            rdCanvas.height = rdcHeight;
            rdCanvas.style.border = "1px solid black";
            if (draw) $8fba87eb7959a54b$export$9a6a0a663dda2923(rdCanvas, rdcHeight, dark, rd_font, rd_lw, rd_lwc, molecules, reactions);
            rdWindow.close();
            rdWindow = null;
            pb.textContent = popOutText;
        }
    });
    (0, $dc4240e6100248ae$export$f0119d1c38383eb8)(rdCanvas, bDiv, null, (0, $dc4240e6100248ae$export$196db41cc586e1c));
}
function $8fba87eb7959a54b$export$9a6a0a663dda2923(canvas, rdcHeight, dark, font, lw, lwc, molecules, reactions) {
    console.log("drawReactionDiagram");
    let units = "kJ/mol"; // Default units for energy. To be replaced with a true value.
    if (canvas != null && reactions.size > 0) {
        // Set foreground and background colors.
        let foreground;
        let background;
        let blue;
        let orange;
        if (dark) {
            foreground = "lightgrey";
            background = "darkgrey";
            blue = "lightblue";
            orange = "orange";
        } else {
            foreground = "darkgrey";
            background = "lightgrey";
            blue = "blue";
            orange = "darkorange";
        }
        let green = "green";
        let red = "red";
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas.
        //ctx.fillStyle = background;
        // Make font bold.
        ctx.font = "bold " + font;
        // Get text height for font size.
        let th = (0, $b7f59824b753c7b9$export$c398604a09be5382)(ctx, "Aj", ctx.font);
        //console.log("th=" + th);
        // Go through reactions:
        // 1. Create sets of reactants, end products, intermediate products and transition states.
        // 2. Create maps of orders and energies.
        // 3. Calculate maximum energy.
        let reactants = [];
        let products = new Set();
        let intProducts = new Set();
        let tss = new Set();
        let orders = new Map();
        let energies = new Map();
        let i = 0;
        let energyMin;
        let energyMax;
        reactions.forEach(function(reaction, id) {
            // Get TransitionStates.
            //let reactionTransitionStates: TransitionState[] = reaction.getTransitionStates();
            let rtss = reaction.getTransitionStates();
            //console.log("reactant=" + reactant);
            let reactantsLabel = reaction.getReactantsLabel();
            if (reactantsLabel != undefined) {
                reactants.push(reactantsLabel);
                if (products.has(reactantsLabel)) intProducts.add(reactantsLabel);
                let energy = reaction.getReactantsEnergy((0, $dc4240e6100248ae$export$7577c09cb43cc206), molecules);
                console.log("energy=" + energy.toString());
                units = reaction.getEnergyUnits((0, $dc4240e6100248ae$export$7577c09cb43cc206), molecules, reaction.getReactants());
                console.log("units=" + units);
                energyMin = (0, $93b71ab6968650c1$export$96ec731ed4dcb222)(energyMin, energy);
                energyMax = (0, $93b71ab6968650c1$export$8960430cfd85939f)(energyMax, energy);
                energies.set(reactantsLabel, energy);
                if (!orders.has(reactantsLabel)) {
                    orders.set(reactantsLabel, i);
                    i++;
                }
            }
            let productsLabel = reaction.getProductsLabel();
            if (productsLabel != undefined) {
                products.add(productsLabel);
                let energy = reaction.getProductsEnergy((0, $dc4240e6100248ae$export$7577c09cb43cc206), molecules);
                console.log("energy=" + energy.toString());
                units = reaction.getEnergyUnits((0, $dc4240e6100248ae$export$7577c09cb43cc206), molecules, reaction.getProducts());
                console.log("units=" + units);
                energyMin = (0, $93b71ab6968650c1$export$96ec731ed4dcb222)(energyMin, energy);
                energyMax = (0, $93b71ab6968650c1$export$8960430cfd85939f)(energyMax, energy);
                energies.set(productsLabel, energy);
                if (orders.has(productsLabel)) {
                    i--;
                    let j = (0, $93b71ab6968650c1$export$3988ae62b71be9a3)(orders, productsLabel);
                    // Move product to end and shift everything back.
                    orders.forEach(function(value, key) {
                        if (value > j) orders.set(key, value - 1);
                    });
                    // Insert transition states.
                    if (rtss != undefined) {
                        rtss.forEach(function(ts, ref) {
                            let moleculeRef = ts.getMolecule().getRef();
                            tss.add(moleculeRef);
                            orders.set(moleculeRef, i);
                            energy = (0, $dc4240e6100248ae$export$7577c09cb43cc206)(moleculeRef, molecules).getEnergy() ?? (0, $dc4240e6100248ae$export$a94c859b6fc3ec52);
                            console.log("energy=" + energy.toString());
                            units = reaction.getEnergyUnits((0, $dc4240e6100248ae$export$7577c09cb43cc206), molecules, reaction.getTransitionStates());
                            console.log("units=" + units);
                            energyMin = (0, $93b71ab6968650c1$export$96ec731ed4dcb222)(energyMin, energy);
                            energyMax = (0, $93b71ab6968650c1$export$8960430cfd85939f)(energyMax, energy);
                            energies.set(moleculeRef, energy);
                            i++;
                        });
                        orders.set(productsLabel, i);
                        i++;
                    }
                } else {
                    if (rtss != undefined) rtss.forEach(function(ts, ref) {
                        let moleculeRef = ts.getMolecule().getRef();
                        tss.add(moleculeRef);
                        orders.set(moleculeRef, i);
                        energy = (0, $dc4240e6100248ae$export$7577c09cb43cc206)(moleculeRef, molecules).getEnergy() ?? (0, $dc4240e6100248ae$export$a94c859b6fc3ec52);
                        console.log("energy=" + energy.toString());
                        energyMin = (0, $93b71ab6968650c1$export$96ec731ed4dcb222)(energyMin, energy);
                        energyMax = (0, $93b71ab6968650c1$export$8960430cfd85939f)(energyMax, energy);
                        energies.set(moleculeRef, energy);
                        i++;
                    });
                    orders.set(productsLabel, i);
                    i++;
                }
            }
        });
        //console.log("orders=" + mapToString(orders));
        //console.log("energies=" + mapToString(energies));
        //console.log("energyMax=" + energyMax);
        //console.log("energyMin=" + energyMin);
        let energyRange = energyMax.minus(energyMin).toNumber();
        //console.log("energyRange=" + energyRange);
        //console.log("reactants=" + reactants);
        //console.log("products=" + products);
        //console.log("transitionStates=" + transitionStates);
        // Create a lookup from order to label.
        let reorders = [];
        orders.forEach(function(value, key) {
            reorders[value] = key;
        });
        //console.log("reorders=" + arrayToString(reorders));
        // Iterate through the reorders:
        // 1. Capture coordinates for connecting lines.
        // 2. Store maximum x.
        let x0 = 0;
        let y0;
        let x1;
        let y1;
        let xmax = 0;
        let tw;
        let textSpacing = 5; // Spacing between end of line and start of text.
        let stepSpacing = 10; // Spacing between steps.
        let reactantsInXY = new Map();
        let reactantsOutXY = new Map();
        let productsInXY = new Map();
        let productsOutXY = new Map();
        let tssInXY = new Map();
        let tssOutXY = new Map();
        reorders.forEach(function(value) {
            //console.log("value=" + value + ".");
            //console.log("energies=" + mapToString(energies));
            let energy = (0, $93b71ab6968650c1$export$3988ae62b71be9a3)(energies, value);
            console.log("energy=" + energy.toString());
            let energyRescaled = (0, $93b71ab6968650c1$export$bd2782c820638828)(energyMin.toNumber(), energyRange, 0, rdcHeight, energy);
            // Get text width.
            tw = Math.max((0, $b7f59824b753c7b9$export$37827d046293d309)(ctx, energy.toString(), font), (0, $b7f59824b753c7b9$export$37827d046293d309)(ctx, value, font));
            x1 = x0 + tw + textSpacing;
            y0 = energyRescaled + lw;
            y1 = y0;
            // Draw horizontal line and add label.
            // (The drawing is now not done here but done later so labels are on top of lines, but
            // the code is left here commented out for code comprehension.)
            //drawLevel(ctx, green, 4, x0, y0, x1, y1, th, value);
            reactantsInXY.set(value, [
                x0,
                y0
            ]);
            reactantsOutXY.set(value, [
                x1,
                y1
            ]);
            if (products.has(value)) {
                productsInXY.set(value, [
                    x0,
                    y0
                ]);
                productsOutXY.set(value, [
                    x1,
                    y1
                ]);
            }
            if (tss.has(value)) {
                tssInXY.set(value, [
                    x0,
                    y0
                ]);
                tssOutXY.set(value, [
                    x1,
                    y1
                ]);
            }
            x0 = x1 + stepSpacing;
            xmax = x1;
        });
        // Set canvas width to maximum x.
        canvas.width = xmax;
        //console.log("canvas.width=" + canvas.width);
        // Set canvas height to maximum energy plus the label.
        let canvasHeightWithBorder = rdcHeight + 4 * th + 2 * lw;
        //console.log("canvasHeightWithBorder=" + canvasHeightWithBorder);
        let originalCanvasHeight = rdcHeight;
        // Update the canvas height.
        canvas.height = canvasHeightWithBorder;
        // Set the transformation matrix.
        //ctx.transform(1, 0, 0, 1, 0, canvasHeightWithBorder);
        ctx.transform(1, 0, 0, -1, 0, canvasHeightWithBorder);
        // Go through reactions and draw connecting lines.
        reactions.forEach(function(reaction, id) {
            //console.log("id=" + id);
            //console.log("reaction=" + reaction);
            // Get TransitionState if there is one.
            //let tss: TransitionState[] = reaction.getTransitionStates();
            let rtss = reaction.getTransitionStates();
            //console.log("reactant=" + reactant);
            let reactantsLabel = reaction.getReactantsLabel();
            let productsLabel = reaction.getProductsLabel();
            let reactantOutXY = (0, $93b71ab6968650c1$export$3988ae62b71be9a3)(reactantsOutXY, reactantsLabel);
            let productInXY = (0, $93b71ab6968650c1$export$3988ae62b71be9a3)(productsInXY, productsLabel);
            if (rtss.size > 0) //tss.forEach(function (ts, ref) {
            rtss.forEach(function(ts, ref) {
                let tsInXY = (0, $93b71ab6968650c1$export$3988ae62b71be9a3)(tssInXY, ref);
                (0, $b7f59824b753c7b9$export$819db45aec5fcbe5)(ctx, foreground, lwc, reactantOutXY[0], reactantOutXY[1], tsInXY[0], tsInXY[1]);
                let tsOutXY = (0, $93b71ab6968650c1$export$3988ae62b71be9a3)(tssOutXY, ref);
                (0, $b7f59824b753c7b9$export$819db45aec5fcbe5)(ctx, foreground, lwc, tsOutXY[0], tsOutXY[1], productInXY[0], productInXY[1]);
            });
            else (0, $b7f59824b753c7b9$export$819db45aec5fcbe5)(ctx, foreground, lwc, reactantOutXY[0], reactantOutXY[1], productInXY[0], productInXY[1]);
        });
        // Plot units on the Y-axis.
        ctx.save();
        ctx.translate(20, originalCanvasHeight / 2); // Move to the center of the Y-axis
        ctx.rotate(-Math.PI / 2); // Rotate the context by -90 degrees
        //ctx.scale(1, -1); // Flip the context vertically
        ctx.scale(-1, 1); // Flip the context vertically
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.font = "16px Arial"; // Set the font size and family
        ctx.fillText("Energy " + units, 0, 0); // Draw the label
        ctx.restore(); // Restore the context to its original state
        // Draw horizontal lines and labels.
        // (This is done last so that the labels are on top of the vertical lines.)
        reactants.forEach(function(value) {
            let energy = (0, $93b71ab6968650c1$export$3988ae62b71be9a3)(energies, value);
            console.log("energy=" + energy.toString());
            let energyRescaled = (0, $93b71ab6968650c1$export$bd2782c820638828)(energyMin.toNumber(), energyRange, 0, originalCanvasHeight, energy);
            console.log("energyRescaled=" + energyRescaled.toString());
            let x0 = (0, $93b71ab6968650c1$export$3988ae62b71be9a3)(reactantsInXY, value)[0];
            let y = energyRescaled + lw;
            let x1 = (0, $93b71ab6968650c1$export$3988ae62b71be9a3)(reactantsOutXY, value)[0];
            let energyString = energy.toString();
            (0, $b7f59824b753c7b9$export$479ac392a7fb4419)(ctx, blue, lw, x0, y, x1, y, font, th, value, energyString);
        });
        products.forEach(function(value) {
            let energy = (0, $93b71ab6968650c1$export$3988ae62b71be9a3)(energies, value);
            console.log("energy=" + energy.toString());
            let energyRescaled = (0, $93b71ab6968650c1$export$bd2782c820638828)(energyMin.toNumber(), energyRange, 0, originalCanvasHeight, energy);
            console.log("energyRescaled=" + energyRescaled.toString());
            let x0 = (0, $93b71ab6968650c1$export$3988ae62b71be9a3)(productsInXY, value)[0];
            let y = energyRescaled + lw;
            let x1 = (0, $93b71ab6968650c1$export$3988ae62b71be9a3)(productsOutXY, value)[0];
            let energyString = energy.toString();
            if (intProducts.has(value)) (0, $b7f59824b753c7b9$export$479ac392a7fb4419)(ctx, orange, lw, x0, y, x1, y, font, th, value, energyString);
            else (0, $b7f59824b753c7b9$export$479ac392a7fb4419)(ctx, green, lw, x0, y, x1, y, font, th, value, energyString);
        });
        tss.forEach(function(value) {
            let energy = (0, $93b71ab6968650c1$export$3988ae62b71be9a3)(energies, value);
            console.log("energy=" + energy.toString());
            let energyRescaled = (0, $93b71ab6968650c1$export$bd2782c820638828)(energyMin.toNumber(), energyRange, 0, originalCanvasHeight, energy);
            console.log("energyRescaled=" + energyRescaled.toString());
            let x0 = (0, $93b71ab6968650c1$export$3988ae62b71be9a3)(tssInXY, value)[0];
            let y = energyRescaled + lw;
            let x1 = (0, $93b71ab6968650c1$export$3988ae62b71be9a3)(tssOutXY, value)[0];
            let energyString = energy.toString();
            (0, $b7f59824b753c7b9$export$479ac392a7fb4419)(ctx, red, lw, x0, y, x1, y, font, th, value, energyString);
        });
    }
}



//import * as $3Dmol from '$3Dmol';
/**
 * Big.js.
 */ // Set the number toString() format for Big.js. The default is Big.PE = 21, so this change means that Big numbers
// with an order of magnitude of greater than 6 (e.g. 1000000) are presented as 1.0e+7.
(0, $ad9e9f310a798519$exports.Big).PE = 7;
/**
 * The filename of the MESMER XML file.
 */ let $dc4240e6100248ae$var$filename;
/**
 * fontSize is set to a relative measure so that component text is resizeable.
 */ let $dc4240e6100248ae$var$fontSize = "1.0em";
/**
 * Margins for spacing GUI components.
 */ let $dc4240e6100248ae$var$s_0px = "0px";
let $dc4240e6100248ae$var$s_1px = "1px";
let $dc4240e6100248ae$var$s_25px = "25px";
let $dc4240e6100248ae$export$b1ddbf2a116c10ee = {
    marginLeft: $dc4240e6100248ae$var$s_0px,
    marginTop: $dc4240e6100248ae$var$s_1px,
    marginBottom: $dc4240e6100248ae$var$s_1px,
    marginRight: $dc4240e6100248ae$var$s_0px
};
let $dc4240e6100248ae$export$39c84188a71202f7 = {
    marginLeft: $dc4240e6100248ae$var$s_25px,
    marginTop: $dc4240e6100248ae$var$s_1px,
    marginBottom: $dc4240e6100248ae$var$s_1px,
    marginRight: $dc4240e6100248ae$var$s_0px
};
let $dc4240e6100248ae$export$d6befed1f1d5e56b = {
    marginLeft: $dc4240e6100248ae$var$s_1px,
    marginTop: $dc4240e6100248ae$var$s_1px,
    marginBottom: $dc4240e6100248ae$var$s_1px,
    marginRight: $dc4240e6100248ae$var$s_1px
};
const $dc4240e6100248ae$export$9932f6cd2d05a4cf = "\uFF0B"; // ＋
const $dc4240e6100248ae$export$96d8a15ea1620cf4 = "\u270E"; // ✎
const $dc4240e6100248ae$export$b758aa9bd161846e = " \u2717"; // ✗
//const sy_refresh: string = "\u27F3"; // ⟳
const $dc4240e6100248ae$var$sy_remove = "\u2715"; // ✕
const $dc4240e6100248ae$export$f0fb6e9d3fd6cf72 = " \u2713"; // ✓
const $dc4240e6100248ae$export$1bb8965d05fbf467 = "Add " + $dc4240e6100248ae$export$9932f6cd2d05a4cf;
const $dc4240e6100248ae$export$b071b08ccb05fd2 = "Add from library " + $dc4240e6100248ae$export$9932f6cd2d05a4cf;
const $dc4240e6100248ae$export$3e0cc820631ca658 = "Add from spreadsheet " + $dc4240e6100248ae$export$9932f6cd2d05a4cf;
const $dc4240e6100248ae$var$s_analysis = "analysis";
const $dc4240e6100248ae$var$s_conditions = "conditions";
const $dc4240e6100248ae$export$7295f538b9762c5 = "container";
const $dc4240e6100248ae$var$s_control = "control";
const $dc4240e6100248ae$export$666359451816b0e7 = "description";
const $dc4240e6100248ae$export$58785e0018b77d4a = "input";
const $dc4240e6100248ae$var$s_menu = "menu";
const $dc4240e6100248ae$var$s_metadata = "metadata";
const $dc4240e6100248ae$var$s_modelParameters = "modelParameters";
const $dc4240e6100248ae$export$d4bce1ca150a4b6a = "molecules";
const $dc4240e6100248ae$export$50cc31b59b02e033 = 'optionOn';
const $dc4240e6100248ae$export$d52efe23389358db = 'optionOff';
const $dc4240e6100248ae$export$2a0edc6caa2454db = "Products";
const $dc4240e6100248ae$export$ae4e72e6b8ac1d64 = "Reactants";
const $dc4240e6100248ae$export$ce30911bcd78542 = "reactions";
const $dc4240e6100248ae$var$s_reactionsDiagram = "reactionsDiagram";
const $dc4240e6100248ae$export$bb916e6caf34db48 = "Remove " + $dc4240e6100248ae$var$sy_remove;
const $dc4240e6100248ae$export$c1dfed4ad865f0b6 = "save";
const $dc4240e6100248ae$export$d8b8827abc8ab7e7 = "Select an option (press a letter key to cycle through options for it)...";
const $dc4240e6100248ae$export$7a850709da5c4f5b = "table";
const $dc4240e6100248ae$var$s_title = "title";
const $dc4240e6100248ae$export$f6270d42dca30dc6 = "Transition States";
const $dc4240e6100248ae$export$de72b11c4a138de9 = "textarea";
const $dc4240e6100248ae$export$4402a75a856d5151 = "Tunneling";
const $dc4240e6100248ae$export$2f2abd8810196a7 = "undefined";
const $dc4240e6100248ae$export$5a13f59b7b9618a3 = "units";
const $dc4240e6100248ae$var$s_xml = "xml";
const $dc4240e6100248ae$export$a59b122474df8e10 = "viewer";
const $dc4240e6100248ae$var$s_welcome = "welcome";
/**
 * allIDs is a set of all IDs used in the GUI.
 * This is used to ensure that all IDs are unique.
 * If an ID is not unique, an error is thrown.
 */ let $dc4240e6100248ae$var$allIDs = new Set();
/**
 * A set of all IDs to be removed when loading a MESMER file.
 */ let $dc4240e6100248ae$var$rIDs = new Set();
function $dc4240e6100248ae$export$39722580448f5a99(...parts) {
    let validID = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(...parts);
    if ($dc4240e6100248ae$var$allIDs.has(validID)) throw new Error(validID + " already exists!");
    $dc4240e6100248ae$var$allIDs.add(validID);
    //console.log("addID: \"" + validID + "\"");
    return validID;
}
function $dc4240e6100248ae$export$bea69a603fae01a6(...parts) {
    let validID = $dc4240e6100248ae$export$39722580448f5a99(...parts);
    $dc4240e6100248ae$var$rIDs.add(validID);
    return validID;
}
function $dc4240e6100248ae$export$cd7f480d6b8286c3(id) {
    let e = document.getElementById(id);
    if (e != null) e.remove();
    $dc4240e6100248ae$var$rIDs.delete(id);
    $dc4240e6100248ae$var$allIDs.delete(id);
}
const $dc4240e6100248ae$export$32f4a893b4a151db = $dc4240e6100248ae$export$39722580448f5a99($dc4240e6100248ae$var$s_menu);
const $dc4240e6100248ae$var$titleDivID = $dc4240e6100248ae$export$39722580448f5a99($dc4240e6100248ae$var$s_title);
const $dc4240e6100248ae$var$moleculesDivID = $dc4240e6100248ae$export$39722580448f5a99($dc4240e6100248ae$export$d4bce1ca150a4b6a);
const $dc4240e6100248ae$var$reactionsDivID = $dc4240e6100248ae$export$39722580448f5a99($dc4240e6100248ae$export$ce30911bcd78542);
const $dc4240e6100248ae$export$d475b637ed2435f7 = $dc4240e6100248ae$export$39722580448f5a99($dc4240e6100248ae$var$s_reactionsDiagram);
const $dc4240e6100248ae$var$conditionsDivID = $dc4240e6100248ae$export$39722580448f5a99($dc4240e6100248ae$var$s_conditions);
const $dc4240e6100248ae$var$modelParametersDivID = $dc4240e6100248ae$export$39722580448f5a99($dc4240e6100248ae$var$s_modelParameters);
const $dc4240e6100248ae$var$controlDivID = $dc4240e6100248ae$export$39722580448f5a99($dc4240e6100248ae$var$s_control);
const $dc4240e6100248ae$var$metadataListDivID = $dc4240e6100248ae$export$39722580448f5a99($dc4240e6100248ae$var$s_metadata);
const $dc4240e6100248ae$var$analysisDivID = $dc4240e6100248ae$export$39722580448f5a99($dc4240e6100248ae$var$s_analysis);
const $dc4240e6100248ae$var$xmlDivID = $dc4240e6100248ae$export$39722580448f5a99($dc4240e6100248ae$var$s_xml);
//const welcomeDivID: string = addID(s_welcome);
// For dark/light mode.
let $dc4240e6100248ae$var$dark = false;
const $dc4240e6100248ae$export$a94c859b6fc3ec52 = new (0, $ad9e9f310a798519$exports.Big)(0);
class $dc4240e6100248ae$export$e0d5b774927d0e2a {
    /**
     * Adds an ID to the map.
     * @param iD The key ID.
     * @param parts The parts of the ID to be created.
     * @returns The ID created.
     */ addID(iD, ...parts) {
        let id = $dc4240e6100248ae$export$bea69a603fae01a6(iD, ...parts);
        if (!this.ids.has(iD)) this.ids.set(iD, new Set());
        this.ids.get(iD)?.add(id);
        return id;
    }
    /**
     * Remove the IDs to the map.
     * @param iD The key ID.
     * @param parts The parts of the ID to be created.
     * @returns The ID created.
     */ removeID(iD) {
        $dc4240e6100248ae$var$rIDs.delete(iD);
        $dc4240e6100248ae$var$allIDs.delete(iD);
    }
    /**
     * Removes the IDs.
     * @param iD The ID key for the IDs to remove.
     */ removeIDs(iD) {
        if (!this.ids.has(iD)) return;
        this.ids.get(iD).forEach((id)=>{
            console.log("remove id " + id);
            this.removeID(id);
        });
        this.ids.delete(iD);
    }
    /**
     * Remove all IDs.
     */ removeAllIDs() {
        this.ids.forEach((value, key)=>{
            this.removeIDs(key);
        });
    }
    constructor(){
        /**
     * A map of IDs with the key ID as the key and a set of IDs as the value.
     */ this.ids = new Map();
    }
}
/**
 * For moleculeList Div ID management.
 */ let $dc4240e6100248ae$var$mIDM;
/**
 * For reactionList Div ID management.
 */ let $dc4240e6100248ae$var$rIDM;
/**
 * For conditionsList Div ID management.
 */ let $dc4240e6100248ae$var$conditionsIDM;
/**
 * For ModelParametersList Div ID management.
 */ let $dc4240e6100248ae$var$mpIDM;
/**
 * For ControlList Div ID management.
 */ let $dc4240e6100248ae$var$controlIDM;
let $dc4240e6100248ae$export$3bb92be1f57fd129;
let $dc4240e6100248ae$export$ebe90cb607ad99e;
let $dc4240e6100248ae$export$7c97c73a2c729cf9;
function $dc4240e6100248ae$export$4802e08cda112391(m) {
    $dc4240e6100248ae$export$7c97c73a2c729cf9 = m;
}
function $dc4240e6100248ae$export$ac55d333e780178c(ask, m, ms) {
    let mid;
    while(true){
        mid = (0, $9eedba3564ea6a49$export$194bfe7da61d65)(ask, m.getID(), m, ms);
        if (mid != undefined) break;
    }
    ms.set(mid, m);
}
/**
 * A map of molecules with id as key and Molecule as value.
 * The key is a composite of the molecule ID and the index.
 */ let $dc4240e6100248ae$var$molecules;
function $dc4240e6100248ae$export$5ac38056c0103baa(molecules) {
    let keys = new Set();
    molecules.forEach((v, k)=>{
        let id = v.getID();
        if (keys.has(id)) keys.add(id + "-" + k.toString());
        else keys.add(id);
    });
    return keys;
}
function $dc4240e6100248ae$export$7577c09cb43cc206(id, ms) {
    for (let [key, value] of ms){
        //if (value.label == label) {
        if (value.id == id) return value;
    }
    return null;
}
/**
 * A map of reactions with Reaction.id as keys and Reactions as values.
 */ let $dc4240e6100248ae$var$reactions;
/**
 * For storing any scatter plots.
 */ let $dc4240e6100248ae$var$scatterPlots;
const $dc4240e6100248ae$export$196db41cc586e1c = "Reactions Diagram";
const $dc4240e6100248ae$var$rddDivID = $dc4240e6100248ae$export$bea69a603fae01a6($dc4240e6100248ae$export$196db41cc586e1c);
const $dc4240e6100248ae$var$rddcID = $dc4240e6100248ae$export$bea69a603fae01a6($dc4240e6100248ae$var$rddDivID, "Canvas");
//let rd_canvas_width: number = 800;
let $dc4240e6100248ae$var$rdcHeight = 400;
let $dc4240e6100248ae$var$rd_lw = 4; // Line width of reactants, transition states and products.
let $dc4240e6100248ae$var$rd_lwc = 2; // Line width of connectors.
let $dc4240e6100248ae$var$rd_font = "1em SensSerif";
let $dc4240e6100248ae$var$rdWindow = null;
// Scatterplot font.
let $dc4240e6100248ae$var$sp_font = "2em SensSerif";
/**
 * Once the DOM is loaded, add the menu and collapsed buttons for content
 */ document.addEventListener('DOMContentLoaded', ()=>{
    // Update the page styles based on the user's preference.
    document.body.className = $dc4240e6100248ae$var$dark ? 'dark-mode' : 'light-mode';
    /* It is not allowed to use localStorage with a Service Worker!
    let darkModePreference = localStorage.getItem('darkMode');
    dark = (darkModePreference === 'true');
    console.log("dark=" + dark);
    */ // Initialise mesmer.
    let mesmerAttributes = new Map();
    mesmerAttributes.set("xmlns", "http://www.xml-cml.org/schema");
    mesmerAttributes.set("xmlns:me", "http://www.chem.leeds.ac.uk/mesmer");
    mesmerAttributes.set("xmlns:xsi", "http://www.w3.org/2001/XMLSchema-instance");
    $dc4240e6100248ae$export$3bb92be1f57fd129 = new (0, $ccef02370f58a770$export$692079bb871c6039)(mesmerAttributes);
    // Create the menu.
    (0, $5a83eb614eac3a1c$export$c9a19c59161f09a0)();
    // StartAfresh
    $dc4240e6100248ae$export$2f77af1e417942e1();
});
/**
 * (Re)Initialise the main GUI and IDManagers.
 */ function $dc4240e6100248ae$var$initialise() {
    // Clear content.
    $dc4240e6100248ae$var$rIDs.forEach((id)=>{
        $dc4240e6100248ae$export$cd7f480d6b8286c3(id);
    });
    // Initialise
    $dc4240e6100248ae$var$rIDs = new Set();
    $dc4240e6100248ae$var$mIDM = new $dc4240e6100248ae$export$e0d5b774927d0e2a();
    $dc4240e6100248ae$var$rIDM = new $dc4240e6100248ae$export$e0d5b774927d0e2a();
    $dc4240e6100248ae$var$conditionsIDM = new $dc4240e6100248ae$export$e0d5b774927d0e2a();
    $dc4240e6100248ae$var$mpIDM = new $dc4240e6100248ae$export$e0d5b774927d0e2a();
    $dc4240e6100248ae$var$controlIDM = new $dc4240e6100248ae$export$e0d5b774927d0e2a();
    // libmols is not reinitialised on purpose. To completely start again, reload the app.
    //libmols = new Map();
    $dc4240e6100248ae$export$ebe90cb607ad99e = new (0, $5d3e67bd01cf7225$export$79d0bd4671c1fc67)();
    $dc4240e6100248ae$var$molecules = new Map();
    $dc4240e6100248ae$var$reactions = new Map();
    $dc4240e6100248ae$var$scatterPlots = [];
}
function $dc4240e6100248ae$export$2f77af1e417942e1() {
    $dc4240e6100248ae$var$initialise();
    // Title.
    let title = "Example_title";
    let attributes = new Map();
    $dc4240e6100248ae$var$createTitle(title, attributes);
    // Molecules.
    let moleculesDiv = document.getElementById($dc4240e6100248ae$var$moleculesDivID);
    let mlDivID = $dc4240e6100248ae$export$bea69a603fae01a6((0, $ccef02370f58a770$export$19d70f3647dee606).tagName);
    let mlDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(mlDivID);
    moleculesDiv.appendChild(mlDiv);
    // Create collapsible content.
    let mlcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(mlDivID, moleculesDiv, null, mlDiv, (0, $ccef02370f58a770$export$19d70f3647dee606).tagName, $dc4240e6100248ae$export$d6befed1f1d5e56b, $dc4240e6100248ae$export$b1ddbf2a116c10ee);
    // Add add molecule button.
    let mb = (0, $9eedba3564ea6a49$export$12aafb9570dfb660)(mlDiv, $dc4240e6100248ae$var$mIDM, $dc4240e6100248ae$var$molecules);
    // Add add from library button.
    let lb = (0, $9eedba3564ea6a49$export$1f1b9bc888fe9f4c)(mlDiv, mb, $dc4240e6100248ae$var$mIDM, $dc4240e6100248ae$var$molecules);
    // Reaction List.
    let rlDivID = $dc4240e6100248ae$export$bea69a603fae01a6((0, $ccef02370f58a770$export$44466a39ca846289).tagName);
    // Remove any existing rlDivID HTMLDivElement.
    $dc4240e6100248ae$export$cd7f480d6b8286c3(rlDivID);
    $dc4240e6100248ae$var$createReactionList((0, $341c675b659c6d43$export$331ff980f0d45cff)(rlDivID));
    // Reactions Diagram.
    (0, $8fba87eb7959a54b$export$f1b90a337037b551)($dc4240e6100248ae$var$rddcID, $dc4240e6100248ae$var$rdcHeight, $dc4240e6100248ae$var$dark, $dc4240e6100248ae$var$rd_font, $dc4240e6100248ae$var$rd_lw, $dc4240e6100248ae$var$rd_lwc, $dc4240e6100248ae$var$rdWindow, $dc4240e6100248ae$var$molecules, $dc4240e6100248ae$var$reactions, true);
    // Conditions.
    let conditionsDiv = document.getElementById($dc4240e6100248ae$var$conditionsDivID);
    let cdlDivID = $dc4240e6100248ae$export$bea69a603fae01a6((0, $5b710835528e7170$export$363c7374d425f4ad).tagName);
    let cdlDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(cdlDivID);
    conditionsDiv.appendChild(cdlDiv);
    // Create a div for the conditionss.
    let conditionssDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(undefined, $dc4240e6100248ae$export$d6befed1f1d5e56b);
    // Create an add button to add a conditions.
    (0, $d0fe07d64e0283ae$export$c1600199abe19050)(conditionssDiv, $dc4240e6100248ae$var$conditionsIDM, $dc4240e6100248ae$var$molecules);
    // Create collapsible content.
    let cdlcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(cdlDivID, cdlDiv, null, conditionssDiv, "ConditionsList", $dc4240e6100248ae$export$d6befed1f1d5e56b, $dc4240e6100248ae$export$b1ddbf2a116c10ee);
    // Model Parameters.
    let modelParametersDiv = document.getElementById($dc4240e6100248ae$var$modelParametersDivID);
    let mplDivID = $dc4240e6100248ae$export$bea69a603fae01a6((0, $6ab526da66ecf283$export$77f098867dc64198).tagName, "list");
    let mplDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(mplDivID);
    modelParametersDiv.appendChild(mplDiv);
    // Create a div for the model parameterss.
    let modelParameterssDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(undefined, $dc4240e6100248ae$export$d6befed1f1d5e56b);
    // Create an add button to add a model parameters.
    (0, $45391daa0c41efdf$export$5733f83ee927902f)(modelParameterssDiv, $dc4240e6100248ae$var$mpIDM);
    // Create collapsible content.
    let mplcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(mplDivID, mplDiv, null, modelParameterssDiv, "ModelParametersList", $dc4240e6100248ae$export$d6befed1f1d5e56b, $dc4240e6100248ae$export$b1ddbf2a116c10ee);
    // Control.
    let controlDiv = document.getElementById($dc4240e6100248ae$var$controlDivID);
    let clDivID = $dc4240e6100248ae$export$bea69a603fae01a6((0, $085f2478c495b249$export$7a7fa4424cb20976).tagName);
    let clDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(clDivID);
    controlDiv.appendChild(clDiv);
    // Create a div for the controls.
    let controlsDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(undefined, $dc4240e6100248ae$export$d6befed1f1d5e56b);
    // Create an add button to add a control.
    (0, $e383a1a86a5ebbd4$export$2e5ceda339237ce2)(controlsDiv, $dc4240e6100248ae$var$controlIDM);
    // Create collapsible content.
    let controlcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(clDivID, clDiv, null, controlsDiv, "ControlList", $dc4240e6100248ae$export$d6befed1f1d5e56b, $dc4240e6100248ae$export$b1ddbf2a116c10ee);
/*
    // MetadataList.
    let metadataListDiv: HTMLDivElement = document.getElementById(metadataListDivID) as HTMLDivElement;
    let mdDivID: string = addRID(MetadataList.tagName);
    let mdDiv: HTMLDivElement = createDiv(mdDivID);
    metadataListDiv.appendChild(mdDiv);
    // Create collapsible content.
    let mdcDiv: HTMLDivElement = getCollapsibleDiv(mdDivID, metadataListDiv, null, mdDiv,
        MetadataList.tagName, boundary1, level0);

    // Analysis.
    let analysisDiv: HTMLDivElement = document.getElementById(analysisDivID) as HTMLDivElement;
    let aDivID: string = addRID(Analysis.tagName);
    let aDiv: HTMLDivElement = createDiv(aDivID);
    analysisDiv.appendChild(aDiv);
    // Create collapsible content.
    let acDiv: HTMLDivElement = getCollapsibleDiv(aDivID, analysisDiv, null, aDiv,
        Analysis.tagName, boundary1, level0);

    // XML.
    let xmlDiv: HTMLDivElement = document.getElementById(xmlDivID) as HTMLDivElement;
    let xDivID: string = addRID(s_xml, 2);
    let xDiv: HTMLDivElement = createDiv(xDivID);
    xmlDiv.appendChild(xDiv);
    // Create collapsible content.
    let xcDiv: HTMLDivElement = getCollapsibleDiv(xDivID, xmlDiv, null, xDiv,
        s_xml, boundary1, level0);
    */ }
/**
 * Create the title input.
 */ function $dc4240e6100248ae$var$createTitle(title, attributes) {
    let titleNode = new (0, $ccef02370f58a770$export$f99233281efd08a0)(attributes, title);
    $dc4240e6100248ae$export$3bb92be1f57fd129.setTitle(titleNode);
    let titleDiv = document.getElementById($dc4240e6100248ae$var$titleDivID);
    let lwiId = $dc4240e6100248ae$export$bea69a603fae01a6('titleDiv');
    // Remove any existing lwiId HTMLDivElement.
    $dc4240e6100248ae$export$cd7f480d6b8286c3(lwiId);
    // Create input element.
    let lwi = (0, $341c675b659c6d43$export$4e9ec2b27757d9dd)("text", $dc4240e6100248ae$export$bea69a603fae01a6(lwiId, $dc4240e6100248ae$export$58785e0018b77d4a), $dc4240e6100248ae$export$d6befed1f1d5e56b, $dc4240e6100248ae$export$b1ddbf2a116c10ee, (event)=>{
        let target = event.target;
        titleNode.value = target.value;
        console.log(titleNode.tagName + " changed to " + titleNode.value);
        (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
    }, title, (0, $ccef02370f58a770$export$f99233281efd08a0).tagName);
    lwi.id = lwiId;
    titleDiv.appendChild(lwi);
}
/**
 * Create the Reaction List.
 * @param rlDiv The reactionList div.
 */ function $dc4240e6100248ae$var$createReactionList(rlDiv) {
    let reactionsDiv = document.getElementById($dc4240e6100248ae$var$reactionsDivID);
    let rlDivID = $dc4240e6100248ae$export$bea69a603fae01a6((0, $ccef02370f58a770$export$44466a39ca846289).tagName);
    //let rlDiv: HTMLDivElement = createDiv(rlDivID);
    reactionsDiv.appendChild(rlDiv);
    // Create collapsible content.
    let rlcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(rlDivID, reactionsDiv, null, rlDiv, (0, $ccef02370f58a770$export$44466a39ca846289).tagName, $dc4240e6100248ae$export$d6befed1f1d5e56b, $dc4240e6100248ae$export$b1ddbf2a116c10ee);
    // Add add reaction button.
    let rb = (0, $7991f82905a8f5df$export$b12ef0e3d99deb64)($dc4240e6100248ae$var$rIDM, rlDiv, $dc4240e6100248ae$var$reactions, $dc4240e6100248ae$var$molecules);
}
function $dc4240e6100248ae$export$e7cd7bead34ef747() {
    if ($dc4240e6100248ae$var$rdWindow == null) {
        let rdCanvas = document.getElementById($dc4240e6100248ae$var$rddcID);
        (0, $8fba87eb7959a54b$export$9a6a0a663dda2923)(rdCanvas, $dc4240e6100248ae$var$rdcHeight, $dc4240e6100248ae$var$dark, $dc4240e6100248ae$var$rd_font, $dc4240e6100248ae$var$rd_lw, $dc4240e6100248ae$var$rd_lwc, $dc4240e6100248ae$var$molecules, $dc4240e6100248ae$var$reactions);
    } else {
        let c = $dc4240e6100248ae$var$rdWindow.document.getElementById($dc4240e6100248ae$var$rddcID);
        (0, $8fba87eb7959a54b$export$9a6a0a663dda2923)(c, $dc4240e6100248ae$var$rdcHeight, $dc4240e6100248ae$var$dark, $dc4240e6100248ae$var$rd_font, $dc4240e6100248ae$var$rd_lw, $dc4240e6100248ae$var$rd_lwc, $dc4240e6100248ae$var$molecules, $dc4240e6100248ae$var$reactions);
    }
}
/**
 * Redraw any scatterplots.
 */ function $dc4240e6100248ae$var$redrawScatterPlots() {
    $dc4240e6100248ae$var$scatterPlots.forEach((scatterPlot)=>{
        scatterPlot.draw($dc4240e6100248ae$var$sp_font);
    });
}
function $dc4240e6100248ae$export$11e63f7b0f3d9900() {
    // Before loading a new file, remove existing content and initialise data containers.
    $dc4240e6100248ae$var$initialise();
    // Create a file input element to prompt the user to select a file.
    let input = document.createElement('input');
    input.type = 'file';
    input.onchange = function() {
        if (input.files) {
            for(let i = 0; i < input.files.length; i++)console.log("inputElement.files[" + i + "]=" + input.files[i]);
            let file = input.files[0];
            //console.log("file=" + file);
            console.log(file.name);
            $dc4240e6100248ae$var$filename = file.name;
            let reader = new FileReader();
            let chunkSize = 1048576; // 1MB
            let start = 0;
            let contents = '';
            reader.onload = function(e) {
                if (e.target == null) throw new Error('Event target is null');
                contents += e.target.result;
                if (file != null) {
                    if (start < file.size) {
                        // Read the next chunk
                        let blob = file.slice(start, start + chunkSize);
                        reader.readAsText(blob);
                        start += chunkSize;
                    } else {
                        // All chunks have been read
                        contents = contents.trim();
                        $dc4240e6100248ae$var$displayXML($dc4240e6100248ae$var$filename, contents);
                        let parser = new DOMParser();
                        let xml = parser.parseFromString(contents, "text/xml");
                        $dc4240e6100248ae$var$parse(xml);
                    }
                }
            };
            // Read the first chunk
            let blob = file.slice(start, start + chunkSize);
            reader.readAsText(blob);
            start += chunkSize;
        }
    };
    input.click();
}
/**
 * Parse an XMLDocument and create the mesmer object.
 * @param xml The XML.
 */ function $dc4240e6100248ae$var$parse(xml) {
    console.log("parse: " + xml);
    // Process the XML.
    let xml_mesmer = (0, $057fa7562ec736a9$export$b7531b8ff18dc588)(xml, (0, $ccef02370f58a770$export$692079bb871c6039).tagName);
    $dc4240e6100248ae$export$3bb92be1f57fd129 = new (0, $ccef02370f58a770$export$692079bb871c6039)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_mesmer));
    // Title.
    let xml_title = xml.getElementsByTagName((0, $ccef02370f58a770$export$f99233281efd08a0).tagName);
    let title;
    let attributes;
    if (xml_title.length > 0) {
        if (xml_title.length > 1) console.warn('Multiple ' + (0, $ccef02370f58a770$export$f99233281efd08a0).tagName + ' tags found, using the first.');
        title = xml_title[0].childNodes[0].nodeValue.trim();
        attributes = (0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_title[0]);
    } else {
        title = $dc4240e6100248ae$var$filename;
        console.warn('No ' + (0, $ccef02370f58a770$export$f99233281efd08a0).tagName + ' tag found, using the filename: ' + $dc4240e6100248ae$var$filename + ' as the title.');
        attributes = new Map();
    }
    $dc4240e6100248ae$var$createTitle(title, attributes);
    // moleculeList.
    let mlDiv = document.getElementById($dc4240e6100248ae$var$moleculesDivID);
    let mlDivID = $dc4240e6100248ae$export$bea69a603fae01a6((0, $ccef02370f58a770$export$19d70f3647dee606).tagName);
    // Remove any existing mlDivID HTMLDivElement.
    $dc4240e6100248ae$export$cd7f480d6b8286c3(mlDivID);
    // Create collapsible content.
    let mlcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(mlDivID, mlDiv, null, (0, $9eedba3564ea6a49$export$ce852d72abd87240)(xml, $dc4240e6100248ae$var$mIDM, $dc4240e6100248ae$var$molecules), (0, $ccef02370f58a770$export$19d70f3647dee606).tagName, $dc4240e6100248ae$export$d6befed1f1d5e56b, $dc4240e6100248ae$export$b1ddbf2a116c10ee);
    //document.body.appendChild(mlcDiv);
    // Reaction List.
    let rlDivID = $dc4240e6100248ae$export$bea69a603fae01a6((0, $ccef02370f58a770$export$44466a39ca846289).tagName);
    // Remove any existing rlDivID HTMLDivElement.
    $dc4240e6100248ae$export$cd7f480d6b8286c3(rlDivID);
    $dc4240e6100248ae$var$createReactionList((0, $7991f82905a8f5df$export$ef4959ac45646090)(xml, $dc4240e6100248ae$var$rIDM, rlDivID, $dc4240e6100248ae$var$reactions, $dc4240e6100248ae$var$molecules));
    // Reactions Diagram.
    (0, $8fba87eb7959a54b$export$f1b90a337037b551)($dc4240e6100248ae$var$rddcID, $dc4240e6100248ae$var$rdcHeight, $dc4240e6100248ae$var$dark, $dc4240e6100248ae$var$rd_font, $dc4240e6100248ae$var$rd_lw, $dc4240e6100248ae$var$rd_lwc, $dc4240e6100248ae$var$rdWindow, $dc4240e6100248ae$var$molecules, $dc4240e6100248ae$var$reactions, true);
    // ConditionsList.
    let cdlDiv = document.getElementById($dc4240e6100248ae$var$conditionsDivID);
    let cdlDivID = $dc4240e6100248ae$export$bea69a603fae01a6((0, $5b710835528e7170$export$363c7374d425f4ad).tagName);
    // Remove any existing cdlDivID HTMLDivElement.
    $dc4240e6100248ae$export$cd7f480d6b8286c3(cdlDivID);
    // Create collapsible content.
    let cdlcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(cdlDivID, cdlDiv, null, (0, $d0fe07d64e0283ae$export$120facc5efd57974)(xml, $dc4240e6100248ae$var$conditionsIDM, $dc4240e6100248ae$var$molecules), "ConditionsList", $dc4240e6100248ae$export$d6befed1f1d5e56b, $dc4240e6100248ae$export$b1ddbf2a116c10ee);
    // ModelParametersList.
    let mplDiv = document.getElementById($dc4240e6100248ae$var$modelParametersDivID);
    let mplDivID = $dc4240e6100248ae$export$bea69a603fae01a6((0, $6ab526da66ecf283$export$77f098867dc64198).tagName, "list");
    // Remove any existing mpDivID HTMLDivElement.
    $dc4240e6100248ae$export$cd7f480d6b8286c3(mplDivID);
    // Create collapsible content.
    let mplcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(mplDivID, mplDiv, null, (0, $45391daa0c41efdf$export$7502110c3a5d7b36)(xml, $dc4240e6100248ae$var$mpIDM), "ModelParametersList", $dc4240e6100248ae$export$d6befed1f1d5e56b, $dc4240e6100248ae$export$b1ddbf2a116c10ee);
    // ControlList.
    let clDiv = document.getElementById($dc4240e6100248ae$var$controlDivID);
    let clDivID = $dc4240e6100248ae$export$bea69a603fae01a6((0, $085f2478c495b249$export$7a7fa4424cb20976).tagName);
    // Remove any existing clDivID HTMLDivElement.
    $dc4240e6100248ae$export$cd7f480d6b8286c3(clDivID);
    // Create collapsible content.
    let controlcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(clDivID, clDiv, null, (0, $e383a1a86a5ebbd4$export$76caf53413cf3464)(xml, $dc4240e6100248ae$var$controlIDM), "ControlList", $dc4240e6100248ae$export$d6befed1f1d5e56b, $dc4240e6100248ae$export$b1ddbf2a116c10ee);
    // MetadataList.
    // Check if xml contains metadata.
    if (xml.getElementsByTagName((0, $cb35636d41d8f309$export$3e18a603070a78a).tagName).length > 0) {
        let mdDiv = document.getElementById($dc4240e6100248ae$var$metadataListDivID);
        let mdDivID = $dc4240e6100248ae$export$bea69a603fae01a6((0, $cb35636d41d8f309$export$3e18a603070a78a).tagName);
        // Remove any existing mdDivID HTMLDivElement.
        $dc4240e6100248ae$export$cd7f480d6b8286c3(mdDivID);
        // Create collapsible content.
        let mdcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(mdDivID, mdDiv, null, $dc4240e6100248ae$var$processMetadataList(xml), (0, $cb35636d41d8f309$export$3e18a603070a78a).tagName, $dc4240e6100248ae$export$d6befed1f1d5e56b, $dc4240e6100248ae$export$b1ddbf2a116c10ee);
    }
    // Analysis.
    // Check if xml contains analysis.
    if (xml.getElementsByTagName((0, $012df152aa25e440$export$c4c153dc94cc96b4).tagName).length > 0) {
        let aDiv = document.getElementById($dc4240e6100248ae$var$analysisDivID);
        let aDivID = $dc4240e6100248ae$export$bea69a603fae01a6((0, $012df152aa25e440$export$c4c153dc94cc96b4).tagName);
        // Remove any existing aDivID HTMLDivElement.
        $dc4240e6100248ae$export$cd7f480d6b8286c3(aDivID);
        // Create collapsible content.
        let acDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(aDivID, aDiv, null, (0, $0ff23b3a70668dbf$export$56a93e1041dcdd6d)(xml), (0, $012df152aa25e440$export$c4c153dc94cc96b4).tagName, $dc4240e6100248ae$export$d6befed1f1d5e56b, $dc4240e6100248ae$export$b1ddbf2a116c10ee);
    }
}
function $dc4240e6100248ae$export$8f4af86541f72bfe(className, optionToRemove) {
    let elements = document.getElementsByClassName(className);
    for(let i = 0; i < elements.length; i++)if (elements[i] instanceof HTMLSelectElement) {
        let options = elements[i].options;
        let selectValue = elements[i].value;
        Array.from(options).forEach((option)=>{
            if (option.value == optionToRemove) {
                option.remove();
                if (selectValue == optionToRemove) {
                    // Create a new event
                    let event = new Event('change');
                    // Dispatch the event
                    elements[i].dispatchEvent(event);
                }
            }
        });
    }
}
function $dc4240e6100248ae$export$a30e0f90a7434924(className, optionToAdd) {
    let elements = document.getElementsByClassName(className);
    console.log("n elements with className " + className + "=" + elements.length);
    for(let i = 0; i < elements.length; i++){
        let select = elements[i];
        if (elements[i] instanceof HTMLSelectElement) {
            let option = document.createElement('option');
            option.value = optionToAdd;
            option.text = optionToAdd;
            select.add(option);
        }
    }
}
function $dc4240e6100248ae$export$10de1fc8385eec4a(options, add) {
    if (add) options.push($dc4240e6100248ae$export$d8b8827abc8ab7e7);
    else {
        // remove selectOption if present.
        let index = options.indexOf($dc4240e6100248ae$export$d8b8827abc8ab7e7);
        if (index > -1) options.splice(index, 1);
    }
}
function $dc4240e6100248ae$export$17d48ee8ddbf2d44(id, tIDM, name, getter, setter, remover, marginComponent, margin) {
    let div = (0, $341c675b659c6d43$export$78253536c0178a32)(id, margin);
    let buttonTextContentSelected = name + $dc4240e6100248ae$export$f0fb6e9d3fd6cf72;
    let buttonTextContentDeselected = name + $dc4240e6100248ae$export$b758aa9bd161846e;
    //let idb: string = tIDM.addID(id, name, s_button);
    let idb = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(id, name, (0, $341c675b659c6d43$export$25280bc3a7ce098e));
    let button = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(buttonTextContentDeselected, idb, marginComponent);
    div.appendChild(button);
    button.classList.add($dc4240e6100248ae$export$50cc31b59b02e033);
    button.classList.add($dc4240e6100248ae$export$d52efe23389358db);
    //let inputId: string = tIDM.addID(id, name, s_input)
    let inputId = (0, $93b71ab6968650c1$export$3205c97bcf96f7dc)(id, name, $dc4240e6100248ae$export$58785e0018b77d4a);
    let value = getter();
    if (value == undefined) {
        //remover(name);
        button.textContent = buttonTextContentDeselected;
        button.classList.toggle($dc4240e6100248ae$export$50cc31b59b02e033);
    } else {
        $dc4240e6100248ae$var$addNumber(div, inputId, name, value, getter, setter, marginComponent);
        button.textContent = buttonTextContentSelected;
        button.classList.toggle($dc4240e6100248ae$export$d52efe23389358db);
    }
    // Add event listener for the button.
    button.addEventListener('click', (event)=>{
        if (document.getElementById(inputId) == null) {
            console.log("Adding " + inputId);
            $dc4240e6100248ae$var$addNumber(div, inputId, name, value, getter, setter, marginComponent);
            // Invoke the setter function.
            let input = div.querySelector($dc4240e6100248ae$export$58785e0018b77d4a);
            // Enact a change event on input.
            if (value != undefined) input.value = value.toString();
            let event = new Event('change');
            input.dispatchEvent(event);
            //setter;
            button.textContent = buttonTextContentSelected;
        } else {
            // Remove existing HTMLElement.
            document.getElementById(inputId)?.remove();
            // Remove node.
            //remover();
            remover(name);
            console.log("Removed " + inputId);
            button.textContent = buttonTextContentDeselected;
        }
        button.classList.toggle($dc4240e6100248ae$export$50cc31b59b02e033);
        button.classList.toggle($dc4240e6100248ae$export$d52efe23389358db);
    });
    return div;
}
/**
 * @param div The div to add the input to.
 * @param id The id.
 * @param name The name of the input.
 * @param value The numerical value.
 * @param setter The setter function to call.
 * @param margin The boundary.
 * @param level The level.
 */ function $dc4240e6100248ae$var$addNumber(div, id, name, value, getter, setter, margin) {
    let valueString;
    if (value == undefined) valueString = "";
    else valueString = value.toString();
    //let input: HTMLInputElement = createInput("number", id, boundary);
    let input = (0, $341c675b659c6d43$export$d80fffb1deb3b97e)("text", id, margin);
    input.addEventListener('click', (event)=>{
        valueString = input.value;
    });
    input.addEventListener('change', (event)=>{
        let target = event.target;
        try {
            let value2 = target.value;
            if (value2 == "") value2 = "0";
            setter(new (0, $ad9e9f310a798519$exports.Big)(value2));
            console.log(name + " changed from " + valueString + " to " + target.value);
        } catch (e) {
            alert("Input invalid, resetting...");
            let value2 = getter();
            if (value2 != undefined) target.value = value2.toString();
        }
        (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
    });
    input.value = valueString;
    //setter(new Big(valueString));
    (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(input);
    div.appendChild(input);
}
function $dc4240e6100248ae$export$590bdcb7f5f5327a(div, margin, removeFunction, ...args) {
    let button = (0, $341c675b659c6d43$export$9b6d6ca62970729f)($dc4240e6100248ae$export$bb916e6caf34db48, undefined, margin);
    div.appendChild(button);
    button.addEventListener('click', ()=>{
        removeFunction(...args);
        div.remove();
        $dc4240e6100248ae$export$cd7f480d6b8286c3(div.id);
    });
    return button;
}
function $dc4240e6100248ae$export$edf19e7acee859e6(id, iDs, name, getter, setter, remover, marginComponent, margin) {
    let div = (0, $341c675b659c6d43$export$78253536c0178a32)(id, margin);
    let buttonTextContentSelected = name + $dc4240e6100248ae$export$f0fb6e9d3fd6cf72;
    let buttonTextContentDeselected = name + $dc4240e6100248ae$export$b758aa9bd161846e;
    let idb = $dc4240e6100248ae$export$bea69a603fae01a6(id, (0, $341c675b659c6d43$export$25280bc3a7ce098e));
    iDs.add(idb);
    let button = (0, $341c675b659c6d43$export$9b6d6ca62970729f)(buttonTextContentDeselected, idb, marginComponent);
    div.appendChild(button);
    button.classList.add($dc4240e6100248ae$export$50cc31b59b02e033);
    button.classList.add($dc4240e6100248ae$export$d52efe23389358db);
    let inputId = $dc4240e6100248ae$export$bea69a603fae01a6(id, name, $dc4240e6100248ae$export$58785e0018b77d4a);
    iDs.add(inputId);
    let value = getter();
    if (value == undefined) {
        button.textContent = buttonTextContentDeselected;
        button.classList.toggle($dc4240e6100248ae$export$50cc31b59b02e033);
    } else {
        $dc4240e6100248ae$var$addString(div, inputId, name, value, setter, marginComponent);
        button.textContent = buttonTextContentSelected;
        button.classList.toggle($dc4240e6100248ae$export$d52efe23389358db);
    }
    // Add event listener for the button.
    button.addEventListener('click', (event)=>{
        if (document.getElementById(inputId) == null) {
            $dc4240e6100248ae$var$addString(div, inputId, name, value, setter, marginComponent);
            button.textContent = buttonTextContentSelected;
        } else {
            // Remove existing.
            document.getElementById(inputId)?.remove();
            // Remove node.
            remover();
            console.log("Removed " + inputId);
            button.textContent = buttonTextContentDeselected;
        }
        button.classList.toggle($dc4240e6100248ae$export$50cc31b59b02e033);
        button.classList.toggle($dc4240e6100248ae$export$d52efe23389358db);
    });
    return div;
}
/**
 * @param div The div to add the input to.
 * @param id The id.
 * @param name The name of the input.
 * @param value The numerical value.
 * @param setter The setter function to call.
 * @param margin The boundary.
 * @param level The level.
 */ function $dc4240e6100248ae$var$addString(div, id, name, value, setter, margin) {
    let valueString;
    if (value == undefined) valueString = "";
    else valueString = value.toString();
    //let input: HTMLInputElement = createInput("number", id, boundary);
    let input = (0, $341c675b659c6d43$export$d80fffb1deb3b97e)("text", id, margin);
    input.addEventListener('change', (event)=>{
        let target = event.target;
        setter(target.value);
        console.log(name + " changed from " + value + " to " + target.value);
        (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(target);
    });
    input.value = valueString;
    (0, $341c675b659c6d43$export$d43d96a9a8ad3e51)(input);
    div.appendChild(input);
}
/**
 * Display the XML.
 * @param {string} xml The XML to display.
 */ function $dc4240e6100248ae$var$displayXML(xmlFilename, xml) {
    let xmlDiv = document.getElementById($dc4240e6100248ae$var$xmlDivID);
    let xml2DivID = $dc4240e6100248ae$export$bea69a603fae01a6($dc4240e6100248ae$var$xmlDivID, 2);
    // Remove any existing mlDivID HTMLDivElement.
    $dc4240e6100248ae$export$cd7f480d6b8286c3(xml2DivID);
    // Create collapsible content.
    let xml2Div = (0, $341c675b659c6d43$export$331ff980f0d45cff)(xml2DivID, $dc4240e6100248ae$export$39c84188a71202f7);
    let xmlcDiv = (0, $341c675b659c6d43$export$8b2cd46c11844202)(xml2DivID, xmlDiv, null, xml2Div, xmlFilename, $dc4240e6100248ae$export$d6befed1f1d5e56b, $dc4240e6100248ae$export$b1ddbf2a116c10ee);
    let xmlPre = document.createElement("pre");
    xmlPre.textContent = xml;
    xml2Div.appendChild(xmlPre);
}
function $dc4240e6100248ae$export$2b2254f82abcc900(units, attributes, divToAddTo, elementToInsertBefore, id, tagOrDictRef, margin, level) {
    if (units != undefined) {
        let lws = $dc4240e6100248ae$var$getUnitsLabelWithSelect(units, attributes, id, tagOrDictRef, margin, level);
        if (lws != undefined) divToAddTo.insertBefore(lws, elementToInsertBefore);
    } else {
        let attributesUnits = attributes.get("units");
        if (attributesUnits != undefined) {
            let label = (0, $341c675b659c6d43$export$f2839682b8c07f35)("units " + attributesUnits, level);
            divToAddTo.insertBefore(label, elementToInsertBefore);
        }
    }
}
/**
 * @param attributes The attributes.
 * @param id The id.
 * @param tagOrDictRef The tag or dictionary reference.
 * @returns A select element for setting the units or undefined if there is not attribute for units.
 */ function $dc4240e6100248ae$var$getUnitsLabelWithSelect(units, attributes, id, tagOrDictRef, boundary, level) {
    let psUnits = attributes.get("units");
    if (psUnits != undefined) {
        // Get a select element for setting the units.
        let lws = (0, $341c675b659c6d43$export$4c3eba01cd3c5ba4)("units", units, "units", psUnits, id, boundary, level);
        let select = lws.querySelector('select');
        // Set the initial value to the units.
        select.value = psUnits;
        // Add event listener to selectElement.
        (0, $341c675b659c6d43$export$fdd146df37959fe8)(select);
        select.addEventListener('change', (event)=>{
            let target = event.target;
            attributes.set("units", target.value);
            console.log("Set " + tagOrDictRef + " units to " + target.value);
            (0, $341c675b659c6d43$export$fdd146df37959fe8)(target);
        });
        return lws;
    }
    return undefined;
}
function $dc4240e6100248ae$export$88ed5e596ed31b40(message) {
    let n = 0;
    let nset = false;
    while(!nset){
        let nString = prompt(message, "0");
        if (nString != null) {
            if ((0, $93b71ab6968650c1$export$e90fb89750dba83f)(nString)) {
                n = parseInt(nString);
                if (n > 0) nset = true;
            }
        }
    }
    return n;
}
function $dc4240e6100248ae$export$3b08dcba56872ec6(options, select) {
    select.addEventListener('click', (event)=>{
        if (options[options.length - 1] == $dc4240e6100248ae$export$d8b8827abc8ab7e7) options.pop();
        let lastIndex = select.options.length - 1;
        if (select.options[lastIndex].value == $dc4240e6100248ae$export$d8b8827abc8ab7e7) select.remove(lastIndex);
    });
}
/**
 * Parses xml to initialise metadataList.
 * @param xml The XML document.
 */ function $dc4240e6100248ae$var$processMetadataList(xml) {
    console.log((0, $cb35636d41d8f309$export$3e18a603070a78a).tagName);
    let mlDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)($dc4240e6100248ae$export$bea69a603fae01a6((0, $cb35636d41d8f309$export$3e18a603070a78a).tagName, 0), $dc4240e6100248ae$export$d6befed1f1d5e56b);
    let xml_mls = xml.getElementsByTagName((0, $cb35636d41d8f309$export$3e18a603070a78a).tagName);
    if (xml_mls.length > 0) {
        if (xml_mls.length > 1) console.warn("More than one MetadataList element - showing the last.");
        let ml = new (0, $cb35636d41d8f309$export$3e18a603070a78a)((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_mls[xml_mls.length - 1]));
        $dc4240e6100248ae$export$3bb92be1f57fd129.setMetadataList(ml);
        function handleElement(tagName, constructor, setter) {
            let xml_elements = xml_mls[xml_mls.length - 1].getElementsByTagName(tagName);
            if (xml_elements.length > 0) {
                if (xml_elements.length == 1) {
                    let s = (0, $057fa7562ec736a9$export$4e07613bf412feb7)(xml_elements[0])?.nodeValue ?? "";
                    let n = new constructor((0, $057fa7562ec736a9$export$fe94072fee8a6976)(xml_elements[0]), s);
                    let cDiv = (0, $341c675b659c6d43$export$331ff980f0d45cff)(undefined, $dc4240e6100248ae$export$39c84188a71202f7);
                    mlDiv.appendChild(cDiv);
                    cDiv.appendChild((0, $341c675b659c6d43$export$f2839682b8c07f35)(n.tagName + " " + s, $dc4240e6100248ae$export$d6befed1f1d5e56b));
                    //console.log(n.tagName + " " + s);
                    setter.call(ml, n);
                } else throw new Error(`More than one ${tagName} element.`);
            }
        }
        handleElement((0, $cb35636d41d8f309$export$c78a95f4a27bad68).tagName, (0, $cb35636d41d8f309$export$c78a95f4a27bad68), ml.setSource);
        handleElement((0, $cb35636d41d8f309$export$61180682f135a7f2).tagName, (0, $cb35636d41d8f309$export$61180682f135a7f2), ml.setCreator);
        handleElement((0, $cb35636d41d8f309$export$bf6d63a1cea4a33c).tagName, (0, $cb35636d41d8f309$export$bf6d63a1cea4a33c), ml.setDate);
        handleElement((0, $cb35636d41d8f309$export$2b747e617c849cca).tagName, (0, $cb35636d41d8f309$export$2b747e617c849cca), ml.setContributor);
    }
    return mlDiv;
}
class $dc4240e6100248ae$export$eec270bd176da5f5 {
    constructor(canvas, data, font, graphdetails){
        this.canvas = canvas;
        this.data = data;
        this.graphdetails = graphdetails;
        // Create a new scatter plot.
        this.draw(font);
    }
    /**
     * Draw the scatter plot.
     */ draw(font) {
        this.canvas.width = 800; // Set the width of the canvas
        this.canvas.height = 400; // Set the height of the canvas
        const ctx = this.canvas.getContext("2d");
        //const ctx: CanvasRenderingContext2D = this.canvas.getContext("2d") as CanvasRenderingContext2D;        
        ctx.font = font;
        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height); // Clear the canvas.
        let width = this.canvas.width;
        let height = this.canvas.height;
        let xMin = Number.MAX_VALUE;
        let xMax = Number.MIN_VALUE;
        let yMin = Number.MAX_VALUE;
        let yMax = Number.MIN_VALUE;
        let maxRefWidth = 0;
        this.data.forEach((ref_pop, x)=>{
            let logx = Math.log10(x.toNumber());
            xMin = Math.min(xMin, logx);
            xMax = Math.max(xMax, logx);
            ref_pop.forEach((p, ref)=>{
                maxRefWidth = Math.max(maxRefWidth, ctx.measureText(ref).width);
            });
            ref_pop.forEach((p, ref)=>{
                yMin = Math.min(yMin, p.toNumber());
                yMax = Math.max(yMax, p.toNumber());
            });
        });
        yMin = Math.min(yMin, 0.0);
        // Find the latest power of 10 that is less than Maximum data point.
        let iDeciFctr = 0;
        let tmp = yMax;
        while(tmp > 10.0){
            tmp /= 10.0;
            iDeciFctr++;
        }
        // Calculate the width of the largest tick label
        let yTicks = 11;
        let yTickSpacing = 1;
        let maxTickLabelWidth = 0;
        for(let i = 0; i < yTicks; i++){
            let yTick = 1 - i * yTickSpacing;
            let tickLabelWidth = ctx.measureText(yTick.toString()).width;
            maxTickLabelWidth = Math.max(maxTickLabelWidth, tickLabelWidth);
        }
        // Calculate the height of the largest tick label
        let metrics = ctx.measureText('0');
        let th = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
        let xmargin = th * 4;
        // Set the margin based on the width of the largest tick label
        let ymargin = maxTickLabelWidth + th * 4;
        let x0 = ymargin;
        let y0 = height - (ymargin + th * 3);
        let x1 = width - (xmargin + maxRefWidth + 20);
        let y1 = xmargin;
        let xScale = (x1 - x0) / (xMax - xMin);
        let yScale = (y1 - y0) / (yMax - yMin);
        // Draw x-axis.
        ctx.beginPath();
        ctx.moveTo(x0, y0);
        ctx.lineTo(x1, y0);
        ctx.stroke();
        // Draw y-axis.
        ctx.beginPath();
        ctx.moveTo(x0, y0);
        ctx.lineTo(x0, y1);
        ctx.stroke();
        // Define an array of colors for different styles
        let colors = [
            "red",
            "green",
            "blue",
            "orange",
            "purple",
            "grey",
            "cyan",
            "magenta",
            "lightblue",
            "lightgreen",
            "pink",
            "yellow",
            "brown",
            "black"
        ];
        let refToColor = new Map();
        // Draw data points.
        this.data.forEach((ref_pop, x)=>{
            // Define a reference id for each color
            let i = 0;
            ref_pop.forEach((p, ref)=>{
                let logx = Math.log10(x.toNumber());
                let xPixel = x0 + (logx - xMin) * xScale;
                let pn = p.toNumber();
                // if (pn < 1) {
                let yPixel = y0 + (pn - yMin) * yScale;
                if (yPixel > 0) {
                    ctx.beginPath();
                    ctx.arc(xPixel, yPixel, 2, 0, 2 * Math.PI); // Points
                    // Use the ref index to select a color
                    let color = colors[i % colors.length];
                    refToColor.set(ref, color);
                    ctx.fillStyle = color;
                    ctx.fill();
                }
                //}
                i++;
            });
        });
        // Draw x-axis labels.
        ctx.textAlign = "center";
        ctx.textBaseline = "top";
        ctx.fillStyle = "black";
        let xLabel = "log10(time/secs)";
        ctx.fillText(xLabel, x0 + (x1 - x0) / 2, y0 + xmargin / 2);
        // Draw y-axis labels.
        ctx.save();
        ctx.rotate(-Math.PI / 2);
        ctx.textAlign = "center";
        ctx.textBaseline = "top";
        let yLabel = this.graphdetails.yAxisLabel;
        if (iDeciFctr != 0) yLabel += "/1.e" + iDeciFctr.toString();
        yLabel += this.graphdetails.units;
        ctx.fillText(yLabel, -y0 - (y1 - y0) / 2, x0 - ymargin);
        ctx.restore();
        // Draw x-axis ticks.
        let xrange = xMax - xMin;
        //console.log("xrange=" + xrange);
        let orderOfMagnitude = Math.floor(Math.log10(xrange));
        //console.log("orderOfMagnitude=" + orderOfMagnitude);
        let xTickSpacing = Math.abs(Math.ceil(xrange / Math.pow(10, orderOfMagnitude)));
        //console.log("xTickSpacing=" + xTickSpacing);
        let i = Math.ceil(xMin / xTickSpacing);
        let xTick = i * xTickSpacing;
        // Draw x-axis ticks > 0.
        while(xTick < xMax){
            //console.log("xTick=" + xTick);
            let xPixel = x0 + (xTick - xMin) * xScale; // Convert xTick to pixel scale
            ctx.beginPath();
            ctx.moveTo(xPixel, y0);
            ctx.lineTo(xPixel, y0 + 5);
            ctx.stroke();
            ctx.fillText(xTick.toString(), xPixel, y0 + 5);
            xTick += xTickSpacing;
        }
        // Draw y-axis ticks.
        let DeciFctr = 10.0 ** iDeciFctr;
        yTickSpacing = (y1 - y0) / (yTicks - 1);
        let diff = (yMax - yMin) / (yTicks - 1);
        for(let i = 0; i < yTicks; i++){
            let yTick = y0 + i * yTickSpacing; // Convert yTick to pixel scale;
            let yValue = Number((yMin + i * diff) / DeciFctr).toPrecision(2);
            ctx.beginPath();
            ctx.moveTo(x0, yTick);
            ctx.lineTo(x0 - 5, yTick);
            ctx.fillText(yValue, x0 - 30, yTick - th * 0.5);
            ctx.stroke();
        }
        // Add a legend.
        // Calculate the maxiimum text height of a ref.
        let maxth = 0;
        refToColor.forEach((color, ref)=>{
            let metrics = ctx.measureText(ref);
            let th = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
            maxth = Math.max(maxth, th);
        });
        // Calculate the position of the legend.
        let legendX = x1 + 20; // Position the legend 20 pixels to the right of the graph
        let legendY = y1; // Position the legend at the top of the graph
        let legendYSpacing = maxth; // Adjust as needed
        // Draw a legend for each ref.
        i = 0;
        refToColor.forEach((color, ref)=>{
            let legendYPos = legendY + i * legendYSpacing;
            ctx.fillStyle = color;
            ctx.fillRect(legendX, legendYPos, maxth / 2, maxth / 2); // Draw a small rectangle of the ref's color
            ctx.fillStyle = "black";
            ctx.fillText(ref, legendX + th + ctx.measureText(ref).width / 2, legendYPos - maxth / 2); // Draw the ref's name
            i++;
        });
    }
}
class $dc4240e6100248ae$export$855b799c430f2201 {
    constructor(){
        this.xAxisLabel = "";
        this.yAxisLabel = "";
        this.units = "";
    }
}
function $dc4240e6100248ae$export$1209ee63cd9aa290(t) {
    let csv = "";
    let rows = t.rows;
    for(let i = 0; i < rows.length; i++){
        let row = rows[i];
        let cells = row.cells;
        for(let j = 0; j < cells.length; j++){
            csv += cells[j].textContent;
            if (j < cells.length - 1) csv += ",";
        }
        csv += "\n";
    }
    return csv;
}
/**
 * For saving data to a file.
 * 
 * @param data The data.
 * @param dataType The data type.
 * @param filename The filename.
 * @param isDataURL A boolean indicating whether the data is a data URL.
 */ function $dc4240e6100248ae$var$saveDataAsFile(data, dataType, filename, isDataURL = false) {
    let a = document.createElement('a');
    a.href = isDataURL ? data : `data:${dataType};charset=utf-8,` + encodeURIComponent(data);
    a.download = filename;
    document.body.appendChild(a); // Append the anchor to the body.
    a.click(); // Programmatically click the anchor to trigger the download.
    document.body.removeChild(a); // Remove the anchor from the body after triggering the download.
}
function $dc4240e6100248ae$export$cffb3d6135ce44ec() {
    if ($dc4240e6100248ae$export$3bb92be1f57fd129 == null) {
        alert("No Mesmer object to save.");
        return;
    } else {
        /**
         * Organise mesmer nodes to be in order:
         * title
         * moleculeList
         * reactionList
         * conditions
         * modelParameters
         * control
         * metadataList
         * analysis
         */ let mesmerOrdered = new (0, $ccef02370f58a770$export$692079bb871c6039)($dc4240e6100248ae$export$3bb92be1f57fd129.attributes);
        mesmerOrdered.setTitle($dc4240e6100248ae$export$3bb92be1f57fd129.getTitle());
        if ($dc4240e6100248ae$var$molecules != undefined) mesmerOrdered.setMoleculeList(new (0, $ccef02370f58a770$export$19d70f3647dee606)(new Map(), Array.from($dc4240e6100248ae$var$molecules.values())));
        if ($dc4240e6100248ae$var$reactions != undefined) mesmerOrdered.setReactionList(new (0, $ccef02370f58a770$export$44466a39ca846289)(new Map(), Array.from($dc4240e6100248ae$var$reactions.values())));
        if ($dc4240e6100248ae$export$3bb92be1f57fd129.getConditionss() != undefined) mesmerOrdered.setConditionss($dc4240e6100248ae$export$3bb92be1f57fd129.getConditionss());
        if ($dc4240e6100248ae$export$3bb92be1f57fd129.getModelParameterss() != undefined) mesmerOrdered.setModelParameterss($dc4240e6100248ae$export$3bb92be1f57fd129.getModelParameterss());
        if ($dc4240e6100248ae$export$3bb92be1f57fd129.getControls() != undefined) mesmerOrdered.setControls($dc4240e6100248ae$export$3bb92be1f57fd129.getControls());
        let mdl = $dc4240e6100248ae$export$3bb92be1f57fd129.getMetadataList();
        if (mdl != undefined) mesmerOrdered.setMetadataList(mdl);
        let analysis = $dc4240e6100248ae$export$3bb92be1f57fd129.getAnalysis();
        if (analysis != undefined) mesmerOrdered.setAnalysis(analysis);
        console.log("saveXML");
        const pad = "  ";
        let xmlData = (0, $ccef02370f58a770$export$692079bb871c6039).header + mesmerOrdered.toXML(pad, "");
        let title = mesmerOrdered.getTitle()?.value;
        $dc4240e6100248ae$var$saveDataAsFile(xmlData, 'text/xml', $dc4240e6100248ae$var$getFilename(title) + ".xml");
    }
}
/**
 * Convert name into a filename.
 */ function $dc4240e6100248ae$var$getFilename(name) {
    return name.replace(/[^a-z0-9]/gi, '_');
}
function $dc4240e6100248ae$export$f0119d1c38383eb8(canvas, divToAddTo, elementToInsertBefore, name) {
    // Add a save button to save the canvas as an image.
    let saveButtonID = $dc4240e6100248ae$export$bea69a603fae01a6(divToAddTo.id, 'saveButton');
    let saveButton = (0, $341c675b659c6d43$export$9b6d6ca62970729f)("Save as PNG", saveButtonID, $dc4240e6100248ae$export$d6befed1f1d5e56b);
    if (elementToInsertBefore != null) divToAddTo.insertBefore(saveButton, elementToInsertBefore);
    else divToAddTo.appendChild(saveButton);
    saveButton.addEventListener('click', ()=>{
        let dataURL = canvas.toDataURL();
        let title = $dc4240e6100248ae$export$3bb92be1f57fd129.getTitle()?.value;
        $dc4240e6100248ae$var$saveDataAsFile(dataURL, 'image/png', $dc4240e6100248ae$var$getFilename(title + "_" + name) + ".png", true);
    });
}
function $dc4240e6100248ae$export$dd526fb3a2a9c049(toCSV, divToAddTo, elementToInsertBefore, name, margin) {
    let bID = $dc4240e6100248ae$export$bea69a603fae01a6(divToAddTo.id, (0, $341c675b659c6d43$export$25280bc3a7ce098e), $dc4240e6100248ae$export$c1dfed4ad865f0b6);
    let b = (0, $341c675b659c6d43$export$9b6d6ca62970729f)("Save as CSV", bID, margin);
    divToAddTo.insertBefore(b, elementToInsertBefore);
    b.addEventListener('click', ()=>{
        let csv = toCSV();
        let title = $dc4240e6100248ae$export$3bb92be1f57fd129.getTitle()?.value;
        let fn = $dc4240e6100248ae$var$getFilename(title + "_" + name) + ".csv";
        $dc4240e6100248ae$var$saveDataAsFile(csv, 'text/csv', fn);
        console.log("Saved " + fn);
    });
}
function $dc4240e6100248ae$export$b1e4cbf5b56e0e21(node, input) {
    try {
        let value = new (0, $ad9e9f310a798519$exports.Big)(input.value);
        //node.setValue(value);
        node.value = value;
    } catch (e) {
        alert("Value invalid, resetting...");
    }
    input.value = node.value.toString();
}


//# sourceMappingURL=index.dcbe6c56.js.map
